var _toConsumableArray = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toArray = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/toArray");

var _classCallCheck = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\GitsRespositories\\PlayerEngagement\\Source\\PlayerEngagementApi\\player-engagement-app\\node_modules\\@babel\\runtime/helpers/inherits");

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 * 
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 * 
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.OktaAuth = t() : e.OktaAuth = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 395);
  }([function (e, t) {
    function n(t) {
      return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, e.exports.default = e.exports, e.exports.__esModule = !0, n(t);
    }

    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    e.exports = n(117);
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    e.exports = function (e, t, r) {
      return t && n(e.prototype, t), r && n(e, r), e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(79);
    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && r(e, t);
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(24).default,
        o = n(114);
    e.exports = function (e, t) {
      return !t || "object" !== r(t) && "function" != typeof t ? o(e) : t;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    var r = n(8),
        o = n(44).f,
        i = n(123),
        a = n(11),
        s = n(34),
        u = n(22),
        c = n(18),
        f = function f(e) {
      var t = function t(_t2, n, r) {
        if (this instanceof e) {
          switch (arguments.length) {
            case 0:
              return new e();

            case 1:
              return new e(_t2);

            case 2:
              return new e(_t2, n);
          }

          return new e(_t2, n, r);
        }

        return e.apply(this, arguments);
      };

      return t.prototype = e.prototype, t;
    };

    e.exports = function (e, t) {
      var n,
          l,
          p,
          h,
          d,
          v,
          y,
          g,
          m = e.target,
          b = e.global,
          x = e.stat,
          w = e.proto,
          k = b ? r : x ? r[m] : (r[m] || {}).prototype,
          S = b ? a : a[m] || (a[m] = {}),
          E = S.prototype;

      for (p in t) {
        n = !i(b ? p : m + (x ? "." : "#") + p, e.forced) && k && c(k, p), d = S[p], n && (v = e.noTargetGet ? (g = o(k, p)) && g.value : k[p]), h = n && v ? v : t[p], n && typeof d == typeof h || (y = e.bind && n ? s(h, r) : e.wrap && n ? f(h) : w && "function" == typeof h ? s(Function.call, h) : h, (e.sham || h && h.sham || d && d.sham) && u(y, "sham", !0), S[p] = y, w && (c(a, l = m + "Prototype") || u(a, l, {}), a[l][p] = h, e.real && E && !E[p] && u(E, p, h)));
      }
    };
  }, function (e, t, n) {
    var r = n(8),
        o = n(85),
        i = n(18),
        a = n(87),
        s = n(90),
        u = n(134),
        c = o("wks"),
        f = r.Symbol,
        l = u ? f : f && f.withoutSetter || a;

    e.exports = function (e) {
      return i(c, e) && (s || "string" == typeof c[e]) || (s && i(f, e) ? c[e] = f[e] : c[e] = l("Symbol." + e)), c[e];
    };
  }, function (e, t, n) {
    (function (t) {
      var n = function n(e) {
        return e && e.Math == Math && e;
      };

      e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof t && t) || function () {
        return this;
      }() || Function("return this")();
    }).call(this, n(43));
  }, function (e, t, n) {
    var r = n(11),
        o = n(18),
        i = n(104),
        a = n(26).f;

    e.exports = function (e) {
      var t = r.Symbol || (r.Symbol = {});
      o(t, e) || a(t, e, {
        value: i.f(e)
      });
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(390),
        o = n(391),
        i = n(118),
        a = n(392);
    e.exports = function (e) {
      return r(e) || o(e) || i(e) || a();
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(10);
    e.exports = !r(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  }, function (e, t, n) {
    var r = n(393);

    function o(t, n, i) {
      return "undefined" != typeof Reflect && Reflect.get ? (e.exports = o = Reflect.get, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = o = function o(e, t, n) {
        var o = r(e, t);

        if (o) {
          var i = Object.getOwnPropertyDescriptor(o, t);
          return i.get ? i.get.call(n) : i.value;
        }
      }, e.exports.default = e.exports, e.exports.__esModule = !0), o(t, n, i || t);
    }

    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(17);

    e.exports = function (e) {
      if (!r(e)) throw TypeError(String(e) + " is not an object");
      return e;
    };
  }, function (e, t, n) {
    e.exports = n(210);
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(25),
        o = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return o.call(r(e), t);
    };
  }, function (e, t, n) {
    (function (t) {
      var n = function n(e) {
        return e && e.Math == Math && e;
      };

      e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof t && t) || function () {
        return this;
      }() || Function("return this")();
    }).call(this, n(43));
  }, function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(80),
        o = n(81);

    e.exports = function (e) {
      return r(o(e));
    };
  }, function (e, t, n) {
    var r = n(13),
        o = n(26),
        i = n(28);
    e.exports = r ? function (e, t, n) {
      return o.f(e, t, i(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(11),
        o = n(8),
        i = function i(e) {
      return "function" == typeof e ? e : void 0;
    };

    e.exports = function (e, t) {
      return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
    };
  }, function (e, t) {
    function n(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = n = function n(e) {
        return typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0), n(t);
    }

    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(81);

    e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t, n) {
    var r = n(13),
        o = n(122),
        i = n(15),
        a = n(61),
        s = Object.defineProperty;
    t.f = r ? s : function (e, t, n) {
      if (i(e), t = a(t, !0), i(n), o) try {
        return s(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, n) {
    var r = n(11);

    e.exports = function (e) {
      return r[e + "Prototype"];
    };
  }, function (e, t) {
    e.exports = !0;
  }, function (e, t, n) {
    var r = n(22);

    e.exports = function (e, t, n, o) {
      o && o.enumerable ? e[t] = n : r(e, t, n);
    };
  }, function (e, t, n) {
    var r = n(92),
        o = n(26).f,
        i = n(22),
        a = n(18),
        s = n(221),
        u = n(7)("toStringTag");

    e.exports = function (e, t, n, c) {
      if (e) {
        var f = n ? e : e.prototype;
        a(f, u) || o(f, u, {
          configurable: !0,
          value: t
        }), c && !r && i(f, "toString", s);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(20);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(36)),
        a = o(n(212)),
        s = o(n(45)),
        u = o(n(229));
    n(237), n(156);

    var c = o(n(42)),
        f = o(n(271)),
        l = o(n(301)),
        p = o(n(349)),
        h = n(74),
        d = function () {
      var e = (0, c.default)(i.default.mark(function e(t) {
        var n, r, o, c, h, d, v, y, g, m, b, x, w, k, S, E, T, _, O, A, R;

        return i.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (o = t.clientId, c = t.domain, h = t.issuer, d = t.stateHandle, v = t.interactionHandle, y = t.version, g = t.redirectUri, m = t.state, b = t.scopes, x = t.codeChallenge, w = t.codeChallengeMethod, h = null === (n = h) || void 0 === n ? void 0 : n.replace(/\/+$/, ""), k = (null === (r = h) || void 0 === r ? void 0 : (0, a.default)(r).call(r, "/oauth2")) > 0 ? h : h + "/oauth2", S = {
                  baseUrl: k,
                  clientId: o,
                  state: m
                }, c || h) {
                  e.next = 6;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "issuer is required"
                }));

              case 6:
                if (d || o) {
                  e.next = 8;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "clientId is required"
                }));

              case 8:
                if (d || g) {
                  e.next = 10;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "redirectUri is required"
                }));

              case 10:
                if (d || x && w) {
                  e.next = 12;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "PKCE params (codeChallenge, codeChallengeMethod) are required"
                }));

              case 12:
                if (c || (c = new u.default(h).origin), y) {
                  e.next = 15;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "version is required"
                }));

              case 15:
                if ((null != y ? y : "").replace(/[^0-9a-zA-Z._-]/, "") === y && y) {
                  e.next = 18;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "invalid version supplied - version is required and uses semver syntax"
                }));

              case 18:
                if (d || v) {
                  e.next = 31;
                  break;
                }

                return e.prev = 19, E = {
                  clientId: o,
                  baseUrl: k,
                  scopes: b,
                  redirectUri: g,
                  codeChallenge: x,
                  codeChallengeMethod: w,
                  state: m
                }, e.next = 23, (0, l.default)(E);

              case 23:
                T = e.sent, v = T, S.interactionHandle = v, e.next = 31;
                break;

              case 28:
                return e.prev = 28, e.t0 = e.catch(19), e.abrupt("return", s.default.reject({
                  error: e.t0
                }));

              case 31:
                return e.prev = 31, _ = (0, p.default)(y), O = _.makeIdxState, e.next = 35, (0, f.default)({
                  domain: c,
                  interactionHandle: v,
                  stateHandle: d,
                  version: y
                }).catch(function (e) {
                  return s.default.reject({
                    error: "introspect call failed",
                    details: O(e, S)
                  });
                });

              case 35:
                return A = e.sent, R = O(A, S), e.abrupt("return", R);

              case 40:
                return e.prev = 40, e.t1 = e.catch(31), e.abrupt("return", s.default.reject({
                  error: e.t1
                }));

              case 43:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[19, 28], [31, 40]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
        v = (0, p.default)("1.0.0").makeIdxState,
        y = {
      start: d,
      introspect: f.default,
      interact: l.default,
      makeIdxState: v,
      client: h.HttpClient,
      LATEST_SUPPORTED_IDX_API_VERSION: "1.0.0"
    };

    t.default = y;
  }, function (e, t, n) {
    var r = n(35);

    e.exports = function (e, t, n) {
      if (r(e), void 0 === t) return e;

      switch (n) {
        case 0:
          return function () {
            return e.call(t);
          };

        case 1:
          return function (n) {
            return e.call(t, n);
          };

        case 2:
          return function (n, r) {
            return e.call(t, n, r);
          };

        case 3:
          return function (n, r, o) {
            return e.call(t, n, r, o);
          };
      }

      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
      return e;
    };
  }, function (e, t, n) {
    e.exports = n(117);
  }, function (e, t, n) {
    var r = n(83),
        o = Math.min;

    e.exports = function (e) {
      return e > 0 ? o(r(e), 9007199254740991) : 0;
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r,
        o,
        i,
        a = n(226),
        s = n(8),
        u = n(17),
        c = n(22),
        f = n(18),
        l = n(86),
        p = n(62),
        h = n(64),
        d = s.WeakMap;

    if (a) {
      var v = l.state || (l.state = new d()),
          y = v.get,
          g = v.has,
          m = v.set;
      r = function r(e, t) {
        if (g.call(v, e)) throw new TypeError("Object already initialized");
        return t.facade = e, m.call(v, e, t), t;
      }, o = function o(e) {
        return y.call(v, e) || {};
      }, i = function i(e) {
        return g.call(v, e);
      };
    } else {
      var b = p("state");
      h[b] = !0, r = function r(e, t) {
        if (f(e, b)) throw new TypeError("Object already initialized");
        return t.facade = e, c(e, b, t), t;
      }, o = function o(e) {
        return f(e, b) ? e[b] : {};
      }, i = function i(e) {
        return f(e, b);
      };
    }

    e.exports = {
      set: r,
      get: o,
      has: i,
      enforce: function enforce(e) {
        return i(e) ? o(e) : r(e, {});
      },
      getterFor: function getterFor(e) {
        return function (t) {
          var n;
          if (!u(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
          return n;
        };
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(147).charAt,
        o = n(39),
        i = n(148),
        a = o.set,
        s = o.getterFor("String Iterator");
    i(String, "String", function (e) {
      a(this, {
        type: "String Iterator",
        string: String(e),
        index: 0
      });
    }, function () {
      var e,
          t = s(this),
          n = t.string,
          o = t.index;
      return o >= n.length ? {
        value: void 0,
        done: !0
      } : (e = r(n, o), t.index += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, t, n) {
    var r = n(162),
        o = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return o.call(r(e), t);
    };
  }, function (e, t, n) {
    var r = n(265);

    function o(e, t, n, o, i, a, s) {
      try {
        var u = e[a](s),
            c = u.value;
      } catch (e) {
        return void n(e);
      }

      u.done ? t(c) : r.resolve(c).then(o, i);
    }

    e.exports = function (e) {
      return function () {
        var t = this,
            n = arguments;
        return new r(function (r, i) {
          var a = e.apply(t, n);

          function s(e) {
            o(a, r, i, s, u, "next", e);
          }

          function u(e) {
            o(a, r, i, s, u, "throw", e);
          }

          s(void 0);
        });
      };
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(13),
        o = n(59),
        i = n(28),
        a = n(21),
        s = n(61),
        u = n(18),
        c = n(122),
        f = Object.getOwnPropertyDescriptor;
    t.f = r ? f : function (e, t) {
      if (e = a(e), t = s(t, !0), c) try {
        return f(e, t);
      } catch (e) {}
      if (u(e, t)) return i(!o.f.call(e, t), e[t]);
    };
  }, function (e, t, n) {
    e.exports = n(216);
  }, function (e, t, n) {
    var r = n(131),
        o = n(89);

    e.exports = Object.keys || function (e) {
      return r(e, o);
    };
  }, function (e, t, n) {
    var r = n(15),
        o = n(133),
        i = n(37),
        a = n(34),
        s = n(48),
        u = n(135),
        c = function c(e, t) {
      this.stopped = e, this.result = t;
    };

    e.exports = function (e, t, n) {
      var f,
          l,
          p,
          h,
          d,
          v,
          y,
          g = n && n.that,
          m = !(!n || !n.AS_ENTRIES),
          b = !(!n || !n.IS_ITERATOR),
          x = !(!n || !n.INTERRUPTED),
          w = a(t, g, 1 + m + x),
          k = function k(e) {
        return f && u(f), new c(!0, e);
      },
          S = function S(e) {
        return m ? (r(e), x ? w(e[0], e[1], k) : w(e[0], e[1])) : x ? w(e, k) : w(e);
      };

      if (b) f = e;else {
        if ("function" != typeof (l = s(e))) throw TypeError("Target is not iterable");

        if (o(l)) {
          for (p = 0, h = i(e.length); h > p; p++) {
            if ((d = S(e[p])) && d instanceof c) return d;
          }

          return new c(!1);
        }

        f = l.call(e);
      }

      for (v = f.next; !(y = v.call(f)).done;) {
        try {
          d = S(y.value);
        } catch (e) {
          throw u(f), e;
        }

        if ("object" == typeof d && d && d instanceof c) return d;
      }

      return new c(!1);
    };
  }, function (e, t, n) {
    var r = n(49),
        o = n(38),
        i = n(7)("iterator");

    e.exports = function (e) {
      if (null != e) return e[i] || e["@@iterator"] || o[r(e)];
    };
  }, function (e, t, n) {
    var r = n(92),
        o = n(60),
        i = n(7)("toStringTag"),
        a = "Arguments" == o(function () {
      return arguments;
    }());
    e.exports = r ? o : function (e) {
      var t, n, r;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
        try {
          return e[t];
        } catch (e) {}
      }(t = Object(e), i)) ? n : a ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(35),
        o = function o(e) {
      var t, n;
      this.promise = new e(function (e, r) {
        if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
        t = e, n = r;
      }), this.resolve = r(t), this.reject = r(n);
    };

    e.exports.f = function (e) {
      return new o(e);
    };
  }, function (e, t, n) {
    n(94);
    var r = n(228),
        o = n(8),
        i = n(49),
        a = n(22),
        s = n(38),
        u = n(7)("toStringTag");

    for (var c in r) {
      var f = o[c],
          l = f && f.prototype;
      l && i(l) !== u && a(l, u, c), s[c] = s.Array;
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(61),
        o = n(26),
        i = n(28);

    e.exports = function (e, t, n) {
      var a = r(t);
      a in e ? o.f(e, a, i(0, n)) : e[a] = n;
    };
  }, function (e, t, n) {
    var r = n(27);
    e.exports = !r(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  }, function (e, t, n) {
    var r = n(53),
        o = n(96),
        i = n(159);
    e.exports = r ? function (e, t, n) {
      return o.f(e, t, i(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(60);

    e.exports = Array.isArray || function (e) {
      return "Array" == r(e);
    };
  }, function (e, t, n) {
    var r = n(34),
        o = n(80),
        i = n(25),
        a = n(37),
        s = n(175),
        u = [].push,
        c = function c(e) {
      var t = 1 == e,
          n = 2 == e,
          c = 3 == e,
          f = 4 == e,
          l = 6 == e,
          p = 7 == e,
          h = 5 == e || l;
      return function (d, v, y, g) {
        for (var m, b, x = i(d), w = o(x), k = r(v, y, 3), S = a(w.length), E = 0, T = g || s, _ = t ? T(d, S) : n || p ? T(d, 0) : void 0; S > E; E++) {
          if ((h || E in w) && (b = k(m = w[E], E, x), e)) if (t) _[E] = b;else if (b) switch (e) {
            case 3:
              return !0;

            case 5:
              return m;

            case 6:
              return E;

            case 2:
              u.call(_, m);
          } else switch (e) {
            case 4:
              return !1;

            case 7:
              u.call(_, m);
          }
        }

        return l ? -1 : c || f ? f : _;
      };
    };

    e.exports = {
      forEach: c(0),
      map: c(1),
      filter: c(2),
      some: c(3),
      every: c(4),
      find: c(5),
      findIndex: c(6),
      filterOut: c(7)
    };
  }, function (e, t, n) {
    e.exports = n(286);
  }, function (e, t, n) {
    var r = n(53),
        o = n(96).f,
        i = Function.prototype,
        a = i.toString,
        s = /^\s*function ([^ (]*)/;
    r && !("name" in i) && o(i, "name", {
      configurable: !0,
      get: function get() {
        try {
          return a.call(this).match(s)[1];
        } catch (e) {
          return "";
        }
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        i = o && !r.call({
      1: 2
    }, 1);
    t.f = i ? function (e) {
      var t = o(this, e);
      return !!t && t.enumerable;
    } : r;
  }, function (e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t, n) {
    var r = n(17);

    e.exports = function (e, t) {
      if (!r(e)) return e;
      var n, o;
      if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
      if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t, n) {
    var r = n(85),
        o = n(87),
        i = r("keys");

    e.exports = function (e) {
      return i[e] || (i[e] = o(e));
    };
  }, function (e, t, n) {
    var r,
        o = n(15),
        i = n(88),
        a = n(89),
        s = n(64),
        u = n(132),
        c = n(82),
        f = n(62),
        l = f("IE_PROTO"),
        p = function p() {},
        h = function h(e) {
      return "<script>" + e + "<\/script>";
    },
        _d = function d() {
      try {
        r = document.domain && new ActiveXObject("htmlfile");
      } catch (e) {}

      var e, t;
      _d = r ? function (e) {
        e.write(h("")), e.close();
        var t = e.parentWindow.Object;
        return e = null, t;
      }(r) : ((t = c("iframe")).style.display = "none", u.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(h("document.F=Object")), e.close(), e.F);

      for (var n = a.length; n--;) {
        delete _d.prototype[a[n]];
      }

      return _d();
    };

    s[l] = !0, e.exports = Object.create || function (e, t) {
      var n;
      return null !== e ? (p.prototype = o(e), n = new p(), p.prototype = null, n[l] = e) : n = _d(), void 0 === t ? n : i(n, t);
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(60),
        o = n(8);
    e.exports = "process" == r(o.process);
  }, function (e, t, n) {
    var r,
        o,
        i = n(8),
        a = n(91),
        s = i.process,
        u = s && s.versions,
        c = u && u.v8;
    c ? o = (r = c.split("."))[0] + r[1] : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return {
          error: !1,
          value: e()
        };
      } catch (e) {
        return {
          error: !0,
          value: e
        };
      }
    };
  }, function (e, t, n) {
    var r = n(160),
        o = n(70);

    e.exports = function (e) {
      return r(o(e));
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (null == e) throw TypeError("Can't call method on " + e);
      return e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(71);

    e.exports = function (e) {
      if (!r(e)) throw TypeError(String(e) + " is not an object");
      return e;
    };
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(75),
        o = n(102),
        i = n(76),
        a = n(105),
        s = n(57),
        u = n(106),
        c = n(107),
        f = n(16),
        l = n(20);
    f(t, "__esModule", {
      value: !0
    }), t.request = t.HttpClient = void 0;
    var p = l(n(36)),
        h = l(n(57)),
        d = l(n(108)),
        v = l(n(42)),
        y = l(n(116)),
        g = n(300);

    function m(e, t) {
      var n = r(e);

      if (o) {
        var s = o(e);
        t && (s = i(s).call(s, function (t) {
          return a(e, t).enumerable;
        })), n.push.apply(n, s);
      }

      return n;
    }

    function b(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n,
            r = null != arguments[t] ? arguments[t] : {};
        if (t % 2) s(n = m(Object(r), !0)).call(n, function (t) {
          (0, d.default)(e, t, r[t]);
        });else if (u) c(e, u(r));else {
          var o;
          s(o = m(Object(r))).call(o, function (t) {
            f(e, t, a(r, t));
          });
        }
      }

      return e;
    }

    var x = {
      interceptors: {
        request: new function () {
          this.handlers = [], this.use = function (e) {
            this.handlers.push({
              before: e
            });
          }, this.clear = function () {
            this.handlers = [];
          };
        }()
      }
    };
    t.HttpClient = x;

    var w = function () {
      var e = (0, v.default)(p.default.mark(function e(t, n) {
        var r, o, i, a, s, u, c, f;
        return p.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = n.method, o = void 0 === r ? "POST" : r, i = n.headers, a = void 0 === i ? {} : i, s = n.body, u = {
                  url: t,
                  method: o,
                  headers: b(b({}, (0, g.userAgentHeaders)()), a),
                  body: s
                }, x.interceptors && (0, h.default)(c = x.interceptors.request.handlers).call(c, function (e) {
                  e.before(u);
                }), f = u.url, delete u.url, e.abrupt("return", (0, y.default)(f, u));

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }();

    t.request = w;
  }, function (e, t, n) {
    e.exports = n(275);
  }, function (e, t, n) {
    e.exports = n(279);
  }, function (e, t, n) {
    var r = n(10),
        o = n(7),
        i = n(66),
        a = o("species");

    e.exports = function (e) {
      return i >= 51 || !r(function () {
        var t = [];
        return (t.constructor = {})[a] = function () {
          return {
            foo: 1
          };
        }, 1 !== t[e](Boolean).foo;
      });
    };
  }, function (e, t) {
    e.exports = function (e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    function n(t, r) {
      return e.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0, n(t, r);
    }

    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(10),
        o = n(60),
        i = "".split;
    e.exports = r(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (e) {
      return "String" == o(e) ? i.call(e, "") : Object(e);
    } : Object;
  }, function (e, t) {
    e.exports = function (e) {
      if (null == e) throw TypeError("Can't call method on " + e);
      return e;
    };
  }, function (e, t, n) {
    var r = n(8),
        o = n(17),
        i = r.document,
        a = o(i) && o(i.createElement);

    e.exports = function (e) {
      return a ? i.createElement(e) : {};
    };
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    var r = n(18),
        o = n(25),
        i = n(62),
        a = n(218),
        s = i("IE_PROTO"),
        u = Object.prototype;
    e.exports = a ? Object.getPrototypeOf : function (e) {
      return e = o(e), r(e, s) ? e[s] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? u : null;
    };
  }, function (e, t, n) {
    var r = n(30),
        o = n(86);
    (e.exports = function (e, t) {
      return o[e] || (o[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.11.0",
      mode: r ? "pure" : "global",
      copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t, n) {
    var r = n(8),
        o = n(217),
        i = r["__core-js_shared__"] || o("__core-js_shared__", {});
    e.exports = i;
  }, function (e, t) {
    var n = 0,
        r = Math.random();

    e.exports = function (e) {
      return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++n + r).toString(36);
    };
  }, function (e, t, n) {
    var r = n(13),
        o = n(26),
        i = n(15),
        a = n(46);
    e.exports = r ? Object.defineProperties : function (e, t) {
      i(e);

      for (var n, r = a(t), s = r.length, u = 0; s > u;) {
        o.f(e, n = r[u++], t[n]);
      }

      return e;
    };
  }, function (e, t) {
    e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  }, function (e, t, n) {
    var r = n(65),
        o = n(66),
        i = n(10);
    e.exports = !!Object.getOwnPropertySymbols && !i(function () {
      return !Symbol.sham && (r ? 38 === o : o > 37 && o < 41);
    });
  }, function (e, t, n) {
    var r = n(23);
    e.exports = r("navigator", "userAgent") || "";
  }, function (e, t, n) {
    var r = {};
    r[n(7)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
  }, function (e, t) {
    e.exports = function (e, t, n) {
      if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(21),
        o = n(151),
        i = n(38),
        a = n(39),
        s = n(148),
        u = a.set,
        c = a.getterFor("Array Iterator");
    e.exports = s(Array, "Array", function (e, t) {
      u(this, {
        type: "Array Iterator",
        target: r(e),
        index: 0,
        kind: t
      });
    }, function () {
      var e = c(this),
          t = e.target,
          n = e.kind,
          r = e.index++;
      return !t || r >= t.length ? (e.target = void 0, {
        value: void 0,
        done: !0
      }) : "keys" == n ? {
        value: r,
        done: !1
      } : "values" == n ? {
        value: t[r],
        done: !1
      } : {
        value: [r, t[r]],
        done: !1
      };
    }, "values"), i.Arguments = i.Array, o("keys"), o("values"), o("entries");
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    var r = n(53),
        o = n(163),
        i = n(72),
        a = n(161),
        s = Object.defineProperty;
    t.f = r ? s : function (e, t, n) {
      if (i(e), t = a(t, !0), i(n), o) try {
        return s(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var r = n(19),
        o = n(54),
        i = n(41),
        a = n(98),
        s = n(164),
        u = n(241),
        c = u.get,
        f = u.enforce,
        l = String(String).split("String");
    (e.exports = function (e, t, n, s) {
      var u,
          c = !!s && !!s.unsafe,
          p = !!s && !!s.enumerable,
          h = !!s && !!s.noTargetGet;
      "function" == typeof n && ("string" != typeof t || i(n, "name") || o(n, "name", t), (u = f(n)).source || (u.source = l.join("string" == typeof t ? t : ""))), e !== r ? (c ? !h && e[t] && (p = !0) : delete e[t], p ? e[t] = n : o(e, t, n)) : p ? e[t] = n : a(t, n);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && c(this).source || s(this);
    });
  }, function (e, t, n) {
    var r = n(19),
        o = n(54);

    e.exports = function (e, t) {
      try {
        o(r, e, t);
      } catch (n) {
        r[e] = t;
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(19),
        o = n(98),
        i = r["__core-js_shared__"] || o("__core-js_shared__", {});
    e.exports = i;
  }, function (e, t, n) {
    var r = n(244),
        o = n(99);
    (e.exports = function (e, t) {
      return o[e] || (o[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.11.0",
      mode: r ? "pure" : "global",
      copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t, n) {
    var r = n(19),
        o = n(100),
        i = n(41),
        a = n(165),
        s = n(170),
        u = n(260),
        c = o("wks"),
        f = r.Symbol,
        l = u ? f : f && f.withoutSetter || a;

    e.exports = function (e) {
      return i(c, e) && (s || "string" == typeof c[e]) || (s && i(f, e) ? c[e] = f[e] : c[e] = l("Symbol." + e)), c[e];
    };
  }, function (e, t, n) {
    e.exports = n(277);
  }, function (e, t, n) {
    var r = n(131),
        o = n(89).concat("length", "prototype");

    t.f = Object.getOwnPropertyNames || function (e) {
      return r(e, o);
    };
  }, function (e, t, n) {
    var r = n(7);
    t.f = r;
  }, function (e, t, n) {
    e.exports = n(283);
  }, function (e, t, n) {
    e.exports = n(291);
  }, function (e, t, n) {
    e.exports = n(295);
  }, function (e, t, n) {
    var r = n(298);
    e.exports = function (e, t, n) {
      return t in e ? r(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    e.exports = n(308);
  }, function (e, t, n) {
    e.exports = n(330);
  }, function (e, t, n) {
    e.exports = n(338);
  }, function (e, t, n) {
    e.exports = n(375);
  }, function (e, t, n) {
    var r = {};
    r[n(101)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(0),
        o = n(79),
        i = n(195),
        a = n(196);

    function s(t) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return e.exports = s = function s(e) {
        if (null === e || !i(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== n) {
          if (n.has(e)) return n.get(e);
          n.set(e, t);
        }

        function t() {
          return a(e, arguments, r(this).constructor);
        }

        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), o(t, e);
      }, e.exports.default = e.exports, e.exports.__esModule = !0, s(t);
    }

    e.exports = s, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    var n = "undefined" != typeof self ? self : this,
        r = function () {
      function e() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }

      return e.prototype = n, new e();
    }();

    !function (e) {
      !function (t) {
        var n = "URLSearchParams" in e,
            r = "Symbol" in e && "iterator" in Symbol,
            o = "FileReader" in e && "Blob" in e && function () {
          try {
            return new Blob(), !0;
          } catch (e) {
            return !1;
          }
        }(),
            i = "FormData" in e,
            a = "ArrayBuffer" in e;

        if (a) var s = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            u = ArrayBuffer.isView || function (e) {
          return e && s.indexOf(Object.prototype.toString.call(e)) > -1;
        };

        function c(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }

        function f(e) {
          return "string" != typeof e && (e = String(e)), e;
        }

        function l(e) {
          var t = {
            next: function next() {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return r && (t[Symbol.iterator] = function () {
            return t;
          }), t;
        }

        function p(e) {
          this.map = {}, e instanceof p ? e.forEach(function (e, t) {
            this.append(t, e);
          }, this) : Array.isArray(e) ? e.forEach(function (e) {
            this.append(e[0], e[1]);
          }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
            this.append(t, e[t]);
          }, this);
        }

        function h(e) {
          if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }

        function d(e) {
          return new Promise(function (t, n) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              n(e.error);
            };
          });
        }

        function v(e) {
          var t = new FileReader(),
              n = d(t);
          return t.readAsArrayBuffer(e), n;
        }

        function y(e) {
          if (e.slice) return e.slice(0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }

        function g() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            var t;
            this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : o && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a && o && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = y(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a && (ArrayBuffer.prototype.isPrototypeOf(e) || u(e)) ? this._bodyArrayBuffer = y(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, o && (this.blob = function () {
            var e = h(this);
            if (e) return e;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(v);
          }), this.text = function () {
            var e,
                t,
                n,
                r = h(this);
            if (r) return r;
            if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), n = d(t), t.readAsText(e), n;
            if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
              for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) {
                n[r] = String.fromCharCode(t[r]);
              }

              return n.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, i && (this.formData = function () {
            return this.text().then(x);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }

        p.prototype.append = function (e, t) {
          e = c(e), t = f(t);
          var n = this.map[e];
          this.map[e] = n ? n + ", " + t : t;
        }, p.prototype.delete = function (e) {
          delete this.map[c(e)];
        }, p.prototype.get = function (e) {
          return e = c(e), this.has(e) ? this.map[e] : null;
        }, p.prototype.has = function (e) {
          return this.map.hasOwnProperty(c(e));
        }, p.prototype.set = function (e, t) {
          this.map[c(e)] = f(t);
        }, p.prototype.forEach = function (e, t) {
          for (var n in this.map) {
            this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
          }
        }, p.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push(n);
          }), l(e);
        }, p.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), l(e);
        }, p.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push([n, t]);
          }), l(e);
        }, r && (p.prototype[Symbol.iterator] = p.prototype.entries);
        var m = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

        function b(e, t) {
          var n,
              r,
              o = (t = t || {}).body;

          if (e instanceof b) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new p(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);

          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (n = t.method || this.method || "GET", r = n.toUpperCase(), m.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");

          this._initBody(o);
        }

        function x(e) {
          var t = new FormData();
          return e.trim().split("&").forEach(function (e) {
            if (e) {
              var n = e.split("="),
                  r = n.shift().replace(/\+/g, " "),
                  o = n.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(r), decodeURIComponent(o));
            }
          }), t;
        }

        function w(e, t) {
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e);
        }

        b.prototype.clone = function () {
          return new b(this, {
            body: this._bodyInit
          });
        }, g.call(b.prototype), g.call(w.prototype), w.prototype.clone = function () {
          return new w(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new p(this.headers),
            url: this.url
          });
        }, w.error = function () {
          var e = new w(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var k = [301, 302, 303, 307, 308];
        w.redirect = function (e, t) {
          if (-1 === k.indexOf(t)) throw new RangeError("Invalid status code");
          return new w(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, t.DOMException = e.DOMException;

        try {
          new t.DOMException();
        } catch (e) {
          t.DOMException = function (e, t) {
            this.message = e, this.name = t;
            var n = Error(e);
            this.stack = n.stack;
          }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
        }

        function S(e, n) {
          return new Promise(function (r, i) {
            var a = new b(e, n);
            if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
            var s = new XMLHttpRequest();

            function u() {
              s.abort();
            }

            s.onload = function () {
              var e,
                  t,
                  n = {
                status: s.status,
                statusText: s.statusText,
                headers: (e = s.getAllResponseHeaders() || "", t = new p(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                  var n = e.split(":"),
                      r = n.shift().trim();

                  if (r) {
                    var o = n.join(":").trim();
                    t.append(r, o);
                  }
                }), t)
              };
              n.url = "responseURL" in s ? s.responseURL : n.headers.get("X-Request-URL");
              var o = "response" in s ? s.response : s.responseText;
              r(new w(o, n));
            }, s.onerror = function () {
              i(new TypeError("Network request failed"));
            }, s.ontimeout = function () {
              i(new TypeError("Network request failed"));
            }, s.onabort = function () {
              i(new t.DOMException("Aborted", "AbortError"));
            }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && o && (s.responseType = "blob"), a.headers.forEach(function (e, t) {
              s.setRequestHeader(t, e);
            }), a.signal && (a.signal.addEventListener("abort", u), s.onreadystatechange = function () {
              4 === s.readyState && a.signal.removeEventListener("abort", u);
            }), s.send(void 0 === a._bodyInit ? null : a._bodyInit);
          });
        }

        S.polyfill = !0, e.fetch || (e.fetch = S, e.Headers = p, e.Request = b, e.Response = w), t.Headers = p, t.Request = b, t.Response = w, t.fetch = S, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }({});
    }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
    var o = r;
    (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
  }, function (e, t, n) {
    var r = function (e) {
      "use strict";

      var t = Object.prototype,
          n = t.hasOwnProperty,
          r = "function" == typeof Symbol ? Symbol : {},
          o = r.iterator || "@@iterator",
          i = r.asyncIterator || "@@asyncIterator",
          a = r.toStringTag || "@@toStringTag";

      function s(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        s({}, "");
      } catch (e) {
        s = function s(e, t, n) {
          return e[t] = n;
        };
      }

      function u(e, t, n, r) {
        var o = t && t.prototype instanceof l ? t : l,
            i = Object.create(o.prototype),
            a = new S(r || []);
        return i._invoke = function (e, t, n) {
          var r = "suspendedStart";
          return function (o, i) {
            if ("executing" === r) throw new Error("Generator is already running");

            if ("completed" === r) {
              if ("throw" === o) throw i;
              return T();
            }

            for (n.method = o, n.arg = i;;) {
              var a = n.delegate;

              if (a) {
                var s = x(a, n);

                if (s) {
                  if (s === f) continue;
                  return s;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if ("suspendedStart" === r) throw r = "completed", n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = "executing";
              var u = c(e, t, n);

              if ("normal" === u.type) {
                if (r = n.done ? "completed" : "suspendedYield", u.arg === f) continue;
                return {
                  value: u.arg,
                  done: n.done
                };
              }

              "throw" === u.type && (r = "completed", n.method = "throw", n.arg = u.arg);
            }
          };
        }(e, n, a), i;
      }

      function c(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      e.wrap = u;
      var f = {};

      function l() {}

      function p() {}

      function h() {}

      var d = {};

      d[o] = function () {
        return this;
      };

      var v = Object.getPrototypeOf,
          y = v && v(v(E([])));
      y && y !== t && n.call(y, o) && (d = y);
      var g = h.prototype = l.prototype = Object.create(d);

      function m(e) {
        ["next", "throw", "return"].forEach(function (t) {
          s(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function b(e, t) {
        var r;

        this._invoke = function (o, i) {
          function a() {
            return new t(function (r, a) {
              !function r(o, i, a, s) {
                var u = c(e[o], e, i);

                if ("throw" !== u.type) {
                  var f = u.arg,
                      l = f.value;
                  return l && "object" == typeof l && n.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    r("next", e, a, s);
                  }, function (e) {
                    r("throw", e, a, s);
                  }) : t.resolve(l).then(function (e) {
                    f.value = e, a(f);
                  }, function (e) {
                    return r("throw", e, a, s);
                  });
                }

                s(u.arg);
              }(o, i, r, a);
            });
          }

          return r = r ? r.then(a, a) : a();
        };
      }

      function x(e, t) {
        var n = e.iterator[t.method];

        if (void 0 === n) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method)) return f;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return f;
        }

        var r = c(n, e.iterator, t.arg);
        if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, f;
        var o = r.arg;
        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, f) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, f);
      }

      function w(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function k(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(w, this), this.reset(!0);
      }

      function E(e) {
        if (e) {
          var t = e[o];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var r = -1,
                i = function t() {
              for (; ++r < e.length;) {
                if (n.call(e, r)) return t.value = e[r], t.done = !1, t;
              }

              return t.value = void 0, t.done = !0, t;
            };

            return i.next = i;
          }
        }

        return {
          next: T
        };
      }

      function T() {
        return {
          value: void 0,
          done: !0
        };
      }

      return p.prototype = g.constructor = h, h.constructor = p, p.displayName = s(h, a, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, h) : (e.__proto__ = h, s(e, a, "GeneratorFunction")), e.prototype = Object.create(g), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, m(b.prototype), b.prototype[i] = function () {
        return this;
      }, e.AsyncIterator = b, e.async = function (t, n, r, o, i) {
        void 0 === i && (i = Promise);
        var a = new b(u(t, n, r, o), i);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, m(g), s(g, a, "Generator"), g[o] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var n in e) {
          t.push(n);
        }

        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }

          return n.done = !0, n;
        };
      }, e.values = E, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(k), !e) for (var t in this) {
            "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function r(n, r) {
            return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
                a = i.completion;
            if ("root" === i.tryLoc) return r("end");

            if (i.tryLoc <= this.prev) {
              var s = n.call(i, "catchLoc"),
                  u = n.call(i, "finallyLoc");

              if (s && u) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              } else if (s) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, f) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), f;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), k(n), f;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];

            if (n.tryLoc === e) {
              var r = n.completion;

              if ("throw" === r.type) {
                var o = r.arg;
                k(n);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: E(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = void 0), f;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = r;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, n) {
    var r = n(119);
    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return r(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var r = n(205),
          o = n(206),
          i = n(207);

      function a() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function s(e, t) {
        if (a() < t) throw new RangeError("Invalid typed array length");
        return u.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = u.prototype : (null === e && (e = new u(t)), e.length = t), e;
      }

      function u(e, t, n) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(e, t, n);

        if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
          return l(this, e);
        }

        return c(this, e, t, n);
      }

      function c(e, t, n, r) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
          if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
          if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
          t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
          u.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = u.prototype : e = p(e, t);
          return e;
        }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
          "string" == typeof n && "" !== n || (n = "utf8");
          if (!u.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
          var r = 0 | d(t, n),
              o = (e = s(e, r)).write(t, n);
          o !== r && (e = e.slice(0, o));
          return e;
        }(e, t, n) : function (e, t) {
          if (u.isBuffer(t)) {
            var n = 0 | h(t.length);
            return 0 === (e = s(e, n)).length || t.copy(e, 0, 0, n), e;
          }

          if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? s(e, 0) : p(e, t);
            if ("Buffer" === t.type && i(t.data)) return p(e, t.data);
          }

          var r;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }

      function f(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative');
      }

      function l(e, t) {
        if (f(t), e = s(e, t < 0 ? 0 : 0 | h(t)), !u.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) {
          e[n] = 0;
        }
        return e;
      }

      function p(e, t) {
        var n = t.length < 0 ? 0 : 0 | h(t.length);
        e = s(e, n);

        for (var r = 0; r < n; r += 1) {
          e[r] = 255 & t[r];
        }

        return e;
      }

      function h(e) {
        if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | e;
      }

      function d(e, t) {
        if (u.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var n = e.length;
        if (0 === n) return 0;

        for (var r = !1;;) {
          switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;

            case "utf8":
            case "utf-8":
            case void 0:
              return F(e).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;

            case "hex":
              return n >>> 1;

            case "base64":
              return H(e).length;

            default:
              if (r) return F(e).length;
              t = ("" + t).toLowerCase(), r = !0;
          }
        }
      }

      function v(e, t, n) {
        var r = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if ((n >>>= 0) <= (t >>>= 0)) return "";

        for (e || (e = "utf8");;) {
          switch (e) {
            case "hex":
              return R(this, t, n);

            case "utf8":
            case "utf-8":
              return _(this, t, n);

            case "ascii":
              return O(this, t, n);

            case "latin1":
            case "binary":
              return A(this, t, n);

            case "base64":
              return T(this, t, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return P(this, t, n);

            default:
              if (r) throw new TypeError("Unknown encoding: " + e);
              e = (e + "").toLowerCase(), r = !0;
          }
        }
      }

      function y(e, t, n) {
        var r = e[t];
        e[t] = e[n], e[n] = r;
      }

      function g(e, t, n, r, o) {
        if (0 === e.length) return -1;

        if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = o ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
          if (o) return -1;
          n = e.length - 1;
        } else if (n < 0) {
          if (!o) return -1;
          n = 0;
        }

        if ("string" == typeof t && (t = u.from(t, r)), u.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, n, r, o);
        if ("number" == typeof t) return t &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : m(e, [t], n, r, o);
        throw new TypeError("val must be string, number or Buffer");
      }

      function m(e, t, n, r, o) {
        var i,
            a = 1,
            s = e.length,
            u = t.length;

        if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
          if (e.length < 2 || t.length < 2) return -1;
          a = 2, s /= 2, u /= 2, n /= 2;
        }

        function c(e, t) {
          return 1 === a ? e[t] : e.readUInt16BE(t * a);
        }

        if (o) {
          var f = -1;

          for (i = n; i < s; i++) {
            if (c(e, i) === c(t, -1 === f ? 0 : i - f)) {
              if (-1 === f && (f = i), i - f + 1 === u) return f * a;
            } else -1 !== f && (i -= i - f), f = -1;
          }
        } else for (n + u > s && (n = s - u), i = n; i >= 0; i--) {
          for (var l = !0, p = 0; p < u; p++) {
            if (c(e, i + p) !== c(t, p)) {
              l = !1;
              break;
            }
          }

          if (l) return i;
        }

        return -1;
      }

      function b(e, t, n, r) {
        n = Number(n) || 0;
        var o = e.length - n;
        r ? (r = Number(r)) > o && (r = o) : r = o;
        var i = t.length;
        if (i % 2 != 0) throw new TypeError("Invalid hex string");
        r > i / 2 && (r = i / 2);

        for (var a = 0; a < r; ++a) {
          var s = parseInt(t.substr(2 * a, 2), 16);
          if (isNaN(s)) return a;
          e[n + a] = s;
        }

        return a;
      }

      function x(e, t, n, r) {
        return q(F(t, e.length - n), e, n, r);
      }

      function w(e, t, n, r) {
        return q(function (e) {
          for (var t = [], n = 0; n < e.length; ++n) {
            t.push(255 & e.charCodeAt(n));
          }

          return t;
        }(t), e, n, r);
      }

      function k(e, t, n, r) {
        return w(e, t, n, r);
      }

      function S(e, t, n, r) {
        return q(H(t), e, n, r);
      }

      function E(e, t, n, r) {
        return q(function (e, t) {
          for (var n, r, o, i = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
            n = e.charCodeAt(a), r = n >> 8, o = n % 256, i.push(o), i.push(r);
          }

          return i;
        }(t, e.length - n), e, n, r);
      }

      function T(e, t, n) {
        return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
      }

      function _(e, t, n) {
        n = Math.min(e.length, n);

        for (var r = [], o = t; o < n;) {
          var i,
              a,
              s,
              u,
              c = e[o],
              f = null,
              l = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (o + l <= n) switch (l) {
            case 1:
              c < 128 && (f = c);
              break;

            case 2:
              128 == (192 & (i = e[o + 1])) && (u = (31 & c) << 6 | 63 & i) > 127 && (f = u);
              break;

            case 3:
              i = e[o + 1], a = e[o + 2], 128 == (192 & i) && 128 == (192 & a) && (u = (15 & c) << 12 | (63 & i) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (f = u);
              break;

            case 4:
              i = e[o + 1], a = e[o + 2], s = e[o + 3], 128 == (192 & i) && 128 == (192 & a) && 128 == (192 & s) && (u = (15 & c) << 18 | (63 & i) << 12 | (63 & a) << 6 | 63 & s) > 65535 && u < 1114112 && (f = u);
          }
          null === f ? (f = 65533, l = 1) : f > 65535 && (f -= 65536, r.push(f >>> 10 & 1023 | 55296), f = 56320 | 1023 & f), r.push(f), o += l;
        }

        return function (e) {
          var t = e.length;
          if (t <= 4096) return String.fromCharCode.apply(String, e);
          var n = "",
              r = 0;

          for (; r < t;) {
            n += String.fromCharCode.apply(String, e.slice(r, r += 4096));
          }

          return n;
        }(r);
      }

      t.Buffer = u, t.SlowBuffer = function (e) {
        +e != e && (e = 0);
        return u.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);
          return e.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = a(), u.poolSize = 8192, u._augment = function (e) {
        return e.__proto__ = u.prototype, e;
      }, u.from = function (e, t, n) {
        return c(null, e, t, n);
      }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
        value: null,
        configurable: !0
      })), u.alloc = function (e, t, n) {
        return function (e, t, n, r) {
          return f(t), t <= 0 ? s(e, t) : void 0 !== n ? "string" == typeof r ? s(e, t).fill(n, r) : s(e, t).fill(n) : s(e, t);
        }(null, e, t, n);
      }, u.allocUnsafe = function (e) {
        return l(null, e);
      }, u.allocUnsafeSlow = function (e) {
        return l(null, e);
      }, u.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, u.compare = function (e, t) {
        if (!u.isBuffer(e) || !u.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;

        for (var n = e.length, r = t.length, o = 0, i = Math.min(n, r); o < i; ++o) {
          if (e[o] !== t[o]) {
            n = e[o], r = t[o];
            break;
          }
        }

        return n < r ? -1 : r < n ? 1 : 0;
      }, u.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, u.concat = function (e, t) {
        if (!i(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return u.alloc(0);
        var n;
        if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) {
          t += e[n].length;
        }
        var r = u.allocUnsafe(t),
            o = 0;

        for (n = 0; n < e.length; ++n) {
          var a = e[n];
          if (!u.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(r, o), o += a.length;
        }

        return r;
      }, u.byteLength = d, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var t = 0; t < e; t += 2) {
          y(this, t, t + 1);
        }

        return this;
      }, u.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var t = 0; t < e; t += 4) {
          y(this, t, t + 3), y(this, t + 1, t + 2);
        }

        return this;
      }, u.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var t = 0; t < e; t += 8) {
          y(this, t, t + 7), y(this, t + 1, t + 6), y(this, t + 2, t + 5), y(this, t + 3, t + 4);
        }

        return this;
      }, u.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? _(this, 0, e) : v.apply(this, arguments);
      }, u.prototype.equals = function (e) {
        if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === u.compare(this, e);
      }, u.prototype.inspect = function () {
        var e = "",
            n = t.INSPECT_MAX_BYTES;
        return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
      }, u.prototype.compare = function (e, t, n, r, o) {
        if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === o && (o = this.length), t < 0 || n > e.length || r < 0 || o > this.length) throw new RangeError("out of range index");
        if (r >= o && t >= n) return 0;
        if (r >= o) return -1;
        if (t >= n) return 1;
        if (this === e) return 0;

        for (var i = (o >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), s = Math.min(i, a), c = this.slice(r, o), f = e.slice(t, n), l = 0; l < s; ++l) {
          if (c[l] !== f[l]) {
            i = c[l], a = f[l];
            break;
          }
        }

        return i < a ? -1 : a < i ? 1 : 0;
      }, u.prototype.includes = function (e, t, n) {
        return -1 !== this.indexOf(e, t, n);
      }, u.prototype.indexOf = function (e, t, n) {
        return g(this, e, t, n, !0);
      }, u.prototype.lastIndexOf = function (e, t, n) {
        return g(this, e, t, n, !1);
      }, u.prototype.write = function (e, t, n, r) {
        if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
        }
        var o = this.length - t;
        if ((void 0 === n || n > o) && (n = o), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        r || (r = "utf8");

        for (var i = !1;;) {
          switch (r) {
            case "hex":
              return b(this, e, t, n);

            case "utf8":
            case "utf-8":
              return x(this, e, t, n);

            case "ascii":
              return w(this, e, t, n);

            case "latin1":
            case "binary":
              return k(this, e, t, n);

            case "base64":
              return S(this, e, t, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return E(this, e, t, n);

            default:
              if (i) throw new TypeError("Unknown encoding: " + r);
              r = ("" + r).toLowerCase(), i = !0;
          }
        }
      }, u.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function O(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);

        for (var o = t; o < n; ++o) {
          r += String.fromCharCode(127 & e[o]);
        }

        return r;
      }

      function A(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);

        for (var o = t; o < n; ++o) {
          r += String.fromCharCode(e[o]);
        }

        return r;
      }

      function R(e, t, n) {
        var r = e.length;
        (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);

        for (var o = "", i = t; i < n; ++i) {
          o += B(e[i]);
        }

        return o;
      }

      function P(e, t, n) {
        for (var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2) {
          o += String.fromCharCode(r[i] + 256 * r[i + 1]);
        }

        return o;
      }

      function I(e, t, n) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
      }

      function C(e, t, n, r, o, i) {
        if (!u.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > o || t < i) throw new RangeError('"value" argument is out of bounds');
        if (n + r > e.length) throw new RangeError("Index out of range");
      }

      function j(e, t, n, r) {
        t < 0 && (t = 65535 + t + 1);

        for (var o = 0, i = Math.min(e.length - n, 2); o < i; ++o) {
          e[n + o] = (t & 255 << 8 * (r ? o : 1 - o)) >>> 8 * (r ? o : 1 - o);
        }
      }

      function L(e, t, n, r) {
        t < 0 && (t = 4294967295 + t + 1);

        for (var o = 0, i = Math.min(e.length - n, 4); o < i; ++o) {
          e[n + o] = t >>> 8 * (r ? o : 3 - o) & 255;
        }
      }

      function M(e, t, n, r, o, i) {
        if (n + r > e.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range");
      }

      function N(e, t, n, r, i) {
        return i || M(e, 0, n, 4), o.write(e, t, n, r, 23, 4), n + 4;
      }

      function U(e, t, n, r, i) {
        return i || M(e, 0, n, 8), o.write(e, t, n, r, 52, 8), n + 8;
      }

      u.prototype.slice = function (e, t) {
        var n,
            r = this.length;
        if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), u.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = u.prototype;else {
          var o = t - e;
          n = new u(o, void 0);

          for (var i = 0; i < o; ++i) {
            n[i] = this[i + e];
          }
        }
        return n;
      }, u.prototype.readUIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);

        for (var r = this[e], o = 1, i = 0; ++i < t && (o *= 256);) {
          r += this[e + i] * o;
        }

        return r;
      }, u.prototype.readUIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);

        for (var r = this[e + --t], o = 1; t > 0 && (o *= 256);) {
          r += this[e + --t] * o;
        }

        return r;
      }, u.prototype.readUInt8 = function (e, t) {
        return t || I(e, 1, this.length), this[e];
      }, u.prototype.readUInt16LE = function (e, t) {
        return t || I(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, u.prototype.readUInt16BE = function (e, t) {
        return t || I(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, u.prototype.readUInt32LE = function (e, t) {
        return t || I(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, u.prototype.readUInt32BE = function (e, t) {
        return t || I(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, u.prototype.readIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);

        for (var r = this[e], o = 1, i = 0; ++i < t && (o *= 256);) {
          r += this[e + i] * o;
        }

        return r >= (o *= 128) && (r -= Math.pow(2, 8 * t)), r;
      }, u.prototype.readIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || I(e, t, this.length);

        for (var r = t, o = 1, i = this[e + --r]; r > 0 && (o *= 256);) {
          i += this[e + --r] * o;
        }

        return i >= (o *= 128) && (i -= Math.pow(2, 8 * t)), i;
      }, u.prototype.readInt8 = function (e, t) {
        return t || I(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, u.prototype.readInt16LE = function (e, t) {
        t || I(e, 2, this.length);
        var n = this[e] | this[e + 1] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, u.prototype.readInt16BE = function (e, t) {
        t || I(e, 2, this.length);
        var n = this[e + 1] | this[e] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, u.prototype.readInt32LE = function (e, t) {
        return t || I(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, u.prototype.readInt32BE = function (e, t) {
        return t || I(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, u.prototype.readFloatLE = function (e, t) {
        return t || I(e, 4, this.length), o.read(this, e, !0, 23, 4);
      }, u.prototype.readFloatBE = function (e, t) {
        return t || I(e, 4, this.length), o.read(this, e, !1, 23, 4);
      }, u.prototype.readDoubleLE = function (e, t) {
        return t || I(e, 8, this.length), o.read(this, e, !0, 52, 8);
      }, u.prototype.readDoubleBE = function (e, t) {
        return t || I(e, 8, this.length), o.read(this, e, !1, 52, 8);
      }, u.prototype.writeUIntLE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || C(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var o = 1,
            i = 0;

        for (this[t] = 255 & e; ++i < n && (o *= 256);) {
          this[t + i] = e / o & 255;
        }

        return t + n;
      }, u.prototype.writeUIntBE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || C(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var o = n - 1,
            i = 1;

        for (this[t + o] = 255 & e; --o >= 0 && (i *= 256);) {
          this[t + o] = e / i & 255;
        }

        return t + n;
      }, u.prototype.writeUInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, u.prototype.writeUInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : j(this, e, t, !0), t + 2;
      }, u.prototype.writeUInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : j(this, e, t, !1), t + 2;
      }, u.prototype.writeUInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : L(this, e, t, !0), t + 4;
      }, u.prototype.writeUInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4;
      }, u.prototype.writeIntLE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var o = Math.pow(2, 8 * n - 1);
          C(this, e, t, n, o - 1, -o);
        }

        var i = 0,
            a = 1,
            s = 0;

        for (this[t] = 255 & e; ++i < n && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + i - 1] && (s = 1), this[t + i] = (e / a >> 0) - s & 255;
        }

        return t + n;
      }, u.prototype.writeIntBE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var o = Math.pow(2, 8 * n - 1);
          C(this, e, t, n, o - 1, -o);
        }

        var i = n - 1,
            a = 1,
            s = 0;

        for (this[t + i] = 255 & e; --i >= 0 && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + i + 1] && (s = 1), this[t + i] = (e / a >> 0) - s & 255;
        }

        return t + n;
      }, u.prototype.writeInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, u.prototype.writeInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : j(this, e, t, !0), t + 2;
      }, u.prototype.writeInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : j(this, e, t, !1), t + 2;
      }, u.prototype.writeInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : L(this, e, t, !0), t + 4;
      }, u.prototype.writeInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || C(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4;
      }, u.prototype.writeFloatLE = function (e, t, n) {
        return N(this, e, t, !0, n);
      }, u.prototype.writeFloatBE = function (e, t, n) {
        return N(this, e, t, !1, n);
      }, u.prototype.writeDoubleLE = function (e, t, n) {
        return U(this, e, t, !0, n);
      }, u.prototype.writeDoubleBE = function (e, t, n) {
        return U(this, e, t, !1, n);
      }, u.prototype.copy = function (e, t, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (r < 0) throw new RangeError("sourceEnd out of bounds");
        r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
        var o,
            i = r - n;
        if (this === e && n < t && t < r) for (o = i - 1; o >= 0; --o) {
          e[o + t] = this[o + n];
        } else if (i < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
          e[o + t] = this[o + n];
        } else Uint8Array.prototype.set.call(e, this.subarray(n, n + i), t);
        return i;
      }, u.prototype.fill = function (e, t, n, r) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
            var o = e.charCodeAt(0);
            o < 256 && (e = o);
          }

          if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
          if ("string" == typeof r && !u.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
        } else "number" == typeof e && (e &= 255);

        if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
        if (n <= t) return this;
        var i;
        if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (i = t; i < n; ++i) {
          this[i] = e;
        } else {
          var a = u.isBuffer(e) ? e : F(new u(e, r).toString()),
              s = a.length;

          for (i = 0; i < n - t; ++i) {
            this[i + t] = a[i % s];
          }
        }
        return this;
      };
      var D = /[^+\/0-9A-Za-z-_]/g;

      function B(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }

      function F(e, t) {
        var n;
        t = t || 1 / 0;

        for (var r = e.length, o = null, i = [], a = 0; a < r; ++a) {
          if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
            if (!o) {
              if (n > 56319) {
                (t -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              if (a + 1 === r) {
                (t -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              o = n;
              continue;
            }

            if (n < 56320) {
              (t -= 3) > -1 && i.push(239, 191, 189), o = n;
              continue;
            }

            n = 65536 + (o - 55296 << 10 | n - 56320);
          } else o && (t -= 3) > -1 && i.push(239, 191, 189);

          if (o = null, n < 128) {
            if ((t -= 1) < 0) break;
            i.push(n);
          } else if (n < 2048) {
            if ((t -= 2) < 0) break;
            i.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((t -= 3) < 0) break;
            i.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");
            if ((t -= 4) < 0) break;
            i.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }

        return i;
      }

      function H(e) {
        return r.toByteArray(function (e) {
          if ((e = function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(D, "")).length < 2) return "";

          for (; e.length % 4 != 0;) {
            e += "=";
          }

          return e;
        }(e));
      }

      function q(e, t, n, r) {
        for (var o = 0; o < r && !(o + n >= t.length || o >= e.length); ++o) {
          t[o + n] = e[o];
        }

        return o;
      }
    }).call(this, n(43));
  }, function (e, t, n) {
    n(211);

    var r = n(11).Object,
        o = e.exports = function (e, t, n) {
      return r.defineProperty(e, t, n);
    };

    r.defineProperty.sham && (o.sham = !0);
  }, function (e, t, n) {
    var r = n(13),
        o = n(10),
        i = n(82);
    e.exports = !r && !o(function () {
      return 7 != Object.defineProperty(i("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var r = n(10),
        o = /#|\.prototype\./,
        i = function i(e, t) {
      var n = s[a(e)];
      return n == c || n != u && ("function" == typeof t ? r(t) : !!t);
    },
        a = i.normalize = function (e) {
      return String(e).replace(o, ".").toLowerCase();
    },
        s = i.data = {},
        u = i.NATIVE = "N",
        c = i.POLYFILL = "P";

    e.exports = i;
  }, function (e, t, n) {
    var r = n(214),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.indexOf;
      return e === o || e instanceof Array && t === o.indexOf ? r : t;
    };
  }, function (e, t, n) {
    var r = n(21),
        o = n(37),
        i = n(126),
        a = function a(e) {
      return function (t, n, a) {
        var s,
            u = r(t),
            c = o(u.length),
            f = i(a, c);

        if (e && n != n) {
          for (; c > f;) {
            if ((s = u[f++]) != s) return !0;
          }
        } else for (; c > f; f++) {
          if ((e || f in u) && u[f] === n) return e || f || 0;
        }

        return !e && -1;
      };
    };

    e.exports = {
      includes: a(!0),
      indexOf: a(!1)
    };
  }, function (e, t, n) {
    var r = n(83),
        o = Math.max,
        i = Math.min;

    e.exports = function (e, t) {
      var n = r(e);
      return n < 0 ? o(n + t, 0) : i(n, t);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(10);

    e.exports = function (e, t) {
      var n = [][e];
      return !!n && r(function () {
        n.call(null, t || function () {
          throw 1;
        }, 1);
      });
    };
  }, function (e, t, n) {
    n(129), n(136), n(220), n(145), n(146), n(227), n(40), n(51);
    var r = n(11);
    e.exports = r.Promise;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(84),
        i = n(130),
        a = n(63),
        s = n(22),
        u = n(28),
        c = n(47),
        f = function f(e, t) {
      var n = this;
      if (!(n instanceof f)) return new f(e, t);
      i && (n = i(new Error(void 0), o(n))), void 0 !== t && s(n, "message", String(t));
      var r = [];
      return c(e, r.push, {
        that: r
      }), s(n, "errors", r), n;
    };

    f.prototype = a(Error.prototype, {
      constructor: u(5, f),
      message: u(5, ""),
      name: u(5, "AggregateError")
    }), r({
      global: !0
    }, {
      AggregateError: f
    });
  }, function (e, t, n) {
    var r = n(15),
        o = n(219);
    e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var e,
          t = !1,
          n = {};

      try {
        (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n, []), t = n instanceof Array;
      } catch (e) {}

      return function (n, i) {
        return r(n), o(i), t ? e.call(n, i) : n.__proto__ = i, n;
      };
    }() : void 0);
  }, function (e, t, n) {
    var r = n(18),
        o = n(21),
        i = n(125).indexOf,
        a = n(64);

    e.exports = function (e, t) {
      var n,
          s = o(e),
          u = 0,
          c = [];

      for (n in s) {
        !r(a, n) && r(s, n) && c.push(n);
      }

      for (; t.length > u;) {
        r(s, n = t[u++]) && (~i(c, n) || c.push(n));
      }

      return c;
    };
  }, function (e, t, n) {
    var r = n(23);
    e.exports = r("document", "documentElement");
  }, function (e, t, n) {
    var r = n(7),
        o = n(38),
        i = r("iterator"),
        a = Array.prototype;

    e.exports = function (e) {
      return void 0 !== e && (o.Array === e || a[i] === e);
    };
  }, function (e, t, n) {
    var r = n(90);
    e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  }, function (e, t, n) {
    var r = n(15);

    e.exports = function (e) {
      var t = e.return;
      if (void 0 !== t) return r(t.call(e)).value;
    };
  }, function (e, t) {}, function (e, t, n) {
    var r = n(8);
    e.exports = r.Promise;
  }, function (e, t, n) {
    var r = n(31);

    e.exports = function (e, t, n) {
      for (var o in t) {
        n && n.unsafe && e[o] ? e[o] = t[o] : r(e, o, t[o], n);
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(86),
        o = Function.toString;
    "function" != typeof r.inspectSource && (r.inspectSource = function (e) {
      return o.call(e);
    }), e.exports = r.inspectSource;
  }, function (e, t, n) {
    var r = n(7)("iterator"),
        o = !1;

    try {
      var i = 0,
          a = {
        next: function next() {
          return {
            done: !!i++
          };
        },
        return: function _return() {
          o = !0;
        }
      };
      a[r] = function () {
        return this;
      }, Array.from(a, function () {
        throw 2;
      });
    } catch (e) {}

    e.exports = function (e, t) {
      if (!t && !o) return !1;
      var n = !1;

      try {
        var i = {};
        i[r] = function () {
          return {
            next: function next() {
              return {
                done: n = !0
              };
            }
          };
        }, e(i);
      } catch (e) {}

      return n;
    };
  }, function (e, t, n) {
    var r = n(15),
        o = n(35),
        i = n(7)("species");

    e.exports = function (e, t) {
      var n,
          a = r(e).constructor;
      return void 0 === a || null == (n = r(a)[i]) ? t : o(n);
    };
  }, function (e, t, n) {
    var r,
        o,
        i,
        a = n(8),
        s = n(10),
        u = n(34),
        c = n(132),
        f = n(82),
        l = n(143),
        p = n(65),
        h = a.location,
        d = a.setImmediate,
        v = a.clearImmediate,
        y = a.process,
        g = a.MessageChannel,
        m = a.Dispatch,
        b = 0,
        x = {},
        w = function w(e) {
      if (x.hasOwnProperty(e)) {
        var t = x[e];
        delete x[e], t();
      }
    },
        k = function k(e) {
      return function () {
        w(e);
      };
    },
        S = function S(e) {
      w(e.data);
    },
        E = function E(e) {
      a.postMessage(e + "", h.protocol + "//" + h.host);
    };

    d && v || (d = function d(e) {
      for (var t = [], n = 1; arguments.length > n;) {
        t.push(arguments[n++]);
      }

      return x[++b] = function () {
        ("function" == typeof e ? e : Function(e)).apply(void 0, t);
      }, r(b), b;
    }, v = function v(e) {
      delete x[e];
    }, p ? r = function r(e) {
      y.nextTick(k(e));
    } : m && m.now ? r = function r(e) {
      m.now(k(e));
    } : g && !l ? (i = (o = new g()).port2, o.port1.onmessage = S, r = u(i.postMessage, i, 1)) : a.addEventListener && "function" == typeof postMessage && !a.importScripts && h && "file:" !== h.protocol && !s(E) ? (r = E, a.addEventListener("message", S, !1)) : r = "onreadystatechange" in f("script") ? function (e) {
      c.appendChild(f("script")).onreadystatechange = function () {
        c.removeChild(this), w(e);
      };
    } : function (e) {
      setTimeout(k(e), 0);
    }), e.exports = {
      set: d,
      clear: v
    };
  }, function (e, t, n) {
    var r = n(91);
    e.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(r);
  }, function (e, t, n) {
    var r = n(15),
        o = n(17),
        i = n(50);

    e.exports = function (e, t) {
      if (r(e), o(t) && t.constructor === e) return t;
      var n = i.f(e);
      return (0, n.resolve)(t), n.promise;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(35),
        i = n(50),
        a = n(67),
        s = n(47);
    r({
      target: "Promise",
      stat: !0
    }, {
      allSettled: function allSettled(e) {
        var t = this,
            n = i.f(t),
            r = n.resolve,
            u = n.reject,
            c = a(function () {
          var n = o(t.resolve),
              i = [],
              a = 0,
              u = 1;
          s(e, function (e) {
            var o = a++,
                s = !1;
            i.push(void 0), u++, n.call(t, e).then(function (e) {
              s || (s = !0, i[o] = {
                status: "fulfilled",
                value: e
              }, --u || r(i));
            }, function (e) {
              s || (s = !0, i[o] = {
                status: "rejected",
                reason: e
              }, --u || r(i));
            });
          }), --u || r(i);
        });
        return c.error && u(c.value), n.promise;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(35),
        i = n(23),
        a = n(50),
        s = n(67),
        u = n(47);
    r({
      target: "Promise",
      stat: !0
    }, {
      any: function any(e) {
        var t = this,
            n = a.f(t),
            r = n.resolve,
            c = n.reject,
            f = s(function () {
          var n = o(t.resolve),
              a = [],
              s = 0,
              f = 1,
              l = !1;
          u(e, function (e) {
            var o = s++,
                u = !1;
            a.push(void 0), f++, n.call(t, e).then(function (e) {
              u || l || (l = !0, r(e));
            }, function (e) {
              u || l || (u = !0, a[o] = e, --f || c(new (i("AggregateError"))(a, "No one promise resolved")));
            });
          }), --f || c(new (i("AggregateError"))(a, "No one promise resolved"));
        });
        return f.error && c(f.value), n.promise;
      }
    });
  }, function (e, t, n) {
    var r = n(83),
        o = n(81),
        i = function i(e) {
      return function (t, n) {
        var i,
            a,
            s = String(o(t)),
            u = r(n),
            c = s.length;
        return u < 0 || u >= c ? e ? "" : void 0 : (i = s.charCodeAt(u)) < 55296 || i > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? e ? s.charAt(u) : i : e ? s.slice(u, u + 2) : a - 56320 + (i - 55296 << 10) + 65536;
      };
    };

    e.exports = {
      codeAt: i(!1),
      charAt: i(!0)
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(149),
        i = n(84),
        a = n(130),
        s = n(32),
        u = n(22),
        c = n(31),
        f = n(7),
        l = n(30),
        p = n(38),
        h = n(150),
        d = h.IteratorPrototype,
        v = h.BUGGY_SAFARI_ITERATORS,
        y = f("iterator"),
        g = function g() {
      return this;
    };

    e.exports = function (e, t, n, f, h, m, b) {
      o(n, t, f);

      var x,
          w,
          k,
          S = function S(e) {
        if (e === h && A) return A;
        if (!v && e in _) return _[e];

        switch (e) {
          case "keys":
          case "values":
          case "entries":
            return function () {
              return new n(this, e);
            };
        }

        return function () {
          return new n(this);
        };
      },
          E = t + " Iterator",
          T = !1,
          _ = e.prototype,
          O = _[y] || _["@@iterator"] || h && _[h],
          A = !v && O || S(h),
          R = "Array" == t && _.entries || O;

      if (R && (x = i(R.call(new e())), d !== Object.prototype && x.next && (l || i(x) === d || (a ? a(x, d) : "function" != typeof x[y] && u(x, y, g)), s(x, E, !0, !0), l && (p[E] = g))), "values" == h && O && "values" !== O.name && (T = !0, A = function A() {
        return O.call(this);
      }), l && !b || _[y] === A || u(_, y, A), p[t] = A, h) if (w = {
        values: S("values"),
        keys: m ? A : S("keys"),
        entries: S("entries")
      }, b) for (k in w) {
        (v || T || !(k in _)) && c(_, k, w[k]);
      } else r({
        target: t,
        proto: !0,
        forced: v || T
      }, w);
      return w;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(150).IteratorPrototype,
        o = n(63),
        i = n(28),
        a = n(32),
        s = n(38),
        u = function u() {
      return this;
    };

    e.exports = function (e, t, n) {
      var c = t + " Iterator";
      return e.prototype = o(r, {
        next: i(1, n)
      }), a(e, c, !1, !0), s[c] = u, e;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i,
        a = n(10),
        s = n(84),
        u = n(22),
        c = n(18),
        f = n(7),
        l = n(30),
        p = f("iterator"),
        h = !1;
    [].keys && ("next" in (i = [].keys()) ? (o = s(s(i))) !== Object.prototype && (r = o) : h = !0);
    var d = null == r || a(function () {
      var e = {};
      return r[p].call(e) !== e;
    });
    d && (r = {}), l && !d || c(r, p) || u(r, p, function () {
      return this;
    }), e.exports = {
      IteratorPrototype: r,
      BUGGY_SAFARI_ITERATORS: h
    };
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t, n) {
    var r = n(10),
        o = n(7),
        i = n(30),
        a = o("iterator");
    e.exports = !r(function () {
      var e = new URL("b?a=1&b=2&c=3", "http://a"),
          t = e.searchParams,
          n = "";
      return e.pathname = "c%20d", t.forEach(function (e, r) {
        t.delete("b"), n += r + e;
      }), i && !e.toJSON || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[a] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== n || "x" !== new URL("http://x", void 0).host;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(25),
        i = n(234),
        a = n(133),
        s = n(37),
        u = n(52),
        c = n(48);

    e.exports = function (e) {
      var t,
          n,
          f,
          l,
          p,
          h,
          d = o(e),
          v = "function" == typeof this ? this : Array,
          y = arguments.length,
          g = y > 1 ? arguments[1] : void 0,
          m = void 0 !== g,
          b = c(d),
          x = 0;
      if (m && (g = r(g, y > 2 ? arguments[2] : void 0, 2)), null == b || v == Array && a(b)) for (n = new v(t = s(d.length)); t > x; x++) {
        h = m ? g(d[x], x) : d[x], u(n, x, h);
      } else for (p = (l = b.call(d)).next, n = new v(); !(f = p.call(l)).done; x++) {
        h = m ? i(l, g, [f.value, x], !0) : f.value, u(n, x, h);
      }
      return n.length = x, n;
    };
  }, function (e, t, n) {
    "use strict";

    n(94);

    var r = n(6),
        o = n(23),
        i = n(152),
        a = n(31),
        s = n(138),
        u = n(32),
        c = n(149),
        f = n(39),
        l = n(93),
        p = n(18),
        h = n(34),
        d = n(49),
        v = n(15),
        y = n(17),
        g = n(63),
        m = n(28),
        b = n(155),
        x = n(48),
        w = n(7),
        k = o("fetch"),
        S = o("Headers"),
        E = w("iterator"),
        T = f.set,
        _ = f.getterFor("URLSearchParams"),
        O = f.getterFor("URLSearchParamsIterator"),
        A = /\+/g,
        R = Array(4),
        P = function P(e) {
      return R[e - 1] || (R[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"));
    },
        I = function I(e) {
      try {
        return decodeURIComponent(e);
      } catch (t) {
        return e;
      }
    },
        C = function C(e) {
      var t = e.replace(A, " "),
          n = 4;

      try {
        return decodeURIComponent(t);
      } catch (e) {
        for (; n;) {
          t = t.replace(P(n--), I);
        }

        return t;
      }
    },
        j = /[!'()~]|%20/g,
        L = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+"
    },
        M = function M(e) {
      return L[e];
    },
        N = function N(e) {
      return encodeURIComponent(e).replace(j, M);
    },
        U = function U(e, t) {
      if (t) for (var n, r, o = t.split("&"), i = 0; i < o.length;) {
        (n = o[i++]).length && (r = n.split("="), e.push({
          key: C(r.shift()),
          value: C(r.join("="))
        }));
      }
    },
        D = function D(e) {
      this.entries.length = 0, U(this.entries, e);
    },
        B = function B(e, t) {
      if (e < t) throw TypeError("Not enough arguments");
    },
        F = c(function (e, t) {
      T(this, {
        type: "URLSearchParamsIterator",
        iterator: b(_(e).entries),
        kind: t
      });
    }, "Iterator", function () {
      var e = O(this),
          t = e.kind,
          n = e.iterator.next(),
          r = n.value;
      return n.done || (n.value = "keys" === t ? r.key : "values" === t ? r.value : [r.key, r.value]), n;
    }),
        H = function H() {
      l(this, H, "URLSearchParams");
      var e,
          t,
          n,
          r,
          o,
          i,
          a,
          s,
          u,
          c = arguments.length > 0 ? arguments[0] : void 0,
          f = this,
          h = [];
      if (T(f, {
        type: "URLSearchParams",
        entries: h,
        updateURL: function updateURL() {},
        updateSearchParams: D
      }), void 0 !== c) if (y(c)) {
        if ("function" == typeof (e = x(c))) for (n = (t = e.call(c)).next; !(r = n.call(t)).done;) {
          if ((a = (i = (o = b(v(r.value))).next).call(o)).done || (s = i.call(o)).done || !i.call(o).done) throw TypeError("Expected sequence with length 2");
          h.push({
            key: a.value + "",
            value: s.value + ""
          });
        } else for (u in c) {
          p(c, u) && h.push({
            key: u,
            value: c[u] + ""
          });
        }
      } else U(h, "string" == typeof c ? "?" === c.charAt(0) ? c.slice(1) : c : c + "");
    },
        q = H.prototype;

    s(q, {
      append: function append(e, t) {
        B(arguments.length, 2);

        var n = _(this);

        n.entries.push({
          key: e + "",
          value: t + ""
        }), n.updateURL();
      },
      delete: function _delete(e) {
        B(arguments.length, 1);

        for (var t = _(this), n = t.entries, r = e + "", o = 0; o < n.length;) {
          n[o].key === r ? n.splice(o, 1) : o++;
        }

        t.updateURL();
      },
      get: function get(e) {
        B(arguments.length, 1);

        for (var t = _(this).entries, n = e + "", r = 0; r < t.length; r++) {
          if (t[r].key === n) return t[r].value;
        }

        return null;
      },
      getAll: function getAll(e) {
        B(arguments.length, 1);

        for (var t = _(this).entries, n = e + "", r = [], o = 0; o < t.length; o++) {
          t[o].key === n && r.push(t[o].value);
        }

        return r;
      },
      has: function has(e) {
        B(arguments.length, 1);

        for (var t = _(this).entries, n = e + "", r = 0; r < t.length;) {
          if (t[r++].key === n) return !0;
        }

        return !1;
      },
      set: function set(e, t) {
        B(arguments.length, 1);

        for (var n, r = _(this), o = r.entries, i = !1, a = e + "", s = t + "", u = 0; u < o.length; u++) {
          (n = o[u]).key === a && (i ? o.splice(u--, 1) : (i = !0, n.value = s));
        }

        i || o.push({
          key: a,
          value: s
        }), r.updateURL();
      },
      sort: function sort() {
        var e,
            t,
            n,
            r = _(this),
            o = r.entries,
            i = o.slice();

        for (o.length = 0, n = 0; n < i.length; n++) {
          for (e = i[n], t = 0; t < n; t++) {
            if (o[t].key > e.key) {
              o.splice(t, 0, e);
              break;
            }
          }

          t === n && o.push(e);
        }

        r.updateURL();
      },
      forEach: function forEach(e) {
        for (var t, n = _(this).entries, r = h(e, arguments.length > 1 ? arguments[1] : void 0, 3), o = 0; o < n.length;) {
          r((t = n[o++]).value, t.key, this);
        }
      },
      keys: function keys() {
        return new F(this, "keys");
      },
      values: function values() {
        return new F(this, "values");
      },
      entries: function entries() {
        return new F(this, "entries");
      }
    }, {
      enumerable: !0
    }), a(q, E, q.entries), a(q, "toString", function () {
      for (var e, t = _(this).entries, n = [], r = 0; r < t.length;) {
        e = t[r++], n.push(N(e.key) + "=" + N(e.value));
      }

      return n.join("&");
    }, {
      enumerable: !0
    }), u(H, "URLSearchParams"), r({
      global: !0,
      forced: !i
    }, {
      URLSearchParams: H
    }), i || "function" != typeof k || "function" != typeof S || r({
      global: !0,
      enumerable: !0,
      forced: !0
    }, {
      fetch: function fetch(e) {
        var t,
            n,
            r,
            o = [e];
        return arguments.length > 1 && (y(t = arguments[1]) && (n = t.body, "URLSearchParams" === d(n) && ((r = t.headers ? new S(t.headers) : new S()).has("content-type") || r.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = g(t, {
          body: m(0, String(n)),
          headers: m(0, r)
        }))), o.push(t)), k.apply(this, o);
      }
    }), e.exports = {
      URLSearchParams: H,
      getState: _
    };
  }, function (e, t, n) {
    var r = n(15),
        o = n(48);

    e.exports = function (e) {
      var t = o(e);
      if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
      return r(t.call(e));
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(157),
        o = n(169);
    r({
      target: "RegExp",
      proto: !0,
      forced: /./.exec !== o
    }, {
      exec: o
    });
  }, function (e, t, n) {
    var r = n(19),
        o = n(158).f,
        i = n(54),
        a = n(97),
        s = n(98),
        u = n(245),
        c = n(254);

    e.exports = function (e, t) {
      var n,
          f,
          l,
          p,
          h,
          d = e.target,
          v = e.global,
          y = e.stat;
      if (n = v ? r : y ? r[d] || s(d, {}) : (r[d] || {}).prototype) for (f in t) {
        if (p = t[f], l = e.noTargetGet ? (h = o(n, f)) && h.value : n[f], !c(v ? f : d + (y ? "." : "#") + f, e.forced) && void 0 !== l) {
          if (typeof p == typeof l) continue;
          u(p, l);
        }

        (e.sham || l && l.sham) && i(p, "sham", !0), a(n, f, p, e);
      }
    };
  }, function (e, t, n) {
    var r = n(53),
        o = n(239),
        i = n(159),
        a = n(68),
        s = n(161),
        u = n(41),
        c = n(163),
        f = Object.getOwnPropertyDescriptor;
    t.f = r ? f : function (e, t) {
      if (e = a(e), t = s(t, !0), c) try {
        return f(e, t);
      } catch (e) {}
      if (u(e, t)) return i(!o.f.call(e, t), e[t]);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, n) {
    var r = n(27),
        o = n(69),
        i = "".split;
    e.exports = r(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (e) {
      return "String" == o(e) ? i.call(e, "") : Object(e);
    } : Object;
  }, function (e, t, n) {
    var r = n(71);

    e.exports = function (e, t) {
      if (!r(e)) return e;
      var n, o;
      if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
      if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t, n) {
    var r = n(70);

    e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t, n) {
    var r = n(53),
        o = n(27),
        i = n(240);
    e.exports = !r && !o(function () {
      return 7 != Object.defineProperty(i("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var r = n(99),
        o = Function.toString;
    "function" != typeof r.inspectSource && (r.inspectSource = function (e) {
      return o.call(e);
    }), e.exports = r.inspectSource;
  }, function (e, t) {
    var n = 0,
        r = Math.random();

    e.exports = function (e) {
      return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++n + r).toString(36);
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(247),
        o = n(19),
        i = function i(e) {
      return "function" == typeof e ? e : void 0;
    };

    e.exports = function (e, t) {
      return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
    };
  }, function (e, t, n) {
    var r = n(73),
        o = Math.min;

    e.exports = function (e) {
      return e > 0 ? o(r(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i = n(255),
        a = n(256),
        s = n(100),
        u = RegExp.prototype.exec,
        c = s("native-string-replace", String.prototype.replace),
        f = u,
        l = (r = /a/, o = /b*/g, u.call(r, "a"), u.call(o, "a"), 0 !== r.lastIndex || 0 !== o.lastIndex),
        p = a.UNSUPPORTED_Y || a.BROKEN_CARET,
        h = void 0 !== /()??/.exec("")[1];
    (l || h || p) && (f = function f(e) {
      var t,
          n,
          r,
          o,
          a = this,
          s = p && a.sticky,
          f = i.call(a),
          d = a.source,
          v = 0,
          y = e;
      return s && (-1 === (f = f.replace("y", "")).indexOf("g") && (f += "g"), y = String(e).slice(a.lastIndex), a.lastIndex > 0 && (!a.multiline || a.multiline && "\n" !== e[a.lastIndex - 1]) && (d = "(?: " + d + ")", y = " " + y, v++), n = new RegExp("^(?:" + d + ")", f)), h && (n = new RegExp("^" + d + "$(?!\\s)", f)), l && (t = a.lastIndex), r = u.call(s ? n : a, y), s ? r ? (r.input = r.input.slice(v), r[0] = r[0].slice(v), r.index = a.lastIndex, a.lastIndex += r[0].length) : a.lastIndex = 0 : l && r && (a.lastIndex = a.global ? r.index + r[0].length : t), h && r && r.length > 1 && c.call(r[0], n, function () {
        for (o = 1; o < arguments.length - 2; o++) {
          void 0 === arguments[o] && (r[o] = void 0);
        }
      }), r;
    }), e.exports = f;
  }, function (e, t, n) {
    var r = n(257),
        o = n(258),
        i = n(27);
    e.exports = !!Object.getOwnPropertySymbols && !i(function () {
      return !Symbol.sham && (r ? 38 === o : o > 37 && o < 41);
    });
  }, function (e, t, n) {
    e.exports = n(272);
  }, function (e, t, n) {
    n(276);
    var r = n(11);
    e.exports = r.Object.keys;
  }, function (e, t, n) {
    n(174);
    var r = n(11);
    e.exports = r.Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(8),
        i = n(23),
        a = n(30),
        s = n(13),
        u = n(90),
        c = n(134),
        f = n(10),
        l = n(18),
        p = n(55),
        h = n(17),
        d = n(15),
        v = n(25),
        y = n(21),
        g = n(61),
        m = n(28),
        b = n(63),
        x = n(46),
        w = n(103),
        k = n(278),
        S = n(95),
        E = n(44),
        T = n(26),
        _ = n(59),
        O = n(22),
        A = n(31),
        R = n(85),
        P = n(62),
        I = n(64),
        C = n(87),
        j = n(7),
        L = n(104),
        M = n(9),
        N = n(32),
        U = n(39),
        D = n(56).forEach,
        B = P("hidden"),
        F = j("toPrimitive"),
        H = U.set,
        q = U.getterFor("Symbol"),
        $ = Object.prototype,
        _z = o.Symbol,
        K = i("JSON", "stringify"),
        G = E.f,
        V = T.f,
        Y = k.f,
        W = _.f,
        J = R("symbols"),
        X = R("op-symbols"),
        Q = R("string-to-symbol-registry"),
        Z = R("symbol-to-string-registry"),
        ee = R("wks"),
        te = o.QObject,
        ne = !te || !te.prototype || !te.prototype.findChild,
        re = s && f(function () {
      return 7 != b(V({}, "a", {
        get: function get() {
          return V(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (e, t, n) {
      var r = G($, t);
      r && delete $[t], V(e, t, n), r && e !== $ && V($, t, r);
    } : V,
        oe = function oe(e, t) {
      var n = J[e] = b(_z.prototype);
      return H(n, {
        type: "Symbol",
        tag: e,
        description: t
      }), s || (n.description = t), n;
    },
        ie = c ? function (e) {
      return "symbol" == typeof e;
    } : function (e) {
      return Object(e) instanceof _z;
    },
        ae = function ae(e, t, n) {
      e === $ && ae(X, t, n), d(e);
      var r = g(t, !0);
      return d(n), l(J, r) ? (n.enumerable ? (l(e, B) && e[B][r] && (e[B][r] = !1), n = b(n, {
        enumerable: m(0, !1)
      })) : (l(e, B) || V(e, B, m(1, {})), e[B][r] = !0), re(e, r, n)) : V(e, r, n);
    },
        se = function se(e, t) {
      d(e);
      var n = y(t),
          r = x(n).concat(le(n));
      return D(r, function (t) {
        s && !ue.call(n, t) || ae(e, t, n[t]);
      }), e;
    },
        ue = function ue(e) {
      var t = g(e, !0),
          n = W.call(this, t);
      return !(this === $ && l(J, t) && !l(X, t)) && (!(n || !l(this, t) || !l(J, t) || l(this, B) && this[B][t]) || n);
    },
        ce = function ce(e, t) {
      var n = y(e),
          r = g(t, !0);

      if (n !== $ || !l(J, r) || l(X, r)) {
        var o = G(n, r);
        return !o || !l(J, r) || l(n, B) && n[B][r] || (o.enumerable = !0), o;
      }
    },
        fe = function fe(e) {
      var t = Y(y(e)),
          n = [];
      return D(t, function (e) {
        l(J, e) || l(I, e) || n.push(e);
      }), n;
    },
        le = function le(e) {
      var t = e === $,
          n = Y(t ? X : y(e)),
          r = [];
      return D(n, function (e) {
        !l(J, e) || t && !l($, e) || r.push(J[e]);
      }), r;
    };

    (u || (A((_z = function z() {
      if (this instanceof _z) throw TypeError("Symbol is not a constructor");

      var e = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
          t = C(e),
          n = function n(e) {
        this === $ && n.call(X, e), l(this, B) && l(this[B], t) && (this[B][t] = !1), re(this, t, m(1, e));
      };

      return s && ne && re($, t, {
        configurable: !0,
        set: n
      }), oe(t, e);
    }).prototype, "toString", function () {
      return q(this).tag;
    }), A(_z, "withoutSetter", function (e) {
      return oe(C(e), e);
    }), _.f = ue, T.f = ae, E.f = ce, w.f = k.f = fe, S.f = le, L.f = function (e) {
      return oe(j(e), e);
    }, s && (V(_z.prototype, "description", {
      configurable: !0,
      get: function get() {
        return q(this).description;
      }
    }), a || A($, "propertyIsEnumerable", ue, {
      unsafe: !0
    }))), r({
      global: !0,
      wrap: !0,
      forced: !u,
      sham: !u
    }, {
      Symbol: _z
    }), D(x(ee), function (e) {
      M(e);
    }), r({
      target: "Symbol",
      stat: !0,
      forced: !u
    }, {
      for: function _for(e) {
        var t = String(e);
        if (l(Q, t)) return Q[t];

        var n = _z(t);

        return Q[t] = n, Z[n] = t, n;
      },
      keyFor: function keyFor(e) {
        if (!ie(e)) throw TypeError(e + " is not a symbol");
        if (l(Z, e)) return Z[e];
      },
      useSetter: function useSetter() {
        ne = !0;
      },
      useSimple: function useSimple() {
        ne = !1;
      }
    }), r({
      target: "Object",
      stat: !0,
      forced: !u,
      sham: !s
    }, {
      create: function create(e, t) {
        return void 0 === t ? b(e) : se(b(e), t);
      },
      defineProperty: ae,
      defineProperties: se,
      getOwnPropertyDescriptor: ce
    }), r({
      target: "Object",
      stat: !0,
      forced: !u
    }, {
      getOwnPropertyNames: fe,
      getOwnPropertySymbols: le
    }), r({
      target: "Object",
      stat: !0,
      forced: f(function () {
        S.f(1);
      })
    }, {
      getOwnPropertySymbols: function getOwnPropertySymbols(e) {
        return S.f(v(e));
      }
    }), K) && r({
      target: "JSON",
      stat: !0,
      forced: !u || f(function () {
        var e = _z();

        return "[null]" != K([e]) || "{}" != K({
          a: e
        }) || "{}" != K(Object(e));
      })
    }, {
      stringify: function stringify(e, t, n) {
        for (var r, o = [e], i = 1; arguments.length > i;) {
          o.push(arguments[i++]);
        }

        if (r = t, (h(t) || void 0 !== e) && !ie(e)) return p(t) || (t = function t(e, _t3) {
          if ("function" == typeof r && (_t3 = r.call(this, e, _t3)), !ie(_t3)) return _t3;
        }), o[1] = t, K.apply(null, o);
      }
    });
    _z.prototype[F] || O(_z.prototype, F, _z.prototype.valueOf), N(_z, "Symbol"), I[B] = !0;
  }, function (e, t, n) {
    var r = n(17),
        o = n(55),
        i = n(7)("species");

    e.exports = function (e, t) {
      var n;
      return o(e) && ("function" != typeof (n = e.constructor) || n !== Array && !o(n.prototype) ? r(n) && null === (n = n[i]) && (n = void 0) : n = void 0), new (void 0 === n ? Array : n)(0 === t ? 0 : t);
    };
  }, function (e, t, n) {
    var r = n(304),
        o = n(307),
        i = n(182),
        a = n(337);
    e.exports = function (e, t) {
      return r(e) || o(e, t) || i(e, t) || a();
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    e.exports = n(305);
  }, function (e, t, n) {
    n(306);
    var r = n(11);
    e.exports = r.Array.isArray;
  }, function (e, t, n) {
    n(180), n(136), n(174), n(309), n(310), n(311), n(312), n(181), n(313), n(314), n(315), n(316), n(317), n(318), n(319), n(320), n(321), n(322), n(323), n(324);
    var r = n(11);
    e.exports = r.Symbol;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(10),
        i = n(55),
        a = n(17),
        s = n(25),
        u = n(37),
        c = n(52),
        f = n(175),
        l = n(77),
        p = n(7),
        h = n(66),
        d = p("isConcatSpreadable"),
        v = h >= 51 || !o(function () {
      var e = [];
      return e[d] = !1, e.concat()[0] !== e;
    }),
        y = l("concat"),
        g = function g(e) {
      if (!a(e)) return !1;
      var t = e[d];
      return void 0 !== t ? !!t : i(e);
    };

    r({
      target: "Array",
      proto: !0,
      forced: !v || !y
    }, {
      concat: function concat(e) {
        var t,
            n,
            r,
            o,
            i,
            a = s(this),
            l = f(a, 0),
            p = 0;

        for (t = -1, r = arguments.length; t < r; t++) {
          if (g(i = -1 === t ? a : arguments[t])) {
            if (p + (o = u(i.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");

            for (n = 0; n < o; n++, p++) {
              n in i && c(l, p, i[n]);
            }
          } else {
            if (p >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
            c(l, p++, i);
          }
        }

        return l.length = p, l;
      }
    });
  }, function (e, t, n) {
    n(9)("iterator");
  }, function (e, t, n) {
    var r = n(331),
        o = n(184),
        i = n(186);
    e.exports = function (e, t) {
      var n;

      if (e) {
        if ("string" == typeof e) return i(e, t);
        var a = r(n = Object.prototype.toString.call(e)).call(n, 8, -1);
        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? o(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? i(e, t) : void 0;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(333),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.slice;
      return e === o || e instanceof Array && t === o.slice ? r : t;
    };
  }, function (e, t, n) {
    e.exports = n(335);
  }, function (e, t, n) {
    n(40), n(336);
    var r = n(11);
    e.exports = r.Array.from;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    e.exports = n(342);
  }, function (e, t, n) {
    e.exports = n(346);
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(20);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(36));
    n(58);

    var a = o(n(351)),
        s = o(n(45)),
        u = o(n(42)),
        c = o(n(356)),
        f = n(360),
        l = function l(e, t) {
      var n,
          r,
          o = e,
          l = (0, f.parseIdxResponse)(e, t),
          p = l.remediations,
          h = l.context,
          d = l.actions,
          v = (0, c.default)(p),
          y = function () {
        var e = (0, u.default)(i.default.mark(function e(t) {
          var n,
              r,
              o = arguments;
          return i.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, a.default)(p).call(p, function (e) {
                    return e.name === t;
                  })) {
                    e.next = 4;
                    break;
                  }

                  return e.abrupt("return", s.default.reject("Unknown remediation choice: [".concat(t, "]")));

                case 4:
                  return e.abrupt("return", r.action(n));

                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }(),
          g = null === (n = o.successWithInteractionCode) || void 0 === n ? void 0 : (0, a.default)(r = n.value).call(r, function (e) {
        return "interaction_code" === e.name;
      }).value;

      return {
        proceed: y,
        neededToProceed: v,
        actions: d,
        context: h,
        rawIdxState: o,
        hasInteractionCode: function hasInteractionCode() {
          return !!o.successWithInteractionCode;
        },
        interactionCode: g,
        toPersist: t
      };
    };

    t.default = l;
  }, function (e, t, n) {
    e.exports = n(364);
  }, function (e, t, n) {
    e.exports = n(372);
  }, function (e, t, n) {
    "use strict";

    var r = n(75),
        o = n(102),
        i = n(76),
        a = n(105),
        s = n(57),
        u = n(106),
        c = n(107),
        f = n(16),
        l = n(20);
    f(t, "__esModule", {
      value: !0
    }), t.default = void 0, n(58);
    var p = l(n(36)),
        h = l(n(171)),
        d = l(n(45)),
        v = l(n(108)),
        y = l(n(42)),
        g = n(74),
        m = n(377),
        b = l(n(189));

    function x(e, t) {
      var n = r(e);

      if (o) {
        var s = o(e);
        t && (s = i(s).call(s, function (t) {
          return a(e, t).enumerable;
        })), n.push.apply(n, s);
      }

      return n;
    }

    function w(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n,
            r = null != arguments[t] ? arguments[t] : {};
        if (t % 2) s(n = x(Object(r), !0)).call(n, function (t) {
          (0, v.default)(e, t, r[t]);
        });else if (u) c(e, u(r));else {
          var o;
          s(o = x(Object(r))).call(o, function (t) {
            f(e, t, a(r, t));
          });
        }
      }

      return e;
    }

    var k = function k(e) {
      var t = e.actionDefinition,
          n = e.defaultParamsForAction,
          r = void 0 === n ? {} : n,
          o = e.immutableParamsForAction,
          i = void 0 === o ? {} : o,
          a = e.toPersist,
          s = t.href;
      return function () {
        var e = (0, y.default)(p.default.mark(function e(n) {
          var o, u;
          return p.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return o = {
                    "content-type": "application/json",
                    accept: t.accepts || "application/ion+json"
                  }, u = (0, h.default)(w(w(w({}, r), n), i)), e.abrupt("return", (0, g.request)(s, {
                    method: t.method,
                    headers: o,
                    body: u
                  }).then(function (e) {
                    var t = e.json();
                    return e.ok ? t : 401 === e.status && 'Oktadevicejwt realm="Okta Device"' === e.headers.get("WWW-Authenticate") ? t.then(function (e) {
                      return d.default.reject((0, b.default)(e, a));
                    }) : t.then(function (e) {
                      return d.default.reject(e);
                    });
                  }).then(function (e) {
                    return (0, b.default)(e, a);
                  }));

                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }();
    },
        S = function S(e, t) {
      var n = k,
          r = (0, m.divideActionParamsByMutability)(e),
          o = r.defaultParams,
          i = r.neededParams,
          a = r.immutableParams,
          s = n({
        actionDefinition: e,
        defaultParamsForAction: o[e.name],
        immutableParamsForAction: a[e.name],
        toPersist: t
      });
      return s.neededParams = i, s;
    };

    t.default = S;
  }, function (e, t, n) {
    var r = n(198),
        o = n(199),
        i = n(118),
        a = n(200);
    e.exports = function (e, t) {
      return r(e) || o(e, t) || i(e, t) || a();
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(24),
          o = n.n(r),
          i = n(116),
          a = n.n(i);

      t.a = function (t, n, r) {
        var i = r.data,
            s = r.headers || {};
        "application/json" === (s["Content-Type"] || s["content-type"] || "") && i && "string" != typeof i && (i = JSON.stringify(i));
        var u = (e.fetch || a.a)(n, {
          method: t,
          headers: r.headers,
          body: i,
          credentials: r.withCredentials ? "include" : "omit"
        });
        return u.finally || (u = Promise.resolve(u)), u.then(function (e) {
          var t = !e.ok,
              n = e.status;
          /*!
           * Copyright (c) 2018-present, Okta, Inc. and/or its affiliates. All rights reserved.
           * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
           *
           * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
           * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           *
           * See the License for the specific language governing permissions and limitations under the License.
           */

          return function (e) {
            return e.headers.get("Content-Type") && e.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e.json().catch(function (e) {
              return {
                error: e,
                errorSummary: "Could not parse server response"
              };
            }) : e.text();
          }(e).then(function (e) {
            return function (e, t) {
              var n = "object" === o()(t),
                  r = {
                responseText: n ? JSON.stringify(t) : t,
                status: e
              };
              return n && (r.responseType = "json", r.responseJSON = t), r;
            }(n, e);
          }).then(function (e) {
            if (t) throw e;
            return e;
          });
        });
      };
    }).call(this, n(43));
  }, function (e, t) {
    e.exports = function (e) {
      return -1 !== Function.toString.call(e).indexOf("[native code]");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(79),
        o = n(197);

    function i(t, n, a) {
      return o() ? (e.exports = i = Reflect.construct, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = i = function i(e, t, n) {
        var o = [null];
        o.push.apply(o, t);
        var i = new (Function.bind.apply(e, o))();
        return n && r(i, n.prototype), i;
      }, e.exports.default = e.exports, e.exports.__esModule = !0), i.apply(null, arguments);
    }

    e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e, t) {
      var n = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);

      if (null != n) {
        var r,
            o,
            i = [],
            a = !0,
            s = !1;

        try {
          for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0) {
            ;
          }
        } catch (e) {
          s = !0, o = e;
        } finally {
          try {
            a || null == n.return || n.return();
          } finally {
            if (s) throw o;
          }
        }

        return i;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r, o;
    /*!
     * JavaScript Cookie v2.2.1
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */

    !function (i) {
      if (void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o), !0, e.exports = i(), !!0) {
        var a = window.Cookies,
            s = window.Cookies = i();

        s.noConflict = function () {
          return window.Cookies = a, s;
        };
      }
    }(function () {
      function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            t[r] = n[r];
          }
        }

        return t;
      }

      function t(e) {
        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }

      return function n(r) {
        function o() {}

        function i(t, n, i) {
          if ("undefined" != typeof document) {
            "number" == typeof (i = e({
              path: "/"
            }, o.defaults, i)).expires && (i.expires = new Date(1 * new Date() + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";

            try {
              var a = JSON.stringify(n);
              /^[\{\[]/.test(a) && (n = a);
            } catch (e) {}

            n = r.write ? r.write(n, t) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var s = "";

            for (var u in i) {
              i[u] && (s += "; " + u, !0 !== i[u] && (s += "=" + i[u].split(";")[0]));
            }

            return document.cookie = t + "=" + n + s;
          }
        }

        function a(e, n) {
          if ("undefined" != typeof document) {
            for (var o = {}, i = document.cookie ? document.cookie.split("; ") : [], a = 0; a < i.length; a++) {
              var s = i[a].split("="),
                  u = s.slice(1).join("=");
              n || '"' !== u.charAt(0) || (u = u.slice(1, -1));

              try {
                var c = t(s[0]);
                if (u = (r.read || r)(u, c) || t(u), n) try {
                  u = JSON.parse(u);
                } catch (e) {}
                if (o[c] = u, e === c) break;
              } catch (e) {}
            }

            return e ? o[e] : o;
          }
        }

        return o.set = i, o.get = function (e) {
          return a(e, !1);
        }, o.getJSON = function (e) {
          return a(e, !0);
        }, o.remove = function (t, n) {
          i(t, "", e(n, {
            expires: -1
          }));
        }, o.defaults = {}, o.withConverter = n, o;
      }(function () {});
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(1),
        o = n(3),
        i = n(4),
        a = n(5),
        s = n(0);

    function u(e, t) {
      var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (!_n2) {
        if (Array.isArray(e) || (_n2 = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return c(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n2 && (e = _n2);

          var r = 0,
              o = function o() {};

          return {
            s: o,
            n: function n() {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            },
            e: function e(_e2) {
              throw _e2;
            },
            f: o
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var i,
          a = !0,
          s = !1;
      return {
        s: function s() {
          _n2 = _n2.call(e);
        },
        n: function n() {
          var e = _n2.next();

          return a = e.done, e;
        },
        e: function e(_e3) {
          s = !0, i = _e3;
        },
        f: function f() {
          try {
            a || null == _n2.return || _n2.return();
          } finally {
            if (s) throw i;
          }
        }
      };
    }

    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function f(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = s(e);

        if (t) {
          var o = s(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return a(this, n);
      };
    }

    var l = function (e) {
      i(n, e);
      var t = f(n);

      function n(e) {
        var o;
        return r(this, n), (o = t.call(this, e || "Promise was canceled")).name = "CancelError", o;
      }

      return o(n, [{
        key: "isCanceled",
        get: function get() {
          return !0;
        }
      }]), n;
    }(n(115)(Error)),
        p = function () {
      function e(t) {
        var n = this;
        r(this, e), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function (e, r) {
          n._reject = r;

          var o = function o(e) {
            if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");

            n._cancelHandlers.push(e);
          };

          return Object.defineProperties(o, {
            shouldReject: {
              get: function get() {
                return n._rejectOnCancel;
              },
              set: function set(e) {
                n._rejectOnCancel = e;
              }
            }
          }), t(function (t) {
            n._isCanceled && o.shouldReject || (n._isPending = !1, e(t));
          }, function (e) {
            n._isPending = !1, r(e);
          }, o);
        });
      }

      return o(e, [{
        key: "then",
        value: function value(e, t) {
          return this._promise.then(e, t);
        }
      }, {
        key: "catch",
        value: function value(e) {
          return this._promise.catch(e);
        }
      }, {
        key: "finally",
        value: function value(e) {
          return this._promise.finally(e);
        }
      }, {
        key: "cancel",
        value: function value(e) {
          if (this._isPending && !this._isCanceled) {
            if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
              var t,
                  n = u(this._cancelHandlers);

              try {
                for (n.s(); !(t = n.n()).done;) {
                  (0, t.value)();
                }
              } catch (e) {
                n.e(e);
              } finally {
                n.f();
              }
            } catch (e) {
              return void this._reject(e);
            }
            this._rejectOnCancel && this._reject(new l(e));
          }
        }
      }, {
        key: "isCanceled",
        get: function get() {
          return this._isCanceled;
        }
      }], [{
        key: "fn",
        value: function value(t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }

            return new e(function (e, n, o) {
              r.push(o), t.apply(void 0, r).then(e, n);
            });
          };
        }
      }]), e;
    }();

    Object.setPrototypeOf(p.prototype, Promise.prototype), e.exports = p, e.exports.CancelError = l;
  }, function (e, t, n) {
    (function () {
      (e.exports = n(204)).version = "5.1.2";
    }).call(this);
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var r,
            o,
            i = [].splice,
            a = function a(e, t) {
          if (!(e instanceof t)) throw new Error("Bound instance method accessed before binding");
        },
            s = [].indexOf;

        o = n(208), r = n(209).EventEmitter, e.exports = function () {
          var e =
          /*#__PURE__*/
          function (_r2) {
            "use strict";

            _inherits(e, _r2);

            function e() {
              var _this;

              var _e4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

              _classCallCheck(this, e);

              _this = _possibleConstructorReturn(this, _getPrototypeOf(e).call(this)), _this.get = _this.get.bind(_assertThisInitialized(_this)), _this.mget = _this.mget.bind(_assertThisInitialized(_this)), _this.set = _this.set.bind(_assertThisInitialized(_this)), _this.mset = _this.mset.bind(_assertThisInitialized(_this)), _this.del = _this.del.bind(_assertThisInitialized(_this)), _this.take = _this.take.bind(_assertThisInitialized(_this)), _this.ttl = _this.ttl.bind(_assertThisInitialized(_this)), _this.getTtl = _this.getTtl.bind(_assertThisInitialized(_this)), _this.keys = _this.keys.bind(_assertThisInitialized(_this)), _this.has = _this.has.bind(_assertThisInitialized(_this)), _this.getStats = _this.getStats.bind(_assertThisInitialized(_this)), _this.flushAll = _this.flushAll.bind(_assertThisInitialized(_this)), _this.flushStats = _this.flushStats.bind(_assertThisInitialized(_this)), _this.close = _this.close.bind(_assertThisInitialized(_this)), _this._checkData = _this._checkData.bind(_assertThisInitialized(_this)), _this._check = _this._check.bind(_assertThisInitialized(_this)), _this._isInvalidKey = _this._isInvalidKey.bind(_assertThisInitialized(_this)), _this._wrap = _this._wrap.bind(_assertThisInitialized(_this)), _this._getValLength = _this._getValLength.bind(_assertThisInitialized(_this)), _this._error = _this._error.bind(_assertThisInitialized(_this)), _this._initErrors = _this._initErrors.bind(_assertThisInitialized(_this)), _this.options = _e4, _this._initErrors(), _this.data = {}, _this.options = Object.assign({
                forceString: !1,
                objectValueSize: 80,
                promiseValueSize: 80,
                arrayValueSize: 40,
                stdTTL: 0,
                checkperiod: 600,
                useClones: !0,
                deleteOnExpire: !0,
                enableLegacyCallbacks: !1,
                maxKeys: -1
              }, _this.options), _this.options.enableLegacyCallbacks && (console.warn("WARNING! node-cache legacy callback support will drop in v6.x"), ["get", "mget", "set", "del", "ttl", "getTtl", "keys", "has"].forEach(function (e) {
                var t;
                t = _this[e], _this[e] = function () {
                  var _r3, _r4, _i$call, _i$call2;

                  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
                    e[_key] = arguments[_key];
                  }

                  var n, r;
                  if (r = e, (_r3 = r, _r4 = _toArray(_r3), e = _r4.slice(0), _r3), (_i$call = i.call(e, -1), _i$call2 = _slicedToArray(_i$call, 1), n = _i$call2[0], _i$call), "function" != typeof n) return t.apply(void 0, _toConsumableArray(e).concat([n]));

                  try {
                    n(null, t.apply(void 0, _toConsumableArray(e)));
                  } catch (e) {
                    n(e);
                  }
                };
              })), _this.stats = {
                hits: 0,
                misses: 0,
                keys: 0,
                ksize: 0,
                vsize: 0
              }, _this.validKeyTypes = ["string", "number"], _this._checkData();
              return _this;
            }

            _createClass(e, [{
              key: "get",
              value: function get(t) {
                var n;
                if (a(this, e), null != (n = this._isInvalidKey(t))) throw n;
                return null != this.data[t] && this._check(t, this.data[t]) ? (this.stats.hits++, this._unwrap(this.data[t])) : void this.stats.misses++;
              }
            }, {
              key: "mget",
              value: function mget(t) {
                var n, r, o, i, s;
                if (a(this, e), !Array.isArray(t)) throw this._error("EKEYSTYPE");

                for (s = {}, r = 0, i = t.length; r < i; r++) {
                  if (o = t[r], null != (n = this._isInvalidKey(o))) throw n;
                  null != this.data[o] && this._check(o, this.data[o]) ? (this.stats.hits++, s[o] = this._unwrap(this.data[o])) : this.stats.misses++;
                }

                return s;
              }
            }, {
              key: "set",
              value: function set(t, n, r) {
                var o, i;
                if (a(this, e), this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) throw this._error("ECACHEFULL");
                if (this.options.forceString, null == r && (r = this.options.stdTTL), null != (o = this._isInvalidKey(t))) throw o;
                return i = !1, this.data[t] && (i = !0, this.stats.vsize -= this._getValLength(this._unwrap(this.data[t], !1))), this.data[t] = this._wrap(n, r), this.stats.vsize += this._getValLength(n), i || (this.stats.ksize += this._getKeyLength(t), this.stats.keys++), this.emit("set", t, n), !0;
              }
            }, {
              key: "mset",
              value: function mset(t) {
                var n, r, o, i, s, u, c, f, l;
                if (a(this, e), this.options.maxKeys > -1 && this.stats.keys + t.length >= this.options.maxKeys) throw this._error("ECACHEFULL");

                for (r = 0, u = t.length; r < u; r++) {
                  var _s;

                  if (s = t[r], (_s = s, i = _s.key, l = _s.val, f = _s.ttl, _s), f && "number" != typeof f) throw this._error("ETTLTYPE");
                  if (null != (n = this._isInvalidKey(i))) throw n;
                }

                for (o = 0, c = t.length; o < c; o++) {
                  var _s2;

                  s = t[o], (_s2 = s, i = _s2.key, l = _s2.val, f = _s2.ttl, _s2), this.set(i, l, f);
                }

                return !0;
              }
            }, {
              key: "del",
              value: function del(t) {
                var n, r, o, i, s, u;

                for (a(this, e), Array.isArray(t) || (t = [t]), n = 0, o = 0, s = t.length; o < s; o++) {
                  if (i = t[o], null != (r = this._isInvalidKey(i))) throw r;
                  null != this.data[i] && (this.stats.vsize -= this._getValLength(this._unwrap(this.data[i], !1)), this.stats.ksize -= this._getKeyLength(i), this.stats.keys--, n++, u = this.data[i], delete this.data[i], this.emit("del", i, u.v));
                }

                return n;
              }
            }, {
              key: "take",
              value: function take(t) {
                var n;
                return a(this, e), null != (n = this.get(t)) && this.del(t), n;
              }
            }, {
              key: "ttl",
              value: function ttl(t, n) {
                var r;
                if (a(this, e), n || (n = this.options.stdTTL), !t) return !1;
                if (null != (r = this._isInvalidKey(t))) throw r;
                return !(null == this.data[t] || !this._check(t, this.data[t])) && (n >= 0 ? this.data[t] = this._wrap(this.data[t].v, n, !1) : this.del(t), !0);
              }
            }, {
              key: "getTtl",
              value: function getTtl(t) {
                var n;

                if (a(this, e), t) {
                  if (null != (n = this._isInvalidKey(t))) throw n;
                  return null != this.data[t] && this._check(t, this.data[t]) ? this.data[t].t : void 0;
                }
              }
            }, {
              key: "keys",
              value: function keys() {
                return a(this, e), Object.keys(this.data);
              }
            }, {
              key: "has",
              value: function has(t) {
                return a(this, e), null != this.data[t] && this._check(t, this.data[t]);
              }
            }, {
              key: "getStats",
              value: function getStats() {
                return a(this, e), this.stats;
              }
            }, {
              key: "flushAll",
              value: function flushAll() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                a(this, e), this.data = {}, this.stats = {
                  hits: 0,
                  misses: 0,
                  keys: 0,
                  ksize: 0,
                  vsize: 0
                }, this._killCheckPeriod(), this._checkData(t), this.emit("flush");
              }
            }, {
              key: "flushStats",
              value: function flushStats() {
                a(this, e), this.stats = {
                  hits: 0,
                  misses: 0,
                  keys: 0,
                  ksize: 0,
                  vsize: 0
                }, this.emit("flush_stats");
              }
            }, {
              key: "close",
              value: function close() {
                a(this, e), this._killCheckPeriod();
              }
            }, {
              key: "_checkData",
              value: function _checkData() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                var n, r, o;

                for (n in a(this, e), r = this.data) {
                  o = r[n], this._check(n, o);
                }

                t && this.options.checkperiod > 0 && (this.checkTimeout = setTimeout(this._checkData, 1e3 * this.options.checkperiod, t), null != this.checkTimeout && null != this.checkTimeout.unref && this.checkTimeout.unref());
              }
            }, {
              key: "_killCheckPeriod",
              value: function _killCheckPeriod() {
                if (null != this.checkTimeout) return clearTimeout(this.checkTimeout);
              }
            }, {
              key: "_check",
              value: function _check(t, n) {
                var r;
                return a(this, e), r = !0, 0 !== n.t && n.t < Date.now() && (this.options.deleteOnExpire && (r = !1, this.del(t)), this.emit("expired", t, this._unwrap(n))), r;
              }
            }, {
              key: "_isInvalidKey",
              value: function _isInvalidKey(t) {
                var n;
                if (a(this, e), n = typeof t, s.call(this.validKeyTypes, n) < 0) return this._error("EKEYTYPE", {
                  type: typeof t
                });
              }
            }, {
              key: "_wrap",
              value: function _wrap(t, n) {
                var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                var i;
                return a(this, e), this.options.useClones || (r = !1), i = Date.now(), 0, 1e3, {
                  t: 0 === n ? 0 : n ? i + 1e3 * n : 0 === this.options.stdTTL ? this.options.stdTTL : i + 1e3 * this.options.stdTTL,
                  v: r ? o(t) : t
                };
              }
            }, {
              key: "_unwrap",
              value: function _unwrap(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                return this.options.useClones || (t = !1), null != e.v ? t ? o(e.v) : e.v : null;
              }
            }, {
              key: "_getKeyLength",
              value: function _getKeyLength(e) {
                return e.toString().length;
              }
            }, {
              key: "_getValLength",
              value: function _getValLength(n) {
                return a(this, e), "string" == typeof n ? n.length : this.options.forceString ? JSON.stringify(n).length : Array.isArray(n) ? this.options.arrayValueSize * n.length : "number" == typeof n ? 8 : "function" == typeof (null != n ? n.then : void 0) ? this.options.promiseValueSize : (null != t ? t.isBuffer(n) : void 0) ? n.length : null != n && "object" == typeof n ? this.options.objectValueSize * Object.keys(n).length : "boolean" == typeof n ? 8 : 0;
              }
            }, {
              key: "_error",
              value: function _error(t) {
                var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var r;
                return a(this, e), (r = new Error()).name = t, r.errorcode = t, r.message = null != this.ERRORS[t] ? this.ERRORS[t](n) : "-", r.data = n, r;
              }
            }, {
              key: "_initErrors",
              value: function _initErrors() {
                var t, n, r;

                for (n in a(this, e), this.ERRORS = {}, r = this._ERRORS) {
                  t = r[n], this.ERRORS[n] = this.createErrorMessage(t);
                }
              }
            }, {
              key: "createErrorMessage",
              value: function createErrorMessage(e) {
                return function (t) {
                  return e.replace("__key", t.type);
                };
              }
            }]);

            return e;
          }(r);

          return e.prototype._ERRORS = {
            ENOTFOUND: "Key `__key` not found",
            ECACHEFULL: "Cache max keys amount exceeded",
            EKEYTYPE: "The key argument has to be of type `string` or `number`. Found: `__key`",
            EKEYSTYPE: "The keys argument has to be an array.",
            ETTLTYPE: "The ttl argument has to be a number."
          }, e;
        }.call(this);
      }).call(this);
    }).call(this, n(120).Buffer);
  }, function (e, t, n) {
    "use strict";

    t.byteLength = function (e) {
      var t = c(e),
          n = t[0],
          r = t[1];
      return 3 * (n + r) / 4 - r;
    }, t.toByteArray = function (e) {
      var t,
          n,
          r = c(e),
          a = r[0],
          s = r[1],
          u = new i(function (e, t, n) {
        return 3 * (t + n) / 4 - n;
      }(0, a, s)),
          f = 0,
          l = s > 0 ? a - 4 : a;

      for (n = 0; n < l; n += 4) {
        t = o[e.charCodeAt(n)] << 18 | o[e.charCodeAt(n + 1)] << 12 | o[e.charCodeAt(n + 2)] << 6 | o[e.charCodeAt(n + 3)], u[f++] = t >> 16 & 255, u[f++] = t >> 8 & 255, u[f++] = 255 & t;
      }

      2 === s && (t = o[e.charCodeAt(n)] << 2 | o[e.charCodeAt(n + 1)] >> 4, u[f++] = 255 & t);
      1 === s && (t = o[e.charCodeAt(n)] << 10 | o[e.charCodeAt(n + 1)] << 4 | o[e.charCodeAt(n + 2)] >> 2, u[f++] = t >> 8 & 255, u[f++] = 255 & t);
      return u;
    }, t.fromByteArray = function (e) {
      for (var t, n = e.length, o = n % 3, i = [], a = 0, s = n - o; a < s; a += 16383) {
        i.push(f(e, a, a + 16383 > s ? s : a + 16383));
      }

      1 === o ? (t = e[n - 1], i.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === o && (t = (e[n - 2] << 8) + e[n - 1], i.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));
      return i.join("");
    };

    for (var r = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, u = a.length; s < u; ++s) {
      r[s] = a[s], o[a.charCodeAt(s)] = s;
    }

    function c(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var n = e.indexOf("=");
      return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
    }

    function f(e, t, n) {
      for (var o, i, a = [], s = t; s < n; s += 3) {
        o = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(r[(i = o) >> 18 & 63] + r[i >> 12 & 63] + r[i >> 6 & 63] + r[63 & i]);
      }

      return a.join("");
    }

    o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
  }, function (e, t) {
    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
    t.read = function (e, t, n, r, o) {
      var i,
          a,
          s = 8 * o - r - 1,
          u = (1 << s) - 1,
          c = u >> 1,
          f = -7,
          l = n ? o - 1 : 0,
          p = n ? -1 : 1,
          h = e[t + l];

      for (l += p, i = h & (1 << -f) - 1, h >>= -f, f += s; f > 0; i = 256 * i + e[t + l], l += p, f -= 8) {
        ;
      }

      for (a = i & (1 << -f) - 1, i >>= -f, f += r; f > 0; a = 256 * a + e[t + l], l += p, f -= 8) {
        ;
      }

      if (0 === i) i = 1 - c;else {
        if (i === u) return a ? NaN : 1 / 0 * (h ? -1 : 1);
        a += Math.pow(2, r), i -= c;
      }
      return (h ? -1 : 1) * a * Math.pow(2, i - r);
    }, t.write = function (e, t, n, r, o, i) {
      var a,
          s,
          u,
          c = 8 * i - o - 1,
          f = (1 << c) - 1,
          l = f >> 1,
          p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          h = r ? 0 : i - 1,
          d = r ? 1 : -1,
          v = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = f) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + l >= 1 ? p / u : p * Math.pow(2, 1 - l)) * u >= 2 && (a++, u /= 2), a + l >= f ? (s = 0, a = f) : a + l >= 1 ? (s = (t * u - 1) * Math.pow(2, o), a += l) : (s = t * Math.pow(2, l - 1) * Math.pow(2, o), a = 0)); o >= 8; e[n + h] = 255 & s, h += d, s /= 256, o -= 8) {
        ;
      }

      for (a = a << o | s, c += o; c > 0; e[n + h] = 255 & a, h += d, a /= 256, c -= 8) {
        ;
      }

      e[n + h - d] |= 128 * v;
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = Array.isArray || function (e) {
      return "[object Array]" == n.call(e);
    };
  }, function (e, t, n) {
    (function (t) {
      var n = function () {
        "use strict";

        function e(e, t) {
          return null != t && e instanceof t;
        }

        var n, r, o;

        try {
          n = Map;
        } catch (e) {
          n = function n() {};
        }

        try {
          r = Set;
        } catch (e) {
          r = function r() {};
        }

        try {
          o = Promise;
        } catch (e) {
          o = function o() {};
        }

        function i(a, u, c, f, l) {
          "object" == typeof u && (c = u.depth, f = u.prototype, l = u.includeNonEnumerable, u = u.circular);
          var p = [],
              h = [],
              d = void 0 !== t;
          return void 0 === u && (u = !0), void 0 === c && (c = 1 / 0), function a(c, v) {
            if (null === c) return null;
            if (0 === v) return c;
            var y, g;
            if ("object" != typeof c) return c;
            if (e(c, n)) y = new n();else if (e(c, r)) y = new r();else if (e(c, o)) y = new o(function (e, t) {
              c.then(function (t) {
                e(a(t, v - 1));
              }, function (e) {
                t(a(e, v - 1));
              });
            });else if (i.__isArray(c)) y = [];else if (i.__isRegExp(c)) y = new RegExp(c.source, s(c)), c.lastIndex && (y.lastIndex = c.lastIndex);else if (i.__isDate(c)) y = new Date(c.getTime());else {
              if (d && t.isBuffer(c)) return y = t.allocUnsafe ? t.allocUnsafe(c.length) : new t(c.length), c.copy(y), y;
              e(c, Error) ? y = Object.create(c) : void 0 === f ? (g = Object.getPrototypeOf(c), y = Object.create(g)) : (y = Object.create(f), g = f);
            }

            if (u) {
              var m = p.indexOf(c);
              if (-1 != m) return h[m];
              p.push(c), h.push(y);
            }

            for (var b in e(c, n) && c.forEach(function (e, t) {
              var n = a(t, v - 1),
                  r = a(e, v - 1);
              y.set(n, r);
            }), e(c, r) && c.forEach(function (e) {
              var t = a(e, v - 1);
              y.add(t);
            }), c) {
              var x;
              g && (x = Object.getOwnPropertyDescriptor(g, b)), x && null == x.set || (y[b] = a(c[b], v - 1));
            }

            if (Object.getOwnPropertySymbols) {
              var w = Object.getOwnPropertySymbols(c);

              for (b = 0; b < w.length; b++) {
                var k = w[b];
                (!(E = Object.getOwnPropertyDescriptor(c, k)) || E.enumerable || l) && (y[k] = a(c[k], v - 1), E.enumerable || Object.defineProperty(y, k, {
                  enumerable: !1
                }));
              }
            }

            if (l) {
              var S = Object.getOwnPropertyNames(c);

              for (b = 0; b < S.length; b++) {
                var E,
                    T = S[b];
                (E = Object.getOwnPropertyDescriptor(c, T)) && E.enumerable || (y[T] = a(c[T], v - 1), Object.defineProperty(y, T, {
                  enumerable: !1
                }));
              }
            }

            return y;
          }(a, c);
        }

        function a(e) {
          return Object.prototype.toString.call(e);
        }

        function s(e) {
          var t = "";
          return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), t;
        }

        return i.clonePrototype = function (e) {
          if (null === e) return null;

          var t = function t() {};

          return t.prototype = e, new t();
        }, i.__objToStr = a, i.__isDate = function (e) {
          return "object" == typeof e && "[object Date]" === a(e);
        }, i.__isArray = function (e) {
          return "object" == typeof e && "[object Array]" === a(e);
        }, i.__isRegExp = function (e) {
          return "object" == typeof e && "[object RegExp]" === a(e);
        }, i.__getRegExpFlags = s, i;
      }();

      e.exports && (e.exports = n);
    }).call(this, n(120).Buffer);
  }, function (e, t, n) {
    "use strict";

    var r,
        o = "object" == typeof Reflect ? Reflect : null,
        i = o && "function" == typeof o.apply ? o.apply : function (e, t, n) {
      return Function.prototype.apply.call(e, t, n);
    };
    r = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (e) {
      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
    } : function (e) {
      return Object.getOwnPropertyNames(e);
    };

    var a = Number.isNaN || function (e) {
      return e != e;
    };

    function s() {
      s.init.call(this);
    }

    e.exports = s, e.exports.once = function (e, t) {
      return new Promise(function (n, r) {
        function o(n) {
          e.removeListener(t, i), r(n);
        }

        function i() {
          "function" == typeof e.removeListener && e.removeListener("error", o), n([].slice.call(arguments));
        }

        g(e, t, i, {
          once: !0
        }), "error" !== t && function (e, t, n) {
          "function" == typeof e.on && g(e, "error", t, n);
        }(e, o, {
          once: !0
        });
      });
    }, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var u = 10;

    function c(e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
    }

    function f(e) {
      return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners;
    }

    function l(e, t, n, r) {
      var o, i, a, s;
      if (c(n), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), i = e._events), a = i[t]), void 0 === a) a = i[t] = n, ++e._eventsCount;else if ("function" == typeof a ? a = i[t] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), (o = f(e)) > 0 && a.length > o && !a.warned) {
        a.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = a.length, s = u, console && console.warn && console.warn(s);
      }
      return e;
    }

    function p() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }

    function h(e, t, n) {
      var r = {
        fired: !1,
        wrapFn: void 0,
        target: e,
        type: t,
        listener: n
      },
          o = p.bind(r);
      return o.listener = n, r.wrapFn = o, o;
    }

    function d(e, t, n) {
      var r = e._events;
      if (void 0 === r) return [];
      var o = r[t];
      return void 0 === o ? [] : "function" == typeof o ? n ? [o.listener || o] : [o] : n ? function (e) {
        for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
          t[n] = e[n].listener || e[n];
        }

        return t;
      }(o) : y(o, o.length);
    }

    function v(e) {
      var t = this._events;

      if (void 0 !== t) {
        var n = t[e];
        if ("function" == typeof n) return 1;
        if (void 0 !== n) return n.length;
      }

      return 0;
    }

    function y(e, t) {
      for (var n = new Array(t), r = 0; r < t; ++r) {
        n[r] = e[r];
      }

      return n;
    }

    function g(e, t, n, r) {
      if ("function" == typeof e.on) r.once ? e.once(t, n) : e.on(t, n);else {
        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
        e.addEventListener(t, function o(i) {
          r.once && e.removeEventListener(t, o), n(i);
        });
      }
    }

    Object.defineProperty(s, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return u;
      },
      set: function set(e) {
        if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
        u = e;
      }
    }), s.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, s.prototype.setMaxListeners = function (e) {
      if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
      return this._maxListeners = e, this;
    }, s.prototype.getMaxListeners = function () {
      return f(this);
    }, s.prototype.emit = function (e) {
      for (var t = [], n = 1; n < arguments.length; n++) {
        t.push(arguments[n]);
      }

      var r = "error" === e,
          o = this._events;
      if (void 0 !== o) r = r && void 0 === o.error;else if (!r) return !1;

      if (r) {
        var a;
        if (t.length > 0 && (a = t[0]), a instanceof Error) throw a;
        var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw s.context = a, s;
      }

      var u = o[e];
      if (void 0 === u) return !1;
      if ("function" == typeof u) i(u, this, t);else {
        var c = u.length,
            f = y(u, c);

        for (n = 0; n < c; ++n) {
          i(f[n], this, t);
        }
      }
      return !0;
    }, s.prototype.addListener = function (e, t) {
      return l(this, e, t, !1);
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (e, t) {
      return l(this, e, t, !0);
    }, s.prototype.once = function (e, t) {
      return c(t), this.on(e, h(this, e, t)), this;
    }, s.prototype.prependOnceListener = function (e, t) {
      return c(t), this.prependListener(e, h(this, e, t)), this;
    }, s.prototype.removeListener = function (e, t) {
      var n, r, o, i, a;
      if (c(t), void 0 === (r = this._events)) return this;
      if (void 0 === (n = r[e])) return this;
      if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
        for (o = -1, i = n.length - 1; i >= 0; i--) {
          if (n[i] === t || n[i].listener === t) {
            a = n[i].listener, o = i;
            break;
          }
        }

        if (o < 0) return this;
        0 === o ? n.shift() : function (e, t) {
          for (; t + 1 < e.length; t++) {
            e[t] = e[t + 1];
          }

          e.pop();
        }(n, o), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, a || t);
      }
      return this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (e) {
      var t, n, r;
      if (void 0 === (n = this._events)) return this;
      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;

      if (0 === arguments.length) {
        var o,
            i = Object.keys(n);

        for (r = 0; r < i.length; ++r) {
          "removeListener" !== (o = i[r]) && this.removeAllListeners(o);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (void 0 !== t) for (r = t.length - 1; r >= 0; r--) {
        this.removeListener(e, t[r]);
      }
      return this;
    }, s.prototype.listeners = function (e) {
      return d(this, e, !0);
    }, s.prototype.rawListeners = function (e) {
      return d(this, e, !1);
    }, s.listenerCount = function (e, t) {
      return "function" == typeof e.listenerCount ? e.listenerCount(t) : v.call(e, t);
    }, s.prototype.listenerCount = v, s.prototype.eventNames = function () {
      return this._eventsCount > 0 ? r(this._events) : [];
    };
  }, function (e, t, n) {
    var r = n(121);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(6),
        o = n(13);
    r({
      target: "Object",
      stat: !0,
      forced: !o,
      sham: !o
    }, {
      defineProperty: n(26).f
    });
  }, function (e, t, n) {
    e.exports = n(213);
  }, function (e, t, n) {
    var r = n(124);
    e.exports = r;
  }, function (e, t, n) {
    n(215);
    var r = n(29);
    e.exports = r("Array").indexOf;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(125).indexOf,
        i = n(127),
        a = [].indexOf,
        s = !!a && 1 / [1].indexOf(1, -0) < 0,
        u = i("indexOf");
    r({
      target: "Array",
      proto: !0,
      forced: s || !u
    }, {
      indexOf: function indexOf(e) {
        return s ? a.apply(this, arguments) || 0 : o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (e, t, n) {
    var r = n(128);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(8),
        o = n(22);

    e.exports = function (e, t) {
      try {
        o(r, e, t);
      } catch (n) {
        r[e] = t;
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(10);
    e.exports = !r(function () {
      function e() {}

      return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
    });
  }, function (e, t, n) {
    var r = n(17);

    e.exports = function (e) {
      if (!r(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i,
        a,
        s = n(6),
        u = n(30),
        c = n(8),
        f = n(23),
        l = n(137),
        p = n(31),
        h = n(138),
        d = n(32),
        v = n(222),
        y = n(17),
        g = n(35),
        m = n(93),
        b = n(139),
        x = n(47),
        w = n(140),
        k = n(141),
        S = n(142).set,
        E = n(223),
        T = n(144),
        _ = n(225),
        O = n(50),
        A = n(67),
        R = n(39),
        P = n(123),
        I = n(7),
        C = n(65),
        j = n(66),
        L = I("species"),
        M = "Promise",
        N = R.get,
        U = R.set,
        D = R.getterFor(M),
        _B = l,
        F = c.TypeError,
        H = c.document,
        q = c.process,
        $ = f("fetch"),
        z = O.f,
        K = z,
        G = !!(H && H.createEvent && c.dispatchEvent),
        V = "function" == typeof PromiseRejectionEvent,
        Y = P(M, function () {
      if (!(b(_B) !== String(_B))) {
        if (66 === j) return !0;
        if (!C && !V) return !0;
      }

      if (u && !_B.prototype.finally) return !0;
      if (j >= 51 && /native code/.test(_B)) return !1;

      var e = _B.resolve(1),
          t = function t(e) {
        e(function () {}, function () {});
      };

      return (e.constructor = {})[L] = t, !(e.then(function () {}) instanceof t);
    }),
        W = Y || !w(function (e) {
      _B.all(e).catch(function () {});
    }),
        J = function J(e) {
      var t;
      return !(!y(e) || "function" != typeof (t = e.then)) && t;
    },
        X = function X(e, t) {
      if (!e.notified) {
        e.notified = !0;
        var n = e.reactions;
        E(function () {
          for (var r = e.value, o = 1 == e.state, i = 0; n.length > i;) {
            var a,
                s,
                u,
                c = n[i++],
                f = o ? c.ok : c.fail,
                l = c.resolve,
                p = c.reject,
                h = c.domain;

            try {
              f ? (o || (2 === e.rejection && te(e), e.rejection = 1), !0 === f ? a = r : (h && h.enter(), a = f(r), h && (h.exit(), u = !0)), a === c.promise ? p(F("Promise-chain cycle")) : (s = J(a)) ? s.call(a, l, p) : l(a)) : p(r);
            } catch (e) {
              h && !u && h.exit(), p(e);
            }
          }

          e.reactions = [], e.notified = !1, t && !e.rejection && Z(e);
        });
      }
    },
        Q = function Q(e, t, n) {
      var r, o;
      G ? ((r = H.createEvent("Event")).promise = t, r.reason = n, r.initEvent(e, !1, !0), c.dispatchEvent(r)) : r = {
        promise: t,
        reason: n
      }, !V && (o = c["on" + e]) ? o(r) : "unhandledrejection" === e && _("Unhandled promise rejection", n);
    },
        Z = function Z(e) {
      S.call(c, function () {
        var t,
            n = e.facade,
            r = e.value;
        if (ee(e) && (t = A(function () {
          C ? q.emit("unhandledRejection", r, n) : Q("unhandledrejection", n, r);
        }), e.rejection = C || ee(e) ? 2 : 1, t.error)) throw t.value;
      });
    },
        ee = function ee(e) {
      return 1 !== e.rejection && !e.parent;
    },
        te = function te(e) {
      S.call(c, function () {
        var t = e.facade;
        C ? q.emit("rejectionHandled", t) : Q("rejectionhandled", t, e.value);
      });
    },
        ne = function ne(e, t, n) {
      return function (r) {
        e(t, r, n);
      };
    },
        re = function re(e, t, n) {
      e.done || (e.done = !0, n && (e = n), e.value = t, e.state = 2, X(e, !0));
    },
        oe = function oe(e, t, n) {
      if (!e.done) {
        e.done = !0, n && (e = n);

        try {
          if (e.facade === t) throw F("Promise can't be resolved itself");
          var r = J(t);
          r ? E(function () {
            var n = {
              done: !1
            };

            try {
              r.call(t, ne(oe, n, e), ne(re, n, e));
            } catch (t) {
              re(n, t, e);
            }
          }) : (e.value = t, e.state = 1, X(e, !1));
        } catch (t) {
          re({
            done: !1
          }, t, e);
        }
      }
    };

    Y && (_B = function B(e) {
      m(this, _B, M), g(e), r.call(this);
      var t = N(this);

      try {
        e(ne(oe, t), ne(re, t));
      } catch (e) {
        re(t, e);
      }
    }, (r = function r(e) {
      U(this, {
        type: M,
        done: !1,
        notified: !1,
        parent: !1,
        reactions: [],
        rejection: !1,
        state: 0,
        value: void 0
      });
    }).prototype = h(_B.prototype, {
      then: function then(e, t) {
        var n = D(this),
            r = z(k(this, _B));
        return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = C ? q.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && X(n, !1), r.promise;
      },
      catch: function _catch(e) {
        return this.then(void 0, e);
      }
    }), o = function o() {
      var e = new r(),
          t = N(e);
      this.promise = e, this.resolve = ne(oe, t), this.reject = ne(re, t);
    }, O.f = z = function z(e) {
      return e === _B || e === i ? new o(e) : K(e);
    }, u || "function" != typeof l || (a = l.prototype.then, p(l.prototype, "then", function (e, t) {
      var n = this;
      return new _B(function (e, t) {
        a.call(n, e, t);
      }).then(e, t);
    }, {
      unsafe: !0
    }), "function" == typeof $ && s({
      global: !0,
      enumerable: !0,
      forced: !0
    }, {
      fetch: function fetch(e) {
        return T(_B, $.apply(c, arguments));
      }
    }))), s({
      global: !0,
      wrap: !0,
      forced: Y
    }, {
      Promise: _B
    }), d(_B, M, !1, !0), v(M), i = f(M), s({
      target: M,
      stat: !0,
      forced: Y
    }, {
      reject: function reject(e) {
        var t = z(this);
        return t.reject.call(void 0, e), t.promise;
      }
    }), s({
      target: M,
      stat: !0,
      forced: u || Y
    }, {
      resolve: function resolve(e) {
        return T(u && this === i ? _B : this, e);
      }
    }), s({
      target: M,
      stat: !0,
      forced: W
    }, {
      all: function all(e) {
        var t = this,
            n = z(t),
            r = n.resolve,
            o = n.reject,
            i = A(function () {
          var n = g(t.resolve),
              i = [],
              a = 0,
              s = 1;
          x(e, function (e) {
            var u = a++,
                c = !1;
            i.push(void 0), s++, n.call(t, e).then(function (e) {
              c || (c = !0, i[u] = e, --s || r(i));
            }, o);
          }), --s || r(i);
        });
        return i.error && o(i.value), n.promise;
      },
      race: function race(e) {
        var t = this,
            n = z(t),
            r = n.reject,
            o = A(function () {
          var o = g(t.resolve);
          x(e, function (e) {
            o.call(t, e).then(n.resolve, r);
          });
        });
        return o.error && r(o.value), n.promise;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(92),
        o = n(49);
    e.exports = r ? {}.toString : function () {
      return "[object " + o(this) + "]";
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(23),
        o = n(26),
        i = n(7),
        a = n(13),
        s = i("species");

    e.exports = function (e) {
      var t = r(e),
          n = o.f;
      a && t && !t[s] && n(t, s, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (e, t, n) {
    var r,
        o,
        i,
        a,
        s,
        u,
        c,
        f,
        l = n(8),
        p = n(44).f,
        h = n(142).set,
        d = n(143),
        v = n(224),
        y = n(65),
        g = l.MutationObserver || l.WebKitMutationObserver,
        m = l.document,
        b = l.process,
        x = l.Promise,
        w = p(l, "queueMicrotask"),
        k = w && w.value;
    k || (r = function r() {
      var e, t;

      for (y && (e = b.domain) && e.exit(); o;) {
        t = o.fn, o = o.next;

        try {
          t();
        } catch (e) {
          throw o ? a() : i = void 0, e;
        }
      }

      i = void 0, e && e.enter();
    }, d || y || v || !g || !m ? x && x.resolve ? (c = x.resolve(void 0), f = c.then, a = function a() {
      f.call(c, r);
    }) : a = y ? function () {
      b.nextTick(r);
    } : function () {
      h.call(l, r);
    } : (s = !0, u = m.createTextNode(""), new g(r).observe(u, {
      characterData: !0
    }), a = function a() {
      u.data = s = !s;
    })), e.exports = k || function (e) {
      var t = {
        fn: e,
        next: void 0
      };
      i && (i.next = t), o || (o = t, a()), i = t;
    };
  }, function (e, t, n) {
    var r = n(91);
    e.exports = /web0s(?!.*chrome)/i.test(r);
  }, function (e, t, n) {
    var r = n(8);

    e.exports = function (e, t) {
      var n = r.console;
      n && n.error && (1 === arguments.length ? n.error(e) : n.error(e, t));
    };
  }, function (e, t, n) {
    var r = n(8),
        o = n(139),
        i = r.WeakMap;
    e.exports = "function" == typeof i && /native code/.test(o(i));
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(30),
        i = n(137),
        a = n(10),
        s = n(23),
        u = n(141),
        c = n(144),
        f = n(31);
    r({
      target: "Promise",
      proto: !0,
      real: !0,
      forced: !!i && a(function () {
        i.prototype.finally.call({
          then: function then() {}
        }, function () {});
      })
    }, {
      finally: function _finally(e) {
        var t = u(this, s("Promise")),
            n = "function" == typeof e;
        return this.then(n ? function (n) {
          return c(t, e()).then(function () {
            return n;
          });
        } : e, n ? function (n) {
          return c(t, e()).then(function () {
            throw n;
          });
        } : e);
      }
    }), o || "function" != typeof i || i.prototype.finally || f(i.prototype, "finally", s("Promise").prototype.finally);
  }, function (e, t) {
    e.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };
  }, function (e, t, n) {
    e.exports = n(230);
  }, function (e, t, n) {
    var r = n(231);
    e.exports = r;
  }, function (e, t, n) {
    n(232), n(236), n(154);
    var r = n(11);
    e.exports = r.URL;
  }, function (e, t, n) {
    "use strict";

    n(40);

    var r,
        o = n(6),
        i = n(13),
        a = n(152),
        s = n(8),
        u = n(88),
        c = n(31),
        f = n(93),
        l = n(18),
        p = n(233),
        h = n(153),
        d = n(147).codeAt,
        v = n(235),
        y = n(32),
        g = n(154),
        m = n(39),
        b = s.URL,
        x = g.URLSearchParams,
        w = g.getState,
        k = m.set,
        S = m.getterFor("URL"),
        E = Math.floor,
        T = Math.pow,
        _ = /[A-Za-z]/,
        O = /[\d+-.A-Za-z]/,
        A = /\d/,
        R = /^(0x|0X)/,
        P = /^[0-7]+$/,
        I = /^\d+$/,
        C = /^[\dA-Fa-f]+$/,
        j = /[\0\t\n\r #%/:?@[\\]]/,
        L = /[\0\t\n\r #/:?@[\\]]/,
        M = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
        N = /[\t\n\r]/g,
        U = function U(e, t) {
      var n, r, o;

      if ("[" == t.charAt(0)) {
        if ("]" != t.charAt(t.length - 1)) return "Invalid host";
        if (!(n = B(t.slice(1, -1)))) return "Invalid host";
        e.host = n;
      } else if (V(e)) {
        if (t = v(t), j.test(t)) return "Invalid host";
        if (null === (n = D(t))) return "Invalid host";
        e.host = n;
      } else {
        if (L.test(t)) return "Invalid host";

        for (n = "", r = h(t), o = 0; o < r.length; o++) {
          n += K(r[o], H);
        }

        e.host = n;
      }
    },
        D = function D(e) {
      var t,
          n,
          r,
          o,
          i,
          a,
          s,
          u = e.split(".");
      if (u.length && "" == u[u.length - 1] && u.pop(), (t = u.length) > 4) return e;

      for (n = [], r = 0; r < t; r++) {
        if ("" == (o = u[r])) return e;
        if (i = 10, o.length > 1 && "0" == o.charAt(0) && (i = R.test(o) ? 16 : 8, o = o.slice(8 == i ? 1 : 2)), "" === o) a = 0;else {
          if (!(10 == i ? I : 8 == i ? P : C).test(o)) return e;
          a = parseInt(o, i);
        }
        n.push(a);
      }

      for (r = 0; r < t; r++) {
        if (a = n[r], r == t - 1) {
          if (a >= T(256, 5 - t)) return null;
        } else if (a > 255) return null;
      }

      for (s = n.pop(), r = 0; r < n.length; r++) {
        s += n[r] * T(256, 3 - r);
      }

      return s;
    },
        B = function B(e) {
      var t,
          n,
          r,
          o,
          i,
          a,
          s,
          u = [0, 0, 0, 0, 0, 0, 0, 0],
          c = 0,
          f = null,
          l = 0,
          p = function p() {
        return e.charAt(l);
      };

      if (":" == p()) {
        if (":" != e.charAt(1)) return;
        l += 2, f = ++c;
      }

      for (; p();) {
        if (8 == c) return;

        if (":" != p()) {
          for (t = n = 0; n < 4 && C.test(p());) {
            t = 16 * t + parseInt(p(), 16), l++, n++;
          }

          if ("." == p()) {
            if (0 == n) return;
            if (l -= n, c > 6) return;

            for (r = 0; p();) {
              if (o = null, r > 0) {
                if (!("." == p() && r < 4)) return;
                l++;
              }

              if (!A.test(p())) return;

              for (; A.test(p());) {
                if (i = parseInt(p(), 10), null === o) o = i;else {
                  if (0 == o) return;
                  o = 10 * o + i;
                }
                if (o > 255) return;
                l++;
              }

              u[c] = 256 * u[c] + o, 2 != ++r && 4 != r || c++;
            }

            if (4 != r) return;
            break;
          }

          if (":" == p()) {
            if (l++, !p()) return;
          } else if (p()) return;

          u[c++] = t;
        } else {
          if (null !== f) return;
          l++, f = ++c;
        }
      }

      if (null !== f) for (a = c - f, c = 7; 0 != c && a > 0;) {
        s = u[c], u[c--] = u[f + a - 1], u[f + --a] = s;
      } else if (8 != c) return;
      return u;
    },
        F = function F(e) {
      var t, n, r, o;

      if ("number" == typeof e) {
        for (t = [], n = 0; n < 4; n++) {
          t.unshift(e % 256), e = E(e / 256);
        }

        return t.join(".");
      }

      if ("object" == typeof e) {
        for (t = "", r = function (e) {
          for (var t = null, n = 1, r = null, o = 0, i = 0; i < 8; i++) {
            0 !== e[i] ? (o > n && (t = r, n = o), r = null, o = 0) : (null === r && (r = i), ++o);
          }

          return o > n && (t = r, n = o), t;
        }(e), n = 0; n < 8; n++) {
          o && 0 === e[n] || (o && (o = !1), r === n ? (t += n ? ":" : "::", o = !0) : (t += e[n].toString(16), n < 7 && (t += ":")));
        }

        return "[" + t + "]";
      }

      return e;
    },
        H = {},
        q = p({}, H, {
      " ": 1,
      '"': 1,
      "<": 1,
      ">": 1,
      "`": 1
    }),
        $ = p({}, q, {
      "#": 1,
      "?": 1,
      "{": 1,
      "}": 1
    }),
        z = p({}, $, {
      "/": 1,
      ":": 1,
      ";": 1,
      "=": 1,
      "@": 1,
      "[": 1,
      "\\": 1,
      "]": 1,
      "^": 1,
      "|": 1
    }),
        K = function K(e, t) {
      var n = d(e, 0);
      return n > 32 && n < 127 && !l(t, e) ? e : encodeURIComponent(e);
    },
        G = {
      ftp: 21,
      file: null,
      http: 80,
      https: 443,
      ws: 80,
      wss: 443
    },
        V = function V(e) {
      return l(G, e.scheme);
    },
        Y = function Y(e) {
      return "" != e.username || "" != e.password;
    },
        W = function W(e) {
      return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
    },
        J = function J(e, t) {
      var n;
      return 2 == e.length && _.test(e.charAt(0)) && (":" == (n = e.charAt(1)) || !t && "|" == n);
    },
        X = function X(e) {
      var t;
      return e.length > 1 && J(e.slice(0, 2)) && (2 == e.length || "/" === (t = e.charAt(2)) || "\\" === t || "?" === t || "#" === t);
    },
        Q = function Q(e) {
      var t = e.path,
          n = t.length;
      !n || "file" == e.scheme && 1 == n && J(t[0], !0) || t.pop();
    },
        Z = function Z(e) {
      return "." === e || "%2e" === e.toLowerCase();
    },
        ee = {},
        te = {},
        ne = {},
        re = {},
        oe = {},
        ie = {},
        ae = {},
        se = {},
        ue = {},
        ce = {},
        fe = {},
        le = {},
        pe = {},
        he = {},
        de = {},
        ve = {},
        ye = {},
        ge = {},
        me = {},
        be = {},
        xe = {},
        we = function we(e, t, n, o) {
      var i,
          a,
          s,
          u,
          c,
          f = n || ee,
          p = 0,
          d = "",
          v = !1,
          y = !1,
          g = !1;

      for (n || (e.scheme = "", e.username = "", e.password = "", e.host = null, e.port = null, e.path = [], e.query = null, e.fragment = null, e.cannotBeABaseURL = !1, t = t.replace(M, "")), t = t.replace(N, ""), i = h(t); p <= i.length;) {
        switch (a = i[p], f) {
          case ee:
            if (!a || !_.test(a)) {
              if (n) return "Invalid scheme";
              f = ne;
              continue;
            }

            d += a.toLowerCase(), f = te;
            break;

          case te:
            if (a && (O.test(a) || "+" == a || "-" == a || "." == a)) d += a.toLowerCase();else {
              if (":" != a) {
                if (n) return "Invalid scheme";
                d = "", f = ne, p = 0;
                continue;
              }

              if (n && (V(e) != l(G, d) || "file" == d && (Y(e) || null !== e.port) || "file" == e.scheme && !e.host)) return;
              if (e.scheme = d, n) return void (V(e) && G[e.scheme] == e.port && (e.port = null));
              d = "", "file" == e.scheme ? f = he : V(e) && o && o.scheme == e.scheme ? f = re : V(e) ? f = se : "/" == i[p + 1] ? (f = oe, p++) : (e.cannotBeABaseURL = !0, e.path.push(""), f = me);
            }
            break;

          case ne:
            if (!o || o.cannotBeABaseURL && "#" != a) return "Invalid scheme";

            if (o.cannotBeABaseURL && "#" == a) {
              e.scheme = o.scheme, e.path = o.path.slice(), e.query = o.query, e.fragment = "", e.cannotBeABaseURL = !0, f = xe;
              break;
            }

            f = "file" == o.scheme ? he : ie;
            continue;

          case re:
            if ("/" != a || "/" != i[p + 1]) {
              f = ie;
              continue;
            }

            f = ue, p++;
            break;

          case oe:
            if ("/" == a) {
              f = ce;
              break;
            }

            f = ge;
            continue;

          case ie:
            if (e.scheme = o.scheme, a == r) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query;else if ("/" == a || "\\" == a && V(e)) f = ae;else if ("?" == a) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = "", f = be;else {
              if ("#" != a) {
                e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.path.pop(), f = ge;
                continue;
              }

              e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query, e.fragment = "", f = xe;
            }
            break;

          case ae:
            if (!V(e) || "/" != a && "\\" != a) {
              if ("/" != a) {
                e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, f = ge;
                continue;
              }

              f = ce;
            } else f = ue;

            break;

          case se:
            if (f = ue, "/" != a || "/" != d.charAt(p + 1)) continue;
            p++;
            break;

          case ue:
            if ("/" != a && "\\" != a) {
              f = ce;
              continue;
            }

            break;

          case ce:
            if ("@" == a) {
              v && (d = "%40" + d), v = !0, s = h(d);

              for (var m = 0; m < s.length; m++) {
                var b = s[m];

                if (":" != b || g) {
                  var x = K(b, z);
                  g ? e.password += x : e.username += x;
                } else g = !0;
              }

              d = "";
            } else if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && V(e)) {
              if (v && "" == d) return "Invalid authority";
              p -= h(d).length + 1, d = "", f = fe;
            } else d += a;

            break;

          case fe:
          case le:
            if (n && "file" == e.scheme) {
              f = ve;
              continue;
            }

            if (":" != a || y) {
              if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && V(e)) {
                if (V(e) && "" == d) return "Invalid host";
                if (n && "" == d && (Y(e) || null !== e.port)) return;
                if (u = U(e, d)) return u;
                if (d = "", f = ye, n) return;
                continue;
              }

              "[" == a ? y = !0 : "]" == a && (y = !1), d += a;
            } else {
              if ("" == d) return "Invalid host";
              if (u = U(e, d)) return u;
              if (d = "", f = pe, n == le) return;
            }

            break;

          case pe:
            if (!A.test(a)) {
              if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && V(e) || n) {
                if ("" != d) {
                  var w = parseInt(d, 10);
                  if (w > 65535) return "Invalid port";
                  e.port = V(e) && w === G[e.scheme] ? null : w, d = "";
                }

                if (n) return;
                f = ye;
                continue;
              }

              return "Invalid port";
            }

            d += a;
            break;

          case he:
            if (e.scheme = "file", "/" == a || "\\" == a) f = de;else {
              if (!o || "file" != o.scheme) {
                f = ge;
                continue;
              }

              if (a == r) e.host = o.host, e.path = o.path.slice(), e.query = o.query;else if ("?" == a) e.host = o.host, e.path = o.path.slice(), e.query = "", f = be;else {
                if ("#" != a) {
                  X(i.slice(p).join("")) || (e.host = o.host, e.path = o.path.slice(), Q(e)), f = ge;
                  continue;
                }

                e.host = o.host, e.path = o.path.slice(), e.query = o.query, e.fragment = "", f = xe;
              }
            }
            break;

          case de:
            if ("/" == a || "\\" == a) {
              f = ve;
              break;
            }

            o && "file" == o.scheme && !X(i.slice(p).join("")) && (J(o.path[0], !0) ? e.path.push(o.path[0]) : e.host = o.host), f = ge;
            continue;

          case ve:
            if (a == r || "/" == a || "\\" == a || "?" == a || "#" == a) {
              if (!n && J(d)) f = ge;else if ("" == d) {
                if (e.host = "", n) return;
                f = ye;
              } else {
                if (u = U(e, d)) return u;
                if ("localhost" == e.host && (e.host = ""), n) return;
                d = "", f = ye;
              }
              continue;
            }

            d += a;
            break;

          case ye:
            if (V(e)) {
              if (f = ge, "/" != a && "\\" != a) continue;
            } else if (n || "?" != a) {
              if (n || "#" != a) {
                if (a != r && (f = ge, "/" != a)) continue;
              } else e.fragment = "", f = xe;
            } else e.query = "", f = be;

            break;

          case ge:
            if (a == r || "/" == a || "\\" == a && V(e) || !n && ("?" == a || "#" == a)) {
              if (".." === (c = (c = d).toLowerCase()) || "%2e." === c || ".%2e" === c || "%2e%2e" === c ? (Q(e), "/" == a || "\\" == a && V(e) || e.path.push("")) : Z(d) ? "/" == a || "\\" == a && V(e) || e.path.push("") : ("file" == e.scheme && !e.path.length && J(d) && (e.host && (e.host = ""), d = d.charAt(0) + ":"), e.path.push(d)), d = "", "file" == e.scheme && (a == r || "?" == a || "#" == a)) for (; e.path.length > 1 && "" === e.path[0];) {
                e.path.shift();
              }
              "?" == a ? (e.query = "", f = be) : "#" == a && (e.fragment = "", f = xe);
            } else d += K(a, $);

            break;

          case me:
            "?" == a ? (e.query = "", f = be) : "#" == a ? (e.fragment = "", f = xe) : a != r && (e.path[0] += K(a, H));
            break;

          case be:
            n || "#" != a ? a != r && ("'" == a && V(e) ? e.query += "%27" : e.query += "#" == a ? "%23" : K(a, H)) : (e.fragment = "", f = xe);
            break;

          case xe:
            a != r && (e.fragment += K(a, q));
        }

        p++;
      }
    },
        ke = function ke(e) {
      var t,
          n,
          r = f(this, ke, "URL"),
          o = arguments.length > 1 ? arguments[1] : void 0,
          a = String(e),
          s = k(r, {
        type: "URL"
      });
      if (void 0 !== o) if (o instanceof ke) t = S(o);else if (n = we(t = {}, String(o))) throw TypeError(n);
      if (n = we(s, a, null, t)) throw TypeError(n);
      var u = s.searchParams = new x(),
          c = w(u);
      c.updateSearchParams(s.query), c.updateURL = function () {
        s.query = String(u) || null;
      }, i || (r.href = Ee.call(r), r.origin = Te.call(r), r.protocol = _e.call(r), r.username = Oe.call(r), r.password = Ae.call(r), r.host = Re.call(r), r.hostname = Pe.call(r), r.port = Ie.call(r), r.pathname = Ce.call(r), r.search = je.call(r), r.searchParams = Le.call(r), r.hash = Me.call(r));
    },
        Se = ke.prototype,
        Ee = function Ee() {
      var e = S(this),
          t = e.scheme,
          n = e.username,
          r = e.password,
          o = e.host,
          i = e.port,
          a = e.path,
          s = e.query,
          u = e.fragment,
          c = t + ":";
      return null !== o ? (c += "//", Y(e) && (c += n + (r ? ":" + r : "") + "@"), c += F(o), null !== i && (c += ":" + i)) : "file" == t && (c += "//"), c += e.cannotBeABaseURL ? a[0] : a.length ? "/" + a.join("/") : "", null !== s && (c += "?" + s), null !== u && (c += "#" + u), c;
    },
        Te = function Te() {
      var e = S(this),
          t = e.scheme,
          n = e.port;
      if ("blob" == t) try {
        return new ke(t.path[0]).origin;
      } catch (e) {
        return "null";
      }
      return "file" != t && V(e) ? t + "://" + F(e.host) + (null !== n ? ":" + n : "") : "null";
    },
        _e = function _e() {
      return S(this).scheme + ":";
    },
        Oe = function Oe() {
      return S(this).username;
    },
        Ae = function Ae() {
      return S(this).password;
    },
        Re = function Re() {
      var e = S(this),
          t = e.host,
          n = e.port;
      return null === t ? "" : null === n ? F(t) : F(t) + ":" + n;
    },
        Pe = function Pe() {
      var e = S(this).host;
      return null === e ? "" : F(e);
    },
        Ie = function Ie() {
      var e = S(this).port;
      return null === e ? "" : String(e);
    },
        Ce = function Ce() {
      var e = S(this),
          t = e.path;
      return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
    },
        je = function je() {
      var e = S(this).query;
      return e ? "?" + e : "";
    },
        Le = function Le() {
      return S(this).searchParams;
    },
        Me = function Me() {
      var e = S(this).fragment;
      return e ? "#" + e : "";
    },
        Ne = function Ne(e, t) {
      return {
        get: e,
        set: t,
        configurable: !0,
        enumerable: !0
      };
    };

    if (i && u(Se, {
      href: Ne(Ee, function (e) {
        var t = S(this),
            n = String(e),
            r = we(t, n);
        if (r) throw TypeError(r);
        w(t.searchParams).updateSearchParams(t.query);
      }),
      origin: Ne(Te),
      protocol: Ne(_e, function (e) {
        var t = S(this);
        we(t, String(e) + ":", ee);
      }),
      username: Ne(Oe, function (e) {
        var t = S(this),
            n = h(String(e));

        if (!W(t)) {
          t.username = "";

          for (var r = 0; r < n.length; r++) {
            t.username += K(n[r], z);
          }
        }
      }),
      password: Ne(Ae, function (e) {
        var t = S(this),
            n = h(String(e));

        if (!W(t)) {
          t.password = "";

          for (var r = 0; r < n.length; r++) {
            t.password += K(n[r], z);
          }
        }
      }),
      host: Ne(Re, function (e) {
        var t = S(this);
        t.cannotBeABaseURL || we(t, String(e), fe);
      }),
      hostname: Ne(Pe, function (e) {
        var t = S(this);
        t.cannotBeABaseURL || we(t, String(e), le);
      }),
      port: Ne(Ie, function (e) {
        var t = S(this);
        W(t) || ("" == (e = String(e)) ? t.port = null : we(t, e, pe));
      }),
      pathname: Ne(Ce, function (e) {
        var t = S(this);
        t.cannotBeABaseURL || (t.path = [], we(t, e + "", ye));
      }),
      search: Ne(je, function (e) {
        var t = S(this);
        "" == (e = String(e)) ? t.query = null : ("?" == e.charAt(0) && (e = e.slice(1)), t.query = "", we(t, e, be)), w(t.searchParams).updateSearchParams(t.query);
      }),
      searchParams: Ne(Le),
      hash: Ne(Me, function (e) {
        var t = S(this);
        "" != (e = String(e)) ? ("#" == e.charAt(0) && (e = e.slice(1)), t.fragment = "", we(t, e, xe)) : t.fragment = null;
      })
    }), c(Se, "toJSON", function () {
      return Ee.call(this);
    }, {
      enumerable: !0
    }), c(Se, "toString", function () {
      return Ee.call(this);
    }, {
      enumerable: !0
    }), b) {
      var Ue = b.createObjectURL,
          De = b.revokeObjectURL;
      Ue && c(ke, "createObjectURL", function (e) {
        return Ue.apply(b, arguments);
      }), De && c(ke, "revokeObjectURL", function (e) {
        return De.apply(b, arguments);
      });
    }

    y(ke, "URL"), o({
      global: !0,
      forced: !a,
      sham: !i
    }, {
      URL: ke
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(13),
        o = n(10),
        i = n(46),
        a = n(95),
        s = n(59),
        u = n(25),
        c = n(80),
        f = Object.assign,
        l = Object.defineProperty;
    e.exports = !f || o(function () {
      if (r && 1 !== f({
        b: 1
      }, f(l({}, "a", {
        enumerable: !0,
        get: function get() {
          l(this, "b", {
            value: 3,
            enumerable: !1
          });
        }
      }), {
        b: 2
      })).b) return !0;
      var e = {},
          t = {},
          n = Symbol();
      return e[n] = 7, "abcdefghijklmnopqrst".split("").forEach(function (e) {
        t[e] = e;
      }), 7 != f({}, e)[n] || "abcdefghijklmnopqrst" != i(f({}, t)).join("");
    }) ? function (e, t) {
      for (var n = u(e), o = arguments.length, f = 1, l = a.f, p = s.f; o > f;) {
        for (var h, d = c(arguments[f++]), v = l ? i(d).concat(l(d)) : i(d), y = v.length, g = 0; y > g;) {
          h = v[g++], r && !p.call(d, h) || (n[h] = d[h]);
        }
      }

      return n;
    } : f;
  }, function (e, t, n) {
    var r = n(15),
        o = n(135);

    e.exports = function (e, t, n, i) {
      try {
        return i ? t(r(n)[0], n[1]) : t(n);
      } catch (t) {
        throw o(e), t;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = /[^\0-\u007E]/,
        o = /[.\u3002\uFF0E\uFF61]/g,
        i = "Overflow: input needs wider integers to process",
        a = Math.floor,
        s = String.fromCharCode,
        u = function u(e) {
      return e + 22 + 75 * (e < 26);
    },
        c = function c(e, t, n) {
      var r = 0;

      for (e = n ? a(e / 700) : e >> 1, e += a(e / t); e > 455; r += 36) {
        e = a(e / 35);
      }

      return a(r + 36 * e / (e + 38));
    },
        f = function f(e) {
      var t,
          n,
          r = [],
          o = (e = function (e) {
        for (var t = [], n = 0, r = e.length; n < r;) {
          var o = e.charCodeAt(n++);

          if (o >= 55296 && o <= 56319 && n < r) {
            var i = e.charCodeAt(n++);
            56320 == (64512 & i) ? t.push(((1023 & o) << 10) + (1023 & i) + 65536) : (t.push(o), n--);
          } else t.push(o);
        }

        return t;
      }(e)).length,
          f = 128,
          l = 0,
          p = 72;

      for (t = 0; t < e.length; t++) {
        (n = e[t]) < 128 && r.push(s(n));
      }

      var h = r.length,
          d = h;

      for (h && r.push("-"); d < o;) {
        var v = 2147483647;

        for (t = 0; t < e.length; t++) {
          (n = e[t]) >= f && n < v && (v = n);
        }

        var y = d + 1;
        if (v - f > a((2147483647 - l) / y)) throw RangeError(i);

        for (l += (v - f) * y, f = v, t = 0; t < e.length; t++) {
          if ((n = e[t]) < f && ++l > 2147483647) throw RangeError(i);

          if (n == f) {
            for (var g = l, m = 36;; m += 36) {
              var b = m <= p ? 1 : m >= p + 26 ? 26 : m - p;
              if (g < b) break;
              var x = g - b,
                  w = 36 - b;
              r.push(s(u(b + x % w))), g = a(x / w);
            }

            r.push(s(u(g))), p = c(l, y, d == h), l = 0, ++d;
          }
        }

        ++l, ++f;
      }

      return r.join("");
    };

    e.exports = function (e) {
      var t,
          n,
          i = [],
          a = e.toLowerCase().replace(o, ".").split(".");

      for (t = 0; t < a.length; t++) {
        n = a[t], i.push(r.test(n) ? "xn--" + f(n) : n);
      }

      return i.join(".");
    };
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    var r = n(238),
        o = n(72),
        i = n(168),
        a = n(73),
        s = n(70),
        u = n(261),
        c = n(263),
        f = n(264),
        l = Math.max,
        p = Math.min;
    r("replace", 2, function (e, t, n, r) {
      var h = r.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
          d = r.REPLACE_KEEPS_$0,
          v = h ? "$" : "$0";
      return [function (n, r) {
        var o = s(this),
            i = null == n ? void 0 : n[e];
        return void 0 !== i ? i.call(n, o, r) : t.call(String(o), n, r);
      }, function (e, r) {
        if (!h && d || "string" == typeof r && -1 === r.indexOf(v)) {
          var s = n(t, e, this, r);
          if (s.done) return s.value;
        }

        var y = o(e),
            g = String(this),
            m = "function" == typeof r;
        m || (r = String(r));
        var b = y.global;

        if (b) {
          var x = y.unicode;
          y.lastIndex = 0;
        }

        for (var w = [];;) {
          var k = f(y, g);
          if (null === k) break;
          if (w.push(k), !b) break;
          "" === String(k[0]) && (y.lastIndex = u(g, i(y.lastIndex), x));
        }

        for (var S, E = "", T = 0, _ = 0; _ < w.length; _++) {
          k = w[_];

          for (var O = String(k[0]), A = l(p(a(k.index), g.length), 0), R = [], P = 1; P < k.length; P++) {
            R.push(void 0 === (S = k[P]) ? S : String(S));
          }

          var I = k.groups;

          if (m) {
            var C = [O].concat(R, A, g);
            void 0 !== I && C.push(I);
            var j = String(r.apply(void 0, C));
          } else j = c(O, g, A, R, I, r);

          A >= T && (E += g.slice(T, A) + j, T = A + O.length);
        }

        return E + g.slice(T);
      }];
    });
  }, function (e, t, n) {
    "use strict";

    n(156);
    var r = n(97),
        o = n(27),
        i = n(101),
        a = n(54),
        s = i("species"),
        u = !o(function () {
      var e = /./;
      return e.exec = function () {
        var e = [];
        return e.groups = {
          a: "7"
        }, e;
      }, "7" !== "".replace(e, "$<a>");
    }),
        c = "$0" === "a".replace(/./, "$0"),
        f = i("replace"),
        l = !!/./[f] && "" === /./[f]("a", "$0"),
        p = !o(function () {
      var e = /(?:)/,
          t = e.exec;

      e.exec = function () {
        return t.apply(this, arguments);
      };

      var n = "ab".split(e);
      return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
    });

    e.exports = function (e, t, n, f) {
      var h = i(e),
          d = !o(function () {
        var t = {};
        return t[h] = function () {
          return 7;
        }, 7 != ""[e](t);
      }),
          v = d && !o(function () {
        var t = !1,
            n = /a/;
        return "split" === e && ((n = {}).constructor = {}, n.constructor[s] = function () {
          return n;
        }, n.flags = "", n[h] = /./[h]), n.exec = function () {
          return t = !0, null;
        }, n[h](""), !t;
      });

      if (!d || !v || "replace" === e && (!u || !c || l) || "split" === e && !p) {
        var y = /./[h],
            g = n(h, ""[e], function (e, t, n, r, o) {
          return t.exec === RegExp.prototype.exec ? d && !o ? {
            done: !0,
            value: y.call(t, n, r)
          } : {
            done: !0,
            value: e.call(n, t, r)
          } : {
            done: !1
          };
        }, {
          REPLACE_KEEPS_$0: c,
          REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: l
        }),
            m = g[0],
            b = g[1];
        r(String.prototype, e, m), r(RegExp.prototype, h, 2 == t ? function (e, t) {
          return b.call(e, this, t);
        } : function (e) {
          return b.call(e, this);
        });
      }

      f && a(RegExp.prototype[h], "sham", !0);
    };
  }, function (e, t, n) {
    "use strict";

    var r = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        i = o && !r.call({
      1: 2
    }, 1);
    t.f = i ? function (e) {
      var t = o(this, e);
      return !!t && t.enumerable;
    } : r;
  }, function (e, t, n) {
    var r = n(19),
        o = n(71),
        i = r.document,
        a = o(i) && o(i.createElement);

    e.exports = function (e) {
      return a ? i.createElement(e) : {};
    };
  }, function (e, t, n) {
    var r,
        o,
        i,
        a = n(242),
        s = n(19),
        u = n(71),
        c = n(54),
        f = n(41),
        l = n(99),
        p = n(243),
        h = n(166),
        d = s.WeakMap;

    if (a) {
      var v = l.state || (l.state = new d()),
          y = v.get,
          g = v.has,
          m = v.set;
      r = function r(e, t) {
        if (g.call(v, e)) throw new TypeError("Object already initialized");
        return t.facade = e, m.call(v, e, t), t;
      }, o = function o(e) {
        return y.call(v, e) || {};
      }, i = function i(e) {
        return g.call(v, e);
      };
    } else {
      var b = p("state");
      h[b] = !0, r = function r(e, t) {
        if (f(e, b)) throw new TypeError("Object already initialized");
        return t.facade = e, c(e, b, t), t;
      }, o = function o(e) {
        return f(e, b) ? e[b] : {};
      }, i = function i(e) {
        return f(e, b);
      };
    }

    e.exports = {
      set: r,
      get: o,
      has: i,
      enforce: function enforce(e) {
        return i(e) ? o(e) : r(e, {});
      },
      getterFor: function getterFor(e) {
        return function (t) {
          var n;
          if (!u(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
          return n;
        };
      }
    };
  }, function (e, t, n) {
    var r = n(19),
        o = n(164),
        i = r.WeakMap;
    e.exports = "function" == typeof i && /native code/.test(o(i));
  }, function (e, t, n) {
    var r = n(100),
        o = n(165),
        i = r("keys");

    e.exports = function (e) {
      return i[e] || (i[e] = o(e));
    };
  }, function (e, t) {
    e.exports = !1;
  }, function (e, t, n) {
    var r = n(41),
        o = n(246),
        i = n(158),
        a = n(96);

    e.exports = function (e, t) {
      for (var n = o(t), s = a.f, u = i.f, c = 0; c < n.length; c++) {
        var f = n[c];
        r(e, f) || s(e, f, u(t, f));
      }
    };
  }, function (e, t, n) {
    var r = n(167),
        o = n(248),
        i = n(253),
        a = n(72);

    e.exports = r("Reflect", "ownKeys") || function (e) {
      var t = o.f(a(e)),
          n = i.f;
      return n ? t.concat(n(e)) : t;
    };
  }, function (e, t, n) {
    var r = n(19);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(249),
        o = n(252).concat("length", "prototype");

    t.f = Object.getOwnPropertyNames || function (e) {
      return r(e, o);
    };
  }, function (e, t, n) {
    var r = n(41),
        o = n(68),
        i = n(250).indexOf,
        a = n(166);

    e.exports = function (e, t) {
      var n,
          s = o(e),
          u = 0,
          c = [];

      for (n in s) {
        !r(a, n) && r(s, n) && c.push(n);
      }

      for (; t.length > u;) {
        r(s, n = t[u++]) && (~i(c, n) || c.push(n));
      }

      return c;
    };
  }, function (e, t, n) {
    var r = n(68),
        o = n(168),
        i = n(251),
        a = function a(e) {
      return function (t, n, a) {
        var s,
            u = r(t),
            c = o(u.length),
            f = i(a, c);

        if (e && n != n) {
          for (; c > f;) {
            if ((s = u[f++]) != s) return !0;
          }
        } else for (; c > f; f++) {
          if ((e || f in u) && u[f] === n) return e || f || 0;
        }

        return !e && -1;
      };
    };

    e.exports = {
      includes: a(!0),
      indexOf: a(!1)
    };
  }, function (e, t, n) {
    var r = n(73),
        o = Math.max,
        i = Math.min;

    e.exports = function (e, t) {
      var n = r(e);
      return n < 0 ? o(n + t, 0) : i(n, t);
    };
  }, function (e, t) {
    e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    var r = n(27),
        o = /#|\.prototype\./,
        i = function i(e, t) {
      var n = s[a(e)];
      return n == c || n != u && ("function" == typeof t ? r(t) : !!t);
    },
        a = i.normalize = function (e) {
      return String(e).replace(o, ".").toLowerCase();
    },
        s = i.data = {},
        u = i.NATIVE = "N",
        c = i.POLYFILL = "P";

    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(72);

    e.exports = function () {
      var e = r(this),
          t = "";
      return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(27);

    function o(e, t) {
      return RegExp(e, t);
    }

    t.UNSUPPORTED_Y = r(function () {
      var e = o("a", "y");
      return e.lastIndex = 2, null != e.exec("abcd");
    }), t.BROKEN_CARET = r(function () {
      var e = o("^r", "gy");
      return e.lastIndex = 2, null != e.exec("str");
    });
  }, function (e, t, n) {
    var r = n(69),
        o = n(19);
    e.exports = "process" == r(o.process);
  }, function (e, t, n) {
    var r,
        o,
        i = n(19),
        a = n(259),
        s = i.process,
        u = s && s.versions,
        c = u && u.v8;
    c ? o = (r = c.split("."))[0] + r[1] : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
  }, function (e, t, n) {
    var r = n(167);
    e.exports = r("navigator", "userAgent") || "";
  }, function (e, t, n) {
    var r = n(170);
    e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  }, function (e, t, n) {
    "use strict";

    var r = n(262).charAt;

    e.exports = function (e, t, n) {
      return t + (n ? r(e, t).length : 1);
    };
  }, function (e, t, n) {
    var r = n(73),
        o = n(70),
        i = function i(e) {
      return function (t, n) {
        var i,
            a,
            s = String(o(t)),
            u = r(n),
            c = s.length;
        return u < 0 || u >= c ? e ? "" : void 0 : (i = s.charCodeAt(u)) < 55296 || i > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? e ? s.charAt(u) : i : e ? s.slice(u, u + 2) : a - 56320 + (i - 55296 << 10) + 65536;
      };
    };

    e.exports = {
      codeAt: i(!1),
      charAt: i(!0)
    };
  }, function (e, t, n) {
    var r = n(162),
        o = Math.floor,
        i = "".replace,
        a = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
        s = /\$([$&'`]|\d{1,2})/g;

    e.exports = function (e, t, n, u, c, f) {
      var l = n + e.length,
          p = u.length,
          h = s;
      return void 0 !== c && (c = r(c), h = a), i.call(f, h, function (r, i) {
        var a;

        switch (i.charAt(0)) {
          case "$":
            return "$";

          case "&":
            return e;

          case "`":
            return t.slice(0, n);

          case "'":
            return t.slice(l);

          case "<":
            a = c[i.slice(1, -1)];
            break;

          default:
            var s = +i;
            if (0 === s) return r;

            if (s > p) {
              var f = o(s / 10);
              return 0 === f ? r : f <= p ? void 0 === u[f - 1] ? i.charAt(1) : u[f - 1] + i.charAt(1) : r;
            }

            a = u[s - 1];
        }

        return void 0 === a ? "" : a;
      });
    };
  }, function (e, t, n) {
    var r = n(69),
        o = n(169);

    e.exports = function (e, t) {
      var n = e.exec;

      if ("function" == typeof n) {
        var i = n.call(e, t);
        if ("object" != typeof i) throw TypeError("RegExp exec method returned something other than an Object or null");
        return i;
      }

      if ("RegExp" !== r(e)) throw TypeError("RegExp#exec called on incompatible receiver");
      return o.call(e, t);
    };
  }, function (e, t, n) {
    e.exports = n(266);
  }, function (e, t, n) {
    var r = n(128);
    n(267), n(268), n(269), n(270), e.exports = r;
  }, function (e, t, n) {
    n(129);
  }, function (e, t, n) {
    n(145);
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(50),
        i = n(67);
    r({
      target: "Promise",
      stat: !0
    }, {
      try: function _try(e) {
        var t = o.f(this),
            n = i(e);
        return (n.error ? t.reject : t.resolve)(n.value), t.promise;
      }
    });
  }, function (e, t, n) {
    n(146);
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(20);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var i = o(n(36)),
        a = o(n(42)),
        s = o(n(45)),
        u = o(n(171)),
        c = n(74),
        f = function f(e) {
      return e.json().then(function (e) {
        return s.default.reject(e);
      });
    },
        l = function () {
      var e = (0, a.default)(i.default.mark(function e(t) {
        var n, r, o, a, s, l, p;
        return i.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.domain, r = t.interactionHandle, o = t.stateHandle, a = t.version, s = "".concat(n, "/idp/idx/introspect"), l = o ? {
                  stateToken: o
                } : {
                  interactionHandle: r
                }, p = {
                  "content-type": "application/ion+json; okta-version=".concat(a),
                  accept: "application/ion+json; okta-version=".concat(a)
                }, e.abrupt("return", (0, c.request)(s, {
                  headers: p,
                  body: (0, u.default)(l)
                }).then(function (e) {
                  return e.ok ? e.json() : f(e);
                }));

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }();

    t.default = l;
  }, function (e, t, n) {
    var r = n(273);
    e.exports = r;
  }, function (e, t, n) {
    n(274);
    var r = n(11);
    r.JSON || (r.JSON = {
      stringify: JSON.stringify
    }), e.exports = function (e, t, n) {
      return r.JSON.stringify.apply(null, arguments);
    };
  }, function (e, t, n) {
    var r = n(6),
        o = n(23),
        i = n(10),
        a = o("JSON", "stringify"),
        s = /[\uD800-\uDFFF]/g,
        u = /^[\uD800-\uDBFF]$/,
        c = /^[\uDC00-\uDFFF]$/,
        f = function f(e, t, n) {
      var r = n.charAt(t - 1),
          o = n.charAt(t + 1);
      return u.test(e) && !c.test(o) || c.test(e) && !u.test(r) ? "\\u" + e.charCodeAt(0).toString(16) : e;
    },
        l = i(function () {
      return "\"\\udf06\\ud834\"" !== a("\uDF06\uD834") || "\"\\udead\"" !== a("\uDEAD");
    });

    a && r({
      target: "JSON",
      stat: !0,
      forced: l
    }, {
      stringify: function stringify(e, t, n) {
        var r = a.apply(null, arguments);
        return "string" == typeof r ? r.replace(s, f) : r;
      }
    });
  }, function (e, t, n) {
    var r = n(172);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(6),
        o = n(25),
        i = n(46);
    r({
      target: "Object",
      stat: !0,
      forced: n(10)(function () {
        i(1);
      })
    }, {
      keys: function keys(e) {
        return i(o(e));
      }
    });
  }, function (e, t, n) {
    var r = n(173);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(21),
        o = n(103).f,
        i = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    e.exports.f = function (e) {
      return a && "[object Window]" == i.call(e) ? function (e) {
        try {
          return o(e);
        } catch (e) {
          return a.slice();
        }
      }(e) : o(r(e));
    };
  }, function (e, t, n) {
    var r = n(280);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(281),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.filter;
      return e === o || e instanceof Array && t === o.filter ? r : t;
    };
  }, function (e, t, n) {
    n(282);
    var r = n(29);
    e.exports = r("Array").filter;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(56).filter;
    r({
      target: "Array",
      proto: !0,
      forced: !n(77)("filter")
    }, {
      filter: function filter(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (e, t, n) {
    var r = n(284);
    e.exports = r;
  }, function (e, t, n) {
    n(285);

    var r = n(11).Object,
        o = e.exports = function (e, t) {
      return r.getOwnPropertyDescriptor(e, t);
    };

    r.getOwnPropertyDescriptor.sham && (o.sham = !0);
  }, function (e, t, n) {
    var r = n(6),
        o = n(10),
        i = n(21),
        a = n(44).f,
        s = n(13),
        u = o(function () {
      a(1);
    });
    r({
      target: "Object",
      stat: !0,
      forced: !s || u,
      sham: !s
    }, {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
        return a(i(e), t);
      }
    });
  }, function (e, t, n) {
    n(51);
    var r = n(287),
        o = n(49),
        i = Array.prototype,
        a = {
      DOMTokenList: !0,
      NodeList: !0
    };

    e.exports = function (e) {
      var t = e.forEach;
      return e === i || e instanceof Array && t === i.forEach || a.hasOwnProperty(o(e)) ? r : t;
    };
  }, function (e, t, n) {
    var r = n(288);
    e.exports = r;
  }, function (e, t, n) {
    n(289);
    var r = n(29);
    e.exports = r("Array").forEach;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(290);
    r({
      target: "Array",
      proto: !0,
      forced: [].forEach != o
    }, {
      forEach: o
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(56).forEach,
        o = n(127)("forEach");
    e.exports = o ? [].forEach : function (e) {
      return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
    };
  }, function (e, t, n) {
    var r = n(292);
    e.exports = r;
  }, function (e, t, n) {
    n(293);
    var r = n(11);
    e.exports = r.Object.getOwnPropertyDescriptors;
  }, function (e, t, n) {
    var r = n(6),
        o = n(13),
        i = n(294),
        a = n(21),
        s = n(44),
        u = n(52);
    r({
      target: "Object",
      stat: !0,
      sham: !o
    }, {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(e) {
        for (var t, n, r = a(e), o = s.f, c = i(r), f = {}, l = 0; c.length > l;) {
          void 0 !== (n = o(r, t = c[l++])) && u(f, t, n);
        }

        return f;
      }
    });
  }, function (e, t, n) {
    var r = n(23),
        o = n(103),
        i = n(95),
        a = n(15);

    e.exports = r("Reflect", "ownKeys") || function (e) {
      var t = o.f(a(e)),
          n = i.f;
      return n ? t.concat(n(e)) : t;
    };
  }, function (e, t, n) {
    var r = n(296);
    e.exports = r;
  }, function (e, t, n) {
    n(297);

    var r = n(11).Object,
        o = e.exports = function (e, t) {
      return r.defineProperties(e, t);
    };

    r.defineProperties.sham && (o.sham = !0);
  }, function (e, t, n) {
    var r = n(6),
        o = n(13);
    r({
      target: "Object",
      stat: !0,
      forced: !o,
      sham: !o
    }, {
      defineProperties: n(88)
    });
  }, function (e, t, n) {
    e.exports = n(299);
  }, function (e, t, n) {
    var r = n(121);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    n(16)(t, "__esModule", {
      value: !0
    }), t.userAgentHeaders = t.getUserAgent = void 0;
    /*!
     * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    var r = function r() {
      return "okta-idx-js/".concat("0.17.0");
    };

    t.getUserAgent = r;

    t.userAgentHeaders = function () {
      return {
        "X-Okta-User-Agent-Extended": r()
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(20);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(36));
    n(302);

    var a = o(n(176)),
        s = o(n(42)),
        u = o(n(45)),
        c = o(n(111)),
        f = o(n(187)),
        l = o(n(188)),
        p = n(74),
        h = function h(e) {
      return e.json().then(function (e) {
        return u.default.reject(e);
      });
    },
        d = function () {
      var e = (0, s.default)(i.default.mark(function e(t) {
        var n, r, o, s, u, d, v, y, g, m, b, x;
        return i.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.clientId, o = t.baseUrl, s = t.scopes, u = void 0 === s ? ["openid", "email"] : s, d = t.redirectUri, v = t.codeChallenge, y = t.codeChallengeMethod, g = t.state, m = "".concat(o, "/v1/interact"), b = (0, c.default)(n = (0, f.default)({
                  client_id: r,
                  scope: u.join(" "),
                  redirect_uri: d,
                  code_challenge: v,
                  code_challenge_method: y,
                  state: g
                })).call(n, function (e) {
                  var t,
                      n = (0, a.default)(e, 2),
                      r = n[0],
                      o = n[1];
                  return (0, l.default)(t = "".concat(r, "=")).call(t, encodeURIComponent(o));
                }).join("&"), x = {
                  "content-type": "application/x-www-form-urlencoded"
                }, e.abrupt("return", (0, p.request)(m, {
                  headers: x,
                  body: b
                }).then(function (e) {
                  return e.ok ? e.json() : h(e);
                }).then(function (e) {
                  return e.interaction_handle;
                }));

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }();

    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(157),
        o = n(160),
        i = n(68),
        a = n(303),
        s = [].join,
        u = o != Object,
        c = a("join", ",");
    r({
      target: "Array",
      proto: !0,
      forced: u || !c
    }, {
      join: function join(e) {
        return s.call(i(this), void 0 === e ? "," : e);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(27);

    e.exports = function (e, t) {
      var n = [][e];
      return !!n && r(function () {
        n.call(null, t || function () {
          throw 1;
        }, 1);
      });
    };
  }, function (e, t, n) {
    var r = n(177);
    e.exports = function (e) {
      if (r(e)) return e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(178);
    e.exports = r;
  }, function (e, t, n) {
    n(6)({
      target: "Array",
      stat: !0
    }, {
      isArray: n(55)
    });
  }, function (e, t, n) {
    var r = n(109),
        o = n(110);
    e.exports = function (e, t) {
      var n = e && (void 0 !== r && o(e) || e["@@iterator"]);

      if (null != n) {
        var i,
            a,
            s = [],
            u = !0,
            c = !1;

        try {
          for (n = n.call(e); !(u = (i = n.next()).done) && (s.push(i.value), !t || s.length !== t); u = !0) {
            ;
          }
        } catch (e) {
          c = !0, a = e;
        } finally {
          try {
            u || null == n.return || n.return();
          } finally {
            if (c) throw a;
          }
        }

        return s;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(179);
    n(325), n(326), n(327), n(328), n(329), e.exports = r;
  }, function (e, t, n) {
    n(9)("asyncIterator");
  }, function (e, t) {}, function (e, t, n) {
    n(9)("hasInstance");
  }, function (e, t, n) {
    n(9)("isConcatSpreadable");
  }, function (e, t, n) {
    n(9)("match");
  }, function (e, t, n) {
    n(9)("matchAll");
  }, function (e, t, n) {
    n(9)("replace");
  }, function (e, t, n) {
    n(9)("search");
  }, function (e, t, n) {
    n(9)("species");
  }, function (e, t, n) {
    n(9)("split");
  }, function (e, t, n) {
    n(9)("toPrimitive");
  }, function (e, t, n) {
    n(9)("toStringTag");
  }, function (e, t, n) {
    n(9)("unscopables");
  }, function (e, t, n) {
    var r = n(8);
    n(32)(r.JSON, "JSON", !0);
  }, function (e, t) {}, function (e, t) {}, function (e, t, n) {
    n(9)("asyncDispose");
  }, function (e, t, n) {
    n(9)("dispose");
  }, function (e, t, n) {
    n(9)("observable");
  }, function (e, t, n) {
    n(9)("patternMatch");
  }, function (e, t, n) {
    n(9)("replaceAll");
  }, function (e, t, n) {
    n(51), n(40);
    var r = n(48);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(332);
  }, function (e, t, n) {
    var r = n(183);
    e.exports = r;
  }, function (e, t, n) {
    n(334);
    var r = n(29);
    e.exports = r("Array").slice;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(17),
        i = n(55),
        a = n(126),
        s = n(37),
        u = n(21),
        c = n(52),
        f = n(7),
        l = n(77)("slice"),
        p = f("species"),
        h = [].slice,
        d = Math.max;
    r({
      target: "Array",
      proto: !0,
      forced: !l
    }, {
      slice: function slice(e, t) {
        var n,
            r,
            f,
            l = u(this),
            v = s(l.length),
            y = a(e, v),
            g = a(void 0 === t ? v : t, v);
        if (i(l) && ("function" != typeof (n = l.constructor) || n !== Array && !i(n.prototype) ? o(n) && null === (n = n[p]) && (n = void 0) : n = void 0, n === Array || void 0 === n)) return h.call(l, y, g);

        for (r = new (void 0 === n ? Array : n)(d(g - y, 0)), f = 0; y < g; y++, f++) {
          y in l && c(r, f, l[y]);
        }

        return r.length = f, r;
      }
    });
  }, function (e, t, n) {
    var r = n(185);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(6),
        o = n(153);
    r({
      target: "Array",
      stat: !0,
      forced: !n(140)(function (e) {
        Array.from(e);
      })
    }, {
      from: o
    });
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(339);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(340),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.map;
      return e === o || e instanceof Array && t === o.map ? r : t;
    };
  }, function (e, t, n) {
    n(341);
    var r = n(29);
    e.exports = r("Array").map;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(56).map;
    r({
      target: "Array",
      proto: !0,
      forced: !n(77)("map")
    }, {
      map: function map(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (e, t, n) {
    var r = n(343);
    e.exports = r;
  }, function (e, t, n) {
    n(344);
    var r = n(11);
    e.exports = r.Object.entries;
  }, function (e, t, n) {
    var r = n(6),
        o = n(345).entries;
    r({
      target: "Object",
      stat: !0
    }, {
      entries: function entries(e) {
        return o(e);
      }
    });
  }, function (e, t, n) {
    var r = n(13),
        o = n(46),
        i = n(21),
        a = n(59).f,
        s = function s(e) {
      return function (t) {
        for (var n, s = i(t), u = o(s), c = u.length, f = 0, l = []; c > f;) {
          n = u[f++], r && !a.call(s, n) || l.push(e ? [n, s[n]] : s[n]);
        }

        return l;
      };
    };

    e.exports = {
      entries: s(!0),
      values: s(!1)
    };
  }, function (e, t, n) {
    var r = n(347);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(348),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.concat;
      return e === o || e instanceof Array && t === o.concat ? r : t;
    };
  }, function (e, t, n) {
    n(180);
    var r = n(29);
    e.exports = r("Array").concat;
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(20);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var i = o(n(350)),
        a = function a(e) {
      switch (e) {
        case "1.0.0":
          return i.default;

        case void 0:
        case null:
          throw new Error("Api version is required");

        default:
          throw new Error("Unknown api version: ".concat(e, ".  Use an exact semver version."));
      }
    };
    /*!
     * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(20);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = {
      makeIdxState: o(n(189)).default
    };
    /*!
     * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    t.default = i;
  }, function (e, t, n) {
    e.exports = n(352);
  }, function (e, t, n) {
    var r = n(353);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(354),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.find;
      return e === o || e instanceof Array && t === o.find ? r : t;
    };
  }, function (e, t, n) {
    n(355);
    var r = n(29);
    e.exports = r("Array").find;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(56).find,
        i = n(151),
        a = !0;
    "find" in [] && Array(1).find(function () {
      a = !1;
    }), r({
      target: "Array",
      proto: !0,
      forced: a
    }, {
      find: function find(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), i("find");
  }, function (e, t, n) {
    var r = n(357),
        o = n(358),
        i = n(182),
        a = n(359);
    e.exports = function (e) {
      return r(e) || o(e) || i(e) || a();
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(177),
        o = n(186);
    e.exports = function (e) {
      if (r(e)) return o(e);
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(109),
        o = n(110),
        i = n(184);
    e.exports = function (e) {
      if (void 0 !== r && null != o(e) || null != e["@@iterator"]) return i(e);
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    var r = n(75),
        o = n(102),
        i = n(76),
        a = n(105),
        s = n(57),
        u = n(106),
        c = n(107),
        f = n(16),
        l = n(20);
    f(t, "__esModule", {
      value: !0
    }), t.parseIdxResponse = t.parseNonRemediations = void 0, n(58);

    var p,
        h = l(n(176)),
        d = l(n(108)),
        v = l(n(361)),
        y = l(n(368)),
        g = l(n(191)),
        m = l(n(111)),
        b = l(n(57)),
        x = l(n(76)),
        w = l(n(75)),
        k = l(n(187)),
        S = l(n(188)),
        E = l(n(112)),
        T = n(376),
        _ = l(n(192)),
        O = l(n(389));

    function A(e, t) {
      var n = r(e);

      if (o) {
        var s = o(e);
        t && (s = i(s).call(s, function (t) {
          return a(e, t).enumerable;
        })), n.push.apply(n, s);
      }

      return n;
    }

    function R(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n,
            r = null != arguments[t] ? arguments[t] : {};
        if (t % 2) s(n = A(Object(r), !0)).call(n, function (t) {
          (0, d.default)(e, t, r[t]);
        });else if (u) c(e, u(r));else {
          var o;
          s(o = A(Object(r))).call(o, function (t) {
            f(e, t, a(r, t));
          });
        }
      }

      return e;
    }

    var P = (0, g.default)((0, m.default)(p = ["remediation", "context"]).call(p, function (e) {
      return [e, !0];
    })),
        I = function I(e) {
      var t,
          n,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          o = {},
          i = {};
      return (0, b.default)(t = (0, x.default)(n = (0, w.default)(e)).call(n, function (e) {
        return !P[e];
      })).call(t, function (t) {
        var n;
        if ("object" === (0, y.default)(e[t]) && !!e[t]) {
          if (e[t].rel) o[e[t].name] = (0, _.default)(e[t], r);else {
            var a = e[t],
                s = a.value,
                u = a.type,
                c = (0, v.default)(a, ["value", "type"]);
            i[t] = R({
              type: u
            }, c), "object" === u ? (i[t].value = {}, (0, b.default)(n = (0, k.default)(s)).call(n, function (e) {
              var n,
                  a = (0, h.default)(e, 2),
                  s = a[0],
                  u = a[1];
              u.rel ? o[(0, S.default)(n = "".concat(t, "-")).call(n, s.name || s)] = (0, _.default)(u, r) : i[t].value[s] = u;
            })) : i[t].value = s;
          }
        } else i[t] = e[t];
      }), {
        context: i,
        actions: o
      };
    };

    t.parseNonRemediations = I;

    var C = function e(t, n) {
      var r;
      (0, b.default)(r = (0, w.default)(n)).call(r, function (r) {
        if ("relatesTo" === r) {
          var o = (0, E.default)(n[r]) ? n[r][0] : n[r];

          if ("string" == typeof o) {
            var i = O.default.query(t, o)[0];
            if (i) return void (n[r] = i);
          }
        }

        var a;
        (0, E.default)(n[r]) && (0, b.default)(a = n[r]).call(a, function (n) {
          return e(t, n);
        });
      });
    },
        j = function j(e, t) {
      var n = (0, T.generateRemediationFunctions)([e], t)[e.name];
      return R(R({}, e), {}, {
        action: n
      });
    };

    t.parseIdxResponse = function (e) {
      var t,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = (null === (t = e.remediation) || void 0 === t ? void 0 : t.value) || [];
      (0, b.default)(r).call(r, function (t) {
        return C(e, t);
      });
      var o = (0, m.default)(r).call(r, function (e) {
        return j(e, n);
      }),
          i = I(e, n),
          a = i.context,
          s = i.actions;
      return {
        remediations: o,
        context: a,
        actions: s
      };
    };
  }, function (e, t, n) {
    var r = n(362),
        o = n(190),
        i = n(365);
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          a,
          s = i(e, t);

      if (r) {
        var u = r(e);

        for (a = 0; a < u.length; a++) {
          n = u[a], o(t).call(t, n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (s[n] = e[n]);
        }
      }

      return s;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    e.exports = n(363);
  }, function (e, t, n) {
    var r = n(173);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(124);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(366),
        o = n(190);
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          i,
          a = {},
          s = r(e);

      for (i = 0; i < s.length; i++) {
        n = s[i], o(t).call(t, n) >= 0 || (a[n] = e[n]);
      }

      return a;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    e.exports = n(367);
  }, function (e, t, n) {
    var r = n(172);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(109),
        o = n(369);

    function i(t) {
      return "function" == typeof r && "symbol" == typeof o ? (e.exports = i = function i(e) {
        return typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = i = function i(e) {
        return e && "function" == typeof r && e.constructor === r && e !== r.prototype ? "symbol" : typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0), i(t);
    }

    e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    e.exports = n(370);
  }, function (e, t, n) {
    var r = n(371);
    e.exports = r;
  }, function (e, t, n) {
    n(181), n(40), n(51);
    var r = n(104);
    e.exports = r.f("iterator");
  }, function (e, t, n) {
    var r = n(373);
    e.exports = r;
  }, function (e, t, n) {
    n(94), n(374);
    var r = n(11);
    e.exports = r.Object.fromEntries;
  }, function (e, t, n) {
    var r = n(6),
        o = n(47),
        i = n(52);
    r({
      target: "Object",
      stat: !0
    }, {
      fromEntries: function fromEntries(e) {
        var t = {};
        return o(e, function (e, n) {
          i(t, e, n);
        }, {
          AS_ENTRIES: !0
        }), t;
      }
    });
  }, function (e, t, n) {
    var r = n(178);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        o = n(20);
    r(t, "__esModule", {
      value: !0
    }), t.generateRemediationFunctions = void 0, n(58);
    var i = o(n(191)),
        a = o(n(111)),
        s = o(n(192));

    t.generateRemediationFunctions = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return (0, i.default)((0, a.default)(e).call(e, function (e) {
        return [e.name, (0, s.default)(e, t)];
      }));
    };
  }, function (e, t, n) {
    "use strict";

    n(378);
    var r = n(381),
        o = n(383),
        i = n(385),
        a = n(110),
        s = n(112),
        u = n(387),
        c = n(16),
        f = n(20);
    c(t, "__esModule", {
      value: !0
    }), t.divideActionParamsByMutability = void 0;
    var l = f(n(112));

    function p(e, t) {
      var _n3;

      if (void 0 === i || null == a(e)) {
        if (s(e) || (_n3 = function (e, t) {
          var n;
          if (!e) return;
          if ("string" == typeof e) return h(e, t);
          var i = r(n = Object.prototype.toString.call(e)).call(n, 8, -1);
          "Object" === i && e.constructor && (i = e.constructor.name);
          if ("Map" === i || "Set" === i) return o(e);
          if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return h(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n3 && (e = _n3);

          var c = 0,
              f = function f() {};

          return {
            s: f,
            n: function n() {
              return c >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[c++]
              };
            },
            e: function e(_e5) {
              throw _e5;
            },
            f: f
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var l,
          p = !0,
          d = !1;
      return {
        s: function s() {
          _n3 = u(e);
        },
        n: function n() {
          var e = _n3.next();

          return p = e.done, e;
        },
        e: function e(_e6) {
          d = !0, l = _e6;
        },
        f: function f() {
          try {
            p || null == _n3.return || _n3.return();
          } finally {
            if (d) throw l;
          }
        }
      };
    }

    function h(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }
    /*!
     * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    n(58);

    var d = function d(e) {
      return !1 !== e.mutable;
    },
        v = function v(e) {
      var t = {},
          n = [],
          r = {};
      if (!e.value) return n.push(e), {
        defaultParamsForAction: t,
        neededParamsForAction: n,
        immutableParamsForAction: r
      };
      var o,
          i = p(e.value);

      try {
        for (i.s(); !(o = i.n()).done;) {
          var a,
              s,
              u = o.value;
          if (d(u)) n.push(u), null !== (a = u.value) && void 0 !== a && a && (t[u.name] = u.value);else r[u.name] = null !== (s = u.value) && void 0 !== s ? s : "";
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }

      return {
        defaultParamsForAction: t,
        neededParamsForAction: n,
        immutableParamsForAction: r
      };
    };

    t.divideActionParamsByMutability = function (e) {
      var t,
          n = [],
          r = {},
          o = {},
          i = p(e = (0, l.default)(e) ? e : [e]);

      try {
        for (i.s(); !(t = i.n()).done;) {
          var a = t.value,
              s = v(a),
              u = s.defaultParamsForAction,
              c = s.neededParamsForAction,
              f = s.immutableParamsForAction;
          n.push(c), r[a.name] = u, o[a.name] = f;
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }

      return {
        defaultParams: r,
        neededParams: n,
        immutableParams: o
      };
    };
  }, function (e, t, n) {
    var r = n(113),
        o = n(97),
        i = n(379);
    r || o(Object.prototype, "toString", i, {
      unsafe: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(113),
        o = n(380);
    e.exports = r ? {}.toString : function () {
      return "[object " + o(this) + "]";
    };
  }, function (e, t, n) {
    var r = n(113),
        o = n(69),
        i = n(101)("toStringTag"),
        a = "Arguments" == o(function () {
      return arguments;
    }());
    e.exports = r ? o : function (e) {
      var t, n, r;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
        try {
          return e[t];
        } catch (e) {}
      }(t = Object(e), i)) ? n : a ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
    };
  }, function (e, t, n) {
    e.exports = n(382);
  }, function (e, t, n) {
    var r = n(183);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(384);
  }, function (e, t, n) {
    var r = n(185);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(386);
  }, function (e, t, n) {
    var r = n(179);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(388);
  }, function (e, t, n) {
    n(51), n(40);
    var r = n(155);
    e.exports = r;
  }, function (e, t, n) {
    (function (t) {
      e.exports = function e(t, n, r) {
        function o(a, s) {
          if (!n[a]) {
            if (!t[a]) {
              if (i) return i(a, !0);
              var u = new Error("Cannot find module '" + a + "'");
              throw u.code = "MODULE_NOT_FOUND", u;
            }

            var c = n[a] = {
              exports: {}
            };
            t[a][0].call(c.exports, function (e) {
              var n = t[a][1][e];
              return o(n || e);
            }, c, c.exports, e, t, n, r);
          }

          return n[a].exports;
        }

        for (var i = !1, a = 0; a < r.length; a++) {
          o(r[a]);
        }

        return o;
      }({
        "./aesprim": [function (e, t, n) {
          !function (e, t) {
            "use strict";

            t(void 0 !== n ? n : e.esprima = {});
          }(this, function (e) {
            "use strict";

            var t, n, r, o, i, a, s, u, c, f, l, p, h, d, v, y, g, m;

            function b(e, t) {
              if (!e) throw new Error("ASSERT: " + t);
            }

            function x(e) {
              return e >= 48 && e <= 57;
            }

            function w(e) {
              return "0123456789abcdefABCDEF".indexOf(e) >= 0;
            }

            function k(e) {
              return "01234567".indexOf(e) >= 0;
            }

            function S(e) {
              return 32 === e || 9 === e || 11 === e || 12 === e || 160 === e || e >= 5760 && [5760, 6158, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279].indexOf(e) >= 0;
            }

            function E(e) {
              return 10 === e || 13 === e || 8232 === e || 8233 === e;
            }

            function T(e) {
              return 64 == e || 36 === e || 95 === e || e >= 65 && e <= 90 || e >= 97 && e <= 122 || 92 === e || e >= 128 && s.NonAsciiIdentifierStart.test(String.fromCharCode(e));
            }

            function _(e) {
              return 36 === e || 95 === e || e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || 92 === e || e >= 128 && s.NonAsciiIdentifierPart.test(String.fromCharCode(e));
            }

            function O(e) {
              switch (e) {
                case "implements":
                case "interface":
                case "package":
                case "private":
                case "protected":
                case "public":
                case "static":
                case "yield":
                case "let":
                  return !0;

                default:
                  return !1;
              }
            }

            function A(e) {
              return "eval" === e || "arguments" === e;
            }

            function R(e, t, n, r, o) {
              var i;
              b("number" == typeof n, "Comment must have valid position"), g.lastCommentStart >= n || (g.lastCommentStart = n, i = {
                type: e,
                value: t
              }, m.range && (i.range = [n, r]), m.loc && (i.loc = o), m.comments.push(i), m.attachComment && (m.leadingComments.push(i), m.trailingComments.push(i)));
            }

            function P(e) {
              var t, n, r, o;

              for (t = l - e, n = {
                start: {
                  line: p,
                  column: l - h - e
                }
              }; l < d;) {
                if (r = c.charCodeAt(l), ++l, E(r)) return m.comments && (o = c.slice(t + e, l - 1), n.end = {
                  line: p,
                  column: l - h - 1
                }, R("Line", o, t, l - 1, n)), 13 === r && 10 === c.charCodeAt(l) && ++l, ++p, void (h = l);
              }

              m.comments && (o = c.slice(t + e, l), n.end = {
                line: p,
                column: l - h
              }, R("Line", o, t, l, n));
            }

            function I() {
              var e, t, n, r;

              for (m.comments && (e = l - 2, t = {
                start: {
                  line: p,
                  column: l - h - 2
                }
              }); l < d;) {
                if (E(n = c.charCodeAt(l))) 13 === n && 10 === c.charCodeAt(l + 1) && ++l, ++p, ++l, h = l, l >= d && V({}, a.UnexpectedToken, "ILLEGAL");else if (42 === n) {
                  if (47 === c.charCodeAt(l + 1)) return ++l, ++l, void (m.comments && (r = c.slice(e + 2, l - 2), t.end = {
                    line: p,
                    column: l - h
                  }, R("Block", r, e, l, t)));
                  ++l;
                } else ++l;
              }

              V({}, a.UnexpectedToken, "ILLEGAL");
            }

            function C() {
              var e, t;

              for (t = 0 === l; l < d;) {
                if (S(e = c.charCodeAt(l))) ++l;else if (E(e)) ++l, 13 === e && 10 === c.charCodeAt(l) && ++l, ++p, h = l, t = !0;else if (47 === e) {
                  if (47 === (e = c.charCodeAt(l + 1))) ++l, ++l, P(2), t = !0;else {
                    if (42 !== e) break;
                    ++l, ++l, I();
                  }
                } else if (t && 45 === e) {
                  if (45 !== c.charCodeAt(l + 1) || 62 !== c.charCodeAt(l + 2)) break;
                  l += 3, P(3);
                } else {
                  if (60 !== e) break;
                  if ("!--" !== c.slice(l + 1, l + 4)) break;
                  ++l, ++l, ++l, ++l, P(4);
                }
              }
            }

            function j(e) {
              var t,
                  n,
                  r,
                  o = 0;

              for (n = "u" === e ? 4 : 2, t = 0; t < n; ++t) {
                if (!(l < d && w(c[l]))) return "";
                r = c[l++], o = 16 * o + "0123456789abcdef".indexOf(r.toLowerCase());
              }

              return String.fromCharCode(o);
            }

            function L() {
              var e, t;

              for (e = c.charCodeAt(l++), t = String.fromCharCode(e), 92 === e && (117 !== c.charCodeAt(l) && V({}, a.UnexpectedToken, "ILLEGAL"), ++l, (e = j("u")) && "\\" !== e && T(e.charCodeAt(0)) || V({}, a.UnexpectedToken, "ILLEGAL"), t = e); l < d && _(e = c.charCodeAt(l));) {
                ++l, t += String.fromCharCode(e), 92 === e && (t = t.substr(0, t.length - 1), 117 !== c.charCodeAt(l) && V({}, a.UnexpectedToken, "ILLEGAL"), ++l, (e = j("u")) && "\\" !== e && _(e.charCodeAt(0)) || V({}, a.UnexpectedToken, "ILLEGAL"), t += e);
              }

              return t;
            }

            function M() {
              var e, n;
              return e = l, {
                type: 1 === (n = 92 === c.charCodeAt(l) ? L() : function () {
                  var e, t;

                  for (e = l++; l < d;) {
                    if (92 === (t = c.charCodeAt(l))) return l = e, L();
                    if (!_(t)) break;
                    ++l;
                  }

                  return c.slice(e, l);
                }()).length ? t.Identifier : function (e) {
                  if (f && O(e)) return !0;

                  switch (e.length) {
                    case 2:
                      return "if" === e || "in" === e || "do" === e;

                    case 3:
                      return "var" === e || "for" === e || "new" === e || "try" === e || "let" === e;

                    case 4:
                      return "this" === e || "else" === e || "case" === e || "void" === e || "with" === e || "enum" === e;

                    case 5:
                      return "while" === e || "break" === e || "catch" === e || "throw" === e || "const" === e || "yield" === e || "class" === e || "super" === e;

                    case 6:
                      return "return" === e || "typeof" === e || "delete" === e || "switch" === e || "export" === e || "import" === e;

                    case 7:
                      return "default" === e || "finally" === e || "extends" === e;

                    case 8:
                      return "function" === e || "continue" === e || "debugger" === e;

                    case 10:
                      return "instanceof" === e;

                    default:
                      return !1;
                  }
                }(n) ? t.Keyword : "null" === n ? t.NullLiteral : "true" === n || "false" === n ? t.BooleanLiteral : t.Identifier,
                value: n,
                lineNumber: p,
                lineStart: h,
                start: e,
                end: l
              };
            }

            function N() {
              var e,
                  n,
                  r,
                  o,
                  i = l,
                  s = c.charCodeAt(l),
                  u = c[l];

              switch (s) {
                case 46:
                case 40:
                case 41:
                case 59:
                case 44:
                case 123:
                case 125:
                case 91:
                case 93:
                case 58:
                case 63:
                case 126:
                  return ++l, m.tokenize && (40 === s ? m.openParenToken = m.tokens.length : 123 === s && (m.openCurlyToken = m.tokens.length)), {
                    type: t.Punctuator,
                    value: String.fromCharCode(s),
                    lineNumber: p,
                    lineStart: h,
                    start: i,
                    end: l
                  };

                default:
                  if (61 === (e = c.charCodeAt(l + 1))) switch (s) {
                    case 43:
                    case 45:
                    case 47:
                    case 60:
                    case 62:
                    case 94:
                    case 124:
                    case 37:
                    case 38:
                    case 42:
                      return l += 2, {
                        type: t.Punctuator,
                        value: String.fromCharCode(s) + String.fromCharCode(e),
                        lineNumber: p,
                        lineStart: h,
                        start: i,
                        end: l
                      };

                    case 33:
                    case 61:
                      return l += 2, 61 === c.charCodeAt(l) && ++l, {
                        type: t.Punctuator,
                        value: c.slice(i, l),
                        lineNumber: p,
                        lineStart: h,
                        start: i,
                        end: l
                      };
                  }
              }

              return ">>>=" === (o = c.substr(l, 4)) ? {
                type: t.Punctuator,
                value: o,
                lineNumber: p,
                lineStart: h,
                start: i,
                end: l += 4
              } : ">>>" === (r = o.substr(0, 3)) || "<<=" === r || ">>=" === r ? {
                type: t.Punctuator,
                value: r,
                lineNumber: p,
                lineStart: h,
                start: i,
                end: l += 3
              } : u === (n = r.substr(0, 2))[1] && "+-<>&|".indexOf(u) >= 0 || "=>" === n ? {
                type: t.Punctuator,
                value: n,
                lineNumber: p,
                lineStart: h,
                start: i,
                end: l += 2
              } : "<>=!+-*%&|^/".indexOf(u) >= 0 ? (++l, {
                type: t.Punctuator,
                value: u,
                lineNumber: p,
                lineStart: h,
                start: i,
                end: l
              }) : void V({}, a.UnexpectedToken, "ILLEGAL");
            }

            function U() {
              var e, n, r;

              if (b(x((r = c[l]).charCodeAt(0)) || "." === r, "Numeric literal must start with a decimal digit or a decimal point"), n = l, e = "", "." !== r) {
                if (e = c[l++], r = c[l], "0" === e) {
                  if ("x" === r || "X" === r) return ++l, function (e) {
                    for (var n = ""; l < d && w(c[l]);) {
                      n += c[l++];
                    }

                    return 0 === n.length && V({}, a.UnexpectedToken, "ILLEGAL"), T(c.charCodeAt(l)) && V({}, a.UnexpectedToken, "ILLEGAL"), {
                      type: t.NumericLiteral,
                      value: parseInt("0x" + n, 16),
                      lineNumber: p,
                      lineStart: h,
                      start: e,
                      end: l
                    };
                  }(n);
                  if (k(r)) return function (e) {
                    for (var n = "0" + c[l++]; l < d && k(c[l]);) {
                      n += c[l++];
                    }

                    return (T(c.charCodeAt(l)) || x(c.charCodeAt(l))) && V({}, a.UnexpectedToken, "ILLEGAL"), {
                      type: t.NumericLiteral,
                      value: parseInt(n, 8),
                      octal: !0,
                      lineNumber: p,
                      lineStart: h,
                      start: e,
                      end: l
                    };
                  }(n);
                  r && x(r.charCodeAt(0)) && V({}, a.UnexpectedToken, "ILLEGAL");
                }

                for (; x(c.charCodeAt(l));) {
                  e += c[l++];
                }

                r = c[l];
              }

              if ("." === r) {
                for (e += c[l++]; x(c.charCodeAt(l));) {
                  e += c[l++];
                }

                r = c[l];
              }

              if ("e" === r || "E" === r) if (e += c[l++], "+" !== (r = c[l]) && "-" !== r || (e += c[l++]), x(c.charCodeAt(l))) for (; x(c.charCodeAt(l));) {
                e += c[l++];
              } else V({}, a.UnexpectedToken, "ILLEGAL");
              return T(c.charCodeAt(l)) && V({}, a.UnexpectedToken, "ILLEGAL"), {
                type: t.NumericLiteral,
                value: parseFloat(e),
                lineNumber: p,
                lineStart: h,
                start: n,
                end: l
              };
            }

            function D() {
              var e, n, r, o;
              return y = null, C(), e = l, n = function () {
                var e, t, n, r;

                for (b("/" === (e = c[l]), "Regular expression literal must start with a slash"), t = c[l++], n = !1, r = !1; l < d;) {
                  if (t += e = c[l++], "\\" === e) E((e = c[l++]).charCodeAt(0)) && V({}, a.UnterminatedRegExp), t += e;else if (E(e.charCodeAt(0))) V({}, a.UnterminatedRegExp);else if (n) "]" === e && (n = !1);else {
                    if ("/" === e) {
                      r = !0;
                      break;
                    }

                    "[" === e && (n = !0);
                  }
                }

                return r || V({}, a.UnterminatedRegExp), {
                  value: t.substr(1, t.length - 2),
                  literal: t
                };
              }(), r = function () {
                var e, t, n, r;

                for (t = "", n = ""; l < d && _((e = c[l]).charCodeAt(0));) {
                  if (++l, "\\" === e && l < d) {
                    if ("u" === (e = c[l])) {
                      if (r = ++l, e = j("u")) for (n += e, t += "\\u"; r < l; ++r) {
                        t += c[r];
                      } else l = r, n += "u", t += "\\u";
                      Y({}, a.UnexpectedToken, "ILLEGAL");
                    } else t += "\\", Y({}, a.UnexpectedToken, "ILLEGAL");
                  } else n += e, t += e;
                }

                return {
                  value: n,
                  literal: t
                };
              }(), o = function (e, t) {
                var n;

                try {
                  n = new RegExp(e, t);
                } catch (e) {
                  V({}, a.InvalidRegExp);
                }

                return n;
              }(n.value, r.value), m.tokenize ? {
                type: t.RegularExpression,
                value: o,
                lineNumber: p,
                lineStart: h,
                start: e,
                end: l
              } : {
                literal: n.literal + r.literal,
                value: o,
                start: e,
                end: l
              };
            }

            function B() {
              var e, t, n, r;
              return C(), e = l, t = {
                start: {
                  line: p,
                  column: l - h
                }
              }, n = D(), t.end = {
                line: p,
                column: l - h
              }, m.tokenize || (m.tokens.length > 0 && (r = m.tokens[m.tokens.length - 1]).range[0] === e && "Punctuator" === r.type && ("/" !== r.value && "/=" !== r.value || m.tokens.pop()), m.tokens.push({
                type: "RegularExpression",
                value: n.literal,
                range: [e, l],
                loc: t
              })), n;
            }

            function F() {
              var e;
              return C(), l >= d ? {
                type: t.EOF,
                lineNumber: p,
                lineStart: h,
                start: l,
                end: l
              } : T(e = c.charCodeAt(l)) ? M() : 40 === e || 41 === e || 59 === e ? N() : 39 === e || 34 === e ? function () {
                var e,
                    n,
                    r,
                    o,
                    i,
                    s,
                    u,
                    f,
                    v = "",
                    y = !1;

                for (u = p, f = h, b("'" === (e = c[l]) || '"' === e, "String literal must starts with a quote"), n = l, ++l; l < d;) {
                  if ((r = c[l++]) === e) {
                    e = "";
                    break;
                  }

                  if ("\\" === r) {
                    if ((r = c[l++]) && E(r.charCodeAt(0))) ++p, "\r" === r && "\n" === c[l] && ++l, h = l;else switch (r) {
                      case "u":
                      case "x":
                        s = l, (i = j(r)) ? v += i : (l = s, v += r);
                        break;

                      case "n":
                        v += "\n";
                        break;

                      case "r":
                        v += "\r";
                        break;

                      case "t":
                        v += "\t";
                        break;

                      case "b":
                        v += "\b";
                        break;

                      case "f":
                        v += "\f";
                        break;

                      case "v":
                        v += "\v";
                        break;

                      default:
                        k(r) ? (0 !== (o = "01234567".indexOf(r)) && (y = !0), l < d && k(c[l]) && (y = !0, o = 8 * o + "01234567".indexOf(c[l++]), "0123".indexOf(r) >= 0 && l < d && k(c[l]) && (o = 8 * o + "01234567".indexOf(c[l++]))), v += String.fromCharCode(o)) : v += r;
                    }
                  } else {
                    if (E(r.charCodeAt(0))) break;
                    v += r;
                  }
                }

                return "" !== e && V({}, a.UnexpectedToken, "ILLEGAL"), {
                  type: t.StringLiteral,
                  value: v,
                  octal: y,
                  startLineNumber: u,
                  startLineStart: f,
                  lineNumber: p,
                  lineStart: h,
                  start: n,
                  end: l
                };
              }() : 46 === e ? x(c.charCodeAt(l + 1)) ? U() : N() : x(e) ? U() : m.tokenize && 47 === e ? function () {
                var e, t;
                if (!(e = m.tokens[m.tokens.length - 1])) return B();

                if ("Punctuator" === e.type) {
                  if ("]" === e.value) return N();
                  if (")" === e.value) return !(t = m.tokens[m.openParenToken - 1]) || "Keyword" !== t.type || "if" !== t.value && "while" !== t.value && "for" !== t.value && "with" !== t.value ? N() : B();

                  if ("}" === e.value) {
                    if (m.tokens[m.openCurlyToken - 3] && "Keyword" === m.tokens[m.openCurlyToken - 3].type) {
                      if (!(t = m.tokens[m.openCurlyToken - 4])) return N();
                    } else {
                      if (!m.tokens[m.openCurlyToken - 4] || "Keyword" !== m.tokens[m.openCurlyToken - 4].type) return N();
                      if (!(t = m.tokens[m.openCurlyToken - 5])) return B();
                    }

                    return r.indexOf(t.value) >= 0 ? N() : B();
                  }

                  return B();
                }

                return "Keyword" === e.type ? B() : N();
              }() : N();
            }

            function H() {
              var e, r, o;
              return C(), e = {
                start: {
                  line: p,
                  column: l - h
                }
              }, r = F(), e.end = {
                line: p,
                column: l - h
              }, r.type !== t.EOF && (o = c.slice(r.start, r.end), m.tokens.push({
                type: n[r.type],
                value: o,
                range: [r.start, r.end],
                loc: e
              })), r;
            }

            function q() {
              var e;
              return l = (e = y).end, p = e.lineNumber, h = e.lineStart, y = void 0 !== m.tokens ? H() : F(), l = e.end, p = e.lineNumber, h = e.lineStart, e;
            }

            function $() {
              var e, t, n;
              e = l, t = p, n = h, y = void 0 !== m.tokens ? H() : F(), l = e, p = t, h = n;
            }

            function z(e, t) {
              this.line = e, this.column = t;
            }

            function K(e, t, n, r) {
              this.start = new z(e, t), this.end = new z(n, r);
            }

            function G() {
              var e, t, n, r;
              return e = l, t = p, n = h, C(), r = p !== t, l = e, p = t, h = n, r;
            }

            function V(e, t) {
              var n,
                  r = Array.prototype.slice.call(arguments, 2),
                  o = t.replace(/%(\d)/g, function (e, t) {
                return b(t < r.length, "Message reference must be in range"), r[t];
              });
              throw "number" == typeof e.lineNumber ? ((n = new Error("Line " + e.lineNumber + ": " + o)).index = e.start, n.lineNumber = e.lineNumber, n.column = e.start - h + 1) : ((n = new Error("Line " + p + ": " + o)).index = l, n.lineNumber = p, n.column = l - h + 1), n.description = o, n;
            }

            function Y() {
              try {
                V.apply(null, arguments);
              } catch (e) {
                if (!m.errors) throw e;
                m.errors.push(e);
              }
            }

            function W(e) {
              if (e.type === t.EOF && V(e, a.UnexpectedEOS), e.type === t.NumericLiteral && V(e, a.UnexpectedNumber), e.type === t.StringLiteral && V(e, a.UnexpectedString), e.type === t.Identifier && V(e, a.UnexpectedIdentifier), e.type === t.Keyword) {
                if (function (e) {
                  switch (e) {
                    case "class":
                    case "enum":
                    case "export":
                    case "extends":
                    case "import":
                    case "super":
                      return !0;

                    default:
                      return !1;
                  }
                }(e.value)) V(e, a.UnexpectedReserved);else if (f && O(e.value)) return void Y(e, a.StrictReservedWord);
                V(e, a.UnexpectedToken, e.value);
              }

              V(e, a.UnexpectedToken, e.value);
            }

            function J(e) {
              var n = q();
              n.type === t.Punctuator && n.value === e || W(n);
            }

            function X(e) {
              var n = q();
              n.type === t.Keyword && n.value === e || W(n);
            }

            function Q(e) {
              return y.type === t.Punctuator && y.value === e;
            }

            function Z(e) {
              return y.type === t.Keyword && y.value === e;
            }

            function ee() {
              var e;
              59 === c.charCodeAt(l) || Q(";") ? q() : (e = p, C(), p === e && (y.type === t.EOF || Q("}") || W(y)));
            }

            function te(e) {
              return e.type === o.Identifier || e.type === o.MemberExpression;
            }

            function ne(e, t) {
              var n, r, o;
              return n = f, o = y, r = Te(), t && f && A(e[0].name) && Y(t, a.StrictParamName), f = n, v.markEnd(v.createFunctionExpression(null, e, [], r), o);
            }

            function re() {
              var e, n;
              return n = y, (e = q()).type === t.StringLiteral || e.type === t.NumericLiteral ? (f && e.octal && Y(e, a.StrictOctalLiteral), v.markEnd(v.createLiteral(e), n)) : v.markEnd(v.createIdentifier(e.value), n);
            }

            function oe() {
              var e, n, r, o, i, s;
              return s = y, (e = y).type === t.Identifier ? (r = re(), "get" !== e.value || Q(":") ? "set" !== e.value || Q(":") ? (J(":"), o = ve(), v.markEnd(v.createProperty("init", r, o), s)) : (n = re(), J("("), (e = y).type !== t.Identifier ? (J(")"), Y(e, a.UnexpectedToken, e.value), o = ne([])) : (i = [me()], J(")"), o = ne(i, e)), v.markEnd(v.createProperty("set", n, o), s)) : (n = re(), J("("), J(")"), o = ne([]), v.markEnd(v.createProperty("get", n, o), s))) : e.type !== t.EOF && e.type !== t.Punctuator ? (n = re(), J(":"), o = ve(), v.markEnd(v.createProperty("init", n, o), s)) : void W(e);
            }

            function ie() {
              var e, n, r, s;
              if (Q("(")) return function () {
                var e;
                return J("("), e = ye(), J(")"), e;
              }();
              if (Q("[")) return function () {
                var e,
                    t = [];

                for (e = y, J("["); !Q("]");) {
                  Q(",") ? (q(), t.push(null)) : (t.push(ve()), Q("]") || J(","));
                }

                return q(), v.markEnd(v.createArrayExpression(t), e);
              }();
              if (Q("{")) return function () {
                var e,
                    t,
                    n,
                    r,
                    s,
                    u = [],
                    c = {},
                    l = String;

                for (s = y, J("{"); !Q("}");) {
                  t = (e = oe()).key.type === o.Identifier ? e.key.name : l(e.key.value), r = "init" === e.kind ? i.Data : "get" === e.kind ? i.Get : i.Set, n = "$" + t, Object.prototype.hasOwnProperty.call(c, n) ? (c[n] === i.Data ? f && r === i.Data ? Y({}, a.StrictDuplicateProperty) : r !== i.Data && Y({}, a.AccessorDataProperty) : r === i.Data ? Y({}, a.AccessorDataProperty) : c[n] & r && Y({}, a.AccessorGetSet), c[n] |= r) : c[n] = r, u.push(e), Q("}") || J(",");
                }

                return J("}"), v.markEnd(v.createObjectExpression(u), s);
              }();
              if (e = y.type, s = y, e === t.Identifier) r = v.createIdentifier(q().value);else if (e === t.StringLiteral || e === t.NumericLiteral) f && y.octal && Y(y, a.StrictOctalLiteral), r = v.createLiteral(q());else if (e === t.Keyword) {
                if (Z("function")) return function () {
                  var e,
                      t,
                      n,
                      r,
                      o,
                      i,
                      s,
                      u,
                      c,
                      l = null;
                  return c = y, X("function"), Q("(") || (e = y, l = me(), f ? A(e.value) && Y(e, a.StrictFunctionName) : A(e.value) ? (n = e, r = a.StrictFunctionName) : O(e.value) && (n = e, r = a.StrictReservedWord)), o = _e(n), i = o.params, t = o.stricted, n = o.firstRestricted, o.message && (r = o.message), u = f, s = Te(), f && n && V(n, r), f && t && Y(t, r), f = u, v.markEnd(v.createFunctionExpression(l, i, [], s), c);
                }();
                Z("this") ? (q(), r = v.createThisExpression()) : W(q());
              } else e === t.BooleanLiteral ? ((n = q()).value = "true" === n.value, r = v.createLiteral(n)) : e === t.NullLiteral ? ((n = q()).value = null, r = v.createLiteral(n)) : Q("/") || Q("/=") ? (r = void 0 !== m.tokens ? v.createLiteral(B()) : v.createLiteral(D()), $()) : W(q());
              return v.markEnd(r, s);
            }

            function ae() {
              var e = [];
              if (J("("), !Q(")")) for (; l < d && (e.push(ve()), !Q(")"));) {
                J(",");
              }
              return J(")"), e;
            }

            function se() {
              var e, n;
              return n = y, function (e) {
                return e.type === t.Identifier || e.type === t.Keyword || e.type === t.BooleanLiteral || e.type === t.NullLiteral;
              }(e = q()) || W(e), v.markEnd(v.createIdentifier(e.value), n);
            }

            function ue() {
              return J("."), se();
            }

            function ce() {
              var e;
              return J("["), e = ye(), J("]"), e;
            }

            function fe() {
              var e, t, n;
              return n = y, X("new"), e = function () {
                var e, t, n, r;

                for (r = y, e = g.allowIn, t = Z("new") ? fe() : ie(), g.allowIn = e; Q(".") || Q("[");) {
                  Q("[") ? (n = ce(), t = v.createMemberExpression("[", t, n)) : (n = ue(), t = v.createMemberExpression(".", t, n)), v.markEnd(t, r);
                }

                return t;
              }(), t = Q("(") ? ae() : [], v.markEnd(v.createNewExpression(e, t), n);
            }

            function le() {
              var e,
                  n,
                  r = y;
              return e = function () {
                var e, t, n, r, o;

                for (o = y, e = g.allowIn, g.allowIn = !0, t = Z("new") ? fe() : ie(), g.allowIn = e;;) {
                  if (Q(".")) r = ue(), t = v.createMemberExpression(".", t, r);else if (Q("(")) n = ae(), t = v.createCallExpression(t, n);else {
                    if (!Q("[")) break;
                    r = ce(), t = v.createMemberExpression("[", t, r);
                  }
                  v.markEnd(t, o);
                }

                return t;
              }(), y.type === t.Punctuator && (!Q("++") && !Q("--") || G() || (f && e.type === o.Identifier && A(e.name) && Y({}, a.StrictLHSPostfix), te(e) || Y({}, a.InvalidLHSInAssignment), n = q(), e = v.markEnd(v.createPostfixExpression(n.value, e), r))), e;
            }

            function pe() {
              var e, n, r;
              return y.type !== t.Punctuator && y.type !== t.Keyword ? n = le() : Q("++") || Q("--") ? (r = y, e = q(), n = pe(), f && n.type === o.Identifier && A(n.name) && Y({}, a.StrictLHSPrefix), te(n) || Y({}, a.InvalidLHSInAssignment), n = v.createUnaryExpression(e.value, n), n = v.markEnd(n, r)) : Q("+") || Q("-") || Q("~") || Q("!") ? (r = y, e = q(), n = pe(), n = v.createUnaryExpression(e.value, n), n = v.markEnd(n, r)) : Z("delete") || Z("void") || Z("typeof") ? (r = y, e = q(), n = pe(), n = v.createUnaryExpression(e.value, n), n = v.markEnd(n, r), f && "delete" === n.operator && n.argument.type === o.Identifier && Y({}, a.StrictDelete)) : n = le(), n;
            }

            function he(e, n) {
              var r = 0;
              if (e.type !== t.Punctuator && e.type !== t.Keyword) return 0;

              switch (e.value) {
                case "||":
                  r = 1;
                  break;

                case "&&":
                  r = 2;
                  break;

                case "|":
                  r = 3;
                  break;

                case "^":
                  r = 4;
                  break;

                case "&":
                  r = 5;
                  break;

                case "==":
                case "!=":
                case "===":
                case "!==":
                  r = 6;
                  break;

                case "<":
                case ">":
                case "<=":
                case ">=":
                case "instanceof":
                  r = 7;
                  break;

                case "in":
                  r = n ? 7 : 0;
                  break;

                case "<<":
                case ">>":
                case ">>>":
                  r = 8;
                  break;

                case "+":
                case "-":
                  r = 9;
                  break;

                case "*":
                case "/":
                case "%":
                  r = 11;
              }

              return r;
            }

            function de() {
              var e, t, n, r, o;
              return o = y, e = function () {
                var e, t, n, r, o, i, a, s, u, c;
                if (e = y, u = pe(), 0 === (o = he(r = y, g.allowIn))) return u;

                for (r.prec = o, q(), t = [e, y], i = [u, r, a = pe()]; (o = he(y, g.allowIn)) > 0;) {
                  for (; i.length > 2 && o <= i[i.length - 2].prec;) {
                    a = i.pop(), s = i.pop().value, u = i.pop(), n = v.createBinaryExpression(s, u, a), t.pop(), e = t[t.length - 1], v.markEnd(n, e), i.push(n);
                  }

                  (r = q()).prec = o, i.push(r), t.push(y), n = pe(), i.push(n);
                }

                for (n = i[c = i.length - 1], t.pop(); c > 1;) {
                  n = v.createBinaryExpression(i[c - 1].value, i[c - 2], n), c -= 2, e = t.pop(), v.markEnd(n, e);
                }

                return n;
              }(), Q("?") && (q(), t = g.allowIn, g.allowIn = !0, n = ve(), g.allowIn = t, J(":"), r = ve(), e = v.createConditionalExpression(e, n, r), v.markEnd(e, o)), e;
            }

            function ve() {
              var e, n, r, i, s, u;
              return e = y, s = y, i = n = de(), y.type !== t.Punctuator || "=" !== (u = y.value) && "*=" !== u && "/=" !== u && "%=" !== u && "+=" !== u && "-=" !== u && "<<=" !== u && ">>=" !== u && ">>>=" !== u && "&=" !== u && "^=" !== u && "|=" !== u || (te(n) || Y({}, a.InvalidLHSInAssignment), f && n.type === o.Identifier && A(n.name) && Y(e, a.StrictLHSAssignment), e = q(), r = ve(), i = v.markEnd(v.createAssignmentExpression(e.value, n, r), s)), i;
            }

            function ye() {
              var e,
                  t = y;

              if (e = ve(), Q(",")) {
                for (e = v.createSequenceExpression([e]); l < d && Q(",");) {
                  q(), e.expressions.push(ve());
                }

                v.markEnd(e, t);
              }

              return e;
            }

            function ge() {
              var e, t;
              return t = y, J("{"), e = function () {
                for (var e, t = []; l < d && !Q("}") && void 0 !== (e = Ae());) {
                  t.push(e);
                }

                return t;
              }(), J("}"), v.markEnd(v.createBlockStatement(e), t);
            }

            function me() {
              var e, n;
              return n = y, (e = q()).type !== t.Identifier && W(e), v.markEnd(v.createIdentifier(e.value), n);
            }

            function be(e) {
              var t,
                  n,
                  r = null;
              return n = y, t = me(), f && A(t.name) && Y({}, a.StrictVarName), "const" === e ? (J("="), r = ve()) : Q("=") && (q(), r = ve()), v.markEnd(v.createVariableDeclarator(t, r), n);
            }

            function xe(e) {
              var t = [];

              do {
                if (t.push(be(e)), !Q(",")) break;
                q();
              } while (l < d);

              return t;
            }

            function we() {
              var e, t, n, r, o, i, s, u, c, f;
              return e = t = n = null, X("for"), J("("), Q(";") ? q() : (Z("var") || Z("let") ? (g.allowIn = !1, f = y, u = q(), c = xe(), e = v.markEnd(v.createVariableDeclaration(c, u.value), f), g.allowIn = !0, 1 === e.declarations.length && Z("in") && (q(), r = e, o = ye(), e = null)) : (g.allowIn = !1, e = ye(), g.allowIn = !0, Z("in") && (te(e) || Y({}, a.InvalidLHSInForIn), q(), r = e, o = ye(), e = null)), void 0 === r && J(";")), void 0 === r && (Q(";") || (t = ye()), J(";"), Q(")") || (n = ye())), J(")"), s = g.inIteration, g.inIteration = !0, i = Ee(), g.inIteration = s, void 0 === r ? v.createForStatement(e, t, n, i) : v.createForInStatement(r, o, i);
            }

            function ke() {
              var e,
                  t,
                  n,
                  r = [];

              for (n = y, Z("default") ? (q(), e = null) : (X("case"), e = ye()), J(":"); l < d && !(Q("}") || Z("default") || Z("case"));) {
                t = Ee(), r.push(t);
              }

              return v.markEnd(v.createSwitchCase(e, r), n);
            }

            function Se() {
              var e,
                  t,
                  n,
                  r,
                  o = [],
                  i = null;
              return X("try"), e = ge(), Z("catch") && o.push((r = y, X("catch"), J("("), Q(")") && W(y), t = me(), f && A(t.name) && Y({}, a.StrictCatchVariable), J(")"), n = ge(), v.markEnd(v.createCatchClause(t, n), r))), Z("finally") && (q(), i = ge()), 0 !== o.length || i || V({}, a.NoCatchOrFinally), v.createTryStatement(e, [], o, i);
            }

            function Ee() {
              var e,
                  n,
                  r,
                  i,
                  s,
                  u,
                  p,
                  h,
                  m,
                  b = y.type;
              if (b === t.EOF && W(y), b === t.Punctuator && "{" === y.value) return ge();
              if (i = y, b === t.Punctuator) switch (y.value) {
                case ";":
                  return v.markEnd((J(";"), v.createEmptyStatement()), i);

                case "(":
                  return v.markEnd(function () {
                    var e = ye();
                    return ee(), v.createExpressionStatement(e);
                  }(), i);
              }
              if (b === t.Keyword) switch (y.value) {
                case "break":
                  return v.markEnd(function () {
                    var e,
                        n = null;
                    return X("break"), 59 === c.charCodeAt(l) ? (q(), g.inIteration || g.inSwitch || V({}, a.IllegalBreak), v.createBreakStatement(null)) : G() ? (g.inIteration || g.inSwitch || V({}, a.IllegalBreak), v.createBreakStatement(null)) : (y.type === t.Identifier && (e = "$" + (n = me()).name, Object.prototype.hasOwnProperty.call(g.labelSet, e) || V({}, a.UnknownLabel, n.name)), ee(), null !== n || g.inIteration || g.inSwitch || V({}, a.IllegalBreak), v.createBreakStatement(n));
                  }(), i);

                case "continue":
                  return v.markEnd(function () {
                    var e,
                        n = null;
                    return X("continue"), 59 === c.charCodeAt(l) ? (q(), g.inIteration || V({}, a.IllegalContinue), v.createContinueStatement(null)) : G() ? (g.inIteration || V({}, a.IllegalContinue), v.createContinueStatement(null)) : (y.type === t.Identifier && (e = "$" + (n = me()).name, Object.prototype.hasOwnProperty.call(g.labelSet, e) || V({}, a.UnknownLabel, n.name)), ee(), null !== n || g.inIteration || V({}, a.IllegalContinue), v.createContinueStatement(n));
                  }(), i);

                case "debugger":
                  return v.markEnd((X("debugger"), ee(), v.createDebuggerStatement()), i);

                case "do":
                  return v.markEnd((X("do"), m = g.inIteration, g.inIteration = !0, p = Ee(), g.inIteration = m, X("while"), J("("), h = ye(), J(")"), Q(";") && q(), v.createDoWhileStatement(p, h)), i);

                case "for":
                  return v.markEnd(we(), i);

                case "function":
                  return v.markEnd(Oe(), i);

                case "if":
                  return v.markEnd(function () {
                    var e, t, n;
                    return X("if"), J("("), e = ye(), J(")"), t = Ee(), Z("else") ? (q(), n = Ee()) : n = null, v.createIfStatement(e, t, n);
                  }(), i);

                case "return":
                  return v.markEnd((u = null, X("return"), g.inFunctionBody || Y({}, a.IllegalReturn), 32 === c.charCodeAt(l) && T(c.charCodeAt(l + 1)) ? (u = ye(), ee(), v.createReturnStatement(u)) : G() ? v.createReturnStatement(null) : (Q(";") || Q("}") || y.type === t.EOF || (u = ye()), ee(), v.createReturnStatement(u))), i);

                case "switch":
                  return v.markEnd(function () {
                    var e, t, n, r, o;
                    if (X("switch"), J("("), e = ye(), J(")"), J("{"), t = [], Q("}")) return q(), v.createSwitchStatement(e, t);

                    for (r = g.inSwitch, g.inSwitch = !0, o = !1; l < d && !Q("}");) {
                      null === (n = ke()).test && (o && V({}, a.MultipleDefaultsInSwitch), o = !0), t.push(n);
                    }

                    return g.inSwitch = r, J("}"), v.createSwitchStatement(e, t);
                  }(), i);

                case "throw":
                  return v.markEnd(function () {
                    var e;
                    return X("throw"), G() && V({}, a.NewlineAfterThrow), e = ye(), ee(), v.createThrowStatement(e);
                  }(), i);

                case "try":
                  return v.markEnd(Se(), i);

                case "var":
                  return v.markEnd((X("var"), s = xe(), ee(), v.createVariableDeclaration(s, "var")), i);

                case "while":
                  return v.markEnd(function () {
                    var e, t, n;
                    return X("while"), J("("), e = ye(), J(")"), n = g.inIteration, g.inIteration = !0, t = Ee(), g.inIteration = n, v.createWhileStatement(e, t);
                  }(), i);

                case "with":
                  return v.markEnd(function () {
                    var e, t;
                    return f && (C(), Y({}, a.StrictModeWith)), X("with"), J("("), e = ye(), J(")"), t = Ee(), v.createWithStatement(e, t);
                  }(), i);
              }
              return (e = ye()).type === o.Identifier && Q(":") ? (q(), r = "$" + e.name, Object.prototype.hasOwnProperty.call(g.labelSet, r) && V({}, a.Redeclaration, "Label", e.name), g.labelSet[r] = !0, n = Ee(), delete g.labelSet[r], v.markEnd(v.createLabeledStatement(e, n), i)) : (ee(), v.markEnd(v.createExpressionStatement(e), i));
            }

            function Te() {
              var e,
                  n,
                  r,
                  i,
                  s,
                  u,
                  p,
                  h,
                  m = [];

              for (h = y, J("{"); l < d && y.type === t.StringLiteral && (n = y, e = Ae(), m.push(e), e.expression.type === o.Literal);) {
                "use strict" === c.slice(n.start + 1, n.end - 1) ? (f = !0, r && Y(r, a.StrictOctalLiteral)) : !r && n.octal && (r = n);
              }

              for (i = g.labelSet, s = g.inIteration, u = g.inSwitch, p = g.inFunctionBody, g.labelSet = {}, g.inIteration = !1, g.inSwitch = !1, g.inFunctionBody = !0; l < d && !Q("}") && void 0 !== (e = Ae());) {
                m.push(e);
              }

              return J("}"), g.labelSet = i, g.inIteration = s, g.inSwitch = u, g.inFunctionBody = p, v.markEnd(v.createBlockStatement(m), h);
            }

            function _e(e) {
              var t,
                  n,
                  r,
                  o,
                  i,
                  s,
                  u = [];
              if (J("("), !Q(")")) for (o = {}; l < d && (n = y, t = me(), i = "$" + n.value, f ? (A(n.value) && (r = n, s = a.StrictParamName), Object.prototype.hasOwnProperty.call(o, i) && (r = n, s = a.StrictParamDupe)) : e || (A(n.value) ? (e = n, s = a.StrictParamName) : O(n.value) ? (e = n, s = a.StrictReservedWord) : Object.prototype.hasOwnProperty.call(o, i) && (e = n, s = a.StrictParamDupe)), u.push(t), o[i] = !0, !Q(")"));) {
                J(",");
              }
              return J(")"), {
                params: u,
                stricted: r,
                firstRestricted: e,
                message: s
              };
            }

            function Oe() {
              var e, t, n, r, o, i, s, u, c, l;
              return l = y, X("function"), r = y, e = me(), f ? A(r.value) && Y(r, a.StrictFunctionName) : A(r.value) ? (s = r, u = a.StrictFunctionName) : O(r.value) && (s = r, u = a.StrictReservedWord), t = (i = _e(s)).params, o = i.stricted, s = i.firstRestricted, i.message && (u = i.message), c = f, n = Te(), f && s && V(s, u), f && o && Y(o, u), f = c, v.markEnd(v.createFunctionDeclaration(e, t, [], n), l);
            }

            function Ae() {
              if (y.type === t.Keyword) switch (y.value) {
                case "const":
                case "let":
                  return e = y.value, r = y, X(e), n = xe(e), ee(), v.markEnd(v.createVariableDeclaration(n, e), r);

                case "function":
                  return Oe();

                default:
                  return Ee();
              }
              var e, n, r;
              if (y.type !== t.EOF) return Ee();
            }

            function Re() {
              var e, n;
              return C(), $(), n = y, f = !1, e = function () {
                for (var e, n, r, i = []; l < d && (n = y).type === t.StringLiteral && (e = Ae(), i.push(e), e.expression.type === o.Literal);) {
                  "use strict" === c.slice(n.start + 1, n.end - 1) ? (f = !0, r && Y(r, a.StrictOctalLiteral)) : !r && n.octal && (r = n);
                }

                for (; l < d && void 0 !== (e = Ae());) {
                  i.push(e);
                }

                return i;
              }(), v.markEnd(v.createProgram(e), n);
            }

            function Pe() {
              var e,
                  t,
                  n,
                  r = [];

              for (e = 0; e < m.tokens.length; ++e) {
                n = {
                  type: (t = m.tokens[e]).type,
                  value: t.value
                }, m.range && (n.range = t.range), m.loc && (n.loc = t.loc), r.push(n);
              }

              m.tokens = r;
            }

            (n = {})[(t = {
              BooleanLiteral: 1,
              EOF: 2,
              Identifier: 3,
              Keyword: 4,
              NullLiteral: 5,
              NumericLiteral: 6,
              Punctuator: 7,
              StringLiteral: 8,
              RegularExpression: 9
            }).BooleanLiteral] = "Boolean", n[t.EOF] = "<end>", n[t.Identifier] = "Identifier", n[t.Keyword] = "Keyword", n[t.NullLiteral] = "Null", n[t.NumericLiteral] = "Numeric", n[t.Punctuator] = "Punctuator", n[t.StringLiteral] = "String", n[t.RegularExpression] = "RegularExpression", r = ["(", "{", "[", "in", "typeof", "instanceof", "new", "return", "case", "delete", "throw", "void", "=", "+=", "-=", "*=", "/=", "%=", "<<=", ">>=", ">>>=", "&=", "|=", "^=", ",", "+", "-", "*", "/", "%", "++", "--", "<<", ">>", ">>>", "&", "|", "^", "!", "~", "&&", "||", "?", ":", "===", "==", ">=", "<=", "<", ">", "!=", "!=="], o = {
              AssignmentExpression: "AssignmentExpression",
              ArrayExpression: "ArrayExpression",
              BlockStatement: "BlockStatement",
              BinaryExpression: "BinaryExpression",
              BreakStatement: "BreakStatement",
              CallExpression: "CallExpression",
              CatchClause: "CatchClause",
              ConditionalExpression: "ConditionalExpression",
              ContinueStatement: "ContinueStatement",
              DoWhileStatement: "DoWhileStatement",
              DebuggerStatement: "DebuggerStatement",
              EmptyStatement: "EmptyStatement",
              ExpressionStatement: "ExpressionStatement",
              ForStatement: "ForStatement",
              ForInStatement: "ForInStatement",
              FunctionDeclaration: "FunctionDeclaration",
              FunctionExpression: "FunctionExpression",
              Identifier: "Identifier",
              IfStatement: "IfStatement",
              Literal: "Literal",
              LabeledStatement: "LabeledStatement",
              LogicalExpression: "LogicalExpression",
              MemberExpression: "MemberExpression",
              NewExpression: "NewExpression",
              ObjectExpression: "ObjectExpression",
              Program: "Program",
              Property: "Property",
              ReturnStatement: "ReturnStatement",
              SequenceExpression: "SequenceExpression",
              SwitchStatement: "SwitchStatement",
              SwitchCase: "SwitchCase",
              ThisExpression: "ThisExpression",
              ThrowStatement: "ThrowStatement",
              TryStatement: "TryStatement",
              UnaryExpression: "UnaryExpression",
              UpdateExpression: "UpdateExpression",
              VariableDeclaration: "VariableDeclaration",
              VariableDeclarator: "VariableDeclarator",
              WhileStatement: "WhileStatement",
              WithStatement: "WithStatement"
            }, i = {
              Data: 1,
              Get: 2,
              Set: 4
            }, a = {
              UnexpectedToken: "Unexpected token %0",
              UnexpectedNumber: "Unexpected number",
              UnexpectedString: "Unexpected string",
              UnexpectedIdentifier: "Unexpected identifier",
              UnexpectedReserved: "Unexpected reserved word",
              UnexpectedEOS: "Unexpected end of input",
              NewlineAfterThrow: "Illegal newline after throw",
              InvalidRegExp: "Invalid regular expression",
              UnterminatedRegExp: "Invalid regular expression: missing /",
              InvalidLHSInAssignment: "Invalid left-hand side in assignment",
              InvalidLHSInForIn: "Invalid left-hand side in for-in",
              MultipleDefaultsInSwitch: "More than one default clause in switch statement",
              NoCatchOrFinally: "Missing catch or finally after try",
              UnknownLabel: "Undefined label '%0'",
              Redeclaration: "%0 '%1' has already been declared",
              IllegalContinue: "Illegal continue statement",
              IllegalBreak: "Illegal break statement",
              IllegalReturn: "Illegal return statement",
              StrictModeWith: "Strict mode code may not include a with statement",
              StrictCatchVariable: "Catch variable may not be eval or arguments in strict mode",
              StrictVarName: "Variable name may not be eval or arguments in strict mode",
              StrictParamName: "Parameter name eval or arguments is not allowed in strict mode",
              StrictParamDupe: "Strict mode function may not have duplicate parameter names",
              StrictFunctionName: "Function name may not be eval or arguments in strict mode",
              StrictOctalLiteral: "Octal literals are not allowed in strict mode.",
              StrictDelete: "Delete of an unqualified identifier in strict mode.",
              StrictDuplicateProperty: "Duplicate data property in object literal not allowed in strict mode",
              AccessorDataProperty: "Object literal may not have data and accessor property with the same name",
              AccessorGetSet: "Object literal may not have multiple get/set accessors with the same name",
              StrictLHSAssignment: "Assignment to eval or arguments is not allowed in strict mode",
              StrictLHSPostfix: "Postfix increment/decrement may not have eval or arguments operand in strict mode",
              StrictLHSPrefix: "Prefix increment/decrement may not have eval or arguments operand in strict mode",
              StrictReservedWord: "Use of future reserved word in strict mode"
            }, s = {
              NonAsciiIdentifierStart: new RegExp("[ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ]"),
              NonAsciiIdentifierPart: new RegExp("[ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮ̀-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁ҃-҇Ҋ-ԧԱ-Ֆՙա-և֑-ׇֽֿׁׂׅׄא-תװ-ײؐ-ؚؠ-٩ٮ-ۓە-ۜ۟-۪ۨ-ۼۿܐ-݊ݍ-ޱ߀-ߵߺࠀ-࠭ࡀ-࡛ࢠࢢ-ࢬࣤ-ࣾऀ-ॣ०-९ॱ-ॷॹ-ॿঁ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-ৱਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૯ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍ୖୗଡ଼ଢ଼ୟ-ୣ୦-୯ୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௯ఁ-ఃఅ-ఌఎ-ఐఒ-నప-ళవ-హఽ-ౄె-ైొ-్ౕౖౘౙౠ-ౣ౦-౯ಂಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೞೠ-ೣ೦-೯ೱೲംഃഅ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൎൗൠ-ൣ൦-൯ൺ-ൿංඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟෲෳก-ฺเ-๎๐-๙ກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ູົ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟༀ༘༙༠-༩༹༵༷༾-ཇཉ-ཬཱ-྄྆-ྗྙ-ྼ࿆က-၉ၐ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፟ᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-᜔ᜠ-᜴ᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-៓ៗៜ៝០-៩᠋-᠍᠐-᠙ᠠ-ᡷᢀ-ᢪᢰ-ᣵᤀ-ᤜᤠ-ᤫᤰ-᤻᥆-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉ᧐-᧙ᨀ-ᨛᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙ᪧᬀ-ᭋ᭐-᭙᭫-᭳ᮀ-᯳ᰀ-᰷᱀-᱉ᱍ-ᱽ᳐-᳔᳒-ᳶᴀ-ᷦ᷼-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‌‍‿⁀⁔ⁱⁿₐ-ₜ⃐-⃥⃜⃡-⃰ℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ⵿-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〯〱-〵〸-〼ぁ-ゖ゙゚ゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘫꙀ-꙯ꙴ-꙽ꙿ-ꚗꚟ-꛱ꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠧꡀ-ꡳꢀ-꣄꣐-꣙꣠-ꣷꣻ꤀-꤭ꤰ-꥓ꥠ-ꥼꦀ-꧀ꧏ-꧙ꨀ-ꨶꩀ-ꩍ꩐-꩙ꩠ-ꩶꩺꩻꪀ-ꫂꫛ-ꫝꫠ-ꫯꫲ-꫶ꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯪ꯬꯭꯰-꯹가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻ︀-️︠-︦︳︴﹍-﹏ﹰ-ﹴﹶ-ﻼ０-９Ａ-Ｚ＿ａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ]")
            }, u = {
              name: "SyntaxTree",
              processComment: function processComment(e) {
                var t, n;

                if (!(e.type === o.Program && e.body.length > 0)) {
                  for (m.trailingComments.length > 0 ? m.trailingComments[0].range[0] >= e.range[1] ? (n = m.trailingComments, m.trailingComments = []) : m.trailingComments.length = 0 : m.bottomRightStack.length > 0 && m.bottomRightStack[m.bottomRightStack.length - 1].trailingComments && m.bottomRightStack[m.bottomRightStack.length - 1].trailingComments[0].range[0] >= e.range[1] && (n = m.bottomRightStack[m.bottomRightStack.length - 1].trailingComments, delete m.bottomRightStack[m.bottomRightStack.length - 1].trailingComments); m.bottomRightStack.length > 0 && m.bottomRightStack[m.bottomRightStack.length - 1].range[0] >= e.range[0];) {
                    t = m.bottomRightStack.pop();
                  }

                  t ? t.leadingComments && t.leadingComments[t.leadingComments.length - 1].range[1] <= e.range[0] && (e.leadingComments = t.leadingComments, delete t.leadingComments) : m.leadingComments.length > 0 && m.leadingComments[m.leadingComments.length - 1].range[1] <= e.range[0] && (e.leadingComments = m.leadingComments, m.leadingComments = []), n && (e.trailingComments = n), m.bottomRightStack.push(e);
                }
              },
              markEnd: function markEnd(e, t) {
                return m.range && (e.range = [t.start, l]), m.loc && (e.loc = new K(void 0 === t.startLineNumber ? t.lineNumber : t.startLineNumber, t.start - (void 0 === t.startLineStart ? t.lineStart : t.startLineStart), p, l - h), this.postProcess(e)), m.attachComment && this.processComment(e), e;
              },
              postProcess: function postProcess(e) {
                return m.source && (e.loc.source = m.source), e;
              },
              createArrayExpression: function createArrayExpression(e) {
                return {
                  type: o.ArrayExpression,
                  elements: e
                };
              },
              createAssignmentExpression: function createAssignmentExpression(e, t, n) {
                return {
                  type: o.AssignmentExpression,
                  operator: e,
                  left: t,
                  right: n
                };
              },
              createBinaryExpression: function createBinaryExpression(e, t, n) {
                return {
                  type: "||" === e || "&&" === e ? o.LogicalExpression : o.BinaryExpression,
                  operator: e,
                  left: t,
                  right: n
                };
              },
              createBlockStatement: function createBlockStatement(e) {
                return {
                  type: o.BlockStatement,
                  body: e
                };
              },
              createBreakStatement: function createBreakStatement(e) {
                return {
                  type: o.BreakStatement,
                  label: e
                };
              },
              createCallExpression: function createCallExpression(e, t) {
                return {
                  type: o.CallExpression,
                  callee: e,
                  arguments: t
                };
              },
              createCatchClause: function createCatchClause(e, t) {
                return {
                  type: o.CatchClause,
                  param: e,
                  body: t
                };
              },
              createConditionalExpression: function createConditionalExpression(e, t, n) {
                return {
                  type: o.ConditionalExpression,
                  test: e,
                  consequent: t,
                  alternate: n
                };
              },
              createContinueStatement: function createContinueStatement(e) {
                return {
                  type: o.ContinueStatement,
                  label: e
                };
              },
              createDebuggerStatement: function createDebuggerStatement() {
                return {
                  type: o.DebuggerStatement
                };
              },
              createDoWhileStatement: function createDoWhileStatement(e, t) {
                return {
                  type: o.DoWhileStatement,
                  body: e,
                  test: t
                };
              },
              createEmptyStatement: function createEmptyStatement() {
                return {
                  type: o.EmptyStatement
                };
              },
              createExpressionStatement: function createExpressionStatement(e) {
                return {
                  type: o.ExpressionStatement,
                  expression: e
                };
              },
              createForStatement: function createForStatement(e, t, n, r) {
                return {
                  type: o.ForStatement,
                  init: e,
                  test: t,
                  update: n,
                  body: r
                };
              },
              createForInStatement: function createForInStatement(e, t, n) {
                return {
                  type: o.ForInStatement,
                  left: e,
                  right: t,
                  body: n,
                  each: !1
                };
              },
              createFunctionDeclaration: function createFunctionDeclaration(e, t, n, r) {
                return {
                  type: o.FunctionDeclaration,
                  id: e,
                  params: t,
                  defaults: n,
                  body: r,
                  rest: null,
                  generator: !1,
                  expression: !1
                };
              },
              createFunctionExpression: function createFunctionExpression(e, t, n, r) {
                return {
                  type: o.FunctionExpression,
                  id: e,
                  params: t,
                  defaults: n,
                  body: r,
                  rest: null,
                  generator: !1,
                  expression: !1
                };
              },
              createIdentifier: function createIdentifier(e) {
                return {
                  type: o.Identifier,
                  name: e
                };
              },
              createIfStatement: function createIfStatement(e, t, n) {
                return {
                  type: o.IfStatement,
                  test: e,
                  consequent: t,
                  alternate: n
                };
              },
              createLabeledStatement: function createLabeledStatement(e, t) {
                return {
                  type: o.LabeledStatement,
                  label: e,
                  body: t
                };
              },
              createLiteral: function createLiteral(e) {
                return {
                  type: o.Literal,
                  value: e.value,
                  raw: c.slice(e.start, e.end)
                };
              },
              createMemberExpression: function createMemberExpression(e, t, n) {
                return {
                  type: o.MemberExpression,
                  computed: "[" === e,
                  object: t,
                  property: n
                };
              },
              createNewExpression: function createNewExpression(e, t) {
                return {
                  type: o.NewExpression,
                  callee: e,
                  arguments: t
                };
              },
              createObjectExpression: function createObjectExpression(e) {
                return {
                  type: o.ObjectExpression,
                  properties: e
                };
              },
              createPostfixExpression: function createPostfixExpression(e, t) {
                return {
                  type: o.UpdateExpression,
                  operator: e,
                  argument: t,
                  prefix: !1
                };
              },
              createProgram: function createProgram(e) {
                return {
                  type: o.Program,
                  body: e
                };
              },
              createProperty: function createProperty(e, t, n) {
                return {
                  type: o.Property,
                  key: t,
                  value: n,
                  kind: e
                };
              },
              createReturnStatement: function createReturnStatement(e) {
                return {
                  type: o.ReturnStatement,
                  argument: e
                };
              },
              createSequenceExpression: function createSequenceExpression(e) {
                return {
                  type: o.SequenceExpression,
                  expressions: e
                };
              },
              createSwitchCase: function createSwitchCase(e, t) {
                return {
                  type: o.SwitchCase,
                  test: e,
                  consequent: t
                };
              },
              createSwitchStatement: function createSwitchStatement(e, t) {
                return {
                  type: o.SwitchStatement,
                  discriminant: e,
                  cases: t
                };
              },
              createThisExpression: function createThisExpression() {
                return {
                  type: o.ThisExpression
                };
              },
              createThrowStatement: function createThrowStatement(e) {
                return {
                  type: o.ThrowStatement,
                  argument: e
                };
              },
              createTryStatement: function createTryStatement(e, t, n, r) {
                return {
                  type: o.TryStatement,
                  block: e,
                  guardedHandlers: t,
                  handlers: n,
                  finalizer: r
                };
              },
              createUnaryExpression: function createUnaryExpression(e, t) {
                return "++" === e || "--" === e ? {
                  type: o.UpdateExpression,
                  operator: e,
                  argument: t,
                  prefix: !0
                } : {
                  type: o.UnaryExpression,
                  operator: e,
                  argument: t,
                  prefix: !0
                };
              },
              createVariableDeclaration: function createVariableDeclaration(e, t) {
                return {
                  type: o.VariableDeclaration,
                  declarations: e,
                  kind: t
                };
              },
              createVariableDeclarator: function createVariableDeclarator(e, t) {
                return {
                  type: o.VariableDeclarator,
                  id: e,
                  init: t
                };
              },
              createWhileStatement: function createWhileStatement(e, t) {
                return {
                  type: o.WhileStatement,
                  test: e,
                  body: t
                };
              },
              createWithStatement: function createWithStatement(e, t) {
                return {
                  type: o.WithStatement,
                  object: e,
                  body: t
                };
              }
            }, e.version = "1.2.2", e.tokenize = function (e, n) {
              var r;
              "string" == typeof e || e instanceof String || (e = String(e)), v = u, l = 0, p = (c = e).length > 0 ? 1 : 0, h = 0, d = c.length, y = null, g = {
                allowIn: !0,
                labelSet: {},
                inFunctionBody: !1,
                inIteration: !1,
                inSwitch: !1,
                lastCommentStart: -1
              }, m = {}, (n = n || {}).tokens = !0, m.tokens = [], m.tokenize = !0, m.openParenToken = -1, m.openCurlyToken = -1, m.range = "boolean" == typeof n.range && n.range, m.loc = "boolean" == typeof n.loc && n.loc, "boolean" == typeof n.comment && n.comment && (m.comments = []), "boolean" == typeof n.tolerant && n.tolerant && (m.errors = []);

              try {
                if ($(), y.type === t.EOF) return m.tokens;

                for (q(); y.type !== t.EOF;) {
                  try {
                    q();
                  } catch (e) {
                    if (m.errors) {
                      m.errors.push(e);
                      break;
                    }

                    throw e;
                  }
                }

                Pe(), r = m.tokens, void 0 !== m.comments && (r.comments = m.comments), void 0 !== m.errors && (r.errors = m.errors);
              } catch (e) {
                throw e;
              } finally {
                m = {};
              }

              return r;
            }, e.parse = function (e, t) {
              var n, r;
              r = String, "string" == typeof e || e instanceof String || (e = r(e)), v = u, l = 0, p = (c = e).length > 0 ? 1 : 0, h = 0, d = c.length, y = null, g = {
                allowIn: !0,
                labelSet: {},
                inFunctionBody: !1,
                inIteration: !1,
                inSwitch: !1,
                lastCommentStart: -1
              }, m = {}, void 0 !== t && (m.range = "boolean" == typeof t.range && t.range, m.loc = "boolean" == typeof t.loc && t.loc, m.attachComment = "boolean" == typeof t.attachComment && t.attachComment, m.loc && null !== t.source && void 0 !== t.source && (m.source = r(t.source)), "boolean" == typeof t.tokens && t.tokens && (m.tokens = []), "boolean" == typeof t.comment && t.comment && (m.comments = []), "boolean" == typeof t.tolerant && t.tolerant && (m.errors = []), m.attachComment && (m.range = !0, m.comments = [], m.bottomRightStack = [], m.trailingComments = [], m.leadingComments = []));

              try {
                n = Re(), void 0 !== m.comments && (n.comments = m.comments), void 0 !== m.tokens && (Pe(), n.tokens = m.tokens), void 0 !== m.errors && (n.errors = m.errors);
              } catch (e) {
                throw e;
              } finally {
                m = {};
              }

              return n;
            }, e.Syntax = function () {
              var e,
                  t = {};

              for (e in "function" == typeof Object.create && (t = Object.create(null)), o) {
                o.hasOwnProperty(e) && (t[e] = o[e]);
              }

              return "function" == typeof Object.freeze && Object.freeze(t), t;
            }();
          });
        }, {}],
        1: [function (e, t, n) {
          (function (r) {
            var o = function () {
              var e = {
                trace: function trace() {},
                yy: {},
                symbols_: {
                  error: 2,
                  JSON_PATH: 3,
                  DOLLAR: 4,
                  PATH_COMPONENTS: 5,
                  LEADING_CHILD_MEMBER_EXPRESSION: 6,
                  PATH_COMPONENT: 7,
                  MEMBER_COMPONENT: 8,
                  SUBSCRIPT_COMPONENT: 9,
                  CHILD_MEMBER_COMPONENT: 10,
                  DESCENDANT_MEMBER_COMPONENT: 11,
                  DOT: 12,
                  MEMBER_EXPRESSION: 13,
                  DOT_DOT: 14,
                  STAR: 15,
                  IDENTIFIER: 16,
                  SCRIPT_EXPRESSION: 17,
                  INTEGER: 18,
                  END: 19,
                  CHILD_SUBSCRIPT_COMPONENT: 20,
                  DESCENDANT_SUBSCRIPT_COMPONENT: 21,
                  "[": 22,
                  SUBSCRIPT: 23,
                  "]": 24,
                  SUBSCRIPT_EXPRESSION: 25,
                  SUBSCRIPT_EXPRESSION_LIST: 26,
                  SUBSCRIPT_EXPRESSION_LISTABLE: 27,
                  ",": 28,
                  STRING_LITERAL: 29,
                  ARRAY_SLICE: 30,
                  FILTER_EXPRESSION: 31,
                  QQ_STRING: 32,
                  Q_STRING: 33,
                  $accept: 0,
                  $end: 1
                },
                terminals_: {
                  2: "error",
                  4: "DOLLAR",
                  12: "DOT",
                  14: "DOT_DOT",
                  15: "STAR",
                  16: "IDENTIFIER",
                  17: "SCRIPT_EXPRESSION",
                  18: "INTEGER",
                  19: "END",
                  22: "[",
                  24: "]",
                  28: ",",
                  30: "ARRAY_SLICE",
                  31: "FILTER_EXPRESSION",
                  32: "QQ_STRING",
                  33: "Q_STRING"
                },
                productions_: [0, [3, 1], [3, 2], [3, 1], [3, 2], [5, 1], [5, 2], [7, 1], [7, 1], [8, 1], [8, 1], [10, 2], [6, 1], [11, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [9, 1], [9, 1], [20, 3], [21, 4], [23, 1], [23, 1], [26, 1], [26, 3], [27, 1], [27, 1], [27, 1], [25, 1], [25, 1], [25, 1], [29, 1], [29, 1]],
                performAction: function performAction(e, n, r, o, i, a, s) {
                  o.ast || (o.ast = t, t.initialize());
                  var u = a.length - 1;

                  switch (i) {
                    case 1:
                      return o.ast.set({
                        expression: {
                          type: "root",
                          value: a[u]
                        }
                      }), o.ast.unshift(), o.ast.yield();

                    case 2:
                      return o.ast.set({
                        expression: {
                          type: "root",
                          value: a[u - 1]
                        }
                      }), o.ast.unshift(), o.ast.yield();

                    case 3:
                      return o.ast.unshift(), o.ast.yield();

                    case 4:
                      return o.ast.set({
                        operation: "member",
                        scope: "child",
                        expression: {
                          type: "identifier",
                          value: a[u - 1]
                        }
                      }), o.ast.unshift(), o.ast.yield();

                    case 5:
                    case 6:
                      break;

                    case 7:
                      o.ast.set({
                        operation: "member"
                      }), o.ast.push();
                      break;

                    case 8:
                      o.ast.set({
                        operation: "subscript"
                      }), o.ast.push();
                      break;

                    case 9:
                      o.ast.set({
                        scope: "child"
                      });
                      break;

                    case 10:
                      o.ast.set({
                        scope: "descendant"
                      });
                      break;

                    case 11:
                      break;

                    case 12:
                      o.ast.set({
                        scope: "child",
                        operation: "member"
                      });
                      break;

                    case 13:
                      break;

                    case 14:
                      o.ast.set({
                        expression: {
                          type: "wildcard",
                          value: a[u]
                        }
                      });
                      break;

                    case 15:
                      o.ast.set({
                        expression: {
                          type: "identifier",
                          value: a[u]
                        }
                      });
                      break;

                    case 16:
                      o.ast.set({
                        expression: {
                          type: "script_expression",
                          value: a[u]
                        }
                      });
                      break;

                    case 17:
                      o.ast.set({
                        expression: {
                          type: "numeric_literal",
                          value: parseInt(a[u])
                        }
                      });
                      break;

                    case 18:
                      break;

                    case 19:
                      o.ast.set({
                        scope: "child"
                      });
                      break;

                    case 20:
                      o.ast.set({
                        scope: "descendant"
                      });
                      break;

                    case 21:
                    case 22:
                    case 23:
                      break;

                    case 24:
                      a[u].length > 1 ? o.ast.set({
                        expression: {
                          type: "union",
                          value: a[u]
                        }
                      }) : this.$ = a[u];
                      break;

                    case 25:
                      this.$ = [a[u]];
                      break;

                    case 26:
                      this.$ = a[u - 2].concat(a[u]);
                      break;

                    case 27:
                      this.$ = {
                        expression: {
                          type: "numeric_literal",
                          value: parseInt(a[u])
                        }
                      }, o.ast.set(this.$);
                      break;

                    case 28:
                      this.$ = {
                        expression: {
                          type: "string_literal",
                          value: a[u]
                        }
                      }, o.ast.set(this.$);
                      break;

                    case 29:
                      this.$ = {
                        expression: {
                          type: "slice",
                          value: a[u]
                        }
                      }, o.ast.set(this.$);
                      break;

                    case 30:
                      this.$ = {
                        expression: {
                          type: "wildcard",
                          value: a[u]
                        }
                      }, o.ast.set(this.$);
                      break;

                    case 31:
                      this.$ = {
                        expression: {
                          type: "script_expression",
                          value: a[u]
                        }
                      }, o.ast.set(this.$);
                      break;

                    case 32:
                      this.$ = {
                        expression: {
                          type: "filter_expression",
                          value: a[u]
                        }
                      }, o.ast.set(this.$);
                      break;

                    case 33:
                    case 34:
                      this.$ = a[u];
                  }
                },
                table: [{
                  3: 1,
                  4: [1, 2],
                  6: 3,
                  13: 4,
                  15: [1, 5],
                  16: [1, 6],
                  17: [1, 7],
                  18: [1, 8],
                  19: [1, 9]
                }, {
                  1: [3]
                }, {
                  1: [2, 1],
                  5: 10,
                  7: 11,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 3],
                  5: 21,
                  7: 11,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 12],
                  12: [2, 12],
                  14: [2, 12],
                  22: [2, 12]
                }, {
                  1: [2, 14],
                  12: [2, 14],
                  14: [2, 14],
                  22: [2, 14]
                }, {
                  1: [2, 15],
                  12: [2, 15],
                  14: [2, 15],
                  22: [2, 15]
                }, {
                  1: [2, 16],
                  12: [2, 16],
                  14: [2, 16],
                  22: [2, 16]
                }, {
                  1: [2, 17],
                  12: [2, 17],
                  14: [2, 17],
                  22: [2, 17]
                }, {
                  1: [2, 18],
                  12: [2, 18],
                  14: [2, 18],
                  22: [2, 18]
                }, {
                  1: [2, 2],
                  7: 22,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 5],
                  12: [2, 5],
                  14: [2, 5],
                  22: [2, 5]
                }, {
                  1: [2, 7],
                  12: [2, 7],
                  14: [2, 7],
                  22: [2, 7]
                }, {
                  1: [2, 8],
                  12: [2, 8],
                  14: [2, 8],
                  22: [2, 8]
                }, {
                  1: [2, 9],
                  12: [2, 9],
                  14: [2, 9],
                  22: [2, 9]
                }, {
                  1: [2, 10],
                  12: [2, 10],
                  14: [2, 10],
                  22: [2, 10]
                }, {
                  1: [2, 19],
                  12: [2, 19],
                  14: [2, 19],
                  22: [2, 19]
                }, {
                  1: [2, 20],
                  12: [2, 20],
                  14: [2, 20],
                  22: [2, 20]
                }, {
                  13: 23,
                  15: [1, 5],
                  16: [1, 6],
                  17: [1, 7],
                  18: [1, 8],
                  19: [1, 9]
                }, {
                  13: 24,
                  15: [1, 5],
                  16: [1, 6],
                  17: [1, 7],
                  18: [1, 8],
                  19: [1, 9],
                  22: [1, 25]
                }, {
                  15: [1, 29],
                  17: [1, 30],
                  18: [1, 33],
                  23: 26,
                  25: 27,
                  26: 28,
                  27: 32,
                  29: 34,
                  30: [1, 35],
                  31: [1, 31],
                  32: [1, 36],
                  33: [1, 37]
                }, {
                  1: [2, 4],
                  7: 22,
                  8: 12,
                  9: 13,
                  10: 14,
                  11: 15,
                  12: [1, 18],
                  14: [1, 19],
                  20: 16,
                  21: 17,
                  22: [1, 20]
                }, {
                  1: [2, 6],
                  12: [2, 6],
                  14: [2, 6],
                  22: [2, 6]
                }, {
                  1: [2, 11],
                  12: [2, 11],
                  14: [2, 11],
                  22: [2, 11]
                }, {
                  1: [2, 13],
                  12: [2, 13],
                  14: [2, 13],
                  22: [2, 13]
                }, {
                  15: [1, 29],
                  17: [1, 30],
                  18: [1, 33],
                  23: 38,
                  25: 27,
                  26: 28,
                  27: 32,
                  29: 34,
                  30: [1, 35],
                  31: [1, 31],
                  32: [1, 36],
                  33: [1, 37]
                }, {
                  24: [1, 39]
                }, {
                  24: [2, 23]
                }, {
                  24: [2, 24],
                  28: [1, 40]
                }, {
                  24: [2, 30]
                }, {
                  24: [2, 31]
                }, {
                  24: [2, 32]
                }, {
                  24: [2, 25],
                  28: [2, 25]
                }, {
                  24: [2, 27],
                  28: [2, 27]
                }, {
                  24: [2, 28],
                  28: [2, 28]
                }, {
                  24: [2, 29],
                  28: [2, 29]
                }, {
                  24: [2, 33],
                  28: [2, 33]
                }, {
                  24: [2, 34],
                  28: [2, 34]
                }, {
                  24: [1, 41]
                }, {
                  1: [2, 21],
                  12: [2, 21],
                  14: [2, 21],
                  22: [2, 21]
                }, {
                  18: [1, 33],
                  27: 42,
                  29: 34,
                  30: [1, 35],
                  32: [1, 36],
                  33: [1, 37]
                }, {
                  1: [2, 22],
                  12: [2, 22],
                  14: [2, 22],
                  22: [2, 22]
                }, {
                  24: [2, 26],
                  28: [2, 26]
                }],
                defaultActions: {
                  27: [2, 23],
                  29: [2, 30],
                  30: [2, 31],
                  31: [2, 32]
                },
                parseError: function parseError(e, t) {
                  if (!t.recoverable) throw new Error(e);
                  this.trace(e);
                },
                parse: function parse(e) {
                  var t = this,
                      n = [0],
                      r = [null],
                      o = [],
                      i = this.table,
                      a = "",
                      s = 0,
                      u = 0,
                      c = 0,
                      f = 2,
                      l = 1,
                      p = o.slice.call(arguments, 1);
                  this.lexer.setInput(e), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {});
                  var h = this.lexer.yylloc;
                  o.push(h);
                  var d = this.lexer.options && this.lexer.options.ranges;

                  function v() {
                    var e;
                    return "number" != typeof (e = t.lexer.lex() || l) && (e = t.symbols_[e] || e), e;
                  }

                  "function" == typeof this.yy.parseError ? this.parseError = this.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

                  for (var y, g, m, b, x, w, k, S, E, T = {};;) {
                    if (m = n[n.length - 1], this.defaultActions[m] ? b = this.defaultActions[m] : (null == y && (y = v()), b = i[m] && i[m][y]), void 0 === b || !b.length || !b[0]) {
                      var _ = "";

                      for (w in E = [], i[m]) {
                        this.terminals_[w] && w > f && E.push("'" + this.terminals_[w] + "'");
                      }

                      _ = this.lexer.showPosition ? "Parse error on line " + (s + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + E.join(", ") + ", got '" + (this.terminals_[y] || y) + "'" : "Parse error on line " + (s + 1) + ": Unexpected " + (y == l ? "end of input" : "'" + (this.terminals_[y] || y) + "'"), this.parseError(_, {
                        text: this.lexer.match,
                        token: this.terminals_[y] || y,
                        line: this.lexer.yylineno,
                        loc: h,
                        expected: E
                      });
                    }

                    if (b[0] instanceof Array && b.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + m + ", token: " + y);

                    switch (b[0]) {
                      case 1:
                        n.push(y), r.push(this.lexer.yytext), o.push(this.lexer.yylloc), n.push(b[1]), y = null, g ? (y = g, g = null) : (u = this.lexer.yyleng, a = this.lexer.yytext, s = this.lexer.yylineno, h = this.lexer.yylloc, c > 0 && c--);
                        break;

                      case 2:
                        if (k = this.productions_[b[1]][1], T.$ = r[r.length - k], T._$ = {
                          first_line: o[o.length - (k || 1)].first_line,
                          last_line: o[o.length - 1].last_line,
                          first_column: o[o.length - (k || 1)].first_column,
                          last_column: o[o.length - 1].last_column
                        }, d && (T._$.range = [o[o.length - (k || 1)].range[0], o[o.length - 1].range[1]]), void 0 !== (x = this.performAction.apply(T, [a, u, s, this.yy, b[1], r, o].concat(p)))) return x;
                        k && (n = n.slice(0, -1 * k * 2), r = r.slice(0, -1 * k), o = o.slice(0, -1 * k)), n.push(this.productions_[b[1]][0]), r.push(T.$), o.push(T._$), S = i[n[n.length - 2]][n[n.length - 1]], n.push(S);
                        break;

                      case 3:
                        return !0;
                    }
                  }

                  return !0;
                }
              },
                  t = {
                initialize: function initialize() {
                  this._nodes = [], this._node = {}, this._stash = [];
                },
                set: function set(e) {
                  for (var t in e) {
                    this._node[t] = e[t];
                  }

                  return this._node;
                },
                node: function node(e) {
                  return arguments.length && (this._node = e), this._node;
                },
                push: function push() {
                  this._nodes.push(this._node), this._node = {};
                },
                unshift: function unshift() {
                  this._nodes.unshift(this._node), this._node = {};
                },
                yield: function _yield() {
                  var e = this._nodes;
                  return this.initialize(), e;
                }
              },
                  n = {
                EOF: 1,
                parseError: function parseError(e, t) {
                  if (!this.yy.parser) throw new Error(e);
                  this.yy.parser.parseError(e, t);
                },
                setInput: function setInput(e) {
                  return this._input = e, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                  }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
                },
                input: function input() {
                  var e = this._input[0];
                  return this.yytext += e, this.yyleng++, this.offset++, this.match += e, this.matched += e, e.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), e;
                },
                unput: function unput(e) {
                  var t = e.length,
                      n = e.split(/(?:\r\n?|\n)/g);
                  this._input = e + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - t - 1), this.offset -= t;
                  var r = this.match.split(/(?:\r\n?|\n)/g);
                  this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
                  var o = this.yylloc.range;
                  return this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - t
                  }, this.options.ranges && (this.yylloc.range = [o[0], o[0] + this.yyleng - t]), this.yyleng = this.yytext.length, this;
                },
                more: function more() {
                  return this._more = !0, this;
                },
                reject: function reject() {
                  return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                  });
                },
                less: function less(e) {
                  this.unput(this.match.slice(e));
                },
                pastInput: function pastInput() {
                  var e = this.matched.substr(0, this.matched.length - this.match.length);
                  return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
                },
                upcomingInput: function upcomingInput() {
                  var e = this.match;
                  return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
                },
                showPosition: function showPosition() {
                  var e = this.pastInput(),
                      t = new Array(e.length + 1).join("-");
                  return e + this.upcomingInput() + "\n" + t + "^";
                },
                test_match: function test_match(e, t) {
                  var n, r, o;
                  if (this.options.backtrack_lexer && (o = {
                    yylineno: this.yylineno,
                    yylloc: {
                      first_line: this.yylloc.first_line,
                      last_line: this.last_line,
                      first_column: this.yylloc.first_column,
                      last_column: this.yylloc.last_column
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                  }, this.options.ranges && (o.yylloc.range = this.yylloc.range.slice(0))), (r = e[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length
                  }, this.yytext += e[0], this.match += e[0], this.matches = e, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(e[0].length), this.matched += e[0], n = this.performAction.call(this, this.yy, this, t, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

                  if (this._backtrack) {
                    for (var i in o) {
                      this[i] = o[i];
                    }

                    return !1;
                  }

                  return !1;
                },
                next: function next() {
                  if (this.done) return this.EOF;
                  var e, t, n, r;
                  this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

                  for (var o = this._currentRules(), i = 0; i < o.length; i++) {
                    if ((n = this._input.match(this.rules[o[i]])) && (!t || n[0].length > t[0].length)) {
                      if (t = n, r = i, this.options.backtrack_lexer) {
                        if (!1 !== (e = this.test_match(n, o[i]))) return e;

                        if (this._backtrack) {
                          t = !1;
                          continue;
                        }

                        return !1;
                      }

                      if (!this.options.flex) break;
                    }
                  }

                  return t ? !1 !== (e = this.test_match(t, o[r])) && e : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                  });
                },
                lex: function lex() {
                  var e = this.next();
                  return e || this.lex();
                },
                begin: function begin(e) {
                  this.conditionStack.push(e);
                },
                popState: function popState() {
                  return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
                },
                _currentRules: function _currentRules() {
                  return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
                },
                topState: function topState(e) {
                  return (e = this.conditionStack.length - 1 - Math.abs(e || 0)) >= 0 ? this.conditionStack[e] : "INITIAL";
                },
                pushState: function pushState(e) {
                  this.begin(e);
                },
                stateStackSize: function stateStackSize() {
                  return this.conditionStack.length;
                },
                options: {},
                performAction: function performAction(e, t, n, r) {
                  switch (n) {
                    case 0:
                      return 4;

                    case 1:
                      return 14;

                    case 2:
                      return 12;

                    case 3:
                      return 15;

                    case 4:
                      return 16;

                    case 5:
                      return 22;

                    case 6:
                      return 24;

                    case 7:
                      return 28;

                    case 8:
                      return 30;

                    case 9:
                      return 18;

                    case 10:
                      return t.yytext = t.yytext.substr(1, t.yyleng - 2), 32;

                    case 11:
                      return t.yytext = t.yytext.substr(1, t.yyleng - 2), 33;

                    case 12:
                      return 17;

                    case 13:
                      return 31;
                  }
                },
                rules: [/^(?:\$)/, /^(?:\.\.)/, /^(?:\.)/, /^(?:\*)/, /^(?:[a-zA-Z_]+[a-zA-Z0-9_]*)/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?:((-?(?:0|[1-9][0-9]*)))?\:((-?(?:0|[1-9][0-9]*)))?(\:((-?(?:0|[1-9][0-9]*)))?)?)/, /^(?:(-?(?:0|[1-9][0-9]*)))/, /^(?:"(?:\\["bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^"\\])*")/, /^(?:'(?:\\['bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^'\\])*')/, /^(?:\(.+?\)(?=\]))/, /^(?:\?\(.+?\)(?=\]))/],
                conditions: {
                  INITIAL: {
                    rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                    inclusive: !0
                  }
                }
              };

              function r() {
                this.yy = {};
              }

              return e.lexer = n, r.prototype = e, e.Parser = r, new r();
            }();

            void 0 !== e && void 0 !== n && (n.parser = o, n.Parser = o.Parser, n.parse = function () {
              return o.parse.apply(o, arguments);
            }, n.main = function (t) {
              t[1] || (console.log("Usage: " + t[0] + " FILE"), r.exit(1));
              var o = e("fs").readFileSync(e("path").normalize(t[1]), "utf8");
              return n.parser.parse(o);
            }, void 0 !== t && e.main === t && n.main(r.argv.slice(1)));
          }).call(this, e("_process"));
        }, {
          _process: 14,
          fs: 12,
          path: 13
        }],
        2: [function (e, t, n) {
          t.exports = {
            identifier: "[a-zA-Z_]+[a-zA-Z0-9_]*",
            integer: "-?(?:0|[1-9][0-9]*)",
            qq_string: "\"(?:\\\\[\"bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^\"\\\\])*\"",
            q_string: "'(?:\\\\['bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^'\\\\])*'"
          };
        }, {}],
        3: [function (e, t, n) {
          var r = e("./dict"),
              o = e("fs"),
              i = {
            lex: {
              macros: {
                esc: "\\\\",
                int: r.integer
              },
              rules: [["\\$", "return 'DOLLAR'"], ["\\.\\.", "return 'DOT_DOT'"], ["\\.", "return 'DOT'"], ["\\*", "return 'STAR'"], [r.identifier, "return 'IDENTIFIER'"], ["\\[", "return '['"], ["\\]", "return ']'"], [",", "return ','"], ["({int})?\\:({int})?(\\:({int})?)?", "return 'ARRAY_SLICE'"], ["{int}", "return 'INTEGER'"], [r.qq_string, "yytext = yytext.substr(1,yyleng-2); return 'QQ_STRING';"], [r.q_string, "yytext = yytext.substr(1,yyleng-2); return 'Q_STRING';"], ["\\(.+?\\)(?=\\])", "return 'SCRIPT_EXPRESSION'"], ["\\?\\(.+?\\)(?=\\])", "return 'FILTER_EXPRESSION'"]]
            },
            start: "JSON_PATH",
            bnf: {
              JSON_PATH: [["DOLLAR", 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()'], ["DOLLAR PATH_COMPONENTS", 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()'], ["LEADING_CHILD_MEMBER_EXPRESSION", "yy.ast.unshift(); return yy.ast.yield()"], ["LEADING_CHILD_MEMBER_EXPRESSION PATH_COMPONENTS", 'yy.ast.set({ operation: "member", scope: "child", expression: { type: "identifier", value: $1 }}); yy.ast.unshift(); return yy.ast.yield()']],
              PATH_COMPONENTS: [["PATH_COMPONENT", ""], ["PATH_COMPONENTS PATH_COMPONENT", ""]],
              PATH_COMPONENT: [["MEMBER_COMPONENT", 'yy.ast.set({ operation: "member" }); yy.ast.push()'], ["SUBSCRIPT_COMPONENT", 'yy.ast.set({ operation: "subscript" }); yy.ast.push() ']],
              MEMBER_COMPONENT: [["CHILD_MEMBER_COMPONENT", 'yy.ast.set({ scope: "child" })'], ["DESCENDANT_MEMBER_COMPONENT", 'yy.ast.set({ scope: "descendant" })']],
              CHILD_MEMBER_COMPONENT: [["DOT MEMBER_EXPRESSION", ""]],
              LEADING_CHILD_MEMBER_EXPRESSION: [["MEMBER_EXPRESSION", 'yy.ast.set({ scope: "child", operation: "member" })']],
              DESCENDANT_MEMBER_COMPONENT: [["DOT_DOT MEMBER_EXPRESSION", ""]],
              MEMBER_EXPRESSION: [["STAR", 'yy.ast.set({ expression: { type: "wildcard", value: $1 } })'], ["IDENTIFIER", 'yy.ast.set({ expression: { type: "identifier", value: $1 } })'], ["SCRIPT_EXPRESSION", 'yy.ast.set({ expression: { type: "script_expression", value: $1 } })'], ["INTEGER", 'yy.ast.set({ expression: { type: "numeric_literal", value: parseInt($1) } })'], ["END", ""]],
              SUBSCRIPT_COMPONENT: [["CHILD_SUBSCRIPT_COMPONENT", 'yy.ast.set({ scope: "child" })'], ["DESCENDANT_SUBSCRIPT_COMPONENT", 'yy.ast.set({ scope: "descendant" })']],
              CHILD_SUBSCRIPT_COMPONENT: [["[ SUBSCRIPT ]", ""]],
              DESCENDANT_SUBSCRIPT_COMPONENT: [["DOT_DOT [ SUBSCRIPT ]", ""]],
              SUBSCRIPT: [["SUBSCRIPT_EXPRESSION", ""], ["SUBSCRIPT_EXPRESSION_LIST", '$1.length > 1? yy.ast.set({ expression: { type: "union", value: $1 } }) : $$ = $1']],
              SUBSCRIPT_EXPRESSION_LIST: [["SUBSCRIPT_EXPRESSION_LISTABLE", "$$ = [$1]"], ["SUBSCRIPT_EXPRESSION_LIST , SUBSCRIPT_EXPRESSION_LISTABLE", "$$ = $1.concat($3)"]],
              SUBSCRIPT_EXPRESSION_LISTABLE: [["INTEGER", '$$ = { expression: { type: "numeric_literal", value: parseInt($1) } }; yy.ast.set($$)'], ["STRING_LITERAL", '$$ = { expression: { type: "string_literal", value: $1 } }; yy.ast.set($$)'], ["ARRAY_SLICE", '$$ = { expression: { type: "slice", value: $1 } }; yy.ast.set($$)']],
              SUBSCRIPT_EXPRESSION: [["STAR", '$$ = { expression: { type: "wildcard", value: $1 } }; yy.ast.set($$)'], ["SCRIPT_EXPRESSION", '$$ = { expression: { type: "script_expression", value: $1 } }; yy.ast.set($$)'], ["FILTER_EXPRESSION", '$$ = { expression: { type: "filter_expression", value: $1 } }; yy.ast.set($$)']],
              STRING_LITERAL: [["QQ_STRING", "$$ = $1"], ["Q_STRING", "$$ = $1"]]
            }
          };
          o.readFileSync && (i.moduleInclude = o.readFileSync(e.resolve("../include/module.js")), i.actionInclude = o.readFileSync(e.resolve("../include/action.js"))), t.exports = i;
        }, {
          "./dict": 2,
          fs: 12
        }],
        4: [function (e, t, n) {
          var r = e("./aesprim"),
              o = e("./slice"),
              i = e("static-eval"),
              a = e("underscore").uniq,
              s = function s() {
            return this.initialize.apply(this, arguments);
          };

          function u(t, n, o) {
            var i = e("./index"),
                a = h(r.parse(n).body[0].expression, {
              "@": t.value
            }),
                s = o.replace(/\{\{\s*value\s*\}\}/g, a),
                u = i.nodes(t.value, s);
            return u.forEach(function (e) {
              e.path = t.path.concat(e.path.slice(1));
            }), u;
          }

          function c(e) {
            return Array.isArray(e);
          }

          function f(e) {
            return function (t, n, r, o) {
              var i = t.value,
                  a = t.path,
                  s = [],
                  u = function (t, i) {
                var a;
                c(t) ? (t.forEach(function (e, t) {
                  s.length >= o || r(t, e, n) && s.push({
                    path: i.concat(t),
                    value: e
                  });
                }), t.forEach(function (t, n) {
                  s.length >= o || e && u(t, i.concat(n));
                })) : (a = t) && !(a instanceof Array) && a instanceof Object && (this.keys(t).forEach(function (e) {
                  s.length >= o || r(e, t[e], n) && s.push({
                    path: i.concat(e),
                    value: t[e]
                  });
                }), this.keys(t).forEach(function (n) {
                  s.length >= o || e && u(t[n], i.concat(n));
                }));
              }.bind(this);

              return u(i, a), s;
            };
          }

          function l(e) {
            return function (t, n, r) {
              return this.descend(n, t.expression.value, e, r);
            };
          }

          function p(e) {
            return function (t, n, r) {
              return this.traverse(n, t.expression.value, e, r);
            };
          }

          function h() {
            try {
              return i.apply(this, arguments);
            } catch (e) {}
          }

          function d(e) {
            return e = e.filter(function (e) {
              return e;
            }), a(e, function (e) {
              return e.path.map(function (e) {
                return String(e).replace("-", "--");
              }).join("-");
            });
          }

          function v(e) {
            var t = String(e);
            return t.match(/^-?[0-9]+$/) ? parseInt(t) : null;
          }

          s.prototype.initialize = function () {
            this.traverse = f(!0), this.descend = f();
          }, s.prototype.keys = Object.keys, s.prototype.resolve = function (e) {
            var t = [e.operation, e.scope, e.expression.type].join("-"),
                n = this._fns[t];
            if (!n) throw new Error("couldn't resolve key: " + t);
            return n.bind(this);
          }, s.prototype.register = function (e, t) {
            if (!t instanceof Function) throw new Error("handler must be a function");
            this._fns[e] = t;
          }, s.prototype._fns = {
            "member-child-identifier": function memberChildIdentifier(e, t) {
              var n = e.expression.value,
                  r = t.value;
              if (r instanceof Object && n in r) return [{
                value: r[n],
                path: t.path.concat(n)
              }];
            },
            "member-descendant-identifier": p(function (e, t, n) {
              return e == n;
            }),
            "subscript-child-numeric_literal": l(function (e, t, n) {
              return e === n;
            }),
            "member-child-numeric_literal": l(function (e, t, n) {
              return String(e) === String(n);
            }),
            "subscript-descendant-numeric_literal": p(function (e, t, n) {
              return e === n;
            }),
            "member-child-wildcard": l(function () {
              return !0;
            }),
            "member-descendant-wildcard": p(function () {
              return !0;
            }),
            "subscript-descendant-wildcard": p(function () {
              return !0;
            }),
            "subscript-child-wildcard": l(function () {
              return !0;
            }),
            "subscript-child-slice": function subscriptChildSlice(e, t) {
              if (c(t.value)) {
                var n = e.expression.value.split(":").map(v),
                    r = t.value.map(function (e, n) {
                  return {
                    value: e,
                    path: t.path.concat(n)
                  };
                });
                return o.apply(null, [r].concat(n));
              }
            },
            "subscript-child-union": function subscriptChildUnion(e, t) {
              var n = [];
              return e.expression.value.forEach(function (e) {
                var r = {
                  operation: "subscript",
                  scope: "child",
                  expression: e.expression
                },
                    o = this.resolve(r)(r, t);
                o && (n = n.concat(o));
              }, this), d(n);
            },
            "subscript-descendant-union": function subscriptDescendantUnion(t, n, r) {
              var o = e(".."),
                  i = this,
                  a = [];
              return o.nodes(n, "$..*").slice(1).forEach(function (e) {
                a.length >= r || t.expression.value.forEach(function (t) {
                  var n = {
                    operation: "subscript",
                    scope: "child",
                    expression: t.expression
                  },
                      r = i.resolve(n)(n, e);
                  a = a.concat(r);
                });
              }), d(a);
            },
            "subscript-child-filter_expression": function subscriptChildFilter_expression(e, t, n) {
              var o = e.expression.value.slice(2, -1),
                  i = r.parse(o).body[0].expression;
              return this.descend(t, null, function (e, t) {
                return h(i, {
                  "@": t
                });
              }, n);
            },
            "subscript-descendant-filter_expression": function subscriptDescendantFilter_expression(e, t, n) {
              var o = e.expression.value.slice(2, -1),
                  i = r.parse(o).body[0].expression;
              return this.traverse(t, null, function (e, t) {
                return h(i, {
                  "@": t
                });
              }, n);
            },
            "subscript-child-script_expression": function subscriptChildScript_expression(e, t) {
              return u(t, e.expression.value.slice(1, -1), "$[{{value}}]");
            },
            "member-child-script_expression": function memberChildScript_expression(e, t) {
              return u(t, e.expression.value.slice(1, -1), "$.{{value}}");
            },
            "member-descendant-script_expression": function memberDescendantScript_expression(e, t) {
              return u(t, e.expression.value.slice(1, -1), "$..value");
            }
          }, s.prototype._fns["subscript-child-string_literal"] = s.prototype._fns["member-child-identifier"], s.prototype._fns["member-descendant-numeric_literal"] = s.prototype._fns["subscript-descendant-string_literal"] = s.prototype._fns["member-descendant-identifier"], t.exports = s;
        }, {
          "..": "jsonpath",
          "./aesprim": "./aesprim",
          "./index": 5,
          "./slice": 7,
          "static-eval": 15,
          underscore: 12
        }],
        5: [function (e, t, n) {
          var r = e("assert"),
              o = e("./dict"),
              i = e("./parser"),
              a = e("./handlers"),
              s = function s() {
            this.initialize.apply(this, arguments);
          };

          function u(e) {
            return "[object String]" == Object.prototype.toString.call(e);
          }

          s.prototype.initialize = function () {
            this.parser = new i(), this.handlers = new a();
          }, s.prototype.parse = function (e) {
            return r.ok(u(e), "we need a path"), this.parser.parse(e);
          }, s.prototype.parent = function (e, t) {
            r.ok(e instanceof Object, "obj needs to be an object"), r.ok(t, "we need a path");
            var n = this.nodes(e, t)[0];
            return n.path.pop(), this.value(e, n.path);
          }, s.prototype.apply = function (e, t, n) {
            r.ok(e instanceof Object, "obj needs to be an object"), r.ok(t, "we need a path"), r.equal(typeof n, "function", "fn needs to be function");
            var o = this.nodes(e, t).sort(function (e, t) {
              return t.path.length - e.path.length;
            });
            return o.forEach(function (t) {
              var r = t.path.pop(),
                  o = this.value(e, this.stringify(t.path)),
                  i = t.value = n.call(e, o[r]);
              o[r] = i;
            }, this), o;
          }, s.prototype.value = function (e, t, n) {
            if (r.ok(e instanceof Object, "obj needs to be an object"), r.ok(t, "we need a path"), arguments.length >= 3) {
              var o = this.nodes(e, t).shift();
              if (!o) return this._vivify(e, t, n);
              var i = o.path.slice(-1).shift(),
                  a = this.parent(e, this.stringify(o.path));
              a[i] = n;
            }

            return this.query(e, this.stringify(t), 1).shift();
          }, s.prototype._vivify = function (e, t, n) {
            var o = this;
            r.ok(e instanceof Object, "obj needs to be an object"), r.ok(t, "we need a path");

            var i = this.parser.parse(t).map(function (e) {
              return e.expression.value;
            }),
                a = function a(t, n) {
              var r = t.pop(),
                  i = o.value(e, t);
              i || (a(t.concat(), "string" == typeof r ? {} : []), i = o.value(e, t)), i[r] = n;
            };

            return a(i, n), this.query(e, t)[0];
          }, s.prototype.query = function (e, t, n) {
            return r.ok(e instanceof Object, "obj needs to be an object"), r.ok(u(t), "we need a path"), this.nodes(e, t, n).map(function (e) {
              return e.value;
            });
          }, s.prototype.paths = function (e, t, n) {
            return r.ok(e instanceof Object, "obj needs to be an object"), r.ok(t, "we need a path"), this.nodes(e, t, n).map(function (e) {
              return e.path;
            });
          }, s.prototype.nodes = function (e, t, n) {
            if (r.ok(e instanceof Object, "obj needs to be an object"), r.ok(t, "we need a path"), 0 === n) return [];
            var o = this.parser.parse(t),
                i = this.handlers,
                a = [{
              path: ["$"],
              value: e
            }],
                s = [];
            return o.length && "root" == o[0].expression.type && o.shift(), o.length ? (o.forEach(function (e, t) {
              if (!(s.length >= n)) {
                var r = i.resolve(e),
                    u = [];
                a.forEach(function (i) {
                  if (!(s.length >= n)) {
                    var a = r(e, i, n);
                    t == o.length - 1 ? s = s.concat(a || []) : u = u.concat(a || []);
                  }
                }), a = u;
              }
            }), n ? s.slice(0, n) : s) : a;
          }, s.prototype.stringify = function (e) {
            r.ok(e, "we need a path");
            var t = "$",
                n = {
              "descendant-member": "..{{value}}",
              "child-member": ".{{value}}",
              "descendant-subscript": "..[{{value}}]",
              "child-subscript": "[{{value}}]"
            };
            return (e = this._normalize(e)).forEach(function (e) {
              if ("root" != e.expression.type) {
                var r,
                    o = [e.scope, e.operation].join("-"),
                    i = n[o];
                if (r = "string_literal" == e.expression.type ? JSON.stringify(e.expression.value) : e.expression.value, !i) throw new Error("couldn't find template " + o);
                t += i.replace(/{{value}}/, r);
              }
            }), t;
          }, s.prototype._normalize = function (e) {
            if (r.ok(e, "we need a path"), "string" == typeof e) return this.parser.parse(e);

            if (Array.isArray(e) && "string" == typeof e[0]) {
              var t = [{
                expression: {
                  type: "root",
                  value: "$"
                }
              }];
              return e.forEach(function (e, n) {
                if ("$" != e || 0 !== n) if ("string" == typeof e && e.match("^" + o.identifier + "$")) t.push({
                  operation: "member",
                  scope: "child",
                  expression: {
                    value: e,
                    type: "identifier"
                  }
                });else {
                  var r = "number" == typeof e ? "numeric_literal" : "string_literal";
                  t.push({
                    operation: "subscript",
                    scope: "child",
                    expression: {
                      value: e,
                      type: r
                    }
                  });
                }
              }), t;
            }

            if (Array.isArray(e) && "object" == typeof e[0]) return e;
            throw new Error("couldn't understand path " + e);
          }, s.Handlers = a, s.Parser = i;
          var c = new s();
          c.JSONPath = s, t.exports = c;
        }, {
          "./dict": 2,
          "./handlers": 4,
          "./parser": 6,
          assert: 8
        }],
        6: [function (e, t, n) {
          var r = e("./grammar"),
              o = e("../generated/parser"),
              i = function i() {
            var e = new o.Parser(),
                t = e.parseError;
            return e.yy.parseError = function () {
              e.yy.ast && e.yy.ast.initialize(), t.apply(e, arguments);
            }, e;
          };

          i.grammar = r, t.exports = i;
        }, {
          "../generated/parser": 1,
          "./grammar": 3
        }],
        7: [function (e, t, n) {
          function r(e) {
            return String(e).match(/^[0-9]+$/) ? parseInt(e) : Number.isFinite(e) ? parseInt(e, 10) : 0;
          }

          t.exports = function (e, t, n, o) {
            if ("string" == typeof t) throw new Error("start cannot be a string");
            if ("string" == typeof n) throw new Error("end cannot be a string");
            if ("string" == typeof o) throw new Error("step cannot be a string");
            var i = e.length;
            if (0 === o) throw new Error("step cannot be zero");
            if (o = o ? r(o) : 1, n = n < 0 ? i + n : n, t = r(0 === (t = t < 0 ? i + t : t) ? 0 : t || (o > 0 ? 0 : i - 1)), n = r(0 === n ? 0 : n || (o > 0 ? i : -1)), t = o > 0 ? Math.max(0, t) : Math.min(i, t), n = o > 0 ? Math.min(n, i) : Math.max(-1, n), o > 0 && n <= t) return [];
            if (o < 0 && t <= n) return [];

            for (var a = [], s = t; s != n && !(o < 0 && s <= n || o > 0 && s >= n); s += o) {
              a.push(e[s]);
            }

            return a;
          };
        }, {}],
        8: [function (e, t, n) {
          var r = e("util/"),
              o = Array.prototype.slice,
              i = Object.prototype.hasOwnProperty,
              a = t.exports = f;

          function s(e, t) {
            return r.isUndefined(t) ? "" + t : r.isNumber(t) && !isFinite(t) || r.isFunction(t) || r.isRegExp(t) ? t.toString() : t;
          }

          function u(e, t) {
            return r.isString(e) ? e.length < t ? e : e.slice(0, t) : e;
          }

          function c(e, t, n, r, o) {
            throw new a.AssertionError({
              message: n,
              actual: e,
              expected: t,
              operator: r,
              stackStartFunction: o
            });
          }

          function f(e, t) {
            e || c(e, !0, t, "==", a.ok);
          }

          function l(e, t) {
            if (e === t) return !0;

            if (r.isBuffer(e) && r.isBuffer(t)) {
              if (e.length != t.length) return !1;

              for (var n = 0; n < e.length; n++) {
                if (e[n] !== t[n]) return !1;
              }

              return !0;
            }

            return r.isDate(e) && r.isDate(t) ? e.getTime() === t.getTime() : r.isRegExp(e) && r.isRegExp(t) ? e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase : r.isObject(e) || r.isObject(t) ? function (e, t) {
              if (r.isNullOrUndefined(e) || r.isNullOrUndefined(t)) return !1;
              if (e.prototype !== t.prototype) return !1;
              if (r.isPrimitive(e) || r.isPrimitive(t)) return e === t;
              var n = p(e),
                  i = p(t);
              if (n && !i || !n && i) return !1;
              if (n) return e = o.call(e), t = o.call(t), l(e, t);
              var a,
                  s,
                  u = v(e),
                  c = v(t);
              if (u.length != c.length) return !1;

              for (u.sort(), c.sort(), s = u.length - 1; s >= 0; s--) {
                if (u[s] != c[s]) return !1;
              }

              for (s = u.length - 1; s >= 0; s--) {
                if (a = u[s], !l(e[a], t[a])) return !1;
              }

              return !0;
            }(e, t) : e == t;
          }

          function p(e) {
            return "[object Arguments]" == Object.prototype.toString.call(e);
          }

          function h(e, t) {
            return !(!e || !t) && ("[object RegExp]" == Object.prototype.toString.call(t) ? t.test(e) : e instanceof t || !0 === t.call({}, e));
          }

          function d(e, t, n, o) {
            var i;
            r.isString(n) && (o = n, n = null);

            try {
              t();
            } catch (e) {
              i = e;
            }

            if (o = (n && n.name ? " (" + n.name + ")." : ".") + (o ? " " + o : "."), e && !i && c(i, n, "Missing expected exception" + o), !e && h(i, n) && c(i, n, "Got unwanted exception" + o), e && i && n && !h(i, n) || !e && i) throw i;
          }

          a.AssertionError = function (e) {
            this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = function (e) {
              return u(JSON.stringify(e.actual, s), 128) + " " + e.operator + " " + u(JSON.stringify(e.expected, s), 128);
            }(this), this.generatedMessage = !0);
            var t = e.stackStartFunction || c;
            if (Error.captureStackTrace) Error.captureStackTrace(this, t);else {
              var n = new Error();

              if (n.stack) {
                var r = n.stack,
                    o = t.name,
                    i = r.indexOf("\n" + o);

                if (i >= 0) {
                  var a = r.indexOf("\n", i + 1);
                  r = r.substring(a + 1);
                }

                this.stack = r;
              }
            }
          }, r.inherits(a.AssertionError, Error), a.fail = c, a.ok = f, a.equal = function (e, t, n) {
            e != t && c(e, t, n, "==", a.equal);
          }, a.notEqual = function (e, t, n) {
            e == t && c(e, t, n, "!=", a.notEqual);
          }, a.deepEqual = function (e, t, n) {
            l(e, t) || c(e, t, n, "deepEqual", a.deepEqual);
          }, a.notDeepEqual = function (e, t, n) {
            l(e, t) && c(e, t, n, "notDeepEqual", a.notDeepEqual);
          }, a.strictEqual = function (e, t, n) {
            e !== t && c(e, t, n, "===", a.strictEqual);
          }, a.notStrictEqual = function (e, t, n) {
            e === t && c(e, t, n, "!==", a.notStrictEqual);
          }, a.throws = function (e, t, n) {
            d.apply(this, [!0].concat(o.call(arguments)));
          }, a.doesNotThrow = function (e, t) {
            d.apply(this, [!1].concat(o.call(arguments)));
          }, a.ifError = function (e) {
            if (e) throw e;
          };

          var v = Object.keys || function (e) {
            var t = [];

            for (var n in e) {
              i.call(e, n) && t.push(n);
            }

            return t;
          };
        }, {
          "util/": 11
        }],
        9: [function (e, t, n) {
          "function" == typeof Object.create ? t.exports = function (e, t) {
            e.super_ = t, e.prototype = Object.create(t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            });
          } : t.exports = function (e, t) {
            e.super_ = t;

            var n = function n() {};

            n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
          };
        }, {}],
        10: [function (e, t, n) {
          t.exports = function (e) {
            return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
          };
        }, {}],
        11: [function (e, n, r) {
          (function (t, n) {
            var o = /%[sdj%]/g;
            r.format = function (e) {
              if (!g(e)) {
                for (var t = [], n = 0; n < arguments.length; n++) {
                  t.push(s(arguments[n]));
                }

                return t.join(" ");
              }

              n = 1;

              for (var r = arguments, i = r.length, a = String(e).replace(o, function (e) {
                if ("%%" === e) return "%";
                if (n >= i) return e;

                switch (e) {
                  case "%s":
                    return String(r[n++]);

                  case "%d":
                    return Number(r[n++]);

                  case "%j":
                    try {
                      return JSON.stringify(r[n++]);
                    } catch (e) {
                      return "[Circular]";
                    }

                  default:
                    return e;
                }
              }), u = r[n]; n < i; u = r[++n]) {
                v(u) || !x(u) ? a += " " + u : a += " " + s(u);
              }

              return a;
            }, r.deprecate = function (e, o) {
              if (m(n.process)) return function () {
                return r.deprecate(e, o).apply(this, arguments);
              };
              if (!0 === t.noDeprecation) return e;
              var i = !1;
              return function () {
                if (!i) {
                  if (t.throwDeprecation) throw new Error(o);
                  t.traceDeprecation ? console.trace(o) : console.error(o), i = !0;
                }

                return e.apply(this, arguments);
              };
            };
            var i,
                a = {};

            function s(e, t) {
              var n = {
                seen: [],
                stylize: c
              };
              return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), d(t) ? n.showHidden = t : t && r._extend(n, t), m(n.showHidden) && (n.showHidden = !1), m(n.depth) && (n.depth = 2), m(n.colors) && (n.colors = !1), m(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = u), f(n, e, n.depth);
            }

            function u(e, t) {
              var n = s.styles[t];
              return n ? "[" + s.colors[n][0] + "m" + e + "[" + s.colors[n][1] + "m" : e;
            }

            function c(e, t) {
              return e;
            }

            function f(e, t, n) {
              if (e.customInspect && t && S(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                var o = t.inspect(n, e);
                return g(o) || (o = f(e, o, n)), o;
              }

              var i = function (e, t) {
                if (m(t)) return e.stylize("undefined", "undefined");

                if (g(t)) {
                  var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                  return e.stylize(n, "string");
                }

                return y(t) ? e.stylize("" + t, "number") : d(t) ? e.stylize("" + t, "boolean") : v(t) ? e.stylize("null", "null") : void 0;
              }(e, t);

              if (i) return i;

              var a = Object.keys(t),
                  s = function (e) {
                var t = {};
                return e.forEach(function (e, n) {
                  t[e] = !0;
                }), t;
              }(a);

              if (e.showHidden && (a = Object.getOwnPropertyNames(t)), k(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return l(t);

              if (0 === a.length) {
                if (S(t)) {
                  var u = t.name ? ": " + t.name : "";
                  return e.stylize("[Function" + u + "]", "special");
                }

                if (b(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                if (w(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                if (k(t)) return l(t);
              }

              var c,
                  x = "",
                  E = !1,
                  T = ["{", "}"];
              return h(t) && (E = !0, T = ["[", "]"]), S(t) && (x = " [Function" + (t.name ? ": " + t.name : "") + "]"), b(t) && (x = " " + RegExp.prototype.toString.call(t)), w(t) && (x = " " + Date.prototype.toUTCString.call(t)), k(t) && (x = " " + l(t)), 0 !== a.length || E && 0 != t.length ? n < 0 ? b(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), c = E ? function (e, t, n, r, o) {
                for (var i = [], a = 0, s = t.length; a < s; ++a) {
                  A(t, String(a)) ? i.push(p(e, t, n, r, String(a), !0)) : i.push("");
                }

                return o.forEach(function (o) {
                  o.match(/^\d+$/) || i.push(p(e, t, n, r, o, !0));
                }), i;
              }(e, t, n, s, a) : a.map(function (r) {
                return p(e, t, n, s, r, E);
              }), e.seen.pop(), function (e, t, n) {
                return e.reduce(function (e, t) {
                  return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0) > 60 ? n[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1] : n[0] + t + " " + e.join(", ") + " " + n[1];
              }(c, x, T)) : T[0] + x + T[1];
            }

            function l(e) {
              return "[" + Error.prototype.toString.call(e) + "]";
            }

            function p(e, t, n, r, o, i) {
              var a, s, u;

              if ((u = Object.getOwnPropertyDescriptor(t, o) || {
                value: t[o]
              }).get ? s = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (s = e.stylize("[Setter]", "special")), A(r, o) || (a = "[" + o + "]"), s || (e.seen.indexOf(u.value) < 0 ? (s = v(n) ? f(e, u.value, null) : f(e, u.value, n - 1)).indexOf("\n") > -1 && (s = i ? s.split("\n").map(function (e) {
                return "  " + e;
              }).join("\n").substr(2) : "\n" + s.split("\n").map(function (e) {
                return "   " + e;
              }).join("\n")) : s = e.stylize("[Circular]", "special")), m(a)) {
                if (i && o.match(/^\d+$/)) return s;
                (a = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
              }

              return a + ": " + s;
            }

            function h(e) {
              return Array.isArray(e);
            }

            function d(e) {
              return "boolean" == typeof e;
            }

            function v(e) {
              return null === e;
            }

            function y(e) {
              return "number" == typeof e;
            }

            function g(e) {
              return "string" == typeof e;
            }

            function m(e) {
              return void 0 === e;
            }

            function b(e) {
              return x(e) && "[object RegExp]" === E(e);
            }

            function x(e) {
              return "object" == typeof e && null !== e;
            }

            function w(e) {
              return x(e) && "[object Date]" === E(e);
            }

            function k(e) {
              return x(e) && ("[object Error]" === E(e) || e instanceof Error);
            }

            function S(e) {
              return "function" == typeof e;
            }

            function E(e) {
              return Object.prototype.toString.call(e);
            }

            function T(e) {
              return e < 10 ? "0" + e.toString(10) : e.toString(10);
            }

            r.debuglog = function (e) {
              if (m(i) && (i = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !a[e]) if (new RegExp("\\b" + e + "\\b", "i").test(i)) {
                var n = t.pid;

                a[e] = function () {
                  var t = r.format.apply(r, arguments);
                  console.error("%s %d: %s", e, n, t);
                };
              } else a[e] = function () {};
              return a[e];
            }, r.inspect = s, s.colors = {
              bold: [1, 22],
              italic: [3, 23],
              underline: [4, 24],
              inverse: [7, 27],
              white: [37, 39],
              grey: [90, 39],
              black: [30, 39],
              blue: [34, 39],
              cyan: [36, 39],
              green: [32, 39],
              magenta: [35, 39],
              red: [31, 39],
              yellow: [33, 39]
            }, s.styles = {
              special: "cyan",
              number: "yellow",
              boolean: "yellow",
              undefined: "grey",
              null: "bold",
              string: "green",
              date: "magenta",
              regexp: "red"
            }, r.isArray = h, r.isBoolean = d, r.isNull = v, r.isNullOrUndefined = function (e) {
              return null == e;
            }, r.isNumber = y, r.isString = g, r.isSymbol = function (e) {
              return "symbol" == typeof e;
            }, r.isUndefined = m, r.isRegExp = b, r.isObject = x, r.isDate = w, r.isError = k, r.isFunction = S, r.isPrimitive = function (e) {
              return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
            }, r.isBuffer = e("./support/isBuffer");
            var _ = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

            function O() {
              var e = new Date(),
                  t = [T(e.getHours()), T(e.getMinutes()), T(e.getSeconds())].join(":");
              return [e.getDate(), _[e.getMonth()], t].join(" ");
            }

            function A(e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }

            r.log = function () {
              console.log("%s - %s", O(), r.format.apply(r, arguments));
            }, r.inherits = e("inherits"), r._extend = function (e, t) {
              if (!t || !x(t)) return e;

              for (var n = Object.keys(t), r = n.length; r--;) {
                e[n[r]] = t[n[r]];
              }

              return e;
            };
          }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {
          "./support/isBuffer": 10,
          _process: 14,
          inherits: 9
        }],
        12: [function (e, t, n) {}, {}],
        13: [function (e, t, n) {
          (function (e) {
            function t(e, t) {
              for (var n = 0, r = e.length - 1; r >= 0; r--) {
                var o = e[r];
                "." === o ? e.splice(r, 1) : ".." === o ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
              }

              if (t) for (; n--; n) {
                e.unshift("..");
              }
              return e;
            }

            function r(e, t) {
              if (e.filter) return e.filter(t);

              for (var n = [], r = 0; r < e.length; r++) {
                t(e[r], r, e) && n.push(e[r]);
              }

              return n;
            }

            n.resolve = function () {
              for (var n = "", o = !1, i = arguments.length - 1; i >= -1 && !o; i--) {
                var a = i >= 0 ? arguments[i] : e.cwd();
                if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
                a && (n = a + "/" + n, o = "/" === a.charAt(0));
              }

              return (o ? "/" : "") + (n = t(r(n.split("/"), function (e) {
                return !!e;
              }), !o).join("/")) || ".";
            }, n.normalize = function (e) {
              var i = n.isAbsolute(e),
                  a = "/" === o(e, -1);
              return (e = t(r(e.split("/"), function (e) {
                return !!e;
              }), !i).join("/")) || i || (e = "."), e && a && (e += "/"), (i ? "/" : "") + e;
            }, n.isAbsolute = function (e) {
              return "/" === e.charAt(0);
            }, n.join = function () {
              var e = Array.prototype.slice.call(arguments, 0);
              return n.normalize(r(e, function (e, t) {
                if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
                return e;
              }).join("/"));
            }, n.relative = function (e, t) {
              function r(e) {
                for (var t = 0; t < e.length && "" === e[t]; t++) {
                  ;
                }

                for (var n = e.length - 1; n >= 0 && "" === e[n]; n--) {
                  ;
                }

                return t > n ? [] : e.slice(t, n - t + 1);
              }

              e = n.resolve(e).substr(1), t = n.resolve(t).substr(1);

              for (var o = r(e.split("/")), i = r(t.split("/")), a = Math.min(o.length, i.length), s = a, u = 0; u < a; u++) {
                if (o[u] !== i[u]) {
                  s = u;
                  break;
                }
              }

              var c = [];

              for (u = s; u < o.length; u++) {
                c.push("..");
              }

              return (c = c.concat(i.slice(s))).join("/");
            }, n.sep = "/", n.delimiter = ":", n.dirname = function (e) {
              if ("string" != typeof e && (e += ""), 0 === e.length) return ".";

              for (var t = e.charCodeAt(0), n = 47 === t, r = -1, o = !0, i = e.length - 1; i >= 1; --i) {
                if (47 === (t = e.charCodeAt(i))) {
                  if (!o) {
                    r = i;
                    break;
                  }
                } else o = !1;
              }

              return -1 === r ? n ? "/" : "." : n && 1 === r ? "/" : e.slice(0, r);
            }, n.basename = function (e, t) {
              var n = function (e) {
                "string" != typeof e && (e += "");
                var t,
                    n = 0,
                    r = -1,
                    o = !0;

                for (t = e.length - 1; t >= 0; --t) {
                  if (47 === e.charCodeAt(t)) {
                    if (!o) {
                      n = t + 1;
                      break;
                    }
                  } else -1 === r && (o = !1, r = t + 1);
                }

                return -1 === r ? "" : e.slice(n, r);
              }(e);

              return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
            }, n.extname = function (e) {
              "string" != typeof e && (e += "");

              for (var t = -1, n = 0, r = -1, o = !0, i = 0, a = e.length - 1; a >= 0; --a) {
                var s = e.charCodeAt(a);
                if (47 !== s) -1 === r && (o = !1, r = a + 1), 46 === s ? -1 === t ? t = a : 1 !== i && (i = 1) : -1 !== t && (i = -1);else if (!o) {
                  n = a + 1;
                  break;
                }
              }

              return -1 === t || -1 === r || 0 === i || 1 === i && t === r - 1 && t === n + 1 ? "" : e.slice(t, r);
            };
            var o = "b" === "ab".substr(-1) ? function (e, t, n) {
              return e.substr(t, n);
            } : function (e, t, n) {
              return t < 0 && (t = e.length + t), e.substr(t, n);
            };
          }).call(this, e("_process"));
        }, {
          _process: 14
        }],
        14: [function (e, t, n) {
          var r,
              o,
              i = t.exports = {};

          function a() {
            throw new Error("setTimeout has not been defined");
          }

          function s() {
            throw new Error("clearTimeout has not been defined");
          }

          function u(e) {
            if (r === setTimeout) return setTimeout(e, 0);
            if ((r === a || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

            try {
              return r(e, 0);
            } catch (t) {
              try {
                return r.call(null, e, 0);
              } catch (t) {
                return r.call(this, e, 0);
              }
            }
          }

          !function () {
            try {
              r = "function" == typeof setTimeout ? setTimeout : a;
            } catch (e) {
              r = a;
            }

            try {
              o = "function" == typeof clearTimeout ? clearTimeout : s;
            } catch (e) {
              o = s;
            }
          }();
          var c,
              f = [],
              l = !1,
              p = -1;

          function h() {
            l && c && (l = !1, c.length ? f = c.concat(f) : p = -1, f.length && d());
          }

          function d() {
            if (!l) {
              var e = u(h);
              l = !0;

              for (var t = f.length; t;) {
                for (c = f, f = []; ++p < t;) {
                  c && c[p].run();
                }

                p = -1, t = f.length;
              }

              c = null, l = !1, function (e) {
                if (o === clearTimeout) return clearTimeout(e);
                if ((o === s || !o) && clearTimeout) return o = clearTimeout, clearTimeout(e);

                try {
                  o(e);
                } catch (t) {
                  try {
                    return o.call(null, e);
                  } catch (t) {
                    return o.call(this, e);
                  }
                }
              }(e);
            }
          }

          function v(e, t) {
            this.fun = e, this.array = t;
          }

          function y() {}

          i.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
              t[n - 1] = arguments[n];
            }
            f.push(new v(e, t)), 1 !== f.length || l || u(d);
          }, v.prototype.run = function () {
            this.fun.apply(null, this.array);
          }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = y, i.addListener = y, i.once = y, i.off = y, i.removeListener = y, i.removeAllListeners = y, i.emit = y, i.prependListener = y, i.prependOnceListener = y, i.listeners = function (e) {
            return [];
          }, i.binding = function (e) {
            throw new Error("process.binding is not supported");
          }, i.cwd = function () {
            return "/";
          }, i.chdir = function (e) {
            throw new Error("process.chdir is not supported");
          }, i.umask = function () {
            return 0;
          };
        }, {}],
        15: [function (e, t, n) {
          var r = e("escodegen").generate;

          t.exports = function (e, t) {
            t || (t = {});

            var n = {},
                o = function e(o, i) {
              if ("Literal" === o.type) return o.value;

              if ("UnaryExpression" === o.type) {
                var a = e(o.argument);
                return "+" === o.operator ? +a : "-" === o.operator ? -a : "~" === o.operator ? ~a : "!" === o.operator ? !a : n;
              }

              if ("ArrayExpression" === o.type) {
                for (var s = [], u = 0, c = o.elements.length; u < c; u++) {
                  if ((g = e(o.elements[u])) === n) return n;
                  s.push(g);
                }

                return s;
              }

              if ("ObjectExpression" === o.type) {
                var f = {};

                for (u = 0; u < o.properties.length; u++) {
                  var l = null === (m = o.properties[u]).value ? m.value : e(m.value);
                  if (l === n) return n;
                  f[m.key.value || m.key.name] = l;
                }

                return f;
              }

              if ("BinaryExpression" === o.type || "LogicalExpression" === o.type) {
                if ((c = e(o.left)) === n) return n;
                var p = e(o.right);
                if (p === n) return n;
                var h = o.operator;
                return "==" === h ? c == p : "===" === h ? c === p : "!=" === h ? c != p : "!==" === h ? c !== p : "+" === h ? c + p : "-" === h ? c - p : "*" === h ? c * p : "/" === h ? c / p : "%" === h ? c % p : "<" === h ? c < p : "<=" === h ? c <= p : ">" === h ? c > p : ">=" === h ? c >= p : "|" === h ? c | p : "&" === h ? c & p : "^" === h ? c ^ p : "&&" === h ? c && p : "||" === h ? c || p : n;
              }

              if ("Identifier" === o.type) return {}.hasOwnProperty.call(t, o.name) ? t[o.name] : n;
              if ("ThisExpression" === o.type) return {}.hasOwnProperty.call(t, "this") ? t.this : n;

              if ("CallExpression" === o.type) {
                var d = e(o.callee);
                if (d === n) return n;
                if ("function" != typeof d) return n;
                var v = o.callee.object ? e(o.callee.object) : n;
                v === n && (v = null);
                var y = [];

                for (u = 0, c = o.arguments.length; u < c; u++) {
                  var g;
                  if ((g = e(o.arguments[u])) === n) return n;
                  y.push(g);
                }

                return d.apply(v, y);
              }

              var m;
              if ("MemberExpression" === o.type) return (f = e(o.object)) === n || "function" == typeof f ? n : "Identifier" === o.property.type ? f[o.property.name] : (m = e(o.property)) === n ? n : f[m];
              if ("ConditionalExpression" === o.type) return (a = e(o.test)) === n ? n : e(a ? o.consequent : o.alternate);
              if ("ExpressionStatement" === o.type) return (a = e(o.expression)) === n ? n : a;
              if ("ReturnStatement" === o.type) return e(o.argument);

              if ("FunctionExpression" === o.type) {
                var b = o.body.body,
                    x = {};

                for (Object.keys(t).forEach(function (e) {
                  x[e] = t[e];
                }), u = 0; u < o.params.length; u++) {
                  var w = o.params[u];
                  if ("Identifier" != w.type) return n;
                  t[w.name] = null;
                }

                for (var u in b) {
                  if (e(b[u]) === n) return n;
                }

                t = x;
                var k = Object.keys(t),
                    S = k.map(function (e) {
                  return t[e];
                });
                return Function(k.join(", "), "return " + r(o)).apply(null, S);
              }

              if ("TemplateLiteral" === o.type) {
                var E = "";

                for (u = 0; u < o.expressions.length; u++) {
                  E += e(o.quasis[u]), E += e(o.expressions[u]);
                }

                return E += e(o.quasis[u]);
              }

              if ("TaggedTemplateExpression" === o.type) {
                var T = e(o.tag),
                    _ = o.quasi,
                    O = _.quasis.map(e),
                    A = _.expressions.map(e);

                return T.apply(null, [O].concat(A));
              }

              return "TemplateElement" === o.type ? o.value.cooked : n;
            }(e);

            return o === n ? void 0 : o;
          };
        }, {
          escodegen: 12
        }],
        jsonpath: [function (e, t, n) {
          t.exports = e("./lib/index");
        }, {
          "./lib/index": 5
        }]
      }, {}, ["jsonpath"])("jsonpath");
    }).call(this, n(43));
  }, function (e, t, n) {
    var r = n(119);
    e.exports = function (e) {
      if (Array.isArray(e)) return r(e);
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(0);
    e.exports = function (e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = r(e));) {
        ;
      }

      return e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    function n() {}

    n.prototype = {
      on: function on(e, t, n) {
        var r = this.e || (this.e = {});
        return (r[e] || (r[e] = [])).push({
          fn: t,
          ctx: n
        }), this;
      },
      once: function once(e, t, n) {
        var r = this;

        function o() {
          r.off(e, o), t.apply(n, arguments);
        }

        return o._ = t, this.on(e, o, n);
      },
      emit: function emit(e) {
        for (var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), r = 0, o = n.length; r < o; r++) {
          n[r].fn.apply(n[r].ctx, t);
        }

        return this;
      },
      off: function off(e, t) {
        var n = this.e || (this.e = {}),
            r = n[e],
            o = [];
        if (r && t) for (var i = 0, a = r.length; i < a; i++) {
          r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
        }
        return o.length ? n[e] = o : delete n[e], this;
      }
    }, e.exports = n;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "OktaAuth", function () {
      return Vo;
    }), n.d(t, "STATE_TOKEN_KEY_NAME", function () {
      return p;
    }), n.d(t, "DEFAULT_POLLING_DELAY", function () {
      return h;
    }), n.d(t, "DEFAULT_MAX_CLOCK_SKEW", function () {
      return d;
    }), n.d(t, "DEFAULT_CACHE_DURATION", function () {
      return v;
    }), n.d(t, "REDIRECT_OAUTH_PARAMS_NAME", function () {
      return y;
    }), n.d(t, "REDIRECT_STATE_COOKIE_NAME", function () {
      return g;
    }), n.d(t, "REDIRECT_NONCE_COOKIE_NAME", function () {
      return m;
    }), n.d(t, "TOKEN_STORAGE_NAME", function () {
      return b;
    }), n.d(t, "CACHE_STORAGE_NAME", function () {
      return x;
    }), n.d(t, "PKCE_STORAGE_NAME", function () {
      return w;
    }), n.d(t, "TRANSACTION_STORAGE_NAME", function () {
      return k;
    }), n.d(t, "IDX_RESPONSE_STORAGE_NAME", function () {
      return S;
    }), n.d(t, "ACCESS_TOKEN_STORAGE_KEY", function () {
      return E;
    }), n.d(t, "ID_TOKEN_STORAGE_KEY", function () {
      return T;
    }), n.d(t, "REFRESH_TOKEN_STORAGE_KEY", function () {
      return _;
    }), n.d(t, "REFERRER_PATH_STORAGE_KEY", function () {
      return O;
    }), n.d(t, "MIN_VERIFIER_LENGTH", function () {
      return A;
    }), n.d(t, "MAX_VERIFIER_LENGTH", function () {
      return R;
    }), n.d(t, "DEFAULT_CODE_CHALLENGE_METHOD", function () {
      return P;
    }), n.d(t, "IDX_API_VERSION", function () {
      return I;
    }), n.d(t, "isOAuthTransactionMeta", function () {
      return Wt;
    }), n.d(t, "isPKCETransactionMeta", function () {
      return Jt;
    }), n.d(t, "isIdxTransactionMeta", function () {
      return Xt;
    }), n.d(t, "isCustomAuthTransactionMeta", function () {
      return Qt;
    }), n.d(t, "isTransactionMeta", function () {
      return Zt;
    }), n.d(t, "IdxStatus", function () {
      return zt;
    }), n.d(t, "IdxFeature", function () {
      return Kt;
    }), n.d(t, "isToken", function () {
      return en;
    }), n.d(t, "isAccessToken", function () {
      return tn;
    }), n.d(t, "isIDToken", function () {
      return nn;
    }), n.d(t, "isRefreshToken", function () {
      return rn;
    }), n.d(t, "transactionStatus", function () {
      return Ae;
    }), n.d(t, "resumeTransaction", function () {
      return Re;
    }), n.d(t, "transactionExists", function () {
      return Ie;
    }), n.d(t, "postToTransaction", function () {
      return Ce;
    }), n.d(t, "introspect", function () {
      return Pe;
    }), n.d(t, "AuthTransaction", function () {
      return Te;
    }), n.d(t, "getPollFn", function () {
      return Ee;
    }), n.d(t, "TransactionState", function () {
      return je;
    }), n.d(t, "addStateToken", function () {
      return xe;
    }), n.d(t, "getStateToken", function () {
      return we;
    }), n.d(t, "AuthApiError", function () {
      return ve;
    }), n.d(t, "AuthPollStopError", function () {
      return Se;
    }), n.d(t, "AuthSdkError", function () {
      return be;
    }), n.d(t, "OAuthError", function () {
      return Me;
    }), n.d(t, "convertTokenParamsToOAuthParams", function () {
      return Xe;
    }), n.d(t, "buildAuthorizeParams", function () {
      return Qe;
    }), n.d(t, "postToTokenEndpoint", function () {
      return tt;
    }), n.d(t, "postRefreshToken", function () {
      return nt;
    }), n.d(t, "getWellKnown", function () {
      return rt;
    }), n.d(t, "getKey", function () {
      return ot;
    }), n.d(t, "addListener", function () {
      return yt;
    }), n.d(t, "removeListener", function () {
      return gt;
    }), n.d(t, "loadFrame", function () {
      return mt;
    }), n.d(t, "loadPopup", function () {
      return bt;
    }), n.d(t, "addPostMessageListener", function () {
      return xt;
    }), n.d(t, "getDefaultTokenParams", function () {
      return Ot;
    }), n.d(t, "isInteractionRequiredError", function () {
      return At;
    }), n.d(t, "isAuthorizationCodeError", function () {
      return Rt;
    }), n.d(t, "hasTokensInHash", function () {
      return Pt;
    }), n.d(t, "hasAuthorizationCode", function () {
      return It;
    }), n.d(t, "hasInteractionCode", function () {
      return Ct;
    }), n.d(t, "hasErrorInUrl", function () {
      return jt;
    }), n.d(t, "isRedirectUri", function () {
      return Lt;
    }), n.d(t, "isCodeFlow", function () {
      return Mt;
    }), n.d(t, "getHashOrSearch", function () {
      return Nt;
    }), n.d(t, "isLoginRedirect", function () {
      return Ut;
    }), n.d(t, "isInteractionRequired", function () {
      return Dt;
    }), n.d(t, "generateState", function () {
      return wt;
    }), n.d(t, "generateNonce", function () {
      return kt;
    }), n.d(t, "getOAuthBaseUrl", function () {
      return Et;
    }), n.d(t, "getOAuthDomain", function () {
      return Tt;
    }), n.d(t, "getOAuthUrls", function () {
      return _t;
    }), n.d(t, "pkce", function () {
      return Ke;
    }), n.d(t, "prepareTokenParams", function () {
      return Bt;
    }), n.d(t, "urlParamsToObject", function () {
      return Ft;
    }), n.d(t, "validateClaims", function () {
      return Ht;
    }), n.d(t, "decodeToken", function () {
      return qt;
    }), n.d(t, "revokeToken", function () {
      return $t;
    }), n.d(t, "renewToken", function () {
      return ln;
    }), n.d(t, "renewTokensWithRefresh", function () {
      return hn;
    }), n.d(t, "renewTokens", function () {
      return dn;
    }), n.d(t, "verifyToken", function () {
      return sn;
    }), n.d(t, "getUserInfo", function () {
      return yn;
    }), n.d(t, "handleOAuthResponse", function () {
      return un;
    }), n.d(t, "exchangeCodeForTokens", function () {
      return on;
    }), n.d(t, "getToken", function () {
      return cn;
    }), n.d(t, "getWithoutPrompt", function () {
      return fn;
    }), n.d(t, "getWithPopup", function () {
      return gn;
    }), n.d(t, "getWithRedirect", function () {
      return mn;
    }), n.d(t, "parseFromUrl", function () {
      return bn;
    }), n.d(t, "EVENT_EXPIRED", function () {
      return In;
    }), n.d(t, "EVENT_RENEWED", function () {
      return Cn;
    }), n.d(t, "EVENT_ADDED", function () {
      return jn;
    }), n.d(t, "EVENT_REMOVED", function () {
      return Ln;
    }), n.d(t, "EVENT_ERROR", function () {
      return Mn;
    }), n.d(t, "TokenManager", function () {
      return Un;
    }), n.d(t, "INITIAL_AUTH_STATE", function () {
      return qn;
    }), n.d(t, "AuthStateManager", function () {
      return zn;
    }), n.d(t, "getNativeConsole", function () {
      return C;
    }), n.d(t, "getConsole", function () {
      return j;
    }), n.d(t, "warn", function () {
      return L;
    }), n.d(t, "deprecate", function () {
      return M;
    }), n.d(t, "deprecateWrap", function () {
      return N;
    }), n.d(t, "isoToUTCString", function () {
      return U;
    }), n.d(t, "genRandomString", function () {
      return D;
    }), n.d(t, "delay", function () {
      return B;
    }), n.d(t, "bind", function () {
      return F;
    }), n.d(t, "extend", function () {
      return H;
    }), n.d(t, "removeNils", function () {
      return q;
    }), n.d(t, "clone", function () {
      return $;
    }), n.d(t, "omit", function () {
      return z;
    }), n.d(t, "find", function () {
      return K;
    }), n.d(t, "getLink", function () {
      return G;
    }), n.d(t, "isString", function () {
      return V;
    }), n.d(t, "isObject", function () {
      return Y;
    }), n.d(t, "isNumber", function () {
      return W;
    }), n.d(t, "isFunction", function () {
      return J;
    }), n.d(t, "isPromise", function () {
      return X;
    }), n.d(t, "isAbsoluteUrl", function () {
      return Q;
    }), n.d(t, "toAbsoluteUrl", function () {
      return Z;
    }), n.d(t, "toRelativeUrl", function () {
      return ee;
    }), n.d(t, "toQueryString", function () {
      return te;
    }), n.d(t, "removeTrailingSlash", function () {
      return ne;
    });
    var r = {};
    n.r(r), n.d(r, "STATE_TOKEN_KEY_NAME", function () {
      return p;
    }), n.d(r, "DEFAULT_POLLING_DELAY", function () {
      return h;
    }), n.d(r, "DEFAULT_MAX_CLOCK_SKEW", function () {
      return d;
    }), n.d(r, "DEFAULT_CACHE_DURATION", function () {
      return v;
    }), n.d(r, "REDIRECT_OAUTH_PARAMS_NAME", function () {
      return y;
    }), n.d(r, "REDIRECT_STATE_COOKIE_NAME", function () {
      return g;
    }), n.d(r, "REDIRECT_NONCE_COOKIE_NAME", function () {
      return m;
    }), n.d(r, "TOKEN_STORAGE_NAME", function () {
      return b;
    }), n.d(r, "CACHE_STORAGE_NAME", function () {
      return x;
    }), n.d(r, "PKCE_STORAGE_NAME", function () {
      return w;
    }), n.d(r, "TRANSACTION_STORAGE_NAME", function () {
      return k;
    }), n.d(r, "IDX_RESPONSE_STORAGE_NAME", function () {
      return S;
    }), n.d(r, "ACCESS_TOKEN_STORAGE_KEY", function () {
      return E;
    }), n.d(r, "ID_TOKEN_STORAGE_KEY", function () {
      return T;
    }), n.d(r, "REFRESH_TOKEN_STORAGE_KEY", function () {
      return _;
    }), n.d(r, "REFERRER_PATH_STORAGE_KEY", function () {
      return O;
    }), n.d(r, "MIN_VERIFIER_LENGTH", function () {
      return A;
    }), n.d(r, "MAX_VERIFIER_LENGTH", function () {
      return R;
    }), n.d(r, "DEFAULT_CODE_CHALLENGE_METHOD", function () {
      return P;
    }), n.d(r, "IDX_API_VERSION", function () {
      return I;
    });
    var o = {};
    n.r(o), n.d(o, "isBrowser", function () {
      return at;
    }), n.d(o, "isIE11OrLess", function () {
      return st;
    }), n.d(o, "getUserAgent", function () {
      return ut;
    }), n.d(o, "isFingerprintSupported", function () {
      return ct;
    }), n.d(o, "isPopupPostMessageSupported", function () {
      return ft;
    }), n.d(o, "isTokenVerifySupported", function () {
      return lt;
    }), n.d(o, "hasTextEncoder", function () {
      return pt;
    }), n.d(o, "isPKCESupported", function () {
      return ht;
    }), n.d(o, "isHTTPS", function () {
      return dt;
    }), n.d(o, "isLocalhost", function () {
      return vt;
    });
    var i = {};
    n.r(i), n.d(i, "Remediator", function () {
      return Pr;
    }), n.d(i, "EnrollAuthenticator", function () {
      return Lr;
    }), n.d(i, "ChallengeAuthenticator", function () {
      return Nr;
    }), n.d(i, "ResetAuthenticator", function () {
      return Dr;
    }), n.d(i, "EnrollProfile", function () {
      return Fr;
    }), n.d(i, "Identify", function () {
      return zr;
    }), n.d(i, "ReEnrollAuthenticator", function () {
      return Gr;
    }), n.d(i, "RedirectIdp", function () {
      return Yr;
    }), n.d(i, "SelectAuthenticatorAuthenticate", function () {
      return to;
    }), n.d(i, "SelectAuthenticatorEnroll", function () {
      return ro;
    }), n.d(i, "SelectEnrollProfile", function () {
      return io;
    }), n.d(i, "AuthenticatorVerificationData", function () {
      return co;
    }), n.d(i, "AuthenticatorEnrollmentData", function () {
      return lo;
    }), n.d(i, "Skip", function () {
      return ho;
    });
    var a = n(1),
        s = n.n(a),
        u = n(3),
        c = n.n(u),
        f = n(2),
        l = n.n(f),
        p = "oktaStateToken",
        h = 500,
        d = 300,
        v = 86400,
        y = "okta-oauth-redirect-params",
        g = "okta-oauth-state",
        m = "okta-oauth-nonce",
        b = "okta-token-storage",
        x = "okta-cache-storage",
        w = "okta-pkce-storage",
        k = "okta-transaction-storage",
        S = "okta-idx-response-storage",
        E = "accessToken",
        T = "idToken",
        _ = "refreshToken",
        O = "referrerPath",
        A = 43,
        R = 128,
        P = "S256",
        I = "1.0.0";
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    function C() {
      return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
    }

    function j() {
      var e = C();
      return e && e.log ? e : {
        log: function log() {},
        warn: function warn() {},
        group: function group() {},
        groupEnd: function groupEnd() {}
      };
    }

    function L(e) {
      j().warn("[okta-auth-sdk] WARN: " + e);
    }

    function M(e) {
      j().warn("[okta-auth-sdk] DEPRECATION: " + e);
    }

    function N(e, t) {
      return function () {
        return M(e), t.apply(null, arguments);
      };
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    function U(e) {
      var t = e.match(/\d+/g),
          n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
      return new Date(n).toUTCString();
    }

    function D(e) {
      for (var t = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", n = "", r = 0, o = t.length; r < e; ++r) {
        n += t[Math.floor(Math.random() * o)];
      }

      return n;
    }

    function B(e) {
      return new Promise(function (t) {
        setTimeout(t, e);
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    function F(e, t) {
      var n = Array.prototype.slice.call(arguments, 2);
      return function () {
        var r = Array.prototype.slice.call(arguments);
        return r = n.concat(r), e.apply(t, r);
      };
    }

    function H() {
      var e = arguments[0],
          t = [].slice.call(arguments, 1);
      return t.forEach(function (t) {
        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e[n] = t[n]);
        }
      }), e;
    }

    function q(e) {
      var t = {};

      for (var n in e) {
        if (Object.prototype.hasOwnProperty.call(e, n)) {
          var r = e[n];
          null != r && (t[n] = r);
        }
      }

      return t;
    }

    function $(e) {
      if (e) {
        var t = JSON.stringify(e);
        if (t) return JSON.parse(t);
      }

      return e;
    }

    function z(e) {
      for (var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
        r[o - 1] = arguments[o];
      }

      for (var i in e) {
        Object.prototype.hasOwnProperty.call(e, i) && -1 == r.indexOf(i) && (t[i] = e[i]);
      }

      return $(t);
    }

    function K(e, t) {
      for (var n = e.length; n--;) {
        var r = e[n],
            o = !0;

        for (var i in t) {
          if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
            o = !1;
            break;
          }
        }

        if (o) return r;
      }
    }

    function G(e, t, n) {
      if (e && e._links) {
        var r = $(e._links[t]);
        return r && r.name && n ? r.name === n ? r : void 0 : r;
      }
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    function V(e) {
      return "[object String]" === Object.prototype.toString.call(e);
    }

    function Y(e) {
      return "[object Object]" === Object.prototype.toString.call(e);
    }

    function W(e) {
      return "[object Number]" === Object.prototype.toString.call(e);
    }

    function J(e) {
      return !!e && "[object Function]" === {}.toString.call(e);
    }

    function X(e) {
      return e && e.finally && "function" == typeof e.finally;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    function Q(e) {
      return /^(?:[a-z]+:)?\/\//i.test(e);
    }

    function Z() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 ? arguments[1] : void 0;
      return Q(e) ? e : (t = ne(t), "/" === e[0] ? "".concat(t).concat(e) : "".concat(t, "/").concat(e));
    }

    function ee() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 ? arguments[1] : void 0;
      return Q(e) && (e = e.substring(t.length)), "/" === e[0] ? e : "/".concat(e);
    }

    function te(e) {
      var t = [];
      if (null !== e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && void 0 !== e[n] && null !== e[n] && t.push(n + "=" + encodeURIComponent(e[n]));
      }
      return t.length ? "?" + t.join("&") : "";
    }

    function ne(e) {
      if (e) {
        var t = e.replace(/^\s+|\s+$/gm, "");
        return t = t.replace(/\/+$/, "");
      }
    }

    var re = n(4),
        oe = n.n(re),
        ie = n(5),
        ae = n.n(ie),
        se = n(0),
        ue = n.n(se),
        ce = n(114),
        fe = n.n(ce),
        le = n(115);

    function pe(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */
      ();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var he = function (e) {
      oe()(n, e);
      var t = pe(n);

      function n(e) {
        var r;
        return s()(this, n), r = t.call(this, e), Object.setPrototypeOf(fe()(r), (this instanceof n ? this.constructor : void 0).prototype), r;
      }

      return n;
    }(n.n(le)()(Error));

    function de(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */
      ();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var ve = function (e) {
      oe()(n, e);
      var t = de(n);

      function n(e, r) {
        var o;
        s()(this, n);
        var i = e.errorSummary;
        return (o = t.call(this, i)).name = "AuthApiError", o.errorSummary = e.errorSummary, o.errorCode = e.errorCode, o.errorLink = e.errorLink, o.errorId = e.errorId, o.errorCauses = e.errorCauses, r && (o.xhr = r), o;
      }

      return n;
    }(he);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function ye(e, t) {
      var n = (t = t || {}).url,
          r = t.method,
          o = t.args,
          i = t.saveAuthnState,
          a = t.accessToken,
          s = !0 === t.withCredentials,
          u = e.options.storageUtil.storage,
          c = e.storageManager.getHttpCache(e.options.cookies);

      if (t.cacheResponse) {
        var f = c.getStorage()[n];
        if (f && Date.now() / 1e3 < f.expiresAt) return Promise.resolve(f.response);
      }

      var l = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Okta-User-Agent-Extended": e.userAgent
      };
      Object.assign(l, e.options.headers, t.headers), l = q(l), a && V(a) && (l.Authorization = "Bearer " + a);
      var h,
          d,
          y = {
        headers: l,
        data: o || void 0,
        withCredentials: s
      };
      return e.options.httpRequestClient(r, n, y).then(function (r) {
        return (d = r.responseText) && V(d) && (d = JSON.parse(d)), i && (d.stateToken || u.delete(p)), d && d.stateToken && d.expiresAt && u.set(p, d.stateToken, d.expiresAt, e.options.cookies), d && t.cacheResponse && c.updateStorage(n, {
          expiresAt: Math.floor(Date.now() / 1e3) + v,
          response: d
        }), d;
      }).catch(function (t) {
        var n = t.responseText || {};
        if (V(n)) try {
          n = JSON.parse(n);
        } catch (e) {
          n = {
            errorSummary: "Unknown error"
          };
        }
        throw t.status >= 500 && (n.errorSummary = "Unknown error"), e.options.transformErrorXHR && (t = e.options.transformErrorXHR($(t))), "E0000011" === (h = new ve(n, t)).errorCode && u.delete(p), h;
      });
    }

    var ge = {
      get: function get(e, t, n) {
        var r = {
          url: t = Q(t) ? t : e.getIssuerOrigin() + t,
          method: "GET"
        };
        return Object.assign(r, n), ye(e, r);
      },
      post: function post(e, t, n, r) {
        var o = {
          url: t = Q(t) ? t : e.getIssuerOrigin() + t,
          method: "POST",
          args: n,
          saveAuthnState: !0
        };
        return Object.assign(o, r), ye(e, o);
      },
      httpRequest: ye
    };

    function me(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */
      ();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var be = function (e) {
      oe()(n, e);
      var t = me(n);

      function n(e, r) {
        var o;
        return s()(this, n), (o = t.call(this, e)).name = "AuthSdkError", o.errorCode = "INTERNAL", o.errorSummary = e, o.errorLink = "INTERNAL", o.errorId = "INTERNAL", o.errorCauses = [], r && (o.xhr = r), o;
      }

      return n;
    }(he);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function xe(e, t) {
      var n = {};
      return Object.assign(n, t), !n.stateToken && e.stateToken && (n.stateToken = e.stateToken), n;
    }

    function we(e) {
      return xe(e);
    }

    function ke(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */
      ();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var Se = function (e) {
      oe()(n, e);
      var t = ke(n);

      function n() {
        s()(this, n);
        return t.call(this, "The poll was stopped by the sdk");
      }

      return n;
    }(he);
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function Ee(e, t, n) {
      return function (r) {
        var o, i, a, s;
        W(r) ? o = r : Y(r) && (o = (r = r).delay, i = r.rememberDevice, a = r.autoPush, s = r.transactionCallBack), o || 0 === o || (o = h);
        var u = G(t, "next", "poll");
        n.isPolling = !0;
        var c = 0;
        return function r() {
          return n.isPolling ? function () {
            var n = {};
            if ("function" == typeof a) try {
              n.autoPush = !!a();
            } catch (e) {
              return Promise.reject(new be("AutoPush resulted in an error."));
            } else null != a && (n.autoPush = !!a);
            if ("function" == typeof i) try {
              n.rememberDevice = !!i();
            } catch (e) {
              return Promise.reject(new be("RememberDevice resulted in an error."));
            } else null != i && (n.rememberDevice = !!i);
            var r = u.href + te(n);
            return ge.post(e, r, we(t), {
              saveAuthnState: !1,
              withCredentials: !0
            });
          }().then(function (t) {
            if (c = 0, t.factorResult && "WAITING" === t.factorResult) {
              if (!n.isPolling) throw new Se();
              return "function" == typeof s && s(t), B(o).then(r);
            }

            return n.isPolling = !1, new Te(e, t);
          }).catch(function (e) {
            if (e.xhr && (0 === e.xhr.status || 429 === e.xhr.status) && c <= 4) {
              var t = 1e3 * Math.pow(2, c);
              return c++, B(t).then(r);
            }

            throw e;
          }) : Promise.reject(new Se());
        }().catch(function (e) {
          throw n.isPolling = !1, e;
        });
      };
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    var Te = function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

      if (s()(this, e), n) {
        if (this.data = n, this.data.interactionHandle) return void (this.status = n.status);
        Object.assign(this, Oe(t, n, n, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== n.status || n._links || (this.cancel = function () {
          return Promise.resolve(new e(t));
        });
      }
    };

    function _e(e, t, n, r, o) {
      if (Array.isArray(r)) return function (i, a) {
        if (!i) throw new be("Must provide a link name");
        var s = K(r, {
          name: i
        });
        if (!s) throw new be("No link found for that name");
        return _e(e, t, n, s, o)(a);
      };
      if (r.hints && r.hints.allow && 1 === r.hints.allow.length) switch (r.hints.allow[0]) {
        case "GET":
          return function () {
            return ge.get(e, r.href, {
              withCredentials: !0
            });
          };

        case "POST":
          return function (i) {
            o && o.isPolling && (o.isPolling = !1);
            var a = xe(t, i);
            "MFA_ENROLL" !== t.status && "FACTOR_ENROLL" !== t.status || Object.assign(a, {
              factorType: n.factorType,
              provider: n.provider
            });
            var s = {},
                u = a.autoPush;

            if (void 0 !== u) {
              if ("function" == typeof u) try {
                s.autoPush = !!u();
              } catch (e) {
                return Promise.reject(new be("AutoPush resulted in an error."));
              } else null !== u && (s.autoPush = !!u);
              a = z(a, "autoPush");
            }

            var c = a.rememberDevice;

            if (void 0 !== c) {
              if ("function" == typeof c) try {
                s.rememberDevice = !!c();
              } catch (e) {
                return Promise.reject(new be("RememberDevice resulted in an error."));
              } else null !== c && (s.rememberDevice = !!c);
              a = z(a, "rememberDevice");
            } else a.profile && void 0 !== a.profile.updatePhone && (a.profile.updatePhone && (s.updatePhone = !0), a.profile = z(a.profile, "updatePhone"));

            var f = r.href + te(s);
            return Ce(e, f, a);
          };
      }
    }

    function Oe(e, t, n, r) {
      if (n = $(n = n || t), Array.isArray(n)) {
        for (var o = [], i = 0, a = n.length; i < a; i++) {
          o.push(Oe(e, t, n[i], r));
        }

        return o;
      }

      var s = n._embedded || {};

      for (var u in s) {
        Object.prototype.hasOwnProperty.call(s, u) && (Y(s[u]) || Array.isArray(s[u])) && (s[u] = Oe(e, t, s[u], r));
      }

      var c = function (e, t, n, r) {
        var o = {};

        for (var i in n._links) {
          if (Object.prototype.hasOwnProperty.call(n._links, i)) {
            var a = n._links[i];
            if ("next" === i && (i = a.name), a.type) o[i] = a;else switch (i) {
              case "poll":
                o.poll = Ee(e, t, r);
                break;

              default:
                var s = _e(e, t, n, a, r);

                s && (o[i] = s);
            }
          }
        }

        return o;
      }(e, t, n, r);

      return Object.assign(s, c), n = z(n, "_embedded", "_links"), Object.assign(n, s), n;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function Ae(e, t) {
      return t = xe(e, t), ge.post(e, e.getIssuerOrigin() + "/api/v1/authn", t, {
        withCredentials: !0
      });
    }

    function Re(e, t) {
      if (!t || !t.stateToken) {
        var n = e.tx.exists._get(p);

        if (!n) return Promise.reject(new be("No transaction to resume"));
        t = {
          stateToken: n
        };
      }

      return e.tx.status(t).then(function (t) {
        return new Te(e, t);
      });
    }

    function Pe(e, t) {
      if (!t || !t.stateToken) {
        var n = e.tx.exists._get(p);

        if (!n) return Promise.reject(new be("No transaction to evaluate"));
        t = {
          stateToken: n
        };
      }

      return function (e, t) {
        return t = xe(e, t), ge.post(e, e.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
          withCredentials: !0
        });
      }(e, t).then(function (t) {
        return new Te(e, t);
      });
    }

    function Ie(e) {
      return !!e.tx.exists._get(p);
    }

    function Ce(e, t, n, r) {
      return ge.post(e, t, n, r).then(function (t) {
        return new Te(e, t);
      });
    }

    var je = function e() {
      s()(this, e);
    };
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function Le(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      /*!
       * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
       * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
       *
       * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
       * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       *
       * See the License for the specific language governing permissions and limitations under the License.
       */
      ();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var Me = function (e) {
      oe()(n, e);
      var t = Le(n);

      function n(e, r) {
        var o;
        return s()(this, n), (o = t.call(this, r)).name = "OAuthError", o.errorCode = e, o.errorSummary = r, o;
      }

      return n;
    }(he),
        Ne = function Ne(e) {
      return atob(e);
    },
        Ue = function Ue(e) {
      return btoa(e);
    },
        De = "undefined" == typeof crypto ? null : crypto;
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    function Be(e) {
      return function (e) {
        return e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
      }(Ue(e));
    }

    function Fe(e) {
      return e.replace(/-/g, "+").replace(/_/g, "/");
    }

    function He(e) {
      var t = Fe(e);

      switch (t.length % 4) {
        case 0:
          break;

        case 2:
          t += "==";
          break;

        case 3:
          t += "=";
          break;

        default:
          throw new be("Not a valid Base64Url");
      }

      var n = Ne(t);

      try {
        return decodeURIComponent(escape(n));
      } catch (e) {
        return n;
      }
    }

    function qe(e) {
      for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) {
        t[n] = e.charCodeAt(n);
      }

      return t;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    function $e(e, t) {
      t = $(t);
      var n = {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
          name: "SHA-256"
        }
      };
      return delete t.use, De.subtle.importKey("jwk", t, n, !0, ["verify"]).then(function (t) {
        var r,
            o = e.split("."),
            i = qe(o[0] + "." + o[1]),
            a = qe((r = o[2], Ne(Fe(r))));
        return De.subtle.verify(n, t, a, i);
      });
    }
    /*!
     * Copyright (c) 2019-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function ze(e) {
      return ("0" + e.toString(16)).substr(-2);
    }

    var Ke = {
      DEFAULT_CODE_CHALLENGE_METHOD: P,
      generateVerifier: function generateVerifier(e) {
        var t,
            n,
            r = e || "";
        return r.length < A && (r += (t = A - r.length, n = new Uint8Array(Math.ceil(t / 2)), De.getRandomValues(n), Array.from(n, ze).join("").slice(0, t))), encodeURIComponent(r).slice(0, R);
      },
      computeChallenge: function computeChallenge(e) {
        var t = new TextEncoder().encode(e);
        return De.subtle.digest("SHA-256", t).then(function (e) {
          return Be(String.fromCharCode.apply(null, new Uint8Array(e)));
        });
      }
    };
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */

    function Ge(e) {
      return e.session.get().then(function (e) {
        return "ACTIVE" === e.status;
      }).catch(function () {
        return !1;
      });
    }

    function Ve(e) {
      return ge.get(e, "/api/v1/sessions/me", {
        withCredentials: !0
      }).then(function (t) {
        var n = z(t, "_links");
        return n.refresh = function () {
          return ge.post(e, G(t, "refresh").href, {}, {
            withCredentials: !0
          });
        }, n.user = function () {
          return ge.get(e, G(t, "user").href, {
            withCredentials: !0
          });
        }, n;
      }).catch(function () {
        return {
          status: "INACTIVE"
        };
      });
    }

    function Ye(e) {
      return ge.httpRequest(e, {
        url: e.getIssuerOrigin() + "/api/v1/sessions/me",
        method: "DELETE",
        withCredentials: !0
      });
    }

    function We(e) {
      return ge.post(e, "/api/v1/sessions/me/lifecycle/refresh", {}, {
        withCredentials: !0
      });
    }

    function Je(e, t, n) {
      n = n || window.location.href, window.location.assign(e.getIssuerOrigin() + "/login/sessionCookieRedirect" + te({
        checkAccountSetupComplete: !0,
        token: t,
        redirectUrl: n
      }));
    }

    function Xe(e) {
      if (!e.clientId) throw new be("A clientId must be specified in the OktaAuth constructor to get a token");
      if (V(e.responseType) && -1 !== e.responseType.indexOf(" ")) throw new be("Multiple OAuth responseTypes must be defined as an array");
      var t = {
        client_id: e.clientId,
        code_challenge: e.codeChallenge,
        code_challenge_method: e.codeChallengeMethod,
        display: e.display,
        idp: e.idp,
        idp_scope: e.idpScope,
        login_hint: e.loginHint,
        max_age: e.maxAge,
        nonce: e.nonce,
        prompt: e.prompt,
        redirect_uri: e.redirectUri,
        response_mode: e.responseMode,
        response_type: e.responseType,
        sessionToken: e.sessionToken,
        state: e.state
      };
      if (t = q(t), ["idp_scope", "response_type"].forEach(function (e) {
        Array.isArray(t[e]) && (t[e] = t[e].join(" "));
      }), -1 !== e.responseType.indexOf("id_token") && -1 === e.scopes.indexOf("openid")) throw new be("openid scope must be specified in the scopes argument when requesting an id_token");
      return t.scope = e.scopes.join(" "), t;
    }

    function Qe(e) {
      return te(Xe(e));
    }

    var Ze = n(193),
        et = n.n(Ze);

    function tt(e, t, n) {
      !function (e) {
        if (!e.clientId) throw new be("A clientId must be specified in the OktaAuth constructor to get a token");
        if (!e.redirectUri) throw new be("The redirectUri passed to /authorize must also be passed to /token");
        if (!e.authorizationCode && !e.interactionCode) throw new be("An authorization code (returned from /authorize) must be passed to /token");
        if (!e.codeVerifier) throw new be('The "codeVerifier" (generated and saved by your app) must be passed to /token');
      }(t);

      var r = function (e, t) {
        var n = q({
          client_id: t.clientId,
          redirect_uri: t.redirectUri,
          grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
          code_verifier: t.codeVerifier
        });
        t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
        var r = e.options.clientSecret;
        return r && (n.client_secret = r), te(n).slice(1);
      }(e, t);

      return ge.httpRequest(e, {
        url: n.tokenUrl,
        method: "POST",
        args: r,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
    }

    function nt(e, t, n) {
      return ge.httpRequest(e, {
        url: n.tokenUrl,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        args: Object.entries({
          client_id: t.clientId,
          grant_type: "refresh_token",
          scope: n.scopes.join(" "),
          refresh_token: n.refreshToken
        }).map(function (e) {
          var t = et()(e, 2),
              n = t[0],
              r = t[1];
          return n + "=" + encodeURIComponent(r);
        }).join("&")
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function rt(e, t) {
      var n = t || e.options.issuer;
      return ge.get(e, n + "/.well-known/openid-configuration", {
        cacheResponse: !0
      });
    }

    function ot(e, t, n) {
      var r = e.storageManager.getHttpCache(e.options.cookies);
      return rt(e, t).then(function (t) {
        var o = t.jwks_uri,
            i = r.getStorage()[o];

        if (i && Date.now() / 1e3 < i.expiresAt) {
          var a = K(i.response.keys, {
            kid: n
          });
          if (a) return a;
        }

        return r.clearStorage(o), ge.get(e, o, {
          cacheResponse: !0
        }).then(function (e) {
          var t = K(e.keys, {
            kid: n
          });
          if (t) return t;
          throw new be("The key id, " + n + ", was not found in the server's keys");
        });
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    var it = /windows phone|iemobile|wpdesktop/i;

    function at() {
      return "undefined" != typeof document && "undefined" != typeof window;
    }

    function st() {
      return at() && !!document.documentMode && document.documentMode <= 11;
    }

    function ut() {
      return navigator.userAgent;
    }

    function ct() {
      var e = ut();
      return e && !it.test(e);
    }

    function ft() {
      if (!at()) return !1;
      var e = document.documentMode && document.documentMode < 10;
      return !(!window.postMessage || e);
    }

    function lt() {
      return void 0 !== De && void 0 !== De.subtle && "undefined" != typeof Uint8Array;
    }

    function pt() {
      return "undefined" != typeof TextEncoder;
    }

    function ht() {
      return lt() && pt();
    }

    function dt() {
      return !!at() && "https:" === window.location.protocol;
    }

    function vt() {
      return at() && "localhost" === window.location.hostname;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function yt(e, t, n) {
      e.addEventListener ? e.addEventListener(t, n) : e.attachEvent("on" + t, n);
    }

    function gt(e, t, n) {
      e.removeEventListener ? e.removeEventListener(t, n) : e.detachEvent("on" + t, n);
    }

    function mt(e) {
      var t = document.createElement("iframe");
      return t.style.display = "none", t.src = e, document.body.appendChild(t);
    }

    function bt(e, t) {
      var n = t.popupTitle || "External Identity Provider User Authentication",
          r = "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";

      if (st()) {
        var o = window.open("/", n, r);
        return o.location.href = e, o;
      }

      return window.open(e, n, r);
    }

    function xt(e, t, n) {
      var r, o;
      return new Promise(function (i, a) {
        r = function r(t) {
          if (t.data && t.data.state === n) return t.origin !== e.getIssuerOrigin() ? a(new be("The request does not match client configuration")) : void i(t.data);
        }, yt(window, "message", r), o = setTimeout(function () {
          a(new be("OAuth flow timed out"));
        }, t || 12e4);
      }).finally(function () {
        clearTimeout(o), gt(window, "message", r);
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function wt() {
      return D(64);
    }

    function kt() {
      return D(64);
    }

    function St(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = ne(t.issuer) || e.options.issuer;
      return n;
    }

    function Et(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = St(e, t),
          r = n.indexOf("/oauth2") > 0 ? n : n + "/oauth2";
      return r;
    }

    function Tt(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = St(e, t),
          r = n.split("/oauth2")[0];
      return r;
    }

    function _t(e, t) {
      if (arguments.length > 2) throw new be('As of version 3.0, "getOAuthUrls" takes only a single set of options');
      var n = ne((t = t || {}).authorizeUrl) || e.options.authorizeUrl,
          r = St(e, t),
          o = ne(t.userinfoUrl) || e.options.userinfoUrl,
          i = ne(t.tokenUrl) || e.options.tokenUrl,
          a = ne(t.logoutUrl) || e.options.logoutUrl,
          s = ne(t.revokeUrl) || e.options.revokeUrl,
          u = Et(e, t);
      return {
        issuer: r,
        authorizeUrl: n = n || u + "/v1/authorize",
        userinfoUrl: o = o || u + "/v1/userinfo",
        tokenUrl: i = i || u + "/v1/token",
        revokeUrl: s = s || u + "/v1/revoke",
        logoutUrl: a = a || u + "/v1/logout"
      };
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function Ot(e) {
      var t = e.options,
          n = t.pkce,
          r = t.clientId,
          o = t.redirectUri,
          i = t.responseType,
          a = t.responseMode,
          s = t.scopes,
          u = t.state,
          c = t.ignoreSignature,
          f = at() ? window.location.href : void 0;
      return q({
        pkce: n,
        clientId: r,
        redirectUri: o || f,
        responseType: i || ["token", "id_token"],
        responseMode: a,
        state: u || wt(),
        nonce: kt(),
        scopes: s || ["openid", "email"],
        ignoreSignature: c
      });
    }

    function At(e) {
      return "OAuthError" === e.name && "interaction_required" === e.errorCode;
    }

    function Rt(e, t) {
      if ("AuthApiError" !== t.name) return !1;
      var n = t.xhr,
          r = null == n ? void 0 : n.responseJSON;
      return e.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
    }

    function Pt(e) {
      return /((id|access)_token=)/i.test(e);
    }

    function It(e) {
      return /(code=)/i.test(e);
    }

    function Ct(e) {
      return /(interaction_code=)/i.test(e);
    }

    function jt(e) {
      return /(error=)/i.test(e) || /(error_description)/i.test(e);
    }

    function Lt(e, t) {
      var n = t.options;
      return e && 0 === e.indexOf(n.redirectUri);
    }

    function Mt(e) {
      return e.pkce || "code" === e.responseType || "query" === e.responseMode;
    }

    function Nt(e) {
      return Mt(e) && "fragment" !== e.responseMode ? window.location.search : window.location.hash;
    }

    function Ut(e) {
      if (!Lt(window.location.href, e)) return !1;
      var t = Mt(e.options),
          n = Nt(e.options);
      return !!jt(n) || (t ? It(n) || Ct(n) : Pt(window.location.hash));
    }

    function Dt(e) {
      if (!Ut(e)) return !1;
      var t = Nt(e.options);
      return /(error=interaction_required)/i.test(t);
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function Bt(e, t) {
      var n = Ot(e);
      if (!1 === (t = Object.assign({}, n, $(t))).pkce) return Promise.resolve(t);

      if (!e.features.isPKCESupported()) {
        var r = "PKCE requires a modern browser with encryption support running in a secure context.";
        return e.features.isHTTPS() || (r += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e.features.hasTextEncoder() || (r += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), Promise.reject(new be(r));
      }

      return t.codeChallengeMethod || (t.codeChallengeMethod = P), t.responseType = "code", rt(e, null).then(function (e) {
        if (-1 === (e.code_challenge_methods_supported || []).indexOf(t.codeChallengeMethod)) throw new be("Invalid code_challenge_method");
      }).then(function () {
        return t.codeVerifier || (t.codeVerifier = Ke.generateVerifier()), Ke.computeChallenge(t.codeVerifier);
      }).then(function (e) {
        var n = $(t) || {};
        return Object.assign(n, t, {
          codeChallenge: e
        }), n;
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function Ft(e) {
      var t = /\+/g,
          n = /([^&=]+)=?([^&]*)/g,
          r = e;
      "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));

      for (var o, i = {}; o = n.exec(r);) {
        var a = o[1],
            s = o[2];
        i[a] = "id_token" === a || "access_token" === a || "code" === a ? s : decodeURIComponent(s.replace(t, " "));
      }

      return i;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function Ht(e, t, n) {
      var r = n.clientId,
          o = n.issuer,
          i = n.nonce;
      if (!t || !o || !r) throw new be("The jwt, iss, and aud arguments are all required");
      if (i && t.nonce !== i) throw new be("OAuth flow response nonce doesn't match request nonce");
      var a = Math.floor(Date.now() / 1e3);
      if (t.iss !== o) throw new be("The issuer [" + t.iss + "] does not match [" + o + "]");
      if (t.aud !== r) throw new be("The audience [" + t.aud + "] does not match [" + r + "]");
      if (t.iat > t.exp) throw new be("The JWT expired before it was issued");
      if (a - e.options.maxClockSkew > t.exp) throw new be("The JWT expired and is no longer valid");
      if (t.iat > a + e.options.maxClockSkew) throw new be("The JWT was issued in the future");
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function qt(e) {
      var t,
          n = e.split(".");

      try {
        t = {
          header: JSON.parse(He(n[0])),
          payload: JSON.parse(He(n[1])),
          signature: n[2]
        };
      } catch (e) {
        throw new be("Malformed token");
      }

      return t;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function $t(e, t) {
      return Promise.resolve().then(function () {
        var n, r;
        if (t && (n = t.accessToken, r = t.refreshToken), !n && !r) throw new be("A valid access or refresh token object is required");
        var o = e.options.clientId,
            i = e.options.clientSecret;
        if (!o) throw new be("A clientId must be specified in the OktaAuth constructor to revoke a token");

        var a = _t(e).revokeUrl,
            s = te({
          token_type_hint: r ? "refresh_token" : "access_token",
          token: r || n
        }).slice(1),
            u = Ue(i ? "".concat(o, ":").concat(i) : o);

        return ge.post(e, a, s, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Basic " + u
          }
        });
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    var zt,
        Kt,
        Gt = n(24),
        Vt = n.n(Gt);

    function Yt(e) {
      return !(!e || "object" !== Vt()(e) || 0 === Object.values(e).length);
    }

    function Wt(e) {
      return !!Yt(e) && (!!e.redirectUri || !!e.responseType);
    }

    function Jt(e) {
      return !!Wt(e) && !!e.codeVerifier;
    }

    function Xt(e) {
      return !!Jt(e) && !!e.interactionHandle;
    }

    function Qt(e) {
      return !!Yt(e) && void 0 === Object.values(e).find(function (e) {
        return "string" != typeof e;
      });
    }

    function Zt(e) {
      return !(!Wt(e) && !Qt(e));
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    function en(e) {
      return !!(e && (e.accessToken || e.idToken || e.refreshToken) && Array.isArray(e.scopes));
    }

    function tn(e) {
      return e && e.accessToken;
    }

    function nn(e) {
      return e && e.idToken;
    }

    function rn(e) {
      return e && e.refreshToken;
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function on(e, t, n) {
      n = n || _t(e, t);
      var r = t = Object.assign({}, Ot(e), $(t)),
          o = r.authorizationCode,
          i = r.interactionCode,
          a = r.codeVerifier,
          s = r.clientId,
          u = r.redirectUri,
          c = r.scopes,
          f = r.ignoreSignature;
      return tt(e, {
        clientId: s,
        redirectUri: u,
        authorizationCode: o,
        interactionCode: i,
        codeVerifier: a
      }, n).then(function (t) {
        var r = ["token"];
        return -1 !== c.indexOf("openid") && r.push("id_token"), un(e, {
          clientId: s,
          redirectUri: u,
          scopes: c,
          responseType: r,
          ignoreSignature: f
        }, t, n).then(function (e) {
          return e.code = o, e;
        });
      }).finally(function () {
        e.transactionManager.clear();
      });
    }

    !function (e) {
      e[e.SUCCESS = 0] = "SUCCESS", e[e.PENDING = 1] = "PENDING", e[e.FAILURE = 2] = "FAILURE", e[e.TERMINAL = 3] = "TERMINAL", e[e.CANCELED = 4] = "CANCELED";
    }(zt || (zt = {})), function (e) {
      e[e.PASSWORD_RECOVERY = 0] = "PASSWORD_RECOVERY", e[e.REGISTRATION = 1] = "REGISTRATION", e[e.SOCIAL_IDP = 2] = "SOCIAL_IDP";
    }(Kt || (Kt = {}));

    var an = function an(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function sn(e, t, n) {
      return an(this, void 0, void 0, l.a.mark(function r() {
        var o, i, a, s;
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (t && t.idToken) {
                  r.next = 2;
                  break;
                }

                throw new be("Only idTokens may be verified");

              case 2:
                return o = qt(t.idToken), r.next = 5, rt(e);

              case 5:
                if (i = r.sent, a = {
                  issuer: i.issuer,
                  clientId: e.options.clientId,
                  ignoreSignature: e.options.ignoreSignature
                }, Object.assign(a, n), Ht(e, o.payload, a), 1 != a.ignoreSignature && e.features.isTokenVerifySupported()) {
                  r.next = 11;
                  break;
                }

                return r.abrupt("return", t);

              case 11:
                return r.next = 13, ot(e, t.issuer, o.header.kid);

              case 13:
                return s = r.sent, r.next = 16, $e(t.idToken, s);

              case 16:
                if (r.sent) {
                  r.next = 19;
                  break;
                }

                throw new be("The token signature is not valid");

              case 19:
                if (!(n && n.accessToken && t.claims.at_hash)) {
                  r.next = 25;
                  break;
                }

                return r.next = 22, u = n.accessToken, c = void 0, c = new TextEncoder().encode(u), De.subtle.digest("SHA-256", c).then(function (e) {
                  var t = new Uint8Array(e).slice(0, 16);
                  return Be(String.fromCharCode.apply(null, t));
                });

              case 22:
                if (r.sent === t.claims.at_hash) {
                  r.next = 25;
                  break;
                }

                throw new be("Token hash verification failed");

              case 25:
                return r.abrupt("return", t);

              case 26:
              case "end":
                return r.stop();
            }
          }
          /*!
           * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
           * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
           *
           * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
           * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           *
           * See the License for the specific language governing permissions and limitations under the License.
           */


          var u, c;
        }, r);
      }));
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function un(e, t, n, r) {
      if (!1 !== e.options.pkce && (n.code || n.interaction_code)) return on(e, Object.assign({}, t, {
        authorizationCode: n.code,
        interactionCode: n.interaction_code
      }), r);
      t = t || Ot(e), r = r || _t(e, t);
      var o,
          i = t.responseType;
      Array.isArray(i) || (i = [i]), o = n.scope ? n.scope.split(" ") : $(t.scopes);
      var a = t.clientId || e.options.clientId;
      return Promise.resolve().then(function () {
        !function (e, t) {
          if (e.error || e.error_description) throw new Me(e.error, e.error_description);
          if (e.state !== t.state) throw new be("OAuth flow response state doesn't match request state");
        }(n, t);
      }).then(function () {
        var i = {},
            s = n.expires_in,
            u = n.token_type,
            c = n.access_token,
            f = n.id_token,
            l = n.refresh_token;

        if (c) {
          var p = e.token.decode(c);
          i.accessToken = {
            accessToken: c,
            claims: p.payload,
            expiresAt: Number(s) + Math.floor(Date.now() / 1e3),
            tokenType: u,
            scopes: o,
            authorizeUrl: r.authorizeUrl,
            userinfoUrl: r.userinfoUrl
          };
        }

        if (l && (i.refreshToken = {
          refreshToken: l,
          expiresAt: Number(s) + Math.floor(Date.now() / 1e3),
          scopes: o,
          tokenUrl: r.tokenUrl,
          authorizeUrl: r.authorizeUrl,
          issuer: r.issuer
        }), f) {
          var h = e.token.decode(f),
              d = {
            idToken: f,
            claims: h.payload,
            expiresAt: h.payload.exp,
            scopes: o,
            authorizeUrl: r.authorizeUrl,
            issuer: r.issuer,
            clientId: a
          },
              v = {
            clientId: a,
            issuer: r.issuer,
            nonce: t.nonce,
            accessToken: c
          };
          return void 0 !== t.ignoreSignature && (v.ignoreSignature = t.ignoreSignature), sn(e, d, v).then(function () {
            return i.idToken = d, i;
          });
        }

        return i;
      }).then(function (e) {
        if (-1 !== i.indexOf("token") && !e.accessToken) throw new be('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
        if (-1 !== i.indexOf("id_token") && !e.idToken) throw new be('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
        return {
          tokens: e,
          state: n.state,
          code: n.code
        };
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function cn(e, t) {
      return arguments.length > 2 ? Promise.reject(new be('As of version 3.0, "getToken" takes only a single set of options')) : Bt(e, t = t || {}).then(function (n) {
        var r, o;

        switch (t.sessionToken ? Object.assign(n, {
          prompt: "none",
          responseMode: "okta_post_message",
          display: null
        }) : t.idp && Object.assign(n, {
          display: "popup"
        }), o = _t(e, n), r = (t.codeVerifier ? o.tokenUrl : o.authorizeUrl) + Qe(n), n.sessionToken || null === n.display ? "IFRAME" : "popup" === n.display ? "POPUP" : "IMPLICIT") {
          case "IFRAME":
            var i = xt(e, t.timeout, n.state),
                a = mt(r);
            return i.then(function (t) {
              return un(e, n, t, o);
            }).finally(function () {
              document.body.contains(a) && a.parentElement.removeChild(a);
            });

          case "POPUP":
            var s;

            if ("okta_post_message" === n.responseMode) {
              if (!e.features.isPopupPostMessageSupported()) throw new be("This browser doesn't have full postMessage support");
              s = xt(e, t.timeout, n.state);
            }

            var u = bt(r, {
              popupTitle: t.popupTitle
            });
            return new Promise(function (e, t) {
              var n = setInterval(function () {
                u && !u.closed || (clearInterval(n), t(new be("Unable to parse OAuth flow response")));
              }, 100);
              s.then(function (t) {
                clearInterval(n), e(t);
              }).catch(function (e) {
                clearInterval(n), t(e);
              });
            }).then(function (t) {
              return un(e, n, t, o);
            }).finally(function () {
              u && !u.closed && u.close();
            });

          default:
            throw new be("The full page redirect flow is not supported");
        }
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function fn(e, t) {
      return arguments.length > 2 ? Promise.reject(new be('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = $(t) || {}, Object.assign(t, {
        prompt: "none",
        responseMode: "okta_post_message",
        display: null
      }), cn(e, t));
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function ln(e, t) {
      return en(t) ? fn(e, {
        responseType: e.options.pkce ? "code" : tn(t) ? "token" : "id_token",
        scopes: t.scopes,
        authorizeUrl: t.authorizeUrl,
        userinfoUrl: t.userinfoUrl,
        issuer: t.issuer
      }).then(function (e) {
        var n = e.tokens;
        return nn(t) ? n.idToken : n.accessToken;
      }) : Promise.reject(new be("Renew must be passed a token with an array of scopes and an accessToken or idToken"));
    }

    var pn = function pn(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function hn(e, t, n) {
      return pn(this, void 0, void 0, l.a.mark(function r() {
        var o, i, a, s, u, c;
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (o = e.options.clientId) {
                  r.next = 3;
                  break;
                }

                throw new be("A clientId must be specified in the OktaAuth constructor to renew tokens");

              case 3:
                return i = Object.assign({}, t, {
                  clientId: o
                }), r.next = 6, nt(e, i, n);

              case 6:
                return a = r.sent, s = _t(e, t), r.next = 10, un(e, i, a, s);

              case 10:
                return u = r.sent, c = u.tokens, r.abrupt("return", c);

              case 13:
              case "end":
                return r.stop();
            }
          }
        }, r);
      }));
    }

    function dn(e, t) {
      return e.tokenManager.getTokens().then(function (e) {
        return e.refreshToken;
      }).then(function (n) {
        if (n) return hn(e, t, n);
        if (t = Object.assign({
          scopes: e.options.scopes,
          authorizeUrl: e.options.authorizeUrl,
          userinfoUrl: e.options.userinfoUrl,
          issuer: e.options.issuer
        }, t), e.options.pkce) t.responseType = "code";else {
          var r = Ot(e).responseType;
          t.responseType = r;
        }
        return fn(e, t).then(function (e) {
          return e.tokens;
        });
      });
    }

    var vn = function vn(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function yn(e, t, n) {
      return vn(this, void 0, void 0, l.a.mark(function r() {
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (t) {
                  r.next = 4;
                  break;
                }

                return r.next = 3, e.tokenManager.getTokens();

              case 3:
                t = r.sent.accessToken;

              case 4:
                if (n) {
                  r.next = 8;
                  break;
                }

                return r.next = 7, e.tokenManager.getTokens();

              case 7:
                n = r.sent.idToken;

              case 8:
                if (t && tn(t)) {
                  r.next = 10;
                  break;
                }

                return r.abrupt("return", Promise.reject(new be("getUserInfo requires an access token object")));

              case 10:
                if (n && nn(n)) {
                  r.next = 12;
                  break;
                }

                return r.abrupt("return", Promise.reject(new be("getUserInfo requires an ID token object")));

              case 12:
                return r.abrupt("return", ge.httpRequest(e, {
                  url: t.userinfoUrl,
                  method: "GET",
                  accessToken: t.accessToken
                }).then(function (e) {
                  return e.sub === n.claims.sub ? e : Promise.reject(new be("getUserInfo request was rejected due to token mismatch"));
                }).catch(function (e) {
                  var t;

                  if (e.xhr && (401 === e.xhr.status || 403 === e.xhr.status) && (e.xhr.headers && J(e.xhr.headers.get) && e.xhr.headers.get("WWW-Authenticate") ? t = e.xhr.headers.get("WWW-Authenticate") : J(e.xhr.getResponseHeader) && (t = e.xhr.getResponseHeader("WWW-Authenticate")), t)) {
                    var n = t.match(/error="(.*?)"/) || [],
                        r = t.match(/error_description="(.*?)"/) || [],
                        o = n[1],
                        i = r[1];
                    o && i && (e = new Me(o, i));
                  }

                  throw e;
                }));

              case 13:
              case "end":
                return r.stop();
            }
          }
        }, r);
      }));
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function gn(e, t) {
      return arguments.length > 2 ? Promise.reject(new be('As of version 3.0, "getWithPopup" takes only a single set of options')) : (t = $(t) || {}, Object.assign(t, {
        display: "popup",
        responseMode: "okta_post_message"
      }), cn(e, t));
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function mn(e, t) {
      return arguments.length > 2 ? Promise.reject(new be('As of version 3.0, "getWithRedirect" takes only a single set of options')) : (t = $(t) || {}, Bt(e, t).then(function (n) {
        var r = _t(e, t),
            o = r.authorizeUrl + Qe(n),
            i = {
          issuer: e.options.issuer,
          responseType: n.responseType,
          state: n.state,
          nonce: n.nonce,
          scopes: n.scopes,
          clientId: n.clientId,
          urls: r,
          ignoreSignature: n.ignoreSignature,
          redirectUri: n.redirectUri,
          codeVerifier: n.codeVerifier,
          codeChallenge: n.codeChallenge,
          codeChallengeMethod: n.codeChallengeMethod
        };

        e.transactionManager.save(i, {
          oauth: !0
        }), e.token.getWithRedirect._setLocation(o);
      }));
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    function bn(e, t) {
      t = V(t = t || {}) ? {
        url: t
      } : t;

      var n,
          r = e.options.pkce ? "query" : "fragment",
          o = t.url,
          i = t.responseMode || e.options.responseMode || r,
          a = e.token.parseFromUrl._getLocation();

      if (!(n = "query" === i ? o ? o.substring(o.indexOf("?")) : a.search : o ? o.substring(o.indexOf("#")) : a.hash)) return Promise.reject(new be("Unable to parse a token from the url"));
      var s = e.transactionManager.load({
        oauth: !0,
        pkce: e.options.pkce
      }),
          u = s.urls;
      return delete s.urls, Promise.resolve(Ft(n)).then(function (t) {
        return o || ("query" === i ? function (e) {
          var t = e.token.parseFromUrl._getHistory(),
              n = e.token.parseFromUrl._getDocument(),
              r = e.token.parseFromUrl._getLocation();

          t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
        }(e) : function (e) {
          var t = e.token.parseFromUrl._getHistory(),
              n = e.token.parseFromUrl._getDocument(),
              r = e.token.parseFromUrl._getLocation();

          t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
        }(e)), un(e, s, t, u).catch(function (t) {
          throw At(t) || e.transactionManager.clear(), t;
        }).then(function (t) {
          return e.transactionManager.clear(), t;
        });
      });
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */

    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */


    var xn = n(201),
        wn = {
      getHttpCache: function getHttpCache() {
        return null;
      },
      getPKCEStorage: function getPKCEStorage() {
        return null;
      },
      browserHasLocalStorage: function browserHasLocalStorage() {
        try {
          var e = wn.getLocalStorage();
          return wn.testStorage(e);
        } catch (e) {
          return !1;
        }
      },
      browserHasSessionStorage: function browserHasSessionStorage() {
        try {
          var e = wn.getSessionStorage();
          return wn.testStorage(e);
        } catch (e) {
          return !1;
        }
      },
      testStorageType: function testStorageType(e) {
        var t = !1;

        switch (e) {
          case "sessionStorage":
            t = wn.browserHasSessionStorage();
            break;

          case "localStorage":
            t = wn.browserHasLocalStorage();
            break;

          case "cookie":
          case "memory":
            t = !0;
            break;

          default:
            t = !1;
        }

        return t;
      },
      getStorageByType: function getStorageByType(e, t) {
        var n = null;

        switch (e) {
          case "sessionStorage":
            n = wn.getSessionStorage();
            break;

          case "localStorage":
            n = wn.getLocalStorage();
            break;

          case "cookie":
            n = wn.getCookieStorage(t);
            break;

          case "memory":
            n = wn.getInMemoryStorage();
            break;

          default:
            throw new be("Unrecognized storage option: ".concat(e));
        }

        return n;
      },
      findStorageType: function findStorageType(e) {
        var t, n;
        return t = (e = e.slice()).shift(), (n = e.length ? e[0] : null) ? wn.testStorageType(t) ? t : (L("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), wn.findStorageType(e)) : t;
      },
      getLocalStorage: function getLocalStorage() {
        return localStorage;
      },
      getSessionStorage: function getSessionStorage() {
        return sessionStorage;
      },
      getCookieStorage: function getCookieStorage(e) {
        var t = e.secure,
            n = e.sameSite,
            r = e.sessionCookie;
        if (void 0 === t || void 0 === n) throw new be('getCookieStorage: "secure" and "sameSite" options must be provided');
        var o = {
          getItem: wn.storage.get,
          setItem: function setItem(e, o) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
            i = r ? null : i, wn.storage.set(e, o, i, {
              secure: t,
              sameSite: n
            });
          },
          removeItem: function removeItem(e) {
            wn.storage.delete(e);
          }
        };
        return e.useMultipleCookies ? {
          getItem: function getItem(e) {
            var t = o.getItem(),
                n = {};
            return Object.keys(t).forEach(function (r) {
              0 === r.indexOf(e) && (n[r.replace("".concat(e, "_"), "")] = JSON.parse(t[r]));
            }), JSON.stringify(n);
          },
          setItem: function setItem(e, t) {
            var n = JSON.parse(this.getItem(e));
            t = JSON.parse(t), Object.keys(t).forEach(function (r) {
              var i = e + "_" + r,
                  a = JSON.stringify(t[r]);
              o.setItem(i, a), delete n[r];
            }), Object.keys(n).forEach(function (t) {
              o.removeItem(e + "_" + t);
            });
          },
          removeItem: function removeItem(e) {
            var t = JSON.parse(this.getItem(e));
            Object.keys(t).forEach(function (t) {
              o.removeItem(e + "_" + t);
            });
          }
        } : o;
      },
      getInMemoryStorage: function getInMemoryStorage() {
        var e = {};
        return {
          getItem: function getItem(t) {
            return e[t];
          },
          setItem: function setItem(t, n) {
            e[t] = n;
          }
        };
      },
      testStorage: function testStorage(e) {
        var t = "okta-test-storage";

        try {
          return e.setItem(t, t), e.removeItem(t), !0;
        } catch (e) {
          return !1;
        }
      },
      storage: {
        set: function set(e, t, n, r) {
          var o = r.sameSite,
              i = r.secure;
          if (void 0 === i || void 0 === o) throw new be('storage.set: "secure" and "sameSite" options must be provided');
          var a = {
            path: r.path || "/",
            secure: i,
            sameSite: o
          };
          return Date.parse(n) && (a.expires = new Date(n)), xn.set(e, t, a), wn.storage.get(e);
        },
        get: function get(e) {
          return xn.get(e);
        },
        delete: function _delete(e) {
          return xn.remove(e, {
            path: "/"
          });
        }
      }
    },
        kn = wn;
    /*!
     * Copyright (c) 2018-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    function Sn(e) {
      var t = (e = e || {}).issuer;
      if (!t) throw new be('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
      if (!new RegExp("^http?s?://.+").test(e.issuer)) throw new be('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
      if (-1 !== t.indexOf("-admin.")) throw new be('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
      var n = e.userAgent;
      if (n && n.template && -1 === n.template.indexOf("$OKTA_AUTH_JS")) throw new be('UserAgentTemplate must include "$OKTA_AUTH_JS" placeholder. Required usage: new OktaAuth({userAgentTemplate: "xxx $OKTA_AUTH_JS xxx"})');
    }

    function En(e, t) {
      var n = e.userAgent || {};
      return n.value ? n.value : n.template ? n.template.replace("$OKTA_AUTH_JS", t) : t;
    }

    var Tn = n(78),
        _n = n.n(Tn),
        On = function () {
      function e(t) {
        s()(this, e), this.localOffset = parseInt(t || 0);
      }

      return c()(e, [{
        key: "now",
        value: function value() {
          var e = (Date.now() + this.localOffset) / 1e3;
          return e;
        }
      }], [{
        key: "create",
        value: function value() {
          return new e(0);
        }
      }]), e;
    }();

    var An = function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        s()(this, e), this.tokenManager = t, this.options = n;
      }

      return c()(e, [{
        key: "start",
        value: function value() {
          var e = this,
              t = [];
          this.onTokenExpiredHandler = function (n) {
            if (e.options.autoRenew) {
              if (function (e) {
                var t = !1;

                if (e.push(Date.now()), e.length >= 10) {
                  var n = e.shift();
                  t = e[e.length - 1] - n < 3e4;
                }

                return t;
              }(t)) {
                var r = new be("Too many token renew requests");
                e.tokenManager.emitError(r);
              } else e.tokenManager.renew(n).catch(function () {});
            } else e.options.autoRemove && e.tokenManager.remove(n);
          }, this.tokenManager.on(In, this.onTokenExpiredHandler), this.tokenManager.setExpireEventTimeoutAll(), this.options.syncStorage && at() && (this.storageListener = function (t) {
            var n = t.key,
                r = t.newValue,
                o = t.oldValue;
            (!n || n === e.options.storageKey && r !== o) && (e.syncTimeout = setTimeout(function () {
              return e.tokenManager.resetExpireEventTimeoutAll(), void e.tokenManager.emitEventsForCrossTabsStorageUpdate(r, o);
            }, e.options._storageEventDelay));
          }, window.addEventListener("storage", this.storageListener));
        }
      }, {
        key: "stop",
        value: function value() {
          this.tokenManager.clearExpireEventTimeoutAll(), this.tokenManager.off(In, this.onTokenExpiredHandler), this.options.syncStorage && at() && (window.removeEventListener("storage", this.storageListener), clearTimeout(this.syncTimeout));
        }
      }]), e;
    }(),
        Rn = function Rn(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        Pn = {
      autoRenew: !0,
      autoRemove: !0,
      storage: void 0,
      expireEarlySeconds: 30,
      storageKey: b,
      syncStorage: !0,
      _storageEventDelay: 0
    },
        In = "expired",
        Cn = "renewed",
        jn = "added",
        Ln = "removed",
        Mn = "error";

    var Nn,
        Un = function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (s()(this, e), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new be("Emitter should be initialized before TokenManager");
        n = Object.assign({}, Pn, q(n)), st() && (n._storageEventDelay = n._storageEventDelay || 1e3), vt() || (n.expireEarlySeconds = Pn.expireEarlySeconds), this.options = n;
        var r = q({
          storageKey: n.storageKey,
          secure: n.secure
        });
        "object" === Vt()(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(r), this.clock = On.create(), this.state = {
          expireTimeouts: {},
          renewPromise: {}
        }, this.on = this.emitter.on.bind(this.emitter), this.off = this.emitter.off.bind(this.emitter);
      }

      return c()(e, [{
        key: "start",
        value: function value() {
          this.service && this.stop(), this.service = new An(this, this.getOptions()), this.service.start();
        }
      }, {
        key: "stop",
        value: function value() {
          this.service && (this.service.stop(), this.service = null);
        }
      }, {
        key: "getOptions",
        value: function value() {
          return $(this.options);
        }
      }, {
        key: "getExpireTime",
        value: function value(e) {
          return e.expiresAt - this.options.expireEarlySeconds;
        }
      }, {
        key: "hasExpired",
        value: function value(e) {
          return this.getExpireTime(e) <= this.clock.now();
        }
      }, {
        key: "emitExpired",
        value: function value(e, t) {
          this.emitter.emit(In, e, t);
        }
      }, {
        key: "emitRenewed",
        value: function value(e, t, n) {
          this.emitter.emit(Cn, e, t, n);
        }
      }, {
        key: "emitAdded",
        value: function value(e, t) {
          this.emitter.emit(jn, e, t);
        }
      }, {
        key: "emitRemoved",
        value: function value(e, t) {
          this.emitter.emit(Ln, e, t);
        }
      }, {
        key: "emitError",
        value: function value(e) {
          this.emitter.emit(Mn, e);
        }
      }, {
        key: "emitEventsForCrossTabsStorageUpdate",
        value: function value(e, t) {
          var n = this,
              r = this.getTokensFromStorageValue(t),
              o = this.getTokensFromStorageValue(e);
          Object.keys(o).forEach(function (e) {
            var t = r[e],
                i = o[e];
            JSON.stringify(t) !== JSON.stringify(i) && n.emitAdded(e, i);
          }), Object.keys(r).forEach(function (e) {
            var t = r[e];
            o[e] || n.emitRemoved(e, t);
          });
        }
      }, {
        key: "clearExpireEventTimeout",
        value: function value(e) {
          clearTimeout(this.state.expireTimeouts[e]), delete this.state.expireTimeouts[e], delete this.state.renewPromise[e];
        }
      }, {
        key: "clearExpireEventTimeoutAll",
        value: function value() {
          var e = this.state.expireTimeouts;

          for (var t in e) {
            Object.prototype.hasOwnProperty.call(e, t) && this.clearExpireEventTimeout(t);
          }
        }
      }, {
        key: "setExpireEventTimeout",
        value: function value(e, t) {
          var n = this,
              r = this.getExpireTime(t),
              o = 1e3 * Math.max(r - this.clock.now(), 0);
          this.clearExpireEventTimeout(e);
          var i = setTimeout(function () {
            n.emitExpired(e, t);
          }, o);
          this.state.expireTimeouts[e] = i;
        }
      }, {
        key: "setExpireEventTimeoutAll",
        value: function value() {
          var e = this.storage.getStorage();

          for (var t in e) {
            if (Object.prototype.hasOwnProperty.call(e, t)) {
              var n = e[t];
              this.setExpireEventTimeout(t, n);
            }
          }
        }
      }, {
        key: "resetExpireEventTimeoutAll",
        value: function value() {
          this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
        }
      }, {
        key: "validateToken",
        value: function value(e) {
          if (!nn(e) && !tn(e) && !rn(e)) throw new be("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
        }
      }, {
        key: "add",
        value: function value(e, t) {
          var n = this.storage.getStorage();
          this.validateToken(t), n[e] = t, this.storage.setStorage(n), this.emitAdded(e, t), this.setExpireEventTimeout(e, t);
        }
      }, {
        key: "getSync",
        value: function value(e) {
          return this.storage.getStorage()[e];
        }
      }, {
        key: "get",
        value: function value(e) {
          return Rn(this, void 0, void 0, l.a.mark(function t() {
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.abrupt("return", this.getSync(e));

                  case 1:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "getTokensSync",
        value: function value() {
          var e = {},
              t = this.storage.getStorage();
          return Object.keys(t).forEach(function (n) {
            var r = t[n];
            tn(r) ? e.accessToken = r : nn(r) ? e.idToken = r : rn(r) && (e.refreshToken = r);
          }), e;
        }
      }, {
        key: "getTokens",
        value: function value() {
          return Rn(this, void 0, void 0, l.a.mark(function e() {
            return l.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", this.getTokensSync());

                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "getStorageKeyByType",
        value: function value(e) {
          var t = this.storage.getStorage();
          return Object.keys(t).filter(function (n) {
            var r = t[n];
            return tn(r) && "accessToken" === e || nn(r) && "idToken" === e || rn(r) && "refreshToken" === e;
          })[0];
        }
      }, {
        key: "setTokens",
        value: function value(e, t, n, r) {
          var o = this,
              i = e.accessToken,
              a = e.idToken,
              s = e.refreshToken,
              u = function u(e, t, n) {
            o.emitAdded(e, t), o.setExpireEventTimeout(e, t), n && n(e, t);
          },
              c = function c(e, t, n) {
            o.clearExpireEventTimeout(e), o.emitRemoved(e, t), n && n(e, t);
          };

          a && this.validateToken(a), i && this.validateToken(i);

          var f = this.getStorageKeyByType("idToken") || T,
              l = this.getStorageKeyByType("accessToken") || E,
              p = this.getStorageKeyByType("refreshToken") || _,
              h = Object.assign(Object.assign(Object.assign({}, a && _n()({}, f, a)), i && _n()({}, l, i)), s && _n()({}, p, s));

          this.storage.setStorage(h);
          var d = this.getTokensSync();
          a ? u(f, a, n) : d.idToken && c(f, d.idToken, n), i ? u(l, i, t) : d.accessToken && c(l, d.accessToken, t), s ? u(p, s, r) : d.refreshToken && c(p, d.refreshToken, r);
        }
      }, {
        key: "remove",
        value: function value(e) {
          this.clearExpireEventTimeout(e);
          var t = this.storage.getStorage(),
              n = t[e];
          delete t[e], this.storage.setStorage(t), this.emitRemoved(e, n);
        }
      }, {
        key: "renewToken",
        value: function value(e) {
          return Rn(this, void 0, void 0, l.a.mark(function t() {
            var n, r;
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (!(n = this.getTokensSync()).refreshToken) {
                      t.next = 6;
                      break;
                    }

                    return t.next = 4, this.sdk.token.renewTokensWithRefresh({
                      scopes: e.scopes
                    }, n.refreshToken);

                  case 4:
                    return r = t.sent, t.abrupt("return", nn(e) ? r.idToken : r.accessToken);

                  case 6:
                    return t.abrupt("return", this.sdk.token.renew(e));

                  case 7:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "renew",
        value: function value(e) {
          var t = this,
              n = this.state.renewPromise[e];
          if (n) return n;

          try {
            var r = this.getSync(e);
            if (!r) throw new be("The tokenManager has no token for the key: " + e);
          } catch (e) {
            return Promise.reject(e);
          }

          return this.clearExpireEventTimeout(e), this.state.renewPromise[e] = this.renewToken(r).then(function (n) {
            var r = t.storage.getStorage();
            return t.remove(e), t.add(e, n), t.emitRenewed(e, n, r[e]), n;
          }).catch(function (n) {
            if ("OAuthError" === n.name || "AuthSdkError" === n.name) {
              var r = t.storage.getStorage(),
                  o = r[e];
              o && t.hasExpired(o) ? (delete r[e], t.clearExpireEventTimeout(e), t.storage.setStorage(r), t.emitRemoved(e, o)) : t.emitRemoved(e), n.tokenKey = e, t.emitError(n);
            }

            throw n;
          }).finally(function () {
            delete t.state.renewPromise[e];
          }), this.state.renewPromise[e];
        }
      }, {
        key: "clear",
        value: function value() {
          this.clearExpireEventTimeoutAll(), this.storage.clearStorage();
        }
      }, {
        key: "getTokensFromStorageValue",
        value: function value(e) {
          var t;

          try {
            t = JSON.parse(e) || {};
          } catch (e) {
            t = {};
          }

          return t;
        }
      }]), e;
    }();

    vt() && (Nn = Un.prototype.add, Object.assign(Un.prototype, {
      add: function add(e, t) {
        L("Use setTokens() instead if you want to add a set of tokens at same time.\nIt prevents current tab from emitting unnecessary StorageEvent,\nwhich may cause false-positive authState change cross tabs."), Nn.call(this, e, t);
      }
    }));
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */

    var Dn = function () {
      function e() {
        s()(this, e), this.queue = [], this.running = !1;
      }

      return c()(e, [{
        key: "push",
        value: function value(e, t) {
          for (var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
            o[i - 2] = arguments[i];
          }

          return new Promise(function (r, i) {
            n.queue.push({
              method: e,
              thisObject: t,
              args: o,
              resolve: r,
              reject: i
            }), n.run();
          });
        }
      }, {
        key: "run",
        value: function value() {
          var e = this;

          if (!this.running && 0 !== this.queue.length) {
            this.running = !0;
            var t = this.queue.shift(),
                n = t.method.apply(t.thisObject, t.args);
            X(n) ? n.then(t.resolve, t.reject).finally(function () {
              e.running = !1, e.run();
            }) : (t.resolve(n), this.running = !1, this.run());
          }
        }
      }]), e;
    }();

    function Bn(e, t) {
      return t = t || {}, ct() ? new Promise(function (i, a) {
        (r = document.createElement("iframe")).style.display = "none", o = function o(t) {
          if (t && t.data && t.origin === e.getIssuerOrigin()) {
            try {
              var n = JSON.parse(t.data);
            } catch (e) {
              return;
            }

            if (n) return "FingerprintAvailable" === n.type ? i(n.fingerprint) : void ("FingerprintServiceReady" === n.type && t.source.postMessage(JSON.stringify({
              type: "GetFingerprint"
            }), t.origin));
          }
        }, yt(window, "message", o), r.src = e.getIssuerOrigin() + "/auth/services/devicefingerprint", document.body.appendChild(r), n = setTimeout(function () {
          a(new be("Fingerprinting timed out"));
        }, t.timeout || 15e3);
      }).finally(function () {
        clearTimeout(n), gt(window, "message", o), document.body.contains(r) && r.parentElement.removeChild(r);
      }) : Promise.reject(new be("Fingerprinting is not supported on this device"));
      var n, r, o;
    }

    var Fn = function Fn(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        Hn = n(202),
        qn = null,
        $n = {
      updateAuthStatePromise: null,
      canceledTimes: 0
    },
        zn = function () {
      function e(t) {
        var n = this;
        if (s()(this, e), !t.emitter) throw new be("Emitter should be initialized before AuthStateManager");
        this._sdk = t, this._pending = Object.assign({}, $n), this._authState = qn, this._logOptions = {}, t.tokenManager.on(jn, function (e, t) {
          n._setLogOptions({
            event: jn,
            key: e,
            token: t
          }), n.updateAuthState();
        }), t.tokenManager.on(Ln, function (e, t) {
          n._setLogOptions({
            event: Ln,
            key: e,
            token: t
          }), n.updateAuthState();
        });
      }

      return c()(e, [{
        key: "_setLogOptions",
        value: function value(e) {
          this._logOptions = e;
        }
      }, {
        key: "getAuthState",
        value: function value() {
          return this._authState;
        }
      }, {
        key: "updateAuthState",
        value: function value() {
          return Fn(this, void 0, void 0, l.a.mark(function e() {
            var t,
                n,
                r,
                o,
                i,
                a,
                s,
                u = this;
            return l.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function o(e) {
                      var t = u._logOptions,
                          n = t.event,
                          r = t.key,
                          o = t.token;
                      j().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e)), j().log(r, o), j().log("Current authState", u._authState), j().groupEnd(), u._logOptions = {};
                    }, i = function i(e) {
                      var t, n;
                      (t = u._authState, n = e, t && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error) ? r && o("unchanged") : (u._authState = e, u._sdk.emitter.emit("authStateChange", Object.assign({}, e)), r && o("emitted"));
                    }, a = function e(t) {
                      return u._pending.updateAuthStatePromise.then(function () {
                        var n = u._pending.updateAuthStatePromise;
                        return n && n !== t ? e(n) : u.getAuthState();
                      });
                    }, !this._pending.updateAuthStatePromise) {
                      e.next = 11;
                      break;
                    }

                    if (!(this._pending.canceledTimes >= 10)) {
                      e.next = 10;
                      break;
                    }

                    return r && o("terminated"), e.abrupt("return", a(this._pending.updateAuthStatePromise));

                  case 10:
                    this._pending.updateAuthStatePromise.cancel();

                  case 11:
                    return s = new Hn(function (e, t, a) {
                      a.shouldReject = !1, a(function () {
                        u._pending.updateAuthStatePromise = null, u._pending.canceledTimes = u._pending.canceledTimes + 1, r && o("canceled");
                      });

                      var c = function c(t) {
                        s.isCanceled ? e() : (i(t), e(), u._pending = Object.assign({}, $n));
                      };

                      u._sdk.isAuthenticated().then(function (t) {
                        if (s.isCanceled) e();else {
                          var r = u._sdk.tokenManager.getTokensSync(),
                              o = r.accessToken,
                              i = r.idToken,
                              a = r.refreshToken,
                              f = {
                            accessToken: o,
                            idToken: i,
                            refreshToken: a,
                            isAuthenticated: t
                          };

                          (n ? n(u._sdk, f) : Promise.resolve(f)).then(function (e) {
                            return c(e);
                          }).catch(function (e) {
                            return c({
                              accessToken: o,
                              idToken: i,
                              refreshToken: a,
                              isAuthenticated: !1,
                              error: e
                            });
                          });
                        }
                      });
                    }), this._pending.updateAuthStatePromise = s, e.abrupt("return", a(s));

                  case 14:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "subscribe",
        value: function value(e) {
          this._sdk.emitter.on("authStateChange", e);
        }
      }, {
        key: "unsubscribe",
        value: function value(e) {
          this._sdk.emitter.off("authStateChange", e);
        }
      }]), e;
    }(),
        Kn = function () {
      function e(t, n) {
        if (s()(this, e), !t) throw new be('"storage" is required');
        if ("string" != typeof n || !n.length) throw new be('"storageName" is required');
        this.storageName = n, this.storageProvider = t;
      }

      return c()(e, [{
        key: "getItem",
        value: function value(e) {
          return this.getStorage()[e];
        }
      }, {
        key: "setItem",
        value: function value(e, t) {
          return this.updateStorage(e, t);
        }
      }, {
        key: "removeItem",
        value: function value(e) {
          return this.clearStorage(e);
        }
      }, {
        key: "getStorage",
        value: function value() {
          var e = this.storageProvider.getItem(this.storageName);
          e = e || "{}";

          try {
            return JSON.parse(e);
          } catch (e) {
            throw new be("Unable to parse storage string: " + this.storageName);
          }
        }
      }, {
        key: "setStorage",
        value: function value(e) {
          try {
            var t = e ? JSON.stringify(e) : "{}";
            this.storageProvider.setItem(this.storageName, t);
          } catch (e) {
            throw new be("Unable to set storage: " + this.storageName);
          }
        }
      }, {
        key: "clearStorage",
        value: function value(e) {
          if (e) {
            var t = this.getStorage();
            delete t[e], this.setStorage(t);
          } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
        }
      }, {
        key: "updateStorage",
        value: function value(e, t) {
          var n = this.getStorage();
          n[e] = t, this.setStorage(n);
        }
      }]), e;
    }();

    function Gn(e) {
      at() || e.storageProvider || e.storageProvider || L("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
    }

    var Vn = function () {
      function e(t, n, r) {
        s()(this, e), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = r;
      }

      return c()(e, [{
        key: "getOptionsForSection",
        value: function value(e, t) {
          return Object.assign({}, this.storageManagerOptions[e], t);
        }
      }, {
        key: "getStorage",
        value: function value(e) {
          if ((e = Object.assign({}, this.cookieOptions, e)).storageProvider) return e.storageProvider;
          var t = e,
              n = t.storageType,
              r = t.storageTypes;

          if ("sessionStorage" === n && (e.sessionCookie = !0), n && r) {
            var o = r.indexOf(n);
            o >= 0 && (r = r.slice(o), n = null);
          }

          return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e);
        }
      }, {
        key: "getTransactionStorage",
        value: function value(e) {
          Gn(e = this.getOptionsForSection("transaction", e));
          var t = this.getStorage(e),
              n = e.storageKey || k;
          return new Kn(t, n);
        }
      }, {
        key: "getIdxResponseStorage",
        value: function value(e) {
          var t;
          if (at()) try {
            t = this.storageUtil.getStorageByType("memory", e);
          } catch (e) {
            L("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
          } else {
            var n = this.getTransactionStorage(e);
            n && (t = {
              getItem: function getItem(e) {
                var t = n.getStorage();
                return t && t[e] ? t[e] : null;
              },
              setItem: function setItem(e, t) {
                var r = n.getStorage();
                if (!r) throw new be("Transaction has been cleared, failed to save idxState");
                r[e] = t, n.setStorage(r);
              },
              removeItem: function removeItem(e) {
                var t = n.getStorage();
                t && (delete t[e], n.setStorage(t));
              }
            });
          }
          return t ? new Kn(t, S) : null;
        }
      }, {
        key: "getTokenStorage",
        value: function value(e) {
          Gn(e = this.getOptionsForSection("token", e));
          var t = this.getStorage(e),
              n = e.storageKey || b;
          return new Kn(t, n);
        }
      }, {
        key: "getHttpCache",
        value: function value(e) {
          e = this.getOptionsForSection("cache", e);
          var t = this.getStorage(e),
              n = e.storageKey || x;
          return new Kn(t, n);
        }
      }, {
        key: "getLegacyPKCEStorage",
        value: function value(e) {
          e = this.getOptionsForSection("legacy-pkce", e);
          var t = this.getStorage(e),
              n = e.storageKey || w;
          return new Kn(t, n);
        }
      }, {
        key: "getLegacyOAuthParamsStorage",
        value: function value(e) {
          e = this.getOptionsForSection("legacy-oauth-params", e);
          var t = this.getStorage(e),
              n = e.storageKey || y;
          return new Kn(t, n);
        }
      }]), e;
    }();

    function Yn(e) {
      return e && e.version;
    }

    var Wn = function () {
      function e(t) {
        s()(this, e), this.storageManager = t.storageManager, this.legacyWidgetSupport = !1 !== t.legacyWidgetSupport, this.saveNonceCookie = !1 !== t.saveNonceCookie, this.saveStateCookie = !1 !== t.saveStateCookie, this.saveParamsCookie = !1 !== t.saveParamsCookie, this.options = t;
      }

      return c()(e, [{
        key: "clear",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = this.storageManager.getTransactionStorage();
          t.clearStorage();
          var n = this.storageManager.getIdxResponseStorage();
          null == n || n.clearStorage(), this.legacyWidgetSupport && (e.oauth && this.clearLegacyOAuthParams(), e.pkce && this.clearLegacyPKCE());
        }
      }, {
        key: "save",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.storageManager.getTransactionStorage(),
              r = n.getStorage();

          if (Zt(r) && L("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e), t.oauth && (this.saveNonceCookie || this.saveStateCookie || this.saveParamsCookie)) {
            var o = this.storageManager.getStorage({
              storageType: "cookie"
            });

            if (this.saveParamsCookie) {
              var i = e.responseType,
                  a = e.state,
                  s = e.nonce,
                  u = e.scopes,
                  c = e.clientId,
                  f = e.urls,
                  l = e.ignoreSignature,
                  p = {
                responseType: i,
                state: a,
                nonce: s,
                scopes: u,
                clientId: c,
                urls: f,
                ignoreSignature: l
              };
              o.setItem(y, JSON.stringify(p), null);
            }

            this.saveNonceCookie && e.nonce && o.setItem(m, e.nonce, null), this.saveStateCookie && e.state && o.setItem(g, e.state, null);
          }
        }
      }, {
        key: "exists",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

          try {
            var t = this.load(e);
            return !!t;
          } catch (e) {
            return !1;
          }
        }
      }, {
        key: "load",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = this.storageManager.getTransactionStorage(),
              n = t.getStorage();
          if (Zt(n)) return n;
          if (!this.legacyWidgetSupport) return null;
          if (e.oauth) try {
            var r = this.loadLegacyOAuthParams();
            Object.assign(n, r);
          } finally {
            this.clearLegacyOAuthParams();
          }
          if (e.pkce) try {
            var o = this.loadLegacyPKCE();
            Object.assign(n, o);
          } finally {
            this.clearLegacyPKCE();
          }
          return Zt(n) ? n : null;
        }
      }, {
        key: "clearLegacyPKCE",
        value: function value() {
          this.storageManager.storageUtil.testStorageType("localStorage") && this.storageManager.getLegacyPKCEStorage({
            storageType: "localStorage"
          }).clearStorage(), this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyPKCEStorage({
            storageType: "sessionStorage"
          }).clearStorage();
        }
      }, {
        key: "loadLegacyPKCE",
        value: function value() {
          var e;
          if (this.storageManager.storageUtil.testStorageType("localStorage") && (e = this.storageManager.getLegacyPKCEStorage({
            storageType: "localStorage"
          }).getStorage()) && e.codeVerifier) return e;
          if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyPKCEStorage({
            storageType: "sessionStorage"
          }).getStorage()) && e.codeVerifier) return e;
          throw new be("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", null);
        }
      }, {
        key: "clearLegacyOAuthParams",
        value: function value() {
          this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyOAuthParamsStorage({
            storageType: "sessionStorage"
          }).clearStorage(), this.storageManager.storageUtil.testStorageType("cookie") && this.storageManager.getLegacyOAuthParamsStorage({
            storageType: "cookie"
          }).clearStorage();
        }
      }, {
        key: "loadLegacyOAuthParams",
        value: function value() {
          var e;
          if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyOAuthParamsStorage({
            storageType: "sessionStorage"
          }).getStorage()), Wt(e)) return e;
          if (this.storageManager.storageUtil.testStorageType("cookie") && (e = this.storageManager.getLegacyOAuthParamsStorage({
            storageType: "cookie"
          }).getStorage()), Wt(e)) return e;
          throw new be("Unable to retrieve OAuth redirect params from storage");
        }
      }, {
        key: "saveIdxResponse",
        value: function value(e) {
          var t = this.storageManager.getIdxResponseStorage();
          t && t.setStorage(e);
        }
      }, {
        key: "loadIdxResponse",
        value: function value() {
          var e = this.storageManager.getIdxResponseStorage();
          if (!e) return null;
          var t = e.getStorage();
          return Yn(t) ? t : null;
        }
      }]), e;
    }(),
        Jn = n(194),
        Xn = new (n(203))(),
        Qn = function () {
      function e(t) {
        s()(this, e), this.nodeCache = t;
      }

      return c()(e, [{
        key: "set",
        value: function value(e, t, n) {
          if (Date.parse(n)) {
            var r = (Date.parse(n) - Date.now()) / 1e3;
            this.nodeCache.set(e, t, r);
          } else this.nodeCache.set(e, t);

          return this.get(e);
        }
      }, {
        key: "get",
        value: function value(e) {
          return this.nodeCache.get(e);
        }
      }, {
        key: "delete",
        value: function value(e) {
          return this.nodeCache.del(e);
        }
      }]), e;
    }(),
        Zn = new (function () {
      function e(t) {
        s()(this, e), this.nodeCache = t, this.storage = new Qn(t);
      }

      return c()(e, [{
        key: "testStorageType",
        value: function value(e) {
          var t = !1;

          switch (e) {
            case "memory":
              t = !0;
          }

          return t;
        }
      }, {
        key: "getStorageByType",
        value: function value(e) {
          var t = null;

          switch (e) {
            case "memory":
              t = this.getStorage();
              break;

            default:
              throw new be("Unrecognized storage option: ".concat(e));
          }

          return t;
        }
      }, {
        key: "findStorageType",
        value: function value() {
          return "memory";
        }
      }, {
        key: "getHttpCache",
        value: function value() {
          return null;
        }
      }, {
        key: "getStorage",
        value: function value() {
          var e = this;
          return {
            getItem: this.nodeCache.get,
            setItem: function setItem(t, n) {
              e.nodeCache.set(t, n, "2200-01-01T00:00:00.000Z");
            }
          };
        }
      }]), e;
    }())(Xn),
        er = {
      token: {
        storageTypes: ["localStorage", "sessionStorage", "cookie"],
        useMultipleCookies: !0
      },
      cache: {
        storageTypes: ["localStorage", "sessionStorage", "cookie"]
      },
      transaction: {
        storageTypes: ["sessionStorage", "localStorage", "cookie"]
      }
    },
        tr = {
      token: {
        storageTypes: ["memory"]
      },
      cache: {
        storageTypes: ["memory"]
      },
      transaction: {
        storageTypes: ["memory"]
      }
    };

    function nr() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 ? arguments[1] : void 0,
          n = e.cookies || {};
      return void 0 === n.secure && (n.secure = t), void 0 === n.sameSite && (n.sameSite = n.secure ? "none" : "lax"), n.secure && !t && (L('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), n.secure = !1), "none" !== n.sameSite || n.secure || (n.sameSite = "lax"), n;
    }

    function rr() {
      var e = at() ? kn : Zn,
          t = at() ? er : tr;
      return {
        devMode: !1,
        httpRequestClient: Jn.a,
        storageUtil: e,
        storageManager: t
      };
    }

    function or(e, t) {
      return Object.assign({}, e, q(t), {
        storageManager: Object.assign({}, e.storageManager, t.storageManager)
      });
    }

    var ir = n(33),
        ar = n.n(ir),
        sr = function sr(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function ur(e) {
      if (e.transactionManager.exists()) {
        var t = e.transactionManager.load();
        if (lr(e, t) && t.interactionHandle) return !0;
      }

      return !1;
    }

    function cr(e) {
      return sr(this, void 0, void 0, l.a.mark(function t() {
        var n, r, o, i, a, s, u, c, f, p, h, d, v, y, g, m, b;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (!e.transactionManager.exists()) {
                  t.next = 5;
                  break;
                }

                if (n = e.transactionManager.load(), !lr(e, n)) {
                  t.next = 4;
                  break;
                }

                return t.abrupt("return", n);

              case 4:
                L("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");

              case 5:
                return t.next = 7, e.token.prepareTokenParams();

              case 7:
                return r = t.sent, o = _t(e, r), i = e.options.issuer, a = r.pkce, s = r.clientId, u = r.redirectUri, c = r.responseType, f = r.responseMode, p = r.scopes, h = r.state, d = r.nonce, v = r.ignoreSignature, y = r.codeVerifier, g = r.codeChallengeMethod, m = r.codeChallenge, b = {
                  issuer: i,
                  pkce: a,
                  clientId: s,
                  redirectUri: u,
                  responseType: c,
                  responseMode: f,
                  scopes: p,
                  state: h,
                  nonce: d,
                  urls: o,
                  ignoreSignature: v,
                  codeVerifier: y,
                  codeChallengeMethod: g,
                  codeChallenge: m
                }, t.abrupt("return", b);

              case 13:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
    }

    function fr(e, t) {
      e.transactionManager.save(t);
    }

    function lr(e, t) {
      return !["issuer", "clientId", "redirectUri"].find(function (n) {
        return e.options[n] !== t[n];
      });
    }
    /*!
     * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    var pr = function pr(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function hr(e) {
      return {
        meta: e,
        interactionHandle: e.interactionHandle,
        state: e.state
      };
    }

    function dr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return pr(this, void 0, void 0, l.a.mark(function n() {
        var r, o, i, a, s, u, c, f, p;
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.next = 2, cr(e);

              case 2:
                if (!(r = n.sent).interactionHandle) {
                  n.next = 5;
                  break;
                }

                return n.abrupt("return", hr(r));

              case 5:
                return o = r.codeChallenge, i = r.codeChallengeMethod, a = e.options, s = a.clientId, u = a.redirectUri, c = t.state || e.options.state || r.state, f = t.scopes || e.options.scopes || r.scopes, p = Et(e), n.abrupt("return", ar.a.interact({
                  clientId: s,
                  baseUrl: p,
                  scopes: f,
                  state: c,
                  redirectUri: u,
                  codeChallenge: o,
                  codeChallengeMethod: i
                }).then(function (t) {
                  var n = Object.assign(Object.assign({}, r), {
                    interactionHandle: t,
                    state: c,
                    scopes: f
                  });
                  return fr(e, n), hr(n);
                }));

              case 11:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }
    /*!
     * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    var vr = function vr(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function yr(e, t) {
      return vr(this, void 0, void 0, l.a.mark(function n() {
        var r, o, i;
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                if (r = e.transactionManager.loadIdxResponse()) {
                  n.next = 7;
                  break;
                }

                return o = I, i = Tt(e), n.next = 6, ar.a.introspect(Object.assign({
                  domain: i,
                  version: o
                }, t));

              case 6:
                r = n.sent;

              case 7:
                return n.abrupt("return", ar.a.makeIdxState(r));

              case 8:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }

    var gr = n(12),
        mr = n.n(gr);

    function br(e, t) {
      var _n4 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (!_n4) {
        if (Array.isArray(e) || (_n4 = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return xr(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return xr(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n4 && (e = _n4);

          var r = 0,
              o = function o() {};

          return {
            s: o,
            n: function n() {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            },
            e: function e(_e7) {
              throw _e7;
            },
            f: o
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var i,
          a = !0,
          s = !1;
      return {
        s: function s() {
          _n4 = _n4.call(e);
        },
        n: function n() {
          var e = _n4.next();

          return a = e.done, e;
        },
        e: function e(_e8) {
          s = !0, i = _e8;
        },
        f: function f() {
          try {
            a || null == _n4.return || _n4.return();
          } finally {
            if (s) throw i;
          }
        }
      };
    }

    function xr(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var wr = function wr(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function kr(e, t, n) {
      var r,
          o,
          i = n.flow,
          a = n.flowMonitor,
          s = [],
          u = br(e);

      try {
        for (u.s(); !(o = u.n()).done;) {
          var c = o.value;
          if (Object.keys(i).includes(c.name)) if (r = new (0, i[c.name])(c, t), a.isRemediatorCandidate(r, e, t)) {
            if (r.canRemediate()) return r;
            s.push(r);
          }
        }
      } catch (e) {
        u.e(e);
      } finally {
        u.f();
      }

      return s[0];
    }

    function Sr(e) {
      var t = e.neededToProceed,
          n = e.interactionCode;
      return !t.length && !n;
    }

    function Er(e, t) {
      var n,
          r = [],
          o = e.rawIdxState,
          i = e.neededToProceed,
          a = null === (n = o.messages) || void 0 === n ? void 0 : n.value.map(function (e) {
        return e;
      });
      a && (r = [].concat(mr()(r), mr()(a)));
      var s,
          u = br(i);

      try {
        for (u.s(); !(s = u.n()).done;) {
          var c = s.value,
              f = t[c.name];

          if (f) {
            var l = new f(c).getMessages();
            l && (r = [].concat(mr()(r), mr()(l)));
          }
        }
      } catch (e) {
        u.e(e);
      } finally {
        u.f();
      }

      return r;
    }

    function Tr(e, t) {
      var n = e.getNextStep(),
          r = function (e) {
        return e.neededToProceed.some(function (e) {
          return "skip" === e.name;
        });
      }(t);

      return Object.assign(Object.assign({}, n), {
        canSkip: r
      });
    }

    function _r(e, t, n) {
      if (Yn(e)) {
        var r = ar.a.makeIdxState(e),
            o = Sr(r),
            i = Er(r, t);
        if (o) return {
          terminal: o,
          messages: i
        };
        var a = n && Tr(n, r);
        return Object.assign({
          messages: i
        }, a && {
          nextStep: a
        });
      }

      throw e;
    }

    function Or(e, t, n) {
      return wr(this, void 0, void 0, l.a.mark(function r() {
        var o, i, a, s, u, c, f, p, h, d, v, y, g, m;
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (o = e.neededToProceed, i = n.actions, a = n.flow, s = n.flowMonitor, !i) {
                  r.next = 31;
                  break;
                }

                u = br(i), r.prev = 4, u.s();

              case 6:
                if ((c = u.n()).done) {
                  r.next = 23;
                  break;
                }

                if (f = c.value, "function" != typeof e.actions[f]) {
                  r.next = 21;
                  break;
                }

                return r.prev = 9, r.next = 12, e.actions[f]();

              case 12:
                e = r.sent, r.next = 18;
                break;

              case 15:
                return r.prev = 15, r.t0 = r.catch(9), r.abrupt("return", _r(r.t0, a));

              case 18:
                if ("cancel" !== f) {
                  r.next = 20;
                  break;
                }

                return r.abrupt("return", {
                  canceled: !0
                });

              case 20:
                return r.abrupt("return", Or(e, t, n));

              case 21:
                r.next = 6;
                break;

              case 23:
                r.next = 28;
                break;

              case 25:
                r.prev = 25, r.t1 = r.catch(4), u.e(r.t1);

              case 28:
                return r.prev = 28, u.f(), r.finish(28);

              case 31:
                if (p = kr(o, t, n)) {
                  r.next = 34;
                  break;
                }

                throw new be("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(o.reduce(function (e, t) {
                  return e ? e + " ," + t.name : t.name;
                }, ""), "]\n    "));

              case 34:
                if (!s.shouldBreak(p)) {
                  r.next = 36;
                  break;
                }

                throw new be("\n      Remediation run into loop, break!!! remediation: ".concat(p.getName(), "\n    "));

              case 36:
                if (p.canRemediate()) {
                  r.next = 39;
                  break;
                }

                return h = Tr(p, e), r.abrupt("return", {
                  idxResponse: e,
                  nextStep: h
                });

              case 39:
                return d = p.getName(), v = p.getData(), r.prev = 41, r.next = 44, e.proceed(d, v);

              case 44:
                if (!(e = r.sent).interactionCode) {
                  r.next = 47;
                  break;
                }

                return r.abrupt("return", {
                  idxResponse: e
                });

              case 47:
                if (y = Sr(e), g = Er(e, a), !y) {
                  r.next = 51;
                  break;
                }

                return r.abrupt("return", {
                  terminal: y,
                  messages: g
                });

              case 51:
                if (!g.length) {
                  r.next = 54;
                  break;
                }

                return m = Tr(p, e), r.abrupt("return", {
                  nextStep: m,
                  messages: g
                });

              case 54:
                return t = p.getValuesAfterProceed(), r.abrupt("return", Or(e, t, n));

              case 58:
                return r.prev = 58, r.t2 = r.catch(41), r.abrupt("return", _r(r.t2, a, p));

              case 61:
              case "end":
                return r.stop();
            }
          }
        }, r, null, [[4, 25, 28, 31], [9, 15], [41, 58]]);
      }));
    }

    function Ar(e) {
      return e.charAt(0).toUpperCase() + e.substring(1);
    }

    function Rr(e) {
      return e.value.find(function (e) {
        return "authenticator" === e.name;
      });
    }

    var Pr = function () {
      function e(t) {
        var n,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        s()(this, e), r.authenticators = (null === (n = r.authenticators) || void 0 === n ? void 0 : n.map(function (e) {
          return "string" == typeof e ? {
            type: e
          } : e;
        })) || [], this.values = r, this.remediation = t;
      }

      return c()(e, [{
        key: "getName",
        value: function value() {
          return this.remediation.name;
        }
      }, {
        key: "canRemediate",
        value: function value() {
          var e = this;
          return !!this.map && !this.remediation.value.reduce(function (e, t) {
            return t.required && e.push(t.name), e;
          }, []).find(function (t) {
            return !e.hasData(t);
          });
        }
      }, {
        key: "getData",
        value: function value(e) {
          var t = this;
          if (!e) return this.remediation.value.map(function (e) {
            return e.name;
          }).reduce(function (e, n) {
            return e[n] = t.getData(n), e;
          }, {});
          if ("function" == typeof this["map".concat(Ar(e))]) return this["map".concat(Ar(e))](this.remediation.value.find(function (t) {
            return t.name === e;
          }));
          if (!this.map) return this.values[e];
          var n = this.map[e];
          if (!n) return this.values[e];

          for (var r = 0; r < n.length; r++) {
            var o = this.values[n[r]];
            if (o) return o;
          }
        }
      }, {
        key: "hasData",
        value: function value(e) {
          var t = this.getData(e);
          return "object" === Vt()(t) ? !!Object.keys(t).find(function (e) {
            return !!t[e];
          }) : !!t;
        }
      }, {
        key: "getNextStep",
        value: function value() {
          var e = this.getName(),
              t = this.getRelatesToType(),
              n = this.getInputs();
          return Object.assign({
            name: e,
            inputs: n
          }, t && {
            type: t
          });
        }
      }, {
        key: "getInputs",
        value: function value() {
          var e = this;
          return this.map ? Object.keys(this.map).reduce(function (t, n) {
            var r,
                o = e.remediation.value.find(function (e) {
              return e.name === n;
            });
            if (!o) return t;
            var i = e.map[n],
                a = o.type;
            if ("function" == typeof e["getInput".concat(Ar(n))]) r = e["getInput".concat(Ar(n))](o);else if ("object" !== a) {
              var s;
              (s = 1 === i.length ? i[0] : i.find(function (t) {
                return Object.keys(e.values).includes(t);
              })) && (r = Object.assign(Object.assign({}, o), {
                name: s
              }));
            }
            if (!r) throw new be("Missing custom getInput".concat(Ar(n), " method in Remediator: ").concat(e.getName()));
            return Array.isArray(r) ? r.forEach(function (e) {
              return t.push(e);
            }) : t.push(r), t;
          }, []) : [];
        }
      }, {
        key: "getMessages",
        value: function value() {
          var e, t;
          if (this.remediation.value) return null === (t = null === (e = this.remediation.value[0]) || void 0 === e ? void 0 : e.form) || void 0 === t ? void 0 : t.value.reduce(function (e, t) {
            return t.messages && (e = [].concat(mr()(e), mr()(t.messages.value))), e;
          }, []);
        }
      }, {
        key: "getValuesAfterProceed",
        value: function value() {
          var e,
              t = this.getRelatesToType(),
              n = null === (e = this.values.authenticators) || void 0 === e ? void 0 : e.filter(function (e) {
            return e.type !== t;
          });
          return Object.assign(Object.assign({}, this.values), {
            authenticators: n
          });
        }
      }, {
        key: "getRelatesToType",
        value: function value() {
          var e;
          return null === (e = this.remediation.relatesTo) || void 0 === e ? void 0 : e.value.type;
        }
      }]), e;
    }();

    function Ir(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var Cr = function (e) {
      oe()(n, e);
      var t = Ir(n);

      function n() {
        var e;
        return s()(this, n), (e = t.apply(this, arguments)).map = {
          credentials: []
        }, e;
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          var e = this.getRelatesToType();
          return !(!this.values.verificationCode || !["email", "phone"].includes(e)) || !(!this.values.password || "password" !== e);
        }
      }, {
        key: "mapCredentials",
        value: function value() {
          return {
            passcode: this.values.verificationCode || this.values.password
          };
        }
      }, {
        key: "getInputCredentials",
        value: function value(e) {
          var t = "password" === this.getRelatesToType() ? "password" : "verificationCode";
          return Object.assign(Object.assign({}, e.form.value[0]), {
            name: t,
            type: "string",
            required: e.required
          });
        }
      }]), n;
    }(Pr);

    function jr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    Cr.remediationName = "challenge-authenticator";

    var Lr = function (e) {
      oe()(n, e);
      var t = jr(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return n;
    }(Cr);

    function Mr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    Lr.remediationName = "enroll-authenticator";

    var Nr = function (e) {
      oe()(n, e);
      var t = Mr(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return n;
    }(Cr);

    function Ur(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    Nr.remediationName = "challenge-authenticator";

    var Dr = function (e) {
      oe()(n, e);
      var t = Ur(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return n;
    }(Cr);

    function Br(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    Dr.remediationName = "reset-authenticator";

    var Fr = function (e) {
      oe()(n, e);
      var t = Br(n);

      function n() {
        var e;
        return s()(this, n), (e = t.apply(this, arguments)).map = {
          userProfile: []
        }, e;
      }

      return c()(n, [{
        key: "mapUserProfile",
        value: function value() {
          var e = this.values;
          return {
            firstName: e.firstName,
            lastName: e.lastName,
            email: e.email
          };
        }
      }, {
        key: "getInputUserProfile",
        value: function value(e) {
          return mr()(e.form.value);
        }
      }, {
        key: "getErrorMessages",
        value: function value(e) {
          return e.value[0].form.value.reduce(function (e, t) {
            return t.messages && e.push(t.messages.value[0].message), e;
          }, []);
        }
      }]), n;
    }(Pr);

    Fr.remediationName = "enroll-profile";
    var Hr = n(14),
        qr = n.n(Hr);

    function $r(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var zr = function (e) {
      oe()(n, e);
      var t = $r(n);

      function n(e, r) {
        var o;
        s()(this, n), (o = t.call(this, e, r)).map = {
          identifier: ["username"],
          credentials: []
        };
        var i = o.values,
            a = i.password,
            u = i.authenticators;
        return a && !u.some(function (e) {
          return "password" === e.type;
        }) && (o.values = Object.assign(Object.assign({}, o.values), {
          authenticators: [{
            type: "password"
          }].concat(mr()(u))
        })), o;
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          return !!this.getData().identifier;
        }
      }, {
        key: "mapCredentials",
        value: function value() {
          return {
            passcode: this.values.password
          };
        }
      }, {
        key: "getInputCredentials",
        value: function value(e) {
          return Object.assign(Object.assign({}, e.form.value[0]), {
            name: "password",
            required: e.required
          });
        }
      }, {
        key: "getValuesAfterProceed",
        value: function value() {
          var e;

          if (this.remediation.value.some(function (e) {
            return "credentials" === e.name;
          })) {
            var t = null === (e = this.values.authenticators) || void 0 === e ? void 0 : e.filter(function (e) {
              return "password" !== e.type;
            });
            return Object.assign(Object.assign({}, this.values), {
              authenticators: t
            });
          }

          return qr()(ue()(n.prototype), "getValuesAfterProceed", this).call(this);
        }
      }]), n;
    }(Pr);

    function Kr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    zr.remediationName = "identify";

    var Gr = function (e) {
      oe()(n, e);
      var t = Kr(n);

      function n() {
        var e;
        return s()(this, n), (e = t.apply(this, arguments)).map = {
          credentials: []
        }, e;
      }

      return c()(n, [{
        key: "mapCredentials",
        value: function value() {
          return {
            passcode: this.values.newPassword
          };
        }
      }, {
        key: "getInputCredentials",
        value: function value(e) {
          var t = "password" === this.getRelatesToType() ? "newPassword" : "verificationCode";
          return Object.assign(Object.assign({}, e.form.value[0]), {
            name: t
          });
        }
      }]), n;
    }(Pr);

    function Vr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    Gr.remediationName = "reenroll-authenticator";

    var Yr = function (e) {
      oe()(n, e);
      var t = Vr(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          return !1;
        }
      }, {
        key: "getNextStep",
        value: function value() {
          var e = this.remediation;
          return {
            name: e.name,
            type: e.type,
            idp: e.idp,
            href: e.href
          };
        }
      }]), n;
    }(Pr);

    function Wr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    function Jr(e, t) {
      var _n5 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (!_n5) {
        if (Array.isArray(e) || (_n5 = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return Xr(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Xr(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n5 && (e = _n5);

          var r = 0,
              o = function o() {};

          return {
            s: o,
            n: function n() {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            },
            e: function e(_e9) {
              throw _e9;
            },
            f: o
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var i,
          a = !0,
          s = !1;
      return {
        s: function s() {
          _n5 = _n5.call(e);
        },
        n: function n() {
          var e = _n5.next();

          return a = e.done, e;
        },
        e: function e(_e10) {
          s = !0, i = _e10;
        },
        f: function f() {
          try {
            a || null == _n5.return || _n5.return();
          } finally {
            if (s) throw i;
          }
        }
      };
    }

    function Xr(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function Qr(e, t) {
      var n,
          r,
          o = Jr(e);

      try {
        var i = function i() {
          var e = r.value;
          if (n = t.find(function (t) {
            return t.relatesTo.type === e.type;
          })) return "break";
        };

        for (o.s(); !(r = o.n()).done;) {
          if ("break" === i()) break;
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }

      return n;
    }

    Yr.remediationName = "redirect-idp";

    var Zr = function (e) {
      oe()(n, e);
      var t = Wr(n);

      function n(e) {
        var r,
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        s()(this, n), (r = t.call(this, e, o)).map = {
          authenticator: []
        };
        var i = r.values,
            a = i.authenticator,
            u = i.authenticators,
            c = null == u ? void 0 : u.some(function (e) {
          return e.type === a;
        });
        return a && !c && (r.values.authenticators = [].concat(mr()(u || []), [{
          type: a
        }])), r;
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          var e = this.values.authenticators,
              t = Rr(this.remediation).options;
          return !(!e || !e.length) && !!Qr(e, t);
        }
      }, {
        key: "getNextStep",
        value: function value() {
          var e = qr()(ue()(n.prototype), "getNextStep", this).call(this),
              t = Rr(this.remediation).options.map(function (e) {
            return {
              label: e.label,
              value: e.relatesTo.type
            };
          });
          return Object.assign(Object.assign({}, e), {
            options: t
          });
        }
      }, {
        key: "mapAuthenticator",
        value: function value(e) {
          var t = Qr(this.values.authenticators, e.options);
          return {
            id: null == t ? void 0 : t.value.form.value.find(function (e) {
              return "id" === e.name;
            }).value
          };
        }
      }, {
        key: "getInputAuthenticator",
        value: function value() {
          return {
            name: "authenticator",
            type: "string"
          };
        }
      }]), n;
    }(Pr);

    function eo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var to = function (e) {
      oe()(n, e);
      var t = eo(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return n;
    }(Zr);

    function no(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    to.remediationName = "select-authenticator-authenticate";

    var ro = function (e) {
      oe()(n, e);
      var t = no(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return n;
    }(Zr);

    function oo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    ro.remediationName = "select-authenticator-enroll";

    var io = function (e) {
      oe()(n, e);
      var t = oo(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          return !0;
        }
      }]), n;
    }(Pr);

    function ao(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    io.remediationName = "select-enroll-profile";

    var so = function (e) {
      oe()(n, e);
      var t = ao(n);

      function n(e) {
        var r,
            o,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        s()(this, n), (r = t.call(this, e, i)).map = {
          authenticator: []
        };
        var a = r.values.authenticators,
            u = r.getRelatesToType(),
            c = null === (o = a) || void 0 === o ? void 0 : o.find(function (e) {
          return e.type === u;
        });
        return r.values.authenticators = c ? a.map(function (e) {
          return u === e.type ? r.mapAuthenticatorFromValues(e) : e;
        }) : [].concat(mr()(a), [r.mapAuthenticatorFromValues()]), r;
      }

      return c()(n, [{
        key: "getNextStep",
        value: function value() {
          var e = qr()(ue()(n.prototype), "getNextStep", this).call(this),
              t = this.getMethodTypes();
          return Object.assign(Object.assign({}, e), t && {
            options: t
          });
        }
      }, {
        key: "getAuthenticatorFromValues",
        value: function value() {
          if (!this.values.authenticators) return null;
          var e = this.getRelatesToType();
          return this.values.authenticators.find(function (t) {
            return t.type === e;
          });
        }
      }, {
        key: "mapAuthenticatorFromValues",
        value: function value(e) {
          var t = this.getRelatesToType(),
              n = this.values.methodType;
          return Object.assign(Object.assign({
            type: t
          }, e && e), n && {
            methodType: n
          });
        }
      }, {
        key: "getAuthenticatorFromRemediation",
        value: function value() {
          return this.remediation.value.find(function (e) {
            return "authenticator" === e.name;
          });
        }
      }, {
        key: "getMethodTypes",
        value: function value() {
          var e;
          return null === (e = this.getAuthenticatorFromRemediation().form.value.find(function (e) {
            return "methodType" === e.name;
          })) || void 0 === e ? void 0 : e.options;
        }
      }]), n;
    }(Pr);

    function uo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var co = function (e) {
      oe()(n, e);
      var t = uo(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          var e = this.getAuthenticatorFromValues();
          return !(!e || !e.methodType);
        }
      }, {
        key: "mapAuthenticator",
        value: function value() {
          var e = this.getAuthenticatorFromRemediation(),
              t = this.getAuthenticatorFromValues();
          return {
            id: e.form.value.find(function (e) {
              return "id" === e.name;
            }).value,
            enrollmentId: e.form.value.find(function (e) {
              return "enrollmentId" === e.name;
            }).value,
            methodType: t.methodType
          };
        }
      }, {
        key: "getInputAuthenticator",
        value: function value() {
          var e = this.getAuthenticatorFromRemediation(),
              t = e.form.value.find(function (e) {
            return "methodType" === e.name;
          });
          return t && t.options ? {
            name: "methodType",
            type: "string",
            required: !0
          } : mr()(e.form.value);
        }
      }]), n;
    }(so);

    function fo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    co.remediationName = "authenticator-verification-data";

    var lo = function (e) {
      oe()(n, e);
      var t = fo(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          var e = this.getAuthenticatorFromValues();
          return !!(e && e.methodType && e.phoneNumber);
        }
      }, {
        key: "mapAuthenticator",
        value: function value() {
          var e = this.getAuthenticatorFromValues();
          return {
            id: Rr(this.remediation).form.value.find(function (e) {
              return "id" === e.name;
            }).value,
            methodType: e.methodType,
            phoneNumber: e.phoneNumber
          };
        }
      }, {
        key: "getInputAuthenticator",
        value: function value() {
          return [{
            name: "methodType",
            type: "string",
            required: !0
          }, {
            name: "phoneNumber",
            type: "string",
            required: !0
          }];
        }
      }, {
        key: "mapAuthenticatorFromValues",
        value: function value(e) {
          e = qr()(ue()(n.prototype), "mapAuthenticatorFromValues", this).call(this, e);
          var t = this.values.phoneNumber;
          return Object.assign(Object.assign({}, e), t && {
            phoneNumber: t
          });
        }
      }]), n;
    }(so);

    function po(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    lo.remediationName = "authenticator-enrollment-data";

    var ho = function (e) {
      oe()(n, e);
      var t = po(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "canRemediate",
        value: function value() {
          return !!this.values.skip;
        }
      }]), n;
    }(Pr);

    function vo(e, t) {
      var _n6 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (!_n6) {
        if (Array.isArray(e) || (_n6 = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return yo(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return yo(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n6 && (e = _n6);

          var r = 0,
              o = function o() {};

          return {
            s: o,
            n: function n() {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            },
            e: function e(_e11) {
              throw _e11;
            },
            f: o
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var i,
          a = !0,
          s = !1;
      return {
        s: function s() {
          _n6 = _n6.call(e);
        },
        n: function n() {
          var e = _n6.next();

          return a = e.done, e;
        },
        e: function e(_e12) {
          s = !0, i = _e12;
        },
        f: function f() {
          try {
            a || null == _n6.return || _n6.return();
          } finally {
            if (s) throw i;
          }
        }
      };
    }

    function yo(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    ho.remediationName = "skip";

    var go = function go(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function mo(e) {
      var t = [],
          n = e.actions,
          r = e.neededToProceed;
      return n["currentAuthenticator-recover"] && t.push(Kt.PASSWORD_RECOVERY), r.some(function (e) {
        return "select-enroll-profile" === e.name;
      }) && t.push(Kt.REGISTRATION), r.some(function (e) {
        return "redirect-idp" === e.name;
      }) && t.push(Kt.SOCIAL_IDP), t;
    }

    function bo(e) {
      var t,
          n = [],
          r = Object.values(i).reduce(function (e, t) {
        return t.remediationName && (e[t.remediationName] = t), e;
      }, {}),
          o = vo(e);

      try {
        for (o.s(); !(t = o.n()).done;) {
          var a = t.value,
              s = r[a.name];

          if (s) {
            var u = new s(a);
            n.push(u.getNextStep());
          }
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }

      return n;
    }

    function xo(e, t) {
      return go(this, void 0, void 0, l.a.mark(function n() {
        var r, o, i, a, s, u, c, f, p, h, d, v, y, g, m, b, x, w, k, S, E, T, _, O, A, R;

        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return f = zt.PENDING, p = !1, n.prev = 2, n.next = 5, dr(e, t);

              case 5:
                return h = n.sent, d = h.interactionHandle, v = h.meta, n.next = 10, yr(e, {
                  interactionHandle: d
                });

              case 10:
                if (y = n.sent, t.flow || t.actions) {
                  n.next = 17;
                  break;
                }

                s = v, u = mo(y), c = bo(y.neededToProceed), n.next = 42;
                break;

              case 17:
                return g = Object.assign(Object.assign({}, t), {
                  stateHandle: y.rawIdxState.stateHandle
                }), n.next = 20, Or(y, g, t);

              case 20:
                if (m = n.sent, b = m.idxResponse, x = m.nextStep, w = m.terminal, k = m.canceled, S = m.messages, i = S, (o = x) && b && e.transactionManager.saveIdxResponse(b.rawIdxState), w && (f = zt.TERMINAL, p = !0), !k) {
                  n.next = 35;
                  break;
                }

                f = zt.CANCELED, p = !0, n.next = 42;
                break;

              case 35:
                if (!(null == b ? void 0 : b.interactionCode)) {
                  n.next = 42;
                  break;
                }

                return E = v.clientId, T = v.codeVerifier, _ = v.ignoreSignature, O = v.redirectUri, A = v.urls, R = v.scopes, n.next = 39, e.token.exchangeCodeForTokens({
                  interactionCode: b.interactionCode,
                  clientId: E,
                  codeVerifier: T,
                  ignoreSignature: _,
                  redirectUri: O,
                  scopes: R
                }, A);

              case 39:
                r = n.sent, f = zt.SUCCESS, p = !0;

              case 42:
                n.next = 49;
                break;

              case 44:
                n.prev = 44, n.t0 = n.catch(2), a = n.t0, f = zt.FAILURE, p = !0;

              case 49:
                return p && e.transactionManager.clear(), n.abrupt("return", Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                  status: f
                }, s && {
                  meta: s
                }), u && {
                  enabledFeatures: u
                }), c && {
                  availableSteps: c
                }), r && {
                  tokens: r.tokens
                }), o && {
                  nextStep: o
                }), i && {
                  messages: i
                }), a && {
                  error: a
                }));

              case 51:
              case "end":
                return n.stop();
            }
          }
        }, n, null, [[2, 44]]);
      }));
    }

    var wo = function () {
      function e() {
        s()(this, e);
      }

      return c()(e, [{
        key: "shouldBreak",
        value: function value(e) {
          return this.previousRemediator && this.previousRemediator.getName() === e.getName() || (this.previousRemediator = e, !1);
        }
      }, {
        key: "isRemediatorCandidate",
        value: function value(e, t, n) {
          var r = e.getName();
          return !(!n.skip && "skip" === r) && (!n.skip || "skip" === r);
        }
      }]), e;
    }();

    function ko(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var So = function (e) {
      oe()(n, e);
      var t = ko(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "isRemediatorCandidate",
        value: function value(e, t, r) {
          var o,
              i = null === (o = this.previousRemediator) || void 0 === o ? void 0 : o.getName();
          return ("select-authenticator-enroll" !== e.getName() || !["select-authenticator-enroll", "authenticator-enrollment-data"].includes(i)) && qr()(ue()(n.prototype), "isRemediatorCandidate", this).call(this, e, t, r);
        }
      }]), n;
    }(wo);

    function Eo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var To = function (e) {
      oe()(n, e);
      var t = Eo(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "isRemediatorCandidate",
        value: function value(e, t, r) {
          var o,
              i = null === (o = this.previousRemediator) || void 0 === o ? void 0 : o.getName(),
              a = e.getName();
          return ("select-authenticator-authenticate" !== a || !["select-authenticator-authenticate"].includes(i)) && ("select-authenticator-authenticate" !== a || !t.some(function (e) {
            return "challenge-authenticator" === e.name;
          })) && ("select-authenticator-enroll" !== a || !["select-authenticator-enroll", "authenticator-enrollment-data"].includes(i)) && qr()(ue()(n.prototype), "isRemediatorCandidate", this).call(this, e, t, r);
        }
      }]), n;
    }(wo);

    function _o(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = ue()(e);

        if (t) {
          var o = ue()(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ae()(this, n);
      };
    }

    var Oo = function (e) {
      oe()(n, e);

      var t = _o(n);

      function n() {
        return s()(this, n), t.apply(this, arguments);
      }

      return c()(n, [{
        key: "isRemediatorCandidate",
        value: function value(e, t, r) {
          var o,
              i = null === (o = this.previousRemediator) || void 0 === o ? void 0 : o.getName(),
              a = e.getName();
          return ("select-authenticator-authenticate" !== a || !["select-authenticator-authenticate", "reenroll-authenticator"].includes(i)) && ("select-authenticator-authenticate" !== a || !t.some(function (e) {
            return "challenge-authenticator" === e.name;
          })) && qr()(ue()(n.prototype), "isRemediatorCandidate", this).call(this, e, t, r);
        }
      }]), n;
    }(wo),
        Ao = function Ao(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        Ro = {
      identify: zr,
      "select-authenticator-authenticate": to,
      "select-authenticator-enroll": ro,
      "authenticator-enrollment-data": lo,
      "authenticator-verification-data": co,
      "enroll-authenticator": Lr,
      "challenge-authenticator": Nr,
      "reenroll-authenticator": Gr,
      "redirect-idp": Yr
    };

    function Po(e, t) {
      return Ao(this, void 0, void 0, l.a.mark(function n() {
        var r;
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return r = new To(), n.abrupt("return", xo(e, Object.assign(Object.assign({}, t), {
                  flow: Ro,
                  flowMonitor: r
                })));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }
    /*!
     * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    var Io = function Io(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function Co(e, t) {
      return Io(this, void 0, void 0, l.a.mark(function n() {
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.abrupt("return", xo(e, Object.assign(Object.assign({}, t), {
                  actions: ["cancel"]
                })));

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }

    var jo = function jo(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function Lo(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return jo(this, void 0, void 0, l.a.mark(function n() {
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.abrupt("return", xo(e, t));

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }

    var Mo = function Mo(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        No = {
      "select-enroll-profile": io,
      "enroll-profile": Fr,
      "authenticator-enrollment-data": lo,
      "select-authenticator-enroll": ro,
      "enroll-authenticator": Lr,
      skip: ho
    };

    function Uo(e, t) {
      return Mo(this, void 0, void 0, l.a.mark(function n() {
        var r, o, i, a;
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                if (ur(e)) {
                  n.next = 8;
                  break;
                }

                return n.next = 3, Lo(e, t);

              case 3:
                if (r = n.sent, !(o = r.enabledFeatures) || o.includes(Kt.REGISTRATION)) {
                  n.next = 8;
                  break;
                }

                return i = new be("Registration is not supported based on your current org configuration."), n.abrupt("return", {
                  status: zt.FAILURE,
                  error: i
                });

              case 8:
                return a = new So(), n.abrupt("return", xo(e, Object.assign(Object.assign({}, t), {
                  flow: No,
                  flowMonitor: a
                })));

              case 10:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }

    var Do = function Do(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        Bo = {
      identify: zr,
      "identify-recovery": zr,
      "select-authenticator-authenticate": to,
      "challenge-authenticator": Nr,
      "authenticator-verification-data": co,
      "reset-authenticator": Dr,
      "reenroll-authenticator": Gr
    };

    function Fo(e, t) {
      return Do(this, void 0, void 0, l.a.mark(function n() {
        var r;
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return r = new Oo(), n.abrupt("return", xo(e, Object.assign(Object.assign({}, t), {
                  flow: Bo,
                  flowMonitor: r,
                  actions: ["currentAuthenticator-recover", "currentAuthenticatorEnrollment-recover"]
                })));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }

    var Ho = function Ho(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    };

    function qo(e, t) {
      return Ho(this, void 0, void 0, l.a.mark(function n() {
        var r, o, i, a, s, u, c, f, p, h;
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                if (r = e.transactionManager.load()) {
                  n.next = 3;
                  break;
                }

                throw new be("No transaction data was found in storage");

              case 3:
                if (o = r.codeVerifier, i = r.state, a = new URL(t), s = a.searchParams, u = s.get("state"), c = s.get("interaction_code"), !(f = s.get("error"))) {
                  n.next = 10;
                  break;
                }

                throw new Me(f, s.get("error_description"));

              case 10:
                if (u === i) {
                  n.next = 12;
                  break;
                }

                throw new be("State in redirect uri does not match with transaction state");

              case 12:
                if (c) {
                  n.next = 14;
                  break;
                }

                throw new be("Unable to parse interaction_code from the url");

              case 14:
                return n.next = 16, e.token.exchangeCodeForTokens({
                  interactionCode: c,
                  codeVerifier: o
                });

              case 16:
                p = n.sent, h = p.tokens, e.tokenManager.setTokens(h);

              case 19:
              case "end":
                return n.stop();
            }
          }
        }, n);
      }));
    }
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     */


    var $o = function $o(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        zo = function zo(e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    },
        Ko = n(394),
        Go = function () {
      function e(t) {
        var n = this;
        s()(this, e), this.options = function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return Sn(e), q({
            issuer: ne((e = or(rr(), e)).issuer),
            tokenUrl: ne(e.tokenUrl),
            authorizeUrl: ne(e.authorizeUrl),
            userinfoUrl: ne(e.userinfoUrl),
            revokeUrl: ne(e.revokeUrl),
            logoutUrl: ne(e.logoutUrl),
            clientId: e.clientId,
            redirectUri: e.redirectUri,
            state: e.state,
            scopes: e.scopes,
            postLogoutRedirectUri: e.postLogoutRedirectUri,
            responseMode: e.responseMode,
            responseType: e.responseType,
            pkce: !1 !== e.pkce,
            useInteractionCodeFlow: e.useInteractionCodeFlow,
            httpRequestClient: e.httpRequestClient,
            transformErrorXHR: e.transformErrorXHR,
            transformAuthState: e.transformAuthState,
            restoreOriginalUri: e.restoreOriginalUri,
            storageUtil: e.storageUtil,
            headers: e.headers,
            devMode: !!e.devMode,
            storageManager: e.storageManager,
            cookies: at() ? nr(e, dt()) : e.cookies,
            ignoreSignature: !!e.ignoreSignature,
            clientSecret: e.clientSecret
          });
        }(t);
        var r = this.options,
            o = r.storageManager,
            i = r.cookies,
            a = r.storageUtil;
        this.storageManager = new Vn(o, i, a), this.transactionManager = new Wn(Object.assign({
          storageManager: this.storageManager
        }, t.transactionManager)), this.tx = {
          status: Ae.bind(null, this),
          resume: Re.bind(null, this),
          exists: Object.assign(Ie.bind(null, this), {
            _get: function _get(e) {
              return a.storage.get(e);
            }
          }),
          introspect: Pe.bind(null, this)
        }, this.pkce = {
          DEFAULT_CODE_CHALLENGE_METHOD: Ke.DEFAULT_CODE_CHALLENGE_METHOD,
          generateVerifier: Ke.generateVerifier,
          computeChallenge: Ke.computeChallenge
        }, Object.assign(this.options.storageUtil, {
          getPKCEStorage: this.storageManager.getLegacyPKCEStorage.bind(this.storageManager),
          getHttpCache: this.storageManager.getHttpCache.bind(this.storageManager)
        }), this._pending = {
          handleLogin: !1
        }, at() ? (this.options = Object.assign(this.options, {
          redirectUri: Z(t.redirectUri, window.location.origin)
        }), this.userAgent = En(t, "okta-auth-js/".concat("5.1.1"))) : this.userAgent = En(t, "okta-auth-js-server/".concat("5.1.1")), t.maxClockSkew || 0 === t.maxClockSkew ? this.options.maxClockSkew = t.maxClockSkew : this.options.maxClockSkew = d, this.session = {
          close: Ye.bind(null, this),
          exists: Ge.bind(null, this),
          get: Ve.bind(null, this),
          refresh: We.bind(null, this),
          setCookieAndRedirect: Je.bind(null, this)
        }, this._tokenQueue = new Dn(), this.token = {
          prepareTokenParams: Bt.bind(null, this),
          exchangeCodeForTokens: on.bind(null, this),
          getWithoutPrompt: fn.bind(null, this),
          getWithPopup: gn.bind(null, this),
          getWithRedirect: mn.bind(null, this),
          parseFromUrl: bn.bind(null, this),
          decode: qt,
          revoke: $t.bind(null, this),
          renew: ln.bind(null, this),
          renewTokensWithRefresh: hn.bind(null, this),
          renewTokens: dn.bind(null, this),
          getUserInfo: yn.bind(null, this),
          verify: sn.bind(null, this),
          isLoginRedirect: Ut.bind(null, this)
        };
        var u = ["decode", "isLoginRedirect"];
        Object.keys(this.token).forEach(function (e) {
          if (!(u.indexOf(e) >= 0)) {
            var t = n.token[e];
            n.token[e] = Dn.prototype.push.bind(n._tokenQueue, t, null);
          }
        }), Object.assign(this.token.getWithRedirect, {
          _setLocation: function _setLocation(e) {
            window.location = e;
          }
        }), Object.assign(this.token.parseFromUrl, {
          _getHistory: function _getHistory() {
            return window.history;
          },
          _getLocation: function _getLocation() {
            return window.location;
          },
          _getDocument: function _getDocument() {
            return window.document;
          }
        }), this.idx = {
          authenticate: Po.bind(null, this),
          register: Uo.bind(null, this),
          cancel: Co.bind(null, this),
          recoverPassword: Fo.bind(null, this),
          handleInteractionCodeRedirect: qo.bind(null, this),
          startTransaction: Lo.bind(null, this)
        }, this.fingerprint = Bn.bind(null, this), this.emitter = new Ko(), this.tokenManager = new Un(this, t.tokenManager), this.authStateManager = new zn(this);
      }

      return c()(e, [{
        key: "start",
        value: function value() {
          this.tokenManager.start(), this.authStateManager.updateAuthState();
        }
      }, {
        key: "stop",
        value: function value() {
          this.tokenManager.stop();
        }
      }, {
        key: "isInteractionRequired",
        value: function value() {
          return Dt(this);
        }
      }, {
        key: "isInteractionRequiredError",
        value: function value(e) {
          return At(e);
        }
      }, {
        key: "signIn",
        value: function value(e) {
          return $o(this, void 0, void 0, l.a.mark(function t() {
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.abrupt("return", this.signInWithCredentials(e));

                  case 1:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "signInWithCredentials",
        value: function value(e) {
          return $o(this, void 0, void 0, l.a.mark(function t() {
            var n,
                r = this;
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (e = $(e || {}), n = function n(t) {
                      return delete e.sendFingerprint, Ce(r, "/api/v1/authn", e, t);
                    }, e.sendFingerprint) {
                      t.next = 4;
                      break;
                    }

                    return t.abrupt("return", n());

                  case 4:
                    return t.abrupt("return", this.fingerprint().then(function (e) {
                      return n({
                        headers: {
                          "X-Device-Fingerprint": e
                        }
                      });
                    }));

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "signInWithRedirect",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return $o(this, void 0, void 0, l.a.mark(function t() {
            var n, r, o;
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (n = e.originalUri, r = zo(e, ["originalUri"]), !this._pending.handleLogin) {
                      t.next = 3;
                      break;
                    }

                    return t.abrupt("return");

                  case 3:
                    return this._pending.handleLogin = !0, t.prev = 4, n && this.setOriginalUri(n), o = Object.assign({
                      scopes: this.options.scopes || ["openid", "email", "profile"]
                    }, r), t.next = 9, this.token.getWithRedirect(o);

                  case 9:
                    return t.prev = 9, this._pending.handleLogin = !1, t.finish(9);

                  case 12:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this, [[4,, 9, 12]]);
          }));
        }
      }, {
        key: "closeSession",
        value: function value() {
          return this.tokenManager.clear(), this.session.close().catch(function (e) {
            if ("AuthApiError" === e.name && "E0000007" === e.errorCode) return null;
            throw e;
          });
        }
      }, {
        key: "revokeAccessToken",
        value: function value(e) {
          return $o(this, void 0, void 0, l.a.mark(function t() {
            var n;
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (e) {
                      t.next = 6;
                      break;
                    }

                    return t.next = 3, this.tokenManager.getTokens();

                  case 3:
                    e = t.sent.accessToken, n = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(n);

                  case 6:
                    if (e) {
                      t.next = 8;
                      break;
                    }

                    return t.abrupt("return", Promise.resolve(null));

                  case 8:
                    return t.abrupt("return", this.token.revoke(e));

                  case 9:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "revokeRefreshToken",
        value: function value(e) {
          return $o(this, void 0, void 0, l.a.mark(function t() {
            var n;
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (e) {
                      t.next = 6;
                      break;
                    }

                    return t.next = 3, this.tokenManager.getTokens();

                  case 3:
                    e = t.sent.refreshToken, n = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(n);

                  case 6:
                    if (e) {
                      t.next = 8;
                      break;
                    }

                    return t.abrupt("return", Promise.resolve(null));

                  case 8:
                    return t.abrupt("return", this.token.revoke(e));

                  case 9:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "getSignOutRedirectUrl",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = e.idToken,
              n = e.postLogoutRedirectUri,
              r = e.state;
          if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
          n || (n = this.options.postLogoutRedirectUri);

          var o = _t(this).logoutUrl,
              i = t.idToken,
              a = o + "?id_token_hint=" + encodeURIComponent(i);

          return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
        }
      }, {
        key: "signOut",
        value: function value(e) {
          return $o(this, void 0, void 0, l.a.mark(function t() {
            var n, r, o, i, a, s, u, c;
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (e = Object.assign({}, e), n = window.location.origin, r = window.location.href, o = e.postLogoutRedirectUri || this.options.postLogoutRedirectUri || n, i = e.accessToken, a = e.refreshToken, s = !1 !== e.revokeAccessToken, (u = !1 !== e.revokeRefreshToken) && void 0 === a && (a = this.tokenManager.getTokensSync().refreshToken), s && void 0 === i && (i = this.tokenManager.getTokensSync().accessToken), e.idToken || (e.idToken = this.tokenManager.getTokensSync().idToken), this.tokenManager.clear(), !u || !a) {
                      t.next = 15;
                      break;
                    }

                    return t.next = 15, this.revokeRefreshToken(a);

                  case 15:
                    if (!s || !i) {
                      t.next = 18;
                      break;
                    }

                    return t.next = 18, this.revokeAccessToken(i);

                  case 18:
                    if (c = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, e), {
                      postLogoutRedirectUri: o
                    }))) {
                      t.next = 23;
                      break;
                    }

                    return t.abrupt("return", this.closeSession().then(function () {
                      o === r ? window.location.reload() : window.location.assign(o);
                    }));

                  case 23:
                    window.location.assign(c);

                  case 24:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "webfinger",
        value: function value(e) {
          var t = "/.well-known/webfinger" + te(e);
          return ge.get(this, t, {
            headers: {
              Accept: "application/jrd+json"
            }
          });
        }
      }, {
        key: "isAuthenticated",
        value: function value() {
          return $o(this, void 0, void 0, l.a.mark(function e() {
            var t, n, r, o, i, a;
            return l.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t = this.tokenManager.getTokensSync(), n = t.accessToken, r = t.idToken, o = this.options.tokenManager || {}, i = o.autoRenew, a = o.autoRemove, !n || !this.tokenManager.hasExpired(n)) {
                      e.next = 11;
                      break;
                    }

                    if (n = null, !i) {
                      e.next = 10;
                      break;
                    }

                    return e.next = 7, this.tokenManager.renew("accessToken");

                  case 7:
                    n = e.sent, e.next = 11;
                    break;

                  case 10:
                    a && this.tokenManager.remove("accessToken");

                  case 11:
                    if (!r || !this.tokenManager.hasExpired(r)) {
                      e.next = 20;
                      break;
                    }

                    if (r = null, !i) {
                      e.next = 19;
                      break;
                    }

                    return e.next = 16, this.tokenManager.renew("idToken");

                  case 16:
                    r = e.sent, e.next = 20;
                    break;

                  case 19:
                    a && this.tokenManager.remove("idToken");

                  case 20:
                    return e.abrupt("return", !(!n || !r));

                  case 21:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "getUser",
        value: function value() {
          return $o(this, void 0, void 0, l.a.mark(function e() {
            var t, n, r;
            return l.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e.abrupt("return", this.token.getUserInfo(r, n));

                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "getIdToken",
        value: function value() {
          var e = this.tokenManager.getTokensSync().idToken;
          return e ? e.idToken : void 0;
        }
      }, {
        key: "getAccessToken",
        value: function value() {
          var e = this.tokenManager.getTokensSync().accessToken;
          return e ? e.accessToken : void 0;
        }
      }, {
        key: "getRefreshToken",
        value: function value() {
          var e = this.tokenManager.getTokensSync().refreshToken;
          return e ? e.refreshToken : void 0;
        }
      }, {
        key: "storeTokensFromRedirect",
        value: function value() {
          return $o(this, void 0, void 0, l.a.mark(function e() {
            var t, n;
            return l.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.token.parseFromUrl();

                  case 2:
                    t = e.sent, n = t.tokens, this.tokenManager.setTokens(n);

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
        }
      }, {
        key: "setOriginalUri",
        value: function value(e) {
          kn.getSessionStorage().setItem(O, e);
        }
      }, {
        key: "getOriginalUri",
        value: function value() {
          return kn.getSessionStorage().getItem(O);
        }
      }, {
        key: "removeOriginalUri",
        value: function value() {
          kn.getSessionStorage().removeItem(O);
        }
      }, {
        key: "isLoginRedirect",
        value: function value() {
          return Ut(this);
        }
      }, {
        key: "handleLoginRedirect",
        value: function value(e) {
          return $o(this, void 0, void 0, l.a.mark(function t() {
            var n, r;
            return l.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (!e) {
                      t.next = 4;
                      break;
                    }

                    this.tokenManager.setTokens(e), t.next = 10;
                    break;

                  case 4:
                    if (!this.isLoginRedirect()) {
                      t.next = 9;
                      break;
                    }

                    return t.next = 7, this.storeTokensFromRedirect();

                  case 7:
                    t.next = 10;
                    break;

                  case 9:
                    return t.abrupt("return");

                  case 10:
                    return t.next = 12, this.authStateManager.updateAuthState();

                  case 12:
                    if (n = this.getOriginalUri(), this.removeOriginalUri(), !(r = this.options.restoreOriginalUri)) {
                      t.next = 20;
                      break;
                    }

                    return t.next = 18, r(this, n);

                  case 18:
                    t.next = 21;
                    break;

                  case 20:
                    window.location.replace(n);

                  case 21:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
        }
      }, {
        key: "isPKCE",
        value: function value() {
          return !!this.options.pkce;
        }
      }, {
        key: "hasResponseType",
        value: function value(e) {
          var t = !1;
          return t = Array.isArray(this.options.responseType) && this.options.responseType.length ? this.options.responseType.indexOf(e) >= 0 : this.options.responseType === e, t;
        }
      }, {
        key: "isAuthorizationCodeFlow",
        value: function value() {
          return this.hasResponseType("code");
        }
      }, {
        key: "getIssuerOrigin",
        value: function value() {
          return this.options.issuer.split("/oauth2/")[0];
        }
      }, {
        key: "forgotPassword",
        value: function value(e) {
          return Ce(this, "/api/v1/authn/recovery/password", e);
        }
      }, {
        key: "unlockAccount",
        value: function value(e) {
          return Ce(this, "/api/v1/authn/recovery/unlock", e);
        }
      }, {
        key: "verifyRecoveryToken",
        value: function value(e) {
          return Ce(this, "/api/v1/authn/recovery/token", e);
        }
      }]), e;
    }();

    Go.features = Go.prototype.features = o, Object.assign(Go, {
      constants: r,
      isInteractionRequiredError: At
    });
    var Vo = Go;
    /*!
     * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
     * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
     *
     * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
     * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     *
     * See the License for the specific language governing permissions and limitations under the License.
     *
     */
  }]);
});